export const en = {
  // Navigation — the worlds on the rail (docs/design_handoff_navigatie)
  "nav.world.today": "Today",
  "nav.world.transport": "Transport",
  "nav.world.resources": "Resources",
  "nav.world.organizations": "Organisations",
  "nav.world.warehouse": "Warehouse",
  "nav.world.commerce": "Commerce",
  "nav.world.finance": "Finance",
  "nav.world.admin": "Administration",
  "nav.worldsLabel": "Sections",
  "nav.backTo": "Back to {{module}}",
  "nav.comingSoon": "coming soon",
  "nav.placeholderTitle": "{{module}} is still being built",
  "nav.favorites": "Favourites",
  "nav.favoriteAdd": "Add to favourites",
  "nav.favoriteRemove": "Remove from favourites",
  "nav.favoritesFull": "You already have {{count}} favourites: remove one first",
  "nav.favoritesHint": "Star a screen in the menu and it appears here",
  "nav.favoriteDragHint": "{{screen}} — drag to change the order",
  "nav.setup": "Setup",
  "nav.waiting": "{{count}} waiting",
  "nav.group.orders": "Orders",
  "nav.group.planning": "Planning",
  "nav.group.documents": "Documents",
  "nav.group.resources": "Resources",
  "nav.group.execution": "Operations",
  "nav.group.stock": "Stock",
  "nav.group.relations": "Relations",
  "nav.group.locations": "Locations",
  "nav.group.invoicing": "Invoicing",
  "nav.group.prices": "Prices",
  "nav.group.purchasing": "Purchasing",
  "nav.group.system": "System",
  "nav.group.project": "Project",
  "nav.orderIntake": "Order intake",
  "nav.ordersBlocked": "Needs attention",
  "nav.ordersPrenotify": "Pre-notify",
  "nav.ordersPrices": "Price approval",
  "nav.transportOrders": "Transport orders",
  "nav.ordersDrafts": "Drafts",
  "nav.allDocuments": "All documents",
  // Navigation — the modules
  "nav.dashboard": "Day start",
  "nav.dossiers": "Dossiers",
  "nav.documents": "Documents",
  "nav.palletCheck": "Pallet check",
  "nav.documentCheck": "Document check",
  "nav.missingCmrs": "Missing CMRs",
  "nav.reservations": "Reservations",
  "nav.tasks": "Tasks",
  "nav.mail": "Mail",
  "nav.calendar": "Calendar",
  "nav.users": "Users",
  "nav.orders": "Orders",
  "nav.warehouseOrders": "Warehouse orders",
  "nav.standingOrders": "Standing orders",
  "nav.carryOver": "Carry over",
  "carryOver.tab.notIn": "Not in",
  "carryOver.tab.done": "Carried over",
  "carryOver.unloadDay": "Unloading day",
  "carryOver.intro": "Hager's orders for this unloading day of which not every collo was scanned in at Haps. When nothing is in and nothing is missing, the whole order goes to the next delivery day; otherwise the colli that are not in go onto a new order, and the rest stays on this day. A collo reported missing at the receipt does not go along.",
  "carryOver.carry_one": "Carry {{count}} order over",
  "carryOver.carry_other": "Carry {{count}} orders over",
  "carryOver.busy": "Carrying over…",
  "carryOver.pickAll": "Select all",
  "carryOver.col.order": "Order",
  "carryOver.col.reference": "Reference",
  "carryOver.col.in": "In",
  "carryOver.col.missing": "Not in",
  "carryOver.col.trip": "Trip",
  "carryOver.col.kind": "Carry over",
  "carryOver.col.toDay": "To unloading day",
  "carryOver.col.place": "Consignee",
  "carryOver.col.colli": "Colli",
  "carryOver.col.manco": "Missing",
  "carryOver.mancosAt": "Missing colli from Scoretrace updated at {{at}}; they stay on the order.",
  "carryOver.mancosNever": "No missing colli received from Scoretrace yet.",
  "carryOver.inOf": "{{in}} of {{total}}",
  "carryOver.more": "+{{count}}",
  "carryOver.kind.order": "Whole order",
  "carryOver.kind.split": "Part to a new order",
  "carryOver.deliveryDays": "Delivered on {{days}}",
  "carryOver.none": "Everything of Hager's for {{day}} is in.",
  "carryOver.result_one": "{{count}} order carried over, {{colli}} colli.",
  "carryOver.result_other": "{{count}} orders carried over, {{colli}} colli.",
  "carryOver.resultSplit": "{{number}}: {{colli}} colli to {{newNumber}}, {{day}}",
  "carryOver.resultMoved": "{{number}}: whole order to {{day}}",
  "carryOver.resultSkipped": "{{number}} not carried over: {{reason}}",
  "carryOver.reason.all_in": "everything is in by now",
  "carryOver.reason.not_on_day": "the order no longer unloads on this day",
  "carryOver.reason.closed": "the order is closed",
  "carryOver.reason.to_day_not_after": "the new unloading day is not after this day",
  "carryOver.reason.colli_changed": "a collo was scanned in meanwhile; try again",
  "carryOver.reason.failed": "something went wrong",
  "carryOver.mailedTo": "Mailed to {{to}}",
  "carryOver.notMailed": "Not mailed (no address set)",
  "carryOver.mailFailed": "Mail failed: {{error}}",
  "carryOver.showDone": "See what was carried over",
  "carryOver.doneIntro": "What was carried over in the last two weeks, per click. The CSV is what the warehouse in Haps got.",
  "carryOver.noneDone": "Nothing carried over yet.",
  "carryOver.batchTitle": "Unloading day {{day}}",
  "carryOver.batchBy": "{{at}} by {{by}} · {{orders}} orders · {{colli}} colli",
  "carryOver.mailAgain": "Mail again",
  "carryOver.csv": "CSV",
  "nav.planning": "Planning board",
  "nav.trips": "Trips",
  "nav.tracking": "Trip follow-up",
  "nav.exceptions": "Exceptions",
  "nav.drivers": "Drivers",
  "nav.transportUnits": "Transport units",
  "nav.locations": "Locations",
  "nav.mailboxes": "Mailboxes",
  "nav.resources": "Reservation resources",
  "nav.taskCategories": "Task categories",
  "nav.focusAreas": "Focus areas",
  "focus.empty": "No focus areas yet — everyone sees all mail.",
  "focus.create": "Add focus area",
  "focus.nameLabel": "Focus area name",
  "focus.namePlaceholder": "e.g. Customer service 1",
  "focus.delete": "Delete",
  "focus.deleteConfirm": "Delete this focus area? Its assigned domains go back into everyone's list.",
  "error.crashTitle": "Something went wrong",
  "error.crashBody":
    "This screen could not be loaded. Try again, or go back to the start. If it keeps happening, let us know what you were doing.",
  "error.notFoundTitle": "This page does not exist",
  "error.notFoundBody": "The link may be out of date, or there is a typo in the address.",
  "error.backToStart": "Back to start",
  "error.reload": "Try again",
  "focus.noMembersWarning": "Nobody assigned. The domains below therefore filter nothing: that mail stays in everyone's list.",
  "focus.noRulesWarning": "No domains assigned. Anyone picking this area sees everything except what belongs to the other areas.",
  "focus.members": "Who may work in it",
  "focus.noMembers": "Nobody assigned yet.",
  "focus.addMemberLabel": "Add a person",
  "focus.addMemberPlaceholder": "Pick a person…",
  "focus.add": "Add",
  "focus.rules": "Domains & addresses",
  "focus.noRules": "No domains assigned yet.",
  "focus.rulePlaceholder": "e.g. axxent.nl or jan@klant.nl",
  "focus.addRuleLabel": "Add domain or address",
  "focus.removeRule": "Remove {{pattern}}",
  "focus.kindDomain": "domain",
  "focus.kindAddress": "address",
  "nav.performance": "Speed",
  "perf.since": "Measured since {{when}} (since the API started or since Start over)",
  "perf.over_one": "{{count}} route over its budget",
  "perf.over_other": "{{count}} routes over their budget",
  "perf.allWithin": "everything within its budget",
  "perf.search": "Search a route",
  "perf.reset": "Start over",
  "perf.col.route": "Route",
  "perf.col.count": "Calls",
  "perf.col.average": "Average",
  "perf.col.p50": "Median",
  "perf.col.p95": "95%",
  "perf.col.max": "Slowest",
  "perf.col.budget": "Budget",
  "perf.col.slow": "Too slow",
  "perf.none": "Nothing measured yet.",
  "perf.slowRequests": "Last slow requests",
  "perf.slowQueries": "Last slow database queries (over 200 ms)",
  "perf.noSlowRequests": "No request over its budget.",
  "perf.noSlowQueries": "No slow query.",
  "perf.footnote": "Budget: the scanner 200 ms (under 200 ms it shows no loading bar), the rest a second. Median and 95% are upper bounds from fixed steps. Each API process measures for itself; a restart starts over. Slow requests and queries are also warnings in the log.",
  "nav.permissions": "Permissions",
  "nav.parties": "Relations",
  "nav.branches": "Branches",
  "nav.integrations": "Integrations",
  // Permissions matrix (Beheer → Rechten)
  "perm.modDashboard": "Day start",
  "perm.modMail": "Mail",
  "perm.modMailPersonal": "Own mailbox",
  "perm.modCalendar": "Calendar",
  "perm.modTasks": "Tasks",
  "perm.modReservations": "Reservations",
  "perm.modParties": "Relations",
  "perm.modDossiers": "Dossiers",
  "perm.modDocuments": "Documents",
  "perm.modRequirements": "Requirements",
  "perm.modAi": "AI assistants",
  "perm.modWorklists": "Work lists",
  "perm.modTmsLocations": "Locations",
  "perm.modTmsDrivers": "Drivers",
  "perm.modTmsTransportUnits": "Transport units",
  "perm.modTmsResourcesWrite": "Manage resources",
  "perm.colPart": "Part",
  "perm.search": "Search a part",
  "perm.worldLabel": "World",
  "perm.group.all": "All",
  "perm.group.other": "Other",
  "perm.none": "No part found.",
  "perm.level.read": "View",
  "perm.level.write": "Change",
  "perm.writeImpliesRead": "Change includes View.",
  "perm.adminAll": "always everything",
  "perm.row.orders": "Orders",
  "perm.row.planning": "Planning board and trips",
  "perm.row.stock": "Stock",
  "perm.row.stockBook": "Write off and increase",
  "perm.row.inbound": "Receipts",
  "perm.row.outbound": "Orders and shipping",
  "perm.row.crossdock": "Crossdock",
  "perm.row.masterdata": "Places and articles",
  "perm.hint.mail": "The shared mailboxes someone is a member of",
  "perm.hint.mailPersonal": "Connect the own Outlook mailbox and calendar",
  "perm.hint.orders": "Change: enter, accept and reject",
  "perm.hint.planning": "Change: make trips and plan consignments onto them",
  "perm.hint.resourcesWrite": "Create and change transport units, and drivers' qualifications",
  "perm.hint.parties": "Change: the fields WLX manages itself; the rest comes from AFAS",
  "perm.hint.stock": "Change: block and release pallets, adjust quantities and lost & found",
  "perm.hint.stockBook": "Change the customer's stock: write off and increase, with the reason for the customer",
  "perm.hint.inbound": "Change: announce, close and the own labels",
  "perm.hint.outbound": "Change: link an address, cancel, shipping form and carrier",
  "perm.hint.crossdock": "Change: dock, unloaded and loaded",
  "perm.hint.masterdata": "Change: add and block places and articles; the settings stay with admins",
  "perm.hint.scanner": "Sign in and scan in the scanner app",
  "perm.hint.scannerLogins": "Reset a password, lock and turn off; for now only an admin creates one",
  "perm.hint.partnerUsers": "Invite people of a customer to the customer portal, set their access up again and turn them off (tab Portal on a relation)",
  "perm.toggleLabel": "{{role}} access to {{module}}",
  "perm.footnote":
    "Administration (users, permissions, mailboxes, resources) always stays admin-only. Mail and tasks of a shared mailbox additionally require membership of that mailbox.",
  "nav.requirements": "Requirements",
  "nav.worklists": "Work lists",
  "nav.diesel": "Diesel",
  "nav.invoices": "Invoices",
  "nav.warehouseBilling": "Warehouse",
  "nav.tariffs": "Tariffs",
  "nav.purchaseInvoices": "Purchase invoices",
  "perm.row.billing": "Invoicing",
  "perm.hint.billing": "Change: the invoice run, holding, finalising and crediting invoices, the numbering, the diesel price and the methods",
  "perm.row.purchaseInvoices": "Purchase invoices",
  "perm.hint.purchaseInvoices": "Change: add a pdf, fill in and code the invoice, and send it to AFAS. Approving is done in AFAS",
  "perm.row.agreementsWrite": "Change price agreements",
  "perm.row.agreementsApprove": "Approve price agreements",
  "perm.hint.agreementsWrite": "Change a price agreement in a draft with a start date, run a trial calculation, offer it for approval, and raise prices by a percentage",
  "perm.hint.agreementsApprove": "Approve or reject a changed price agreement; never one you changed yourself",
  "diesel.tab.months": "Per month",
  "diesel.tab.prices": "Prices",
  "diesel.tab.methods": "Methods",
  "diesel.monthsIntro": "Per unloading month the diesel surcharge percentage of each method, from the average of the month before. Italic: provisional, the last known one.",
  "diesel.allMethods": "Also methods without customers",
  "diesel.colUnloading": "Unloading in",
  "diesel.colAverage": "Average of the month before",
  "diesel.provisional": "Provisional: the average of {{month}}, until the month before is over",
  "diesel.previousMonth": "month before",
  "diesel.sameMonth": "same month",
  "diesel.summarySteps": "base € {{base}} · step € {{step}} · {{rounding}} · {{month}}",
  "diesel.summaryLinear": "base € {{base}} · {{perEuro}} % per euro · plus {{offset}} % · {{month}}",
  "diesel.kindSteps": "In steps",
  "diesel.kindLinear": "Linear",
  "diesel.kindManual": "By hand",
  "diesel.roundingDown": "down to whole percents",
  "diesel.roundingTenth": "to a tenth",
  "diesel.roundingUp": "up to whole percents",
  "diesel.pricesIntro": "The diesel price as Van Kessel mails it, in cents per litre. A price holds from its day until the next; the monthly average counts every calendar day.",
  "diesel.colFrom": "From",
  "diesel.colTo": "Up to and including",
  "diesel.colPrice": "Price (ct/l)",
  "diesel.colNote": "Note",
  "diesel.colChangedBy": "By",
  "diesel.addPrice": "Add price",
  "diesel.priceRequired": "Fill in a price, in cents per litre.",
  "diesel.deletePriceConfirm": "Remove the price from {{date}}? The price before it then carries on.",
  "diesel.pricesShown": "The last {{shown}} of {{count}} prices.",
  "diesel.methodsIntro": "A method turns the monthly average into the percentage; on the relation card you choose a customer's method.",
  "diesel.newMethod": "New method",
  "diesel.colName": "Name",
  "diesel.colKind": "Kind",
  "diesel.colRule": "Rule",
  "diesel.colCustomers": "Customers",
  "diesel.colStatus": "Status",
  "diesel.colPercent": "Percentage",
  "diesel.groupNumber": "group {{group}}",
  "diesel.active": "Active",
  "diesel.inactive": "No longer in use",
  "diesel.basePrice": "Base price (€ per litre)",
  "diesel.step": "Step (€ per litre for 1 %)",
  "diesel.rounding": "Rounding",
  "diesel.minimum": "Minimum (%)",
  "diesel.perEuro": "Percent per euro above the base",
  "diesel.offset": "Percent at the base price",
  "diesel.sameMonthLabel": "The average of the unloading month itself, not of the month before (as AEEA)",
  "diesel.activeLabel": "In use",
  "diesel.manualRates": "The customer's percentages",
  "diesel.manualRatesHelp": "What the customer passes on, for unloading dates from and to. After the last one it carries on until there is a new one.",
  "diesel.addRate": "Add percentage",
  "diesel.percentRequired": "Fill in a percentage.",
  "parties.cmrTitle": "CMR",
  "parties.cmrPrintLabel": "Print the CMR",
  "parties.cmrPrintHelp": "Off: the sender makes its own CMR, and WLX prints none with the trip.",
  "parties.cmrGoodsLinesLabel": "Goods lines on the CMR",
  "parties.cmrGoodsLinesHelp": "A line per handling unit with SSCC, content, batch and quantity. Off: a line per kind of carrier.",
  "parties.cmrCombineLabel": "More consignments on one CMR",
  "parties.deliveryNotePrintLabel": "Delivery note when printing trips",
  "parties.deliveryNotePrintHelp": "Behind the CMR of a consignment that loads in Haps, the delivery note from the WMS, as the warehouse prints it.",
  "parties.cmrCombineHelp": "The consignments a trip unloads at the same address at the same time, together on one CMR under the number of the first. Its scan goes to every consignment on it.",
  "parties.cmrSenderLabel": "Fixed sender (box 1)",
  "parties.cmrSenderHelp": "Empty: the loading address is the sender on the CMR.",
  "parties.cmrSenderNone": "The loading address",
  "parties.cmrSenderClear": "Remove",
  "parties.cmrRemarkLabel": "Remark on the CMR",
  "parties.cmrRemarkHelp": "On every CMR of this customer, for instance about exchanging pallets.",
  "parties.tripReportTitle": "Trip report",
  "parties.tripReportLabel": "Trip report (IFCSUM)",
  "parties.tripReportHelp": "Which of this customer's consignments are one trip, with the customer's place codes. Before: an order of this customer waits in Needs attention, order entry makes the trip and sends it, and the trip number the customer sends back becomes the trip mark. Afterwards: per trip, WLX sends it by itself once the trip is over.",
  "parties.tripReportNone": "None",
  "parties.tripReportBefore": "Before, from Needs attention",
  "parties.tripReportAfter": "Afterwards, by itself after the trip",
  "parties.dossiersTitle": "Dossiers and documents",
  "parties.dossierPerOrderLabel": "A dossier per order",
  "parties.dossierPerOrderHelp": "By default this customer's orders with the same reference share one dossier: the transport order, the warehouse orders and the order in the WMS. Turn this on when this customer reuses its references; then every order gets a dossier of its own.",
  "parties.dossiersWithLabel": "Dossiers shared with",
  "parties.dossiersWithHelp": "The same customer under another VR number, such as the warehouse orders on one and the transport orders on the other. Their orders with the same reference go into one dossier, on the relation of the first order. It holds for both sides.",
  "parties.dossiersWithNone": "None",
  "parties.dossiersWithRemove": "Remove",
  "parties.pendelWithLabel": "Factory shuttles together with",
  "parties.pendelWithHelp": "The same customer under another VR number for factory shuttles, for instance the deliveries on one and the shuttles back on the other. Where no shuttle schedule covers them, planning puts their factory shuttles back and forth on one trip together. It holds for both sides.",
  "parties.dossiersWithPerOrder": "A dossier per order: shares nothing",
  "parties.cargosnapLabel": "Scanned CMR to Cargosnap",
  "parties.cargosnapHelp": "A scanned CMR or warehouse set in a dossier of this customer goes to Cargosnap when the warehouse loaded the order with Cargosnap.",
  "parties.dieselMethodLabel": "Diesel method",
  "parties.dieselMethodHelp": "How this customer's diesel surcharge percentage is set (Commercie → Diesel). Empty: the percentages of the surcharge group.",
  "parties.dieselMethodNone": "None",
  "parties.invoiceRhythmLabel": "Invoice rhythm",
  "parties.invoiceRhythmHelp": "How often this customer is invoiced. Weekly is Monday to Sunday, monthly the calendar month; what is ready later goes on the next one.",
  "parties.invoiceSplitLabel": "Split the collective invoice",
  "parties.invoiceSplitNone": "Do not split",
  "parties.invoiceSplitReference": "Per invoice reference",
  "parties.invoiceLanguageLabel": "Invoice language",
  "parties.invoiceLanguageHelp": "The language of the invoice and its mail. Not the country: a customer in the Netherlands may want an English invoice.",
  "parties.invoiceLanguageNl": "Dutch",
  "parties.invoiceLanguageEn": "English",
  "parties.invoiceSpecificationLabel": "Specification (csv) with the invoice",
  "parties.invoiceSpecificationHelp": "With the invoice mail a csv with per consignment the loading and unloading details and the amounts, in fixed columns.",
  "parties.invoiceAttachCmrLabel": "Signed CMRs with the invoice",
  "parties.invoiceAttachCmrHelp": "Works once the signed CMRs from Scansys are in WLX; until then the invoice goes without them.",
  "parties.transportViaWarehouseLabel": "Transport on the warehouse invoice",
  "parties.transportViaWarehouseHelp": "This customer's transport is on the invoice of the warehouse week. Its consignments get no invoice of their own and are not listed as not invoiceable; one with a price by hand is.",

  // Commerce → Invoices (docs/tms-facturatie.md §18)
  "invoices.until": "Up to and including",
  "invoices.run": "Make proposal",
  "invoices.running": "Working…",
  "invoices.runHelp": "Makes the proposals again from what is unloaded and priced up to that day, per customer in their rhythm. Held invoices stay as they are.",
  "invoices.ranSummary_one": "1 proposal, {{net}} net in all, up to {{until}}. {{held}} held, {{blocked}} consignments not to invoice yet.",
  "invoices.ranSummary_other": "{{count}} proposals, {{net}} net in all, up to {{until}}. {{held}} held, {{blocked}} consignments not to invoice yet.",
  "invoices.tab.proposals": "Proposal",
  "invoices.tab.final": "Final",
  "invoices.tab.blocked": "Not to invoice yet",
  "invoices.tab.numbers": "Numbering",
  "invoices.search": "Search by customer, debtor number, number or reference",
  "invoices.proposalCount_one": "1 proposal, {{net}} net",
  "invoices.proposalCount_other": "{{count}} proposals, {{net}} net",
  "invoices.finalizeConfirm_one": "Make this invoice final dated {{date}}? It gets a number and does not change after that.",
  "invoices.finalizeConfirm_other": "Make {{count}} invoices final dated {{date}}? They get a number and do not change after that.",
  "invoices.finalizedOne": "{{name}}: invoice {{number}}",
  "invoices.failedOne": "{{name}}: not final. {{reason}}",
  "invoices.finalizePicked": "Make final ({{count}})",
  "invoices.noProposals": "No proposals. Make a proposal up to a day.",
  "invoices.pickAll": "Pick all proposals",
  "invoices.colCustomer": "Customer",
  "invoices.colRhythm": "Rhythm",
  "invoices.colPeriod": "Period",
  "invoices.colReference": "Reference",
  "invoices.colLines": "Lines",
  "invoices.colNet": "Net",
  "invoices.colGross": "Total",
  "invoices.colStatus": "Status",
  "invoices.colNumber": "Number",
  "invoices.colDate": "Invoice date",
  "invoices.colDue": "Due date",
  "invoices.colUnloaded": "Unloaded",
  "invoices.colOrder": "Consignment",
  "invoices.colRoute": "From → to",
  "invoices.colDescription": "Description",
  "invoices.colQuantity": "Quantity",
  "invoices.colPrice": "Price",
  "invoices.colAmount": "Amount",
  "invoices.colVat": "VAT",
  "invoices.colLedger": "Ledger",
  "invoices.colReason": "Why not yet",
  "invoices.creditOf": "credit of {{number}}",
  "invoices.rhythm.per_order": "Per order",
  "invoices.rhythm.weekly": "Weekly",
  "invoices.rhythm.monthly": "Monthly",
  "invoices.warehouseWork": "Warehouse, per week or month",
  "invoices.status.draft": "Proposal",
  "invoices.status.held": "Held",
  "invoices.status.final": "Final",
  "invoices.noFinals": "No final invoices yet.",
  "invoices.dueUnknown": "Payment term unknown",
  "invoices.invoiceTitle": "Invoice {{number}}",
  "invoices.creditTitle": "Credit invoice {{number}}",
  "invoices.draftTitle": "Proposal",
  "invoices.draftCreditTitle": "Proposed credit invoice",
  "invoices.hold": "Hold",
  "invoices.holdPrompt": "Why do you hold this invoice? May be empty.",
  "invoices.release": "Release",
  "invoices.deleteCreditConfirm": "Throw this proposed credit invoice away?",
  "invoices.finalize": "Make final",
  "invoices.credit": "Credit",
  "invoices.creditConfirm_one": "Make a credit invoice for 1 consignment of invoice {{number}}? First as a proposal.",
  "invoices.creditConfirm_other": "Make a credit invoice for {{count}} consignments of invoice {{number}}? First as a proposal.",
  "invoices.creditPick": "{{count}} of {{of}} consignments picked to credit",
  "invoices.reinvoiceLabel": "Invoice again",
  "invoices.reinvoiceHelp": "The consignments are priced again and the next run invoices them again: to put a price right.",
  "invoices.closeHelp": "The consignments are not invoiced again: after damage or a goodwill gesture, for instance.",
  "invoices.makeCredit": "Make credit invoice ({{count}})",
  "invoices.afterCredit": "After crediting",
  "invoices.reinvoiced": "invoice again",
  "invoices.closed": "closed",
  "invoices.creditedMark": "credited",
  "invoices.selfBilling": "Self-billing",
  "invoices.selfBillingHelp": "The customer makes the invoice; this one is to compare with theirs.",
  "invoices.heldBy": "Held by {{name}}: {{reason}}",
  "invoices.noReason": "no reason given",
  "invoices.days_one": "{{count}} day",
  "invoices.days_other": "{{count}} days",
  "invoices.creditsLabel": "Credits invoice",
  "invoices.creditedBy": "Credited by",
  "invoices.billTo": "Invoice address",
  "invoices.finalizedBy": "Made final by",
  "invoices.totalNet": "Total net",
  "invoices.vatOver": "VAT {{percent}} % on {{base}}",
  "invoices.totalGross": "Total",
  "invoices.blockedIntro": "Unloaded up to {{until}} and not to put on an invoice yet. Solve the reason and the next run takes the consignment.",
  "invoices.noBlocked": "Nothing: everything unloaded can go on an invoice.",
  "invoices.reason.not_rated": "No tariff worked out yet",
  "invoices.reason.review": "The tariff needs a look (tab Tariff on the order)",
  "invoices.reason.no_account": "No debtor for this customer",
  "invoices.reason.no_agreement": "No price agreement",
  "invoices.reason.nothing_applies": "No line of the billing method fits",
  "invoices.reason.awaiting_approval": "The price was set by hand and awaits planning's approval",
  "invoices.reason.rating_queued": "The tariff is being worked out again",
  "invoices.reason.no_ledger": "A line has no ledger account (surcharge code, price agreement or tariff)",
  "invoices.reason.diesel_provisional": "The diesel surcharge is still provisional: the month is not over",
  "invoices.reason.reference_missing": "The customer wants a reference and the order has none",
  "invoices.reason.order_incomplete": "Invoiced per order, and the order is not complete yet",
  "invoices.numbersIntro": "Where a year's invoice numbers carry on: two digits of the year and six of the sequence.",
  "invoices.year": "Year",
  "invoices.nextSequence": "Next sequence number",
  "invoices.nextNumberIs": "The next invoice gets {{number}}",
  "invoices.noSeries": "No numbering set yet: making an invoice final waits for it.",
  "invoices.nextNumber": "Next number",
  "invoices.lastNumber": "Last given",
  "invoices.error.INVOICE_STALE": "Something changed since the proposal, a tariff or a consignment. Make the proposal again.",
  "invoices.error.NO_NUMBER_SERIES": "There is no numbering for {{year}} yet. Set it under Numbering.",
  "invoices.error.INVOICE_HELD": "This invoice is held. Release it first.",
  "invoices.error.INVOICE_NOT_DRAFT": "This invoice is final already.",
  "invoices.error.INVOICE_NOT_HELD": "This invoice is not held.",
  "invoices.error.INVOICE_NOT_FINAL": "Only a final invoice can be credited.",
  "invoices.error.INVOICE_CREDITED": "Everything on this invoice is credited already.",
  "invoices.error.CONSIGNMENT_CREDITED": "One of the consignments is credited already.",
  "invoices.error.NOT_ON_INVOICE": "One of the consignments is not on this invoice.",
  "invoices.referenceEdit": "Change",
  "invoices.referencePrompt": "The invoice reference, a PO number for instance. The next run keeps it; empty puts back the week or the month.",
  "invoices.pdfLabel": "PDF",
  "invoices.mailLabel": "Mail",
  "invoices.bookingLabel": "AFAS",
  "invoices.pdf.none": "Not asked for",
  "invoices.pdf.requested": "Being made",
  "invoices.pdf.ready": "Ready",
  "invoices.pdf.failed": "Failed",
  "invoices.pdfView": "View",
  "invoices.specificationDownload": "Specification (csv)",
  "invoices.invoiceFromLabel": "Invoice from",
  "invoices.invoiceFromHelp": "The unloading day from which WLX invoices. What was unloaded before goes on no proposal. Empty: everything in WLX.",
  // Commercie → Tarieven (docs/tms-facturatie.md §24).
  "tariffs.tab.customers": "Per customer",
  "tariffs.tab.tariffs": "Tariffs",
  "tariffs.tab.surcharges": "Surcharges",
  "tariffs.agreement.edit.error.LAST_RATE": "A surcharge keeps at least one percentage.",
  "warehouse.tab.weeks": "Weeks",
  "warehouse.tab.agreements": "Price lists",
  "warehouse.status.none": "Not made yet",
  "warehouse.status.open": "Open",
  "warehouse.status.ready": "Ready",
  "warehouse.status.invoiced": "Invoiced",
  "warehouse.status.credited": "Credited",
  "warehouse.state.running": "Running",
  "warehouse.state.future": "Starts later",
  "warehouse.state.ended": "Ended",
  "warehouse.rhythmLabel": "Rhythm",
  "warehouse.rhythm.weekly": "Week",
  "warehouse.rhythm.monthly": "Month",
  "warehouse.colChange": "Change",
  "warehouse.change.none": "None",
  "warehouse.change.new": "New, waits for approval",
  "warehouse.change.submitted": "Waits for approval",
  "warehouse.change.rejected": "Sent back",
  "warehouse.change.waits": "{{name}} offered a change on {{date}}; it holds once a second person approves it.",
  "warehouse.change.waitsNew": "New price list by {{name}} ({{date}}): weeks are made of it once a second person approves it.",
  "warehouse.change.rejectedBy": "Sent back by {{name}}: {{reason}}",
  "warehouse.change.heading": "heading",
  "warehouse.change.added": "New: {{line}} ({{value}})",
  "warehouse.change.removed": "Removed: {{line}}",
  "warehouse.change.changed": "{{line}}: {{what}}",
  "warehouse.change.details": "ledger, activity, branch, VAT or surcharge",
  "warehouse.change.approve": "Approve",
  "warehouse.change.reject": "Send back",
  "warehouse.change.sendBack": "Send back with this reason",
  "warehouse.change.reason": "Why",
  "warehouse.change.notYours": "You worked on this change yourself: somebody else approves it.",
  "warehouse.change.withdraw": "Take the change back",
  "warehouse.change.offer": "Offer the change",
  "warehouse.change.saveAndOffer": "Save and offer",
  "warehouse.change.help": "A change holds once a second person approves it (with the right to approve price agreements, never whoever worked on it).",
  "warehouse.error.NO_CHANGE": "No change waits for approval.",
  "warehouse.error.CHANGE_OWN": "You worked on this change yourself: somebody else approves it.",
  "warehouse.colCustomer": "Customer",
  "warehouse.colDebtor": "Debtor",
  "warehouse.colAgreement": "Price list",
  "warehouse.colPeriod": "Period",
  "warehouse.colFilled": "Filled in",
  "warehouse.colNet": "Amount",
  "warehouse.colInvoice": "Invoice",
  "warehouse.colRhythm": "Rhythm",
  "warehouse.colFrom": "From",
  "warehouse.colTo": "Up to",
  "warehouse.colLines": "Lines",
  "warehouse.colWeeks": "Weeks",
  "warehouse.invoiceDraft": "proposal",
  "warehouse.previous": "Previous period",
  "warehouse.next": "Next period",
  "warehouse.pending": "Everything still open",
  "warehouse.pendingTitle": "Open and ready, of any period",
  "warehouse.makeWeeks_zero": "Make weeks",
  "warehouse.makeWeeks_one": "Make 1 week",
  "warehouse.makeWeeks_other": "Make {{count}} weeks",
  "warehouse.noAgreements": "No price list for this period.",
  "warehouse.nothingPending": "Nothing is open any more.",
  "warehouse.per": "Per",
  "warehouse.ledger": "Ledger",
  "warehouse.axis1": "Activity",
  "warehouse.axis2": "Branch",
  "warehouse.vat": "VAT",
  "warehouse.surcharges": "Surcharges over it",
  "warehouse.surchargesShort": "Surcharge",
  "warehouse.week.helpOpen": "Type the quantities of this period in; Enter or arrow down goes to the next line, and what you type is saved at once. A fixed line fills itself. Setting it ready works the surcharge out; the next invoice run makes an invoice of it.",
  "warehouse.week.helpReady": "Ready: the next invoice run makes an invoice of it. To change something, set the week back to open.",
  "warehouse.week.helpDone": "This week is on an invoice.",
  "warehouse.week.colDescription": "Description",
  "warehouse.week.colQuantity": "Quantity",
  "warehouse.week.colUnit": "Unit",
  "warehouse.week.colPrice": "Price",
  "warehouse.week.colAmount": "Amount",
  "warehouse.week.colLedger": "Ledger · activity · branch",
  "warehouse.week.quantityOf": "Quantity {{line}}",
  "warehouse.week.headingOf": "Heading {{line}}",
  "warehouse.week.amountOf": "Amount {{line}}",
  "warehouse.week.byHand": "added",
  "warehouse.week.withSurcharges": "with surcharges",
  "warehouse.week.total": "Total",
  "warehouse.week.saving": "saving…",
  "warehouse.week.notSaved": "Not everything was saved; check the quantities.",
  "warehouse.week.noRate": "Surcharge {{surcharge}} has no percentage on {{date}} and is left off.",
  "warehouse.week.ready": "Set ready",
  "warehouse.week.addLine": "Add a line",
  "warehouse.week.handLine": "Line by hand",
  "warehouse.week.edit": "Change",
  "warehouse.week.refresh": "Again from the price list",
  "warehouse.week.refreshHelp": "Takes the prices and lines of the price list as it is now; what you typed and added stays.",
  "warehouse.week.delete": "Delete week",
  "warehouse.week.deleteSure": "Sure? Delete",
  "warehouse.week.reopen": "Set back to open",
  "warehouse.week.reason": "Why (for the log)",
  "warehouse.agreements.intro": "Per customer a price list per invoice it gets: a warehouse or a department. A week made already keeps its prices.",
  "warehouse.agreements.none": "No price list yet.",
  "warehouse.agreements.alsoEnded": "Also ended",
  "warehouse.agreements.new": "New price list",
  "warehouse.agreements.newTitle": "New price list",
  "warehouse.agreements.weeksMade_zero": "No week made yet",
  "warehouse.agreements.weeksMade_one": "1 week made",
  "warehouse.agreements.weeksMade_other": "{{count}} weeks made",
  "warehouse.agreements.reference": "On the invoice and in AFAS",
  "warehouse.agreements.referencePlaceholder": "Weekly invoice warehousing DC Haps",
  "warehouse.agreements.note": "Note",
  "warehouse.agreements.remarks": "Text lines on the invoice",
  "warehouse.agreements.remarksPlaceholder": "Reference: cost centre or PO number\nFor the attention of …",
  "warehouse.agreements.quantity": "Quantity",
  "warehouse.agreements.byHand": "By hand",
  "warehouse.agreements.fixed": "Fixed",
  "warehouse.agreements.amount": "Amount each time",
  "warehouse.agreements.fixedQuantity": "Fixed quantity",
  "warehouse.agreements.headingPlaceholder": "Heading, for instance DC Rijkevoort",
  "warehouse.agreements.up": "Up",
  "warehouse.agreements.down": "Down",
  "warehouse.agreements.addLine": "Add a line",
  "warehouse.agreements.addHeading": "Add a heading",
  "warehouse.agreements.delete": "Delete price list",
  "warehouse.agreements.deleteSure": "Sure? Delete",
  "warehouse.agreements.customerRequired": "Choose a customer.",
  "warehouse.agreements.nameRequired": "Give the price list a name.",
  "warehouse.agreements.pricesHelp": "A changed price holds for the weeks made after this. An open week takes it over with *Again from the price list*.",
  "warehouse.error.NO_ACCOUNT": "This relation has no debtor account: choose a customer.",
  "warehouse.error.HAS_WEEKS": "This price list has weeks: it cannot be deleted and keeps its customer. Give it an end date.",
  "warehouse.error.WEEK_NOT_OPEN": "This week is no longer open.",
  "warehouse.error.WEEK_NOT_READY": "Only a ready week can go back to open.",
  "warehouse.error.WEEK_ON_INVOICE": "This week is on an invoice that is held or final.",
  "warehouse.error.NOT_A_LINE": "A heading takes no quantity.",
  "warehouse.error.NOT_BY_HAND": "Only a line added by hand can be changed whole or taken off.",
  "warehouse.error.EMPTY_WEEK": "Nothing on this week has an amount yet.",
  "warehouse.error.NO_LEDGER": "The line {{description}} has no ledger.",
  "surcharges.intro": "Every surcharge's percentage over time. A new percentage from a date prices the open orders from that day again.",
  "surcharges.alsoInactive": "Also inactive",
  "surcharges.colGroup": "Surcharge group",
  "surcharges.colKind": "Kind",
  "surcharges.colSince": "Since",
  "surcharges.colNext": "Next",
  "surcharges.colCustomers": "Customers",
  "surcharges.colFrom": "From",
  "surcharges.colTo": "Up to",
  "surcharges.colPercent": "Percentage",
  "surcharges.kind.levy": "Road toll",
  "surcharges.kind.levyIn": "Road toll {{country}}",
  "surcharges.kind.diesel": "Diesel",
  "surcharges.kind.discount": "Discount",
  "surcharges.kind.other": "Surcharge",
  "surcharges.nextFrom": "{{percent}} from {{date}}",
  "surcharges.drawerTitle": "Surcharge {{code}}",
  "surcharges.ledger": "ledger {{account}}",
  "surcharges.vat": "VAT {{code}}",
  "surcharges.help.levy": "Comes over the freight and the extras of customers whose price agreement carries all surcharges, when unloading in {{country}}.",
  "surcharges.help.diesel": "Customers with a diesel method get their method's percentage (Commercie → Diesel); this percentage holds for those without one.",
  "surcharges.help.other": "Comes over the freight and the extras of the customers in this surcharge group.",
  "surcharges.customers_zero": "At no customer now.",
  "surcharges.customers_one": "At 1 customer now.",
  "surcharges.customers_other": "At {{count}} customers now.",
  "surcharges.newRate": "New percentage",
  "surcharges.newRateHelp": "The percentage that held on that day runs to the day before. On the same day it replaces one that was there.",
  "surcharges.addRate": "Add percentage",
  "surcharges.percentRequired": "Enter a percentage.",
  "surcharges.noRates": "No percentage yet.",
  "surcharges.now": "now",
  "surcharges.removeSure": "Sure? Remove",
  "tariffs.tab.texts": "English texts",
  "tariffs.colDutch": "Dutch",
  "tariffs.colEnglish": "English",
  "tariffs.colUses": "On lines",
  "tariffs.textsIntro_one": "What an English customer's invoice says. Without an English text the Dutch stays; {{count}} text has none yet.",
  "tariffs.textsIntro_other": "What an English customer's invoice says. Without an English text the Dutch stays; {{count}} texts have none yet.",
  "tariffs.onlyMissing": "Only without English",
  "tariffs.noEnglish": "no English yet: the Dutch stays",
  "tariffs.sameInEnglish": "Same",
  "tariffs.sameInEnglishHelp": "It reads the same in English, as a route of place names does",
  "tariffs.saveFailed": "Not saved",
  "invoices.untranslated_one": "This customer gets an English invoice, but {{count}} line text has no English yet: {{texts}}.",
  "invoices.untranslated_other": "This customer gets an English invoice, but {{count}} line texts have no English yet: {{texts}}.",
  "invoices.untranslatedLink": "English texts",
  "tariffs.colCustomer": "Customer",
  "tariffs.colDebtor": "Customer no.",
  "tariffs.colReview": "To review",
  "tariffs.colRhythm": "Rhythm",
  "tariffs.colDiesel": "Diesel method",
  "tariffs.colSurchargeGroup": "Surcharge group",
  "tariffs.colZoneScheme": "Zone scheme",
  "tariffs.colAgreement": "Price agreement",
  "tariffs.agreement.freight": "Freight",
  "tariffs.agreement.colFrom": "From",
  "tariffs.agreement.colTo": "To",
  "tariffs.agreement.colCounts": "Priced on",
  "tariffs.agreement.colWhat": "What",
  "tariffs.agreement.colWhen": "When",
  "tariffs.agreement.noFreight": "No freight rules.",
  "tariffs.agreement.bothWays": "both ways",
  "tariffs.agreement.onlyWith": "only with {{code}}",
  "tariffs.agreement.perConsignment": "per consignment",
  "tariffs.agreement.extras": "Extras",
  "tariffs.agreement.noExtras": "No extras.",
  "tariffs.agreement.extra.window_loading": "Timed collection",
  "tariffs.agreement.extra.window_unloading": "Timed delivery",
  "tariffs.agreement.extra.waiting_hours": "Waiting hours",
  "tariffs.agreement.extra.saturday": "Saturday",
  "tariffs.agreement.extra.requirement": "Transport requirement",
  "tariffs.agreement.extra.pickup": "Collection",
  "tariffs.agreement.extra.other": "On conditions",
  "tariffs.agreement.when.window_loading": "the loading window is narrower than the opening hours",
  "tariffs.agreement.when.window_unloading": "the unloading window is narrower than the opening hours",
  "tariffs.agreement.when.waiting_hours": "waiting hours are recorded",
  "tariffs.agreement.when.saturday": "unloaded on a Saturday",
  "tariffs.agreement.when.requirement": "the consignment has {{code}}",
  "tariffs.agreement.when.pickup": "once per loading stop",
  "tariffs.agreement.when.other": "when everything below holds",
  "tariffs.agreement.surcharges.all": "Diesel and road toll",
  "tariffs.agreement.surcharges.diesel": "Diesel only",
  "tariffs.agreement.surcharges.none": "None",
  "tariffs.agreement.place.anywhere": "Anywhere",
  "tariffs.agreement.place.cityContains": "a city with \"{{value}}\"",
  "tariffs.agreement.place.postal": "postal code {{value}}…",
  "tariffs.agreement.place.zone": "rayon {{value}}",
  "tariffs.tab.changes": "Changes",
  "tariffs.colValidFrom": "Valid from",
  "tariffs.colFreight": "Freight rules",
  "tariffs.colExtras": "Extras",
  "tariffs.colEditors": "Changed by",
  "tariffs.colTrial": "Trial",
  "tariffs.agreement.state.active": "Active",
  "tariffs.agreement.state.concept": "Draft",
  "tariffs.agreement.state.submitted": "Awaiting approval",
  "tariffs.agreement.state.rejected": "Sent back",
  "tariffs.agreement.state.future": "Starts {{date}}",
  "tariffs.agreement.state.past": "Replaced",
  "tariffs.agreement.state.none": "None",
  "tariffs.agreement.conceptFrom": "Draft from {{date}}",
  "tariffs.agreement.fromTheStart": "from the start",
  "tariffs.agreement.version": "Version",
  "tariffs.agreement.versionFrom": "from {{date}}",
  "tariffs.agreement.versionStart": "first version",
  "tariffs.agreement.versionConcept": "draft from {{date}}",
  "tariffs.agreement.newVersion": "New version",
  "tariffs.agreement.newVersionHelp": "A new version starts as a copy of the agreement that holds on that day. You change it rule by rule, try it on a month that is over, and a second person approves it. Until that day the current version keeps pricing.",
  "tariffs.agreement.validFrom": "Starts on",
  "tariffs.agreement.note": "Why",
  "tariffs.agreement.notePlaceholder": "For example: new prices agreed with the customer",
  "tariffs.agreement.none": "This customer has no price agreement yet.",
  "tariffs.agreement.withdrawToChange": "This draft awaits approval. Take it back to change it further.",
  "tariffs.agreement.freightChip": "One rule per consignment: the most specific that fits",
  "tariffs.agreement.extrasChip": "Come on top when the consignment asks for them",
  "tariffs.agreement.surchargesTitle": "Surcharges",
  "tariffs.agreement.surchargesChip": "Over the freight and the extras",
  "tariffs.agreement.addRule": "Rule",
  "tariffs.agreement.addExtra": "Extra",
  "tariffs.agreement.colMinimum": "Minimum",
  "tariffs.agreement.colSurcharge": "Surcharge",
  "tariffs.agreement.colHow": "How",
  "tariffs.agreement.onlyIf": "only when:",
  "tariffs.agreement.onInvoice": "On the invoice: {{text}}",
  "tariffs.agreement.diesel": "Fuel surcharge",
  "tariffs.agreement.dieselByMethod": "diesel method {{method}}",
  "tariffs.agreement.dieselByGroup": "surcharge {{code}} of the surcharge group",
  "tariffs.agreement.levy": "Road toll",
  "tariffs.agreement.levyHow": "by itself, by the country of unloading",
  "tariffs.agreement.fromGroup": "of the surcharge group",
  "tariffs.agreement.noSurcharges": "No surcharges.",
  "tariffs.agreement.tie": "Rules {{a}} and {{b}} are as specific as each other and could both fit. WLX does not choose then: the consignment goes to review. Make one of them more specific.",
  "tariffs.agreement.placeKind.anywhere": "Anywhere",
  "tariffs.agreement.placeKind.country": "Country",
  "tariffs.agreement.placeKind.zone": "Rayon",
  "tariffs.agreement.placeKind.city": "City",
  "tariffs.agreement.placeKind.postal": "Postal area",
  "tariffs.agreement.placeKind.location": "Location",
  "tariffs.agreement.pricing.perUnit": "{{price}} per unit",
  "tariffs.agreement.pricing.none": "No price",
  "tariffs.agreement.pricing.staffel": "Scale on {{what}}",
  "tariffs.agreement.pricing.matrix": "{{rows}} × {{columns}}",
  "tariffs.agreement.pricing.matrixSize": "matrix, {{rows}} × {{columns}}",
  "tariffs.agreement.pricing.sum": "{{first}} plus {{second}}",
  "tariffs.agreement.pricing.more": "+{{count}}",
  "tariffs.agreement.conceptTitle": "Draft",
  "tariffs.agreement.conceptSubmitted": "Awaiting approval",
  "tariffs.agreement.startsOn": "Starts on {{date}}",
  "tariffs.agreement.changedBy": "Changed by {{names}}",
  "tariffs.agreement.offeredBy": "Offered by {{name}}, {{when}}",
  "tariffs.agreement.offeredOn": "offered {{when}}",
  "tariffs.agreement.sentBack": "Sent back by {{name}}: {{reason}}",
  "tariffs.agreement.tryFirst": "Run a trial first: whoever approves sees the outcome.",
  "tariffs.agreement.submit": "Offer for approval",
  "tariffs.agreement.withdraw": "Take back",
  "tariffs.agreement.approve": "Approve",
  "tariffs.agreement.reject": "Send back",
  "tariffs.agreement.rejectReason": "Why it goes back",
  "tariffs.agreement.discard": "Throw the draft away",
  "tariffs.agreement.discardSure": "Sure? Throw away",
  "tariffs.agreement.trial.title": "Trial",
  "tariffs.agreement.trial.help": "The customer's consignments in a month that is over: as they are priced now, and as this draft would price them. Nothing is kept.",
  "tariffs.agreement.trial.month": "Month",
  "tariffs.agreement.trial.run": "Calculate",
  "tariffs.agreement.trial.consignments_one": "1 consignment in {{month}}",
  "tariffs.agreement.trial.consignments_other": "{{count}} consignments in {{month}}",
  "tariffs.agreement.trial.same": "{{count}} the same",
  "tariffs.agreement.trial.differ": "{{count}} different: {{delta}}",
  "tariffs.agreement.trial.totals": "Now {{now}}, draft {{concept}}",
  "tariffs.agreement.trial.show": "See the differences",
  "tariffs.agreement.trial.hide": "Hide the differences",
  "tariffs.agreement.trial.runToSee": "Calculate again to see the differences per consignment.",
  "tariffs.agreement.trial.colOrder": "Consignment",
  "tariffs.agreement.trial.colNow": "Now",
  "tariffs.agreement.trial.colConcept": "Draft",
  "tariffs.agreement.trial.status.review": "To review",
  "tariffs.agreement.trial.status.nothing_applies": "No rule",
  "tariffs.agreement.trial.status.no_agreement": "No agreement",
  "tariffs.agreement.trial.status.no_account": "No customer",
  "tariffs.agreement.trial.status.awaiting_approval": "Awaiting approval",
  "tariffs.agreement.trial.status.by_hand": "By hand",
  "tariffs.agreement.trial.status.counted": "Counted",
  "tariffs.agreement.trial.listSame": "{{month}}: all the same",
  "tariffs.agreement.trial.listDiffer": "{{month}}: {{count}} different, {{delta}}",
  "tariffs.agreement.trial.notYet": "not calculated yet",
  "tariffs.agreement.forEveryoneTitle": "For everyone, without a rule",
  "tariffs.agreement.forEveryone1": "Not billable: no amount.",
  "tariffs.agreement.forEveryone2": "No rayon or quantity: no price, and the consignment goes to review.",
  "tariffs.agreement.forEveryone3": "Consignments on one trip add up as always.",
  "tariffs.agreement.history": "History",
  "tariffs.agreement.historyConcept": "Draft from {{when}}",
  "tariffs.agreement.historyApproved": "From {{when}}, approved by {{name}} on {{on}}",
  "tariffs.agreement.historyFirst": "First version, {{when}}, since {{on}}",
  "tariffs.agreement.customer": "Customer",
  "tariffs.agreement.pickAll": "All shown",
  "tariffs.agreement.changesIntro": "The drafts being changed or awaiting approval. Whoever changed a draft does not approve it.",
  "tariffs.agreement.noChanges": "No drafts.",
  "tariffs.agreement.approvePicked_zero": "Approve",
  "tariffs.agreement.approvePicked_one": "Approve 1",
  "tariffs.agreement.approvePicked_other": "Approve {{count}}",
  "tariffs.agreement.approved_one": "1 draft approved: it prices from its date.",
  "tariffs.agreement.approved_other": "{{count}} drafts approved: they price from their date.",
  "tariffs.agreement.approvedSome": "{{count}} approved, {{failed}} not: you changed those yourself or they no longer wait.",
  "tariffs.agreement.increase.button": "Raise by %",
  "tariffs.agreement.increase.title": "Raise prices",
  "tariffs.agreement.increase.forPicked_zero": "Raise by %",
  "tariffs.agreement.increase.forPicked_one": "Raise by % (1)",
  "tariffs.agreement.increase.forPicked_other": "Raise by % ({{count}})",
  "tariffs.agreement.increase.help_one": "For 1 customer",
  "tariffs.agreement.increase.help_other": "For {{count}} customers: per customer a draft with every price, minimum and table raised, from the prices of the day before. A second person approves each draft.",
  "tariffs.agreement.increase.helpOne": "A draft for {{name}} with every price, minimum and table raised, from the prices of the day before. A second person approves it.",
  "tariffs.agreement.increase.percent": "Percentage",
  "tariffs.agreement.increase.notePlaceholder": "For example: indexation 2027",
  "tariffs.agreement.increase.make": "Make the drafts",
  "tariffs.agreement.increase.badPercent": "A percentage between -50 and 100, not 0.",
  "tariffs.agreement.increase.created_one": "1 draft made. It is under Changes until someone approves it.",
  "tariffs.agreement.increase.created_other": "{{count}} drafts made. They are under Changes until someone approves them.",
  "tariffs.agreement.increase.skip.NO_ACCOUNT": "no customer",
  "tariffs.agreement.increase.skip.NO_AGREEMENT": "has no active price agreement",
  "tariffs.agreement.increase.skip.CONCEPT_EXISTS": "has a draft already",
  "tariffs.agreement.increase.skip.other": "failed ({{reason}})",
  "tariffs.agreement.edit.freightTitle": "Freight rule {{sequence}}",
  "tariffs.agreement.edit.newFreight": "New freight rule",
  "tariffs.agreement.edit.extraTitle": "Change extra",
  "tariffs.agreement.edit.newExtra": "New extra",
  "tariffs.agreement.edit.bothWays": "Holds both ways",
  "tariffs.agreement.edit.onlyWith": "Only for consignments with",
  "tariffs.agreement.edit.allConsignments": "— every consignment —",
  "tariffs.agreement.edit.choose": "— choose —",
  "tariffs.agreement.edit.mode.perConsignment": "Per consignment",
  "tariffs.agreement.edit.mode.perUnit": "Per unit",
  "tariffs.agreement.edit.mode.staffel": "Scale",
  "tariffs.agreement.edit.mode.matrix": "Matrix",
  "tariffs.agreement.edit.mode.sum": "Two tables",
  "tariffs.agreement.edit.sumHelp": "This rule adds two tables up. Those are not changed here; the rest of the rule is.",
  "tariffs.agreement.edit.price": "Price",
  "tariffs.agreement.edit.perWhat": "Per",
  "tariffs.agreement.edit.perHowMany": "Per how many",
  "tariffs.agreement.edit.counts": "Bounds in",
  "tariffs.agreement.edit.rows": "Rows",
  "tariffs.agreement.edit.columns": "Columns",
  "tariffs.agreement.edit.staffelHelp": "Each row holds up to and including its bound. An empty last bound is everything above. Pasting from Excel works: click in the table and paste.",
  "tariffs.agreement.edit.matrixHelp": "Rows and columns hold up to and including their bound; an empty last bound is everything above, an empty price no price. Pasting from Excel works, with the column bounds on the first line.",
  "tariffs.agreement.edit.upTo": "up to",
  "tariffs.agreement.edit.above": "above",
  "tariffs.agreement.edit.columnBound": "Column bound",
  "tariffs.agreement.edit.perUnitShort": "per unit",
  "tariffs.agreement.edit.row": "Row",
  "tariffs.agreement.edit.column": "Column",
  "tariffs.agreement.edit.lastColumn": "Last column",
  "tariffs.agreement.edit.minimum": "Minimum per consignment",
  "tariffs.agreement.edit.invoiceText": "Text on the invoice",
  "tariffs.agreement.edit.dropConditions": "Take these conditions away",
  "tariffs.agreement.edit.reviewed": "Checked: consignments with this rule no longer go to review",
  "tariffs.agreement.edit.findLocation": "Find a location",
  "tariffs.agreement.edit.cityContains": "Also when the city name contains this",
  "tariffs.agreement.edit.placeholder.country": "NL, BE",
  "tariffs.agreement.edit.placeholder.zone": "1, 2, 3",
  "tariffs.agreement.edit.placeholder.city": "Waalwijk",
  "tariffs.agreement.edit.placeholder.postal": "51, 5251",
  "tariffs.agreement.edit.deleteSure": "Sure? Remove",
  "tariffs.agreement.edit.save": "Save in draft",
  "tariffs.agreement.edit.error.place": "Say where: a country, rayon, city, postal area or location.",
  "tariffs.agreement.edit.error.price": "A price is an amount of 0 or more.",
  "tariffs.agreement.edit.error.quantity": "Choose what the rule is priced on.",
  "tariffs.agreement.edit.error.per": "Per how many is a number.",
  "tariffs.agreement.edit.error.table": "A table has at least one row.",
  "tariffs.agreement.edit.error.bound": "Every bound is a number; only the last may be empty.",
  "tariffs.agreement.edit.error.order": "The bounds go up.",
  "tariffs.agreement.edit.error.minimum": "The minimum is an amount.",
  "tariffs.agreement.edit.error.requirement": "Choose the transport requirement.",
  "tariffs.agreement.edit.error.UNKNOWN_LOCATION": "A location is not in the address book.",
  "tariffs.agreement.edit.error.BAD_COUNTRY": "A country is two capitals: NL, BE.",
  "tariffs.agreement.edit.error.BAD_ZONE": "A rayon is a number.",
  "tariffs.agreement.edit.error.UNKNOWN_REQUIREMENT": "No transport requirement has that code.",
  "tariffs.agreement.edit.error.BAD_TABLE": "A matrix has columns and counts two things; a scale one.",
  "tariffs.agreement.edit.error.AGREEMENT_NOT_DRAFT": "Only a draft changes; make a new version.",
  "tariffs.agreement.edit.error.CONCEPT_EXISTS": "This customer has a draft already: change that one, or throw it away.",
  "tariffs.agreement.edit.error.AGREEMENT_OWN": "You changed this draft yourself: someone else approves it.",
  "tariffs.agreement.edit.error.AGREEMENT_NOT_SUBMITTED": "This draft has not been offered yet.",
  "tariffs.agreement.edit.error.NO_START_DATE": "Say first from when it holds.",
  "tariffs.colKind": "Kind",
  "tariffs.colQuantity": "Counts",
  "tariffs.colNow": "Today",
  "tariffs.colPeriods": "Periods",
  "tariffs.colUsedBy": "Customers",
  "tariffs.colLedger": "Ledger",
  "tariffs.colVat": "VAT code",
  "tariffs.colSurcharges": "Surcharges",
  "tariffs.colPrice": "Price",
  "tariffs.customersCount_one": "{{count}} customer",
  "tariffs.customersCount_other": "{{count}} customers",
  "tariffs.tariffsCount_one": "{{count}} tariff",
  "tariffs.tariffsCount_other": "{{count}} tariffs",
  "tariffs.allCustomers": "Also customers without a price agreement",
  "tariffs.noCustomers": "No customers with a price agreement.",
  "tariffs.noTariffs": "No tariffs.",
  "tariffs.noPeriodNow": "No price today",
  "tariffs.table": "Table",
  "tariffs.kind.fixed": "Fixed price",
  "tariffs.kind.staffel": "Scale",
  "tariffs.kind.matrix": "Matrix",
  "tariffs.kind.sum": "Two scales",
  "tariffs.talisField": "Field without a name ({{field}})",
  "tariffs.upTo": "up to {{value}}",
  "tariffs.moreThan": "more than {{value}}",
  "tariffs.anyAmount": "any amount",
  "tariffs.aboveReview": "More than {{value}}: to review, WLX charges no price here.",
  "tariffs.abovePerUnit": "Above: the same price per unit.",
  "tariffs.columnsAboveReview": "A column above {{value}}: to review.",
  "tariffs.noPrice": "no price",
  "tariffs.pricePer": "{{price}} per {{per}}",
  "tariffs.periodBetween": "{{from}} to {{to}}",
  "tariffs.periodFrom": "from {{from}}",
  "tariffs.periodUntil": "until {{to}}",
  "tariffs.periodAlways": "always",
  "tariffs.op.equals": "is {{value}}",
  "tariffs.op.notEquals": "is not {{value}}",
  "tariffs.op.startsWith": "starts with {{value}}",
  "tariffs.op.contains": "contains {{value}}",
  "tariffs.op.between": "is between {{value}} and {{value2}}",
  "tariffs.op.empty": "is empty",
  "tariffs.op.notEmpty": "is not empty",
  "tariffs.op.notContains": "does not contain {{value}}",
  "tariffs.op.notStartsWith": "does not start with {{value}}",
  "tariffs.op.notOneOf": "is none of {{values}}",
  "tariffs.op.notPlaces": "is not {{value}}: {{places}}",
  "tariffs.op.lessThan": "is less than {{value}}",
  "tariffs.op.atLeast": "is at least {{value}}",
  "tariffs.op.oneOf": "is one of {{values}}",
  "tariffs.op.places": "is {{value}}: {{places}}",
  "tariffs.op.placesNone": "is {{value}} (not in WLX)",
  "tariffs.op.unsupported": "(cannot be read: {{value}})",
  "tariffs.not": "not: {{condition}}",
  "tariffs.field.billableLoadingMeters": "Billable loading metres",
  "tariffs.field.loadingMeters": "Loading metres",
  "tariffs.field.billablePallets": "Billable pallets",
  "tariffs.field.pallets": "Pallets",
  "tariffs.field.billableWeightKg": "Billable weight (kg)",
  "tariffs.field.zoneUnloading": "Zone of the unloading place",
  "tariffs.field.zoneLoading": "Zone of the loading place",
  "tariffs.field.zoneHighest": "Highest zone",
  "tariffs.field.unloadingWindowMinutes": "Minutes of the unloading window (timed delivery)",
  "tariffs.field.loadingWindowMinutes": "Minutes of the loading window",
  "tariffs.field.extraWaitingHours": "Extra waiting hours",
  "tariffs.field.tariffPostcode": "Tariff postcode (first two digits of the unloading place)",
  "tariffs.field.count": "Count",
  "tariffs.field.cubicMeters": "Cubic metres",
  "tariffs.field.hours": "Hours",
  "tariffs.field.kilometres": "Kilometres",
  "tariffs.field.unloadingWeekday": "Unloading weekday (1 = Monday)",
  "tariffs.field.notLoaded": "Not loaded",
  "tariffs.field.notBillable": "Not billable",
  "tariffs.field.loading.location": "Loading place",
  "tariffs.field.unloading.location": "Unloading place",
  "tariffs.field.loading.city": "Loading city",
  "tariffs.field.unloading.city": "Unloading city",
  "tariffs.field.loading.name": "Name of the loading place",
  "tariffs.field.unloading.name": "Name of the unloading place",
  "tariffs.field.loading.postalCode": "Loading postcode",
  "tariffs.field.unloading.postalCode": "Unloading postcode",
  "tariffs.field.loading.country": "Loading country",
  "tariffs.field.unloading.country": "Unloading country",
  "tariffs.field.loading.customerPlaceCode": "Customer's place code, loading",
  "tariffs.field.unloading.customerPlaceCode": "Customer's place code, unloading",
  "tariffs.field.loading.windowRequested": "Timed loading",
  "tariffs.field.unloading.windowRequested": "Timed delivery",
  "tariffs.field.loading.windowStart": "Start of the loading window",
  "tariffs.field.unloading.windowStart": "Start of the unloading window",
  "tariffs.field.unloading.windowEnd": "End of the unloading window",
  "tariffs.field.loading.planned": "Plannable (loading)",
  "tariffs.field.unloading.planned": "Plannable (unloading)",
  "tariffs.field.loading.preNotify": "Pre-notify loading",
  "tariffs.field.unloading.preNotify": "Pre-notify unloading",
  "tariffs.field.requirement": "Transport requirement",
  "tariffs.field.invoiceReference": "Invoice reference",
  "tariffs.field.returnLoad": "Return load",
  "tariffs.field.route": "Route",
  "tariffs.field.consignmentLine": "Line number in the order",
  "tariffs.field.loading.firstAtStop": "First consignment at the loading stop",
  "tariffs.field.unloading.firstAtStop": "First consignment at the unloading stop",
  "tariffs.field.unloading.vehicle": "Vehicle that unloads",
  "tariffs.field.unloading.carrier": "Charter that unloads",
  "tariffs.field.unloading.charter": "Charter that unloads",
  "tariffs.field.loadingWeekday": "Loading weekday (1 = Monday)",
  "tariffs.backToList": "Back to Tariffs",
  "tariffs.openRelation": "Relation card",
  "tariffs.vatCode": "VAT code",
  "tariffs.zoneSchemeDefault": "the default scheme",
  "tariffs.kgPerLoadingMeter": "Kilos per loading metre",
  "tariffs.conversion.weight_to_lm": "weight to loading metres",
  "tariffs.conversion.lm_to_weight": "loading metres to weight",
  "tariffs.noRateToday": "no percentage today",
  "tariffs.discount": "Discount",
  "tariffs.seeTable": "see the table",
  "tariffs.review": "To review",
  "tariffs.reviewHelp": "A consignment this rule prices goes to review until someone has checked the rule.",
  "tariffs.noSurcharges": "Without surcharges",
  "tariffs.withSurcharges": "With surcharges",
  "tariffs.countsNothing": "a fixed amount",
  "tariffs.units": "Unit",
  "tariffs.surchargesLabel": "Surcharges",
  "tariffs.invoiceText": "Text on the invoice",
  "tariffs.noPeriods": "This tariff has no periods.",
  "tariffs.currentPeriod": "Holds today",
  "tariffs.usedByTitle_one": "Used by {{count}} line",
  "tariffs.usedByTitle_other": "Used by {{count}} lines",
  "tariffs.usedByNone": "No price agreement uses this tariff.",
  "tariffs.colRule": "Rule",
  "tariffs.usedByFreight": "Freight rule {{sequence}}",
  "tariffs.usedByExtra": "Extra {{sequence}}",
  "tariffs.quantity": "Quantity",
  "tariffs.columnsAre": "The columns: {{quantity}}",
  "invoices.pdfAgain": "Make again",
  "invoices.mail.sent": "Sent {{at}} to {{to}}",
  "invoices.mail.notSent": "Not sent",
  "invoices.mail.selfBilling": "Not sent: the customer bills itself",
  "invoices.mail.noAddress": "The customer has no invoice address (relation card, Communication).",
  "invoices.mailSend": "Send",
  "invoices.mailAgain": "Send again",
  "invoices.booking.none": "Not booked",
  "invoices.booking.queued": "Queued",
  "invoices.booking.booked": "Booked",
  "invoices.booking.failed": "Failed",
  "invoices.booking.dry_run": "Dry run, not in AFAS",
  "invoices.bookAgain": "Book again",
  "invoices.afasPdfLabel": "Pdf in AFAS",
  "invoices.afasPdf.none": "Not yet",
  "invoices.afasPdf.queued": "Queued",
  "invoices.afasPdf.attached": "With the invoice",
  "invoices.afasPdf.failed": "Failed",
  "invoices.afasPdf.dry_run": "Dry run, not in AFAS",
  "invoices.afasPdfSend": "To AFAS",
  "invoices.afasPdfAgain": "To AFAS again",
  "invoices.afasPdfAgainHint": "AFAS then gets the pdf once more, as a second dossier item with the invoice.",
  "invoices.error.INVOICE_DOCUMENTS_OFF": "Invoice pdfs are not switched on yet.",
  "invoices.error.INVOICE_BOOKING_OFF": "Booking in AFAS is not switched on yet.",
  "invoices.error.INVOICE_MAIL_OFF": "Mailing invoices is not switched on yet.",
  "invoices.error.INVOICE_BOOKED": "This invoice is booked in AFAS already.",
  "invoices.error.INVOICE_NO_PDF": "The pdf of this invoice is not there yet.",
  "invoices.error.INVOICE_NOT_BOOKED": "This invoice is not in AFAS yet.",
  "invoices.error.NUMBER_USED": "That number was given already; the last is {{last}}.",

  // Work lists — lists DataBridge runs for you
  "worklists.group.warehouse": "Warehouse",
  "worklists.group.transport": "Transport",
  "worklists.request": "Request",
  "worklists.requesting": "Working…",
  "worklists.requested": "Requested",
  "worklists.requestedHint.print": "The list is printed on site. If it takes a while, check the printer.",
  "worklists.requestedHint.mail": "The list is on its way by mail. If it takes a while, check your junk folder.",
  "worklists.failed": "Request failed",
  "worklists.unavailable": "The connection to DataBridge is not configured, so nothing can be requested here yet.",
  "worklists.field.warehouse": "Warehouse",
  "worklists.field.owner": "Owner",
  "worklists.field.collectionDate": "Collection date",
  "worklists.field.unloadingDate": "Unloading date",
  "worklists.field.fromRow": "From row",
  "worklists.field.toRow": "To row",
  "worklists.field.printer": "Printer",
  "worklists.option.allOwners": "All owners",
  "worklists.option.sameAsFrom": "Same as from",
  "worklists.tellijstPicklocaties.label": "Pick location count list",
  "worklists.tellijstPicklocaties.desc":
    "Pick locations whose stock changed since the previous cut-off, with room to write down the counted quantity.",
  "worklists.tellijstSecties.label": "Section count list",
  "worklists.tellijstSecties.desc":
    "Per section the locations and the number of pallets according to the system, with room to write down the counted number. Each row gets a page of its own.",
  "worklists.overzichtPicking.label": "Picking overview",
  "worklists.overzichtPicking.desc":
    "Orders to pick on the chosen collection day, with full pallets, hand-picked remainder and VAS per order.",
  "worklists.aanvullijst.label": "Replenishment list",
  "worklists.aanvullijst.desc":
    "Which pallets to move from bulk to a replenishment location so the chosen collection day can be picked, with a destination per pallet. Arrives as an Excel by mail.",
  "worklists.vrijeLocaties.label": "Free locations",
  "worklists.vrijeLocaties.desc":
    "Every location in the chosen warehouse with nothing on it. Arrives as a csv by mail to the warehouse's mailbox.",
  "worklists.laadmetersHager.label": "Hager loading metres",
  "worklists.laadmetersHager.desc":
    "Hager's consignments on the chosen unloading day, with their loading metres and room to write down a correction.",
  "worklists.requestedHint.screen": "The picture opens as soon as the pallets are in from the system.",
  "worklists.field.rows": "Rows",
  "worklists.ticked_one": "1 row chosen",
  "worklists.ticked_other": "{{count}} rows chosen",
  "worklists.tickAll": "All",
  "worklists.tickNone": "None",
  "worklists.tickRangeHint": "Shift + click picks everything from the previous one.",
  "worklists.tellijstPlaat.label": "Count sheet as a picture",
  "worklists.tellijstPlaat.desc":
    "Each row chosen drawn the way you see it from the aisle: per section the beams with the pallets according to the system, and a box for the number counted. On the picture you then tick the owners, one or more, from those in the rows: only their pallets count. Appears here on screen, to print on A4 landscape, a sheet per row.",

  // Count sheet as a picture (route /count-sheet)
  "countSheet.back": "Worklists",
  "countSheet.print": "Print",
  "countSheet.paper": "Paper in",
  "countSheet.paperNl": "Nederlands",
  "countSheet.paperEn": "English",
  "countSheet.waiting": "Fetching the pallets from the system…",
  "countSheet.slow": "No answer yet. The screen keeps waiting; if nothing comes, request the picture again in a few minutes.",
  "countSheet.failed": "The pallets could not be fetched.",
  "countSheet.notFound": "This count sheet does not exist (any more).",
  "countSheet.noAccess": "You have no access to the worklists.",
  "countSheet.noPlaces_one": "WLX does not know the places of row {{rows}} in {{warehouse}}, so there is nothing to draw there.",
  "countSheet.noPlaces_other": "WLX does not know the places of rows {{rows}} in {{warehouse}}, so there is nothing to draw there.",
  "countSheet.noOwnerPallets_one": "No pallets of {{owner}} in row {{rows}}, so there is no picture of it.",
  "countSheet.noOwnerPallets_other": "No pallets of {{owner}} in rows {{rows}}, so there are no pictures of them.",
  "countSheet.sheets_one": "1 picture",
  "countSheet.sheets_other": "{{count}} pictures, a sheet per row",
  "countSheet.owner": "Only pallets of {{owner}}",
  "countSheet.ownersOnPaper": "Count only the pallets of the owners with a cross:",
  "countSheet.owners": "Owners in these rows",
  "countSheet.ownersAll": "Nothing ticked: everyone's pallets count.",
  "countSheet.ownersTicked": "Only the pallets of the owners ticked count: on the picture they have a cross, and another's pallets are grey.",
  "countSheet.ownersReset": "All owners",
  "countSheet.ownerNumber": "Owner {{number}}",
  "countSheet.ownerMeta_one": "Owner {{number}} · 1 pallet",
  "countSheet.ownerMeta_other": "Owner {{number}} · {{count}} pallets",
  "countSheet.ownersUnknown": "The system did not say whose the pallets are, so owners cannot be picked on this picture.",
  "countSheet.legend.other": "Pallet of another owner: do not count",
  "countSheet.notInWlx": "In the system but not in WLX ({{count}}): {{names}}",
  "countSheet.notInWms": "Places in WLX the system does not mention: {{count}}. They are on the picture with a question mark.",
  "countSheet.requested": "Requested by {{name}} on {{when}}",
  "countSheet.title": "Count sheet row",
  "countSheet.subtitle": "{{warehouse}} · {{sections}} sections · {{levels}} levels · {{places}} places",
  "countSheet.walk": "Walking direction: start at",
  "countSheet.legend.pallet": "Pallet according to the system",
  "countSheet.legend.palletCounted": "Pallet of an owner with a cross: count",
  "countSheet.legend.multiple": "More than one pallet on the place",
  "countSheet.legend.empty": "Empty according to the system",
  "countSheet.legend.noPlace": "No place",
  "countSheet.legend.blocked": "Blocked",
  "countSheet.legend.pick": "Pick place",
  "countSheet.legend.bulk": "Bulk place in the rack",
  "countSheet.legend.set": "Pallet set: 2 stacked",
  "countSheet.legend.unknown": "Not known in the system",
  "countSheet.systemTotal": "According to the system",
  "countSheet.pallets": "{{count}} pallets",
  "countSheet.asOf": "as of {{when}}",
  "countSheet.instruction":
    "Compare each section with the drawing. Pallet gone: strike it through. Pallet on an empty place: cross the place. Write the number counted per section in the box.",
  "countSheet.attention": "Note",
  "countSheet.multiple": "According to the system there is more than one pallet on {{places}}. Check those places closely.",
  "countSheet.notDrawn": "This row also has bulk that is not drawn: {{places}} places with {{pallets}} pallets. Count those separately.",
  "countSheet.section": "Section {{number}}",
  "countSheet.level": "Lvl",
  "countSheet.noPlace": "no place",
  "countSheet.system": "System",
  "countSheet.counted": "Counted",
  "countSheet.totalSystem": "Total according to the system",
  "countSheet.totalCounted": "Total counted",
  "countSheet.totalDeviating": "Total deviating",
  "countSheet.name": "Name",
  "countSheet.date": "Date",
  "countSheet.initials": "Initials",

  // Requirements module
  "req.tab.dashboard": "Dashboard",
  "req.tab.requirements": "Requirements",
  "req.tab.functionAreas": "Function areas",
  "req.tab.relations": "Relations",
  "req.tab.explore": "Explore",
  "req.explore.root": "Top",
  "req.explore.back": "Back",
  "req.explore.noArea": "No function area",
  "req.explore.empty": "Nothing to show for this area.",
  "req.explore.hint": "Click an area to zoom in; click a requirement for its relations.",
  "req.project.select": "Choose a project",
  "req.project.new": "+ New project",
  "req.project.manage": "Manage project",
  "req.project.none": "No projects yet. Create one to get started.",
  "req.project.nameLabel": "Name",
  "req.project.descLabel": "Description",
  "req.project.vendorLabel": "Vendor / package",
  "req.project.statusLabel": "Status",
  "req.projStatus.active": "Active",
  "req.projStatus.completed": "Completed",
  "req.prio.must": "Must",
  "req.prio.should": "Should",
  "req.prio.could": "Could",
  "req.prio.wont": "Won't",
  "req.status.new": "New",
  "req.status.accepted": "Accepted",
  "req.status.rejected": "Rejected",
  "req.type.functional": "Functional",
  "req.type.non_functional": "Non-functional",
  "req.fa.add": "Add function area",
  "req.fa.addChild": "Add sub-area",
  "req.fa.rename": "Rename",
  "req.fa.delete": "Delete",
  "req.fa.namePrompt": "Function area name",
  "req.fa.empty": "No function areas yet. Add one.",
  "req.fa.adminOnly": "Only admins can change function areas.",
  "req.fa.deleteBlocked": "Cannot delete: it still has sub-areas or requirements.",
  "req.fa.new": "New function area",
  "req.fa.editTitle": "Edit function area",
  "req.fa.under": "Under: {{parent}}",
  "req.fa.nameLabel": "Name",
  "req.fa.deleteTitle": "Delete function area",
  "req.fa.deleteMsg": "Are you sure you want to delete “{{name}}”? This cannot be undone.",
  "req.col.number": "No.",
  "req.col.title": "Title",
  "req.col.areas": "Function areas",
  "req.col.priority": "Priority",
  "req.col.status": "Status",
  "req.col.type": "Type",
  "req.col.requester": "Requester",
  "req.col.actions": "Actions",
  "req.filter.all": "All",
  "req.filter.search": "Search…",
  "req.new": "New requirement",
  "req.edit": "Edit requirement",
  "req.empty": "No requirements found.",
  "req.field.title": "Title",
  "req.field.description": "Description",
  "req.field.priority": "Priority",
  "req.field.status": "Status",
  "req.field.type": "Type",
  "req.field.areas": "Function areas",
  "req.field.related": "Related requirements",
  "req.delete.confirm": "Delete this requirement?",
  "req.export": "Export",
  "req.import": "Import",
  "req.dash.total": "Total",
  "req.dash.byStatus": "By status",
  "req.dash.byPriority": "MoSCoW breakdown",
  "req.dash.byArea": "By function area",
  "req.dash.empty": "No requirements to show yet.",
  "req.import.title": "Import requirements",
  "req.import.help":
    "Paste or upload a CSV with columns: title, description, priority, status, type, functionAreas. Areas separated by ';' and hierarchy with '>'. Areas that don't exist yet are created automatically.",
  "req.import.run": "Import",
  "req.import.result": "{{created}} created, {{failed}} failed of {{total}}.",
  "req.import.areasCreated": "New function areas created: {{count}}.",
  "req.import.errorsHeading": "Errors",
  "req.rel.loading": "Loading graph…",
  "req.rel.pickHint": "Click a requirement in the graph for details.",
  "req.rel.anchor.label": "Anchor requirement",
  "req.rel.anchor.placeholder": "Search by number or title…",
  "req.rel.anchor.none": "Pick an anchor requirement to start linking.",
  "req.rel.dropzone": "Drop here to link",
  "req.rel.linked": "Linked",
  "req.rel.link": "+ Link",
  "req.rel.unlink": "Unlink",
  "req.rel.empty": "No requirements found.",
  "req.rel.error": "Linking failed. Please try again.",

  // Env labels
  "env.prod": "PROD",
  "env.acc": "ACC",
  "env.local": "LOCAL",

  // Non-production notice banner
  "banner.acc": "Acceptance environment",
  "banner.local": "Development environment",
  "banner.note": "data here is separate from production",

  // User menu
  "user.unknownUser": "Unknown user",
  "user.menuLabel": "User menu for {{name}}",
  "user.profile": "Profile",
  "user.language": "Language",
  "user.theme": "Theme",
  "user.themeLight": "Light",
  "user.themeDark": "Dark",
  "user.themeSystem": "System",
  "user.keyboardShortcuts": "Keyboard shortcuts",
  "user.releaseNotes": "Release notes",
  "releaseNotes.title": "Release notes",
  "releaseNotes.summary": "{{count}} versions · the latest is {{version}} of {{date}}",
  "releaseNotes.search": "Search for a word, part or version",
  "releaseNotes.showOther": "Include documentation and maintenance",
  "releaseNotes.groupNew": "New",
  "releaseNotes.groupFixed": "Fixed",
  "releaseNotes.groupOther": "Documentation and maintenance",
  "releaseNotes.onlyOther": "Only documentation and maintenance in this version.",
  "releaseNotes.noMatch": "Nothing found.",
  "user.signOut": "Sign out",

  // Keyboard shortcuts dialog
  "kb.title": "Keyboard shortcuts",
  "kb.close": "Close",
  "kb.comingSoon": "— coming soon",
  "kb.groups.global": "Global",
  "kb.shortcuts.openPanel": "Keyboard shortcuts (this panel)",
  "kb.shortcuts.commandPalette": "Command palette",
  "kb.groups.tables": "Tables",
  "kb.shortcuts.nextRow": "Move to next row",
  "kb.shortcuts.prevRow": "Move to previous row",
  "kb.shortcuts.openRow": "Open / select row",
  "kb.shortcuts.focusSearch": "Focus search",
  "kb.groups.general": "General",
  "kb.shortcuts.closePanel": "Close panel or cancel",

  // Common / shared
  "common.loading": "Loading…",
  "columns.button": "Columns",
  "columns.buttonHint": "Choose which columns you see and in what order",
  "columns.title": "Columns",
  "columns.alwaysShown": "Always shown",
  "columns.hint":
    "Drag a row (or Alt+↑/↓) to move a column. In the table, drag a column header to another place, or its edge to change the width.",
  "columns.reset": "Restore default view",
  "columns.resize": "Width of {{column}}",
  "columns.resizeHint": "Drag to change the width, double-click to make the column as wide as its longest row",
  "columns.filterBy": "Filter on {{column}}",
  "columns.filteredBy": "Filtered on {{column}}: click to change the filter",
  "columns.filterContains": "Contains…",
  "columns.filterRangeFrom": "From",
  "columns.filterRangeTo": "Up to and including",
  "columns.filterFrom": "from {{value}}",
  "columns.filterUntil": "up to {{value}}",
  "columns.filterClear": "Clear",
  "columns.filterDone": "Done",
  "columns.filteredOn": "Filtered on",
  "columns.filterRemove": "Remove the filter on {{column}}",
  "columns.filterClearAll": "Clear all filters",
  "columns.sortBy": "Sort by {{column}} · drag to move the column",
  "columns.dragHint": "Drag to move the column",
  "lightbox.label": "Image",
  "lightbox.toolbar": "Zoom",
  "lightbox.zoomIn": "Zoom in",
  "lightbox.zoomOut": "Zoom out",
  "lightbox.fit": "Whole image",
  "lightbox.openInTab": "Open in new tab",
  "lightbox.hint": "Scroll or click to zoom, drag to move",
  "lightbox.failed": "The image could not be loaded.",
  "common.cancel": "Cancel",
  "common.save": "Save changes",
  "common.saved": "Saved",
  "common.moreInfo": "More information",
  "common.close": "Close",
  "common.back": "Back",
  "common.saving": "Saving…",
  "common.remove": "Remove",
  "common.create": "Create",
  "common.deactivate": "Deactivate",
  "common.reactivate": "Reactivate",
  "common.firstPage": "← First page",
  "common.nextPage": "Next page →",
  "common.onThisPage_one": "{{count}} on this page",
  "common.onThisPage_other": "{{count}} on this page",
  "common.perPage": "Per page",
  "common.errorGeneric": "An error occurred",
  "common.status": "Status",
  "common.name": "Name",
  "common.code": "Code",
  "common.type": "Type",
  "common.created": "Created",
  "common.updated": "Updated",
  "common.details": "Details",
  "common.record": "Record",
  "common.id": "ID",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.yes": "Yes",
  "common.no": "No",
  "common.all": "All",
  "common.changedAt": "Last changed",
  "common.changedBy": "Changed by",
  "common.changedViaWlx": "WLX",
  "common.changedViaTalis": "TALIS",
  "common.changedViaAfas": "AFAS",
  "common.changedViaDatabridge": "DataBridge",
  "common.changedViaScoretrace": "Scoretrace",
  "common.changedViaPortal": "Customer portal",
  "common.changedViaCustomer": "Customer interface",
  "common.changedBySystem": "A coupling or WLX itself, not a person",
  "common.lastUpdated": "Last updated",

  // Login
  "login.logoAlt": "Willems Logistics",
  "login.platform": "Willems Logistics Platform",
  // Brand line under the payoff. Deliberately empty: while it is empty nothing
  // renders below "Your business on track." Fill it to bring the line back.
  "login.taglineSub": "",
  "login.copyright": "© 1930–2026 Willems Logistics · Rijkevoort, NL",
  "login.privacy": "Privacy",
  "login.support": "Support",
  "login.signInEyebrow": "Sign in",
  "login.welcomeBack": "Welcome back.",
  "login.signInDesc": "Use your Willems Microsoft 365 account to sign in.",
  "login.signInFailed": "Sign-in failed. Please try again or contact IT support.",
  "login.signInWith": "Sign in with Microsoft",
  "login.willemsInternal": "· Willems internal",
  "login.mfaEnforced": "MFA enforced via Entra ID",
  "login.devMode": "Development mode — Entra ID bypassed",
  "login.signInAsMock": "Sign in as mock user",

  // Dashboard screen
  "dashboard.summary": "Week {{week}} · {{events}} appointments today · {{overdue}} overdue and {{today}} tasks for today.",
  "dashboard.noModules": "No modules have been granted to you yet. Contact your administrator.",
  "dashboard.workQueues": "Work queues",
  "dashboard.agendaTitle": "Today in your calendar",
  "dashboard.agendaEmpty": "No appointments today.",
  "dashboard.agendaNotLinked": "Link your Outlook calendar to see your appointments here.",
  "dashboard.openAgenda": "Open calendar",
  "dashboard.tasksTitle": "Tasks",
  "dashboard.tasksEmpty": "Nothing overdue or due today. Nice.",
  "dashboard.tasksOverdue": "Overdue ({{count}})",
  "dashboard.tasksToday": "Today ({{count}})",
  "dashboard.tasksUnclaimed": "Unclaimed in your mailbox ({{count}})",
  "dashboard.teamTitle": "Your team",
  "dashboard.andMore": "+ {{count}} more",
  // The "waiting for you" strip — at the top of the day start, above any deadline.
  "dashboard.forYouTitle": "Waiting for you",
  "dashboard.forYouDesc": "Somebody asked you personally.",
  "dashboard.forYouOpen": "Open",
  "dashboard.forYouMarkAll": "Mark all read",
  "dashboard.openTasks": "Open tasks",
  "dashboard.mailTitle": "Unread mail",
  "dashboard.mailEmpty": "All read.",
  "dashboard.openMail": "Open mail",
  "dashboard.notImplemented": "Dashboard content is not yet implemented.",
  "dashboard.referenceNote": "See {{path}} for the reference design.",

  // Documents screen
  "documents.type.SignedCMR": "Signed CMR",
  "documents.type.CMR": "CMR",
  "documents.type.PackingSlip": "Packing slip",
  "documents.type.Checklist": "Checklist",
  "documents.type.PalletList": "Pallet list",
  "documents.type.InboundChecklist": "Inbound checklist",
  "documents.type.WarehouseSet": "Warehouse set",
  "documents.type.Other": "Other",
  "documents.visibility.CustomerVisible": "The customer too",
  "documents.visibility.InternalOnly": "Willems only",
  "documents.col.type": "Kind",
  "documents.col.consignment": "Consignment",
  "documents.col.file": "File",
  "documents.col.version": "Version",
  "documents.col.visibility": "Visible to",
  "documents.col.received": "Received",
  "documents.noneForOrder": "No documents for this order yet. The signed CMR appears here once it is scanned.",
  "documents.replaced": "replaced",
  "documents.inbox.title": "Scans without a consignment",
  "documents.inbox.intro": "Scans that found no consignment: no barcode, a number WLX does not know, or several consignments it may be. Open the scan, pick or type the consignment number and link it; without a consignment it can be the number of the dossier, the order or the delivery. Put aside a page that is no CMR.",
  "documents.inbox.state.open": "Without consignment",
  "documents.inbox.state.linked": "Linked",
  "documents.inbox.state.discarded": "Put aside",
  "documents.inbox.colReceived": "Received",
  "documents.inbox.colType": "Kind",
  "documents.inbox.colRead": "Number read",
  "documents.inbox.colFile": "Scan",
  "documents.inbox.colSource": "Source",
  "documents.inbox.colResult": "Consignment and dossier",
  "documents.inbox.colActions": "Link",
  "documents.inbox.noNumber": "no barcode read",
  "documents.inbox.discarded": "put aside",
  "documents.inbox.toTalis": "To TALIS, activity {{activity}}",
  "documents.inbox.talisRefused": "TALIS refused activity {{activity}}: {{error}}",
  "documents.inbox.empty.open": "No scans without a consignment.",
  "documents.inbox.empty.linked": "Nothing linked yet.",
  "documents.inbox.empty.discarded": "Nothing put aside.",
  "documents.inbox.numberPlaceholder": "ORD-2026-000123-1",
  "documents.inbox.numberLabel": "Consignment, order or dossier number",
  "documents.inbox.link": "Link",
  "documents.inbox.discard": "Put aside",
  "documents.inbox.state.files": "Read in",
  "documents.inbox.colReason": "Why",
  "documents.inbox.reason.no_barcode": "No barcode",
  "documents.inbox.reason.behind_cmr": "No CMR: most likely belongs behind the scan before it",
  "documents.inbox.reason.unknown_number": "Number not found",
  "documents.inbox.reason.several": "More orders or dossiers with this delivery",
  "documents.inbox.behindTrip": "behind trip {{trip}}",
  "documents.inbox.pages": "p. {{pages}}",
  "documents.inbox.numberPick": "Pick or type the consignment",
  "documents.scans.add": "Add scans",
  "documents.scans.title": "Add scans",
  "documents.scans.folder": "Folder",
  "documents.scans.folders.MetVoorblad": "With cover sheet",
  "documents.scans.folders.ZonderVoorblad": "Without cover sheet",
  "documents.scans.folders.Magazijn": "Warehouse",
  "documents.scans.folderHelp.MetVoorblad": "CMRs behind a trip sheet, and the loading and unloading lists. A page without a barcode belongs to the trip sheet before it.",
  "documents.scans.folderHelp.ZonderVoorblad": "CMRs without a trip sheet before them.",
  "documents.scans.folderHelp.Magazijn": "Sets from the warehouse: the checklist with the delivery, the pallet list and the CMR behind them.",
  "documents.scans.files": "Files",
  "documents.scans.drop": "Drop pdfs here, or choose them",
  "documents.scans.chosen_one": "1 file · {{size}}",
  "documents.scans.chosen_other": "{{count}} files · {{size}}",
  "documents.scans.skipped_one": "1 skipped: not a pdf",
  "documents.scans.skipped_other": "{{count}} skipped: not a pdf",
  "documents.scans.order": "WLX reads them by name, one by one, as the scanner numbers them. A file read before changes nothing.",
  "documents.scans.read": "Read in",
  "documents.scans.stop": "Stop",
  "documents.scans.more": "Read more",
  "documents.scans.progress": "{{done}} of {{total}}",
  "documents.scans.stopped": "stopped",
  "documents.scans.pagesRead": "With barcode",
  "documents.scans.outcome.linked": "Linked",
  "documents.scans.outcome.inbox": "In the work queue",
  "documents.scans.outcome.talis": "From TALIS",
  "documents.scans.outcome.no_transport": "No dossier",
  "documents.scans.outcome.trip": "With a trip",
  "documents.scans.outcome.blank": "Blank",
  "documents.scans.errors": "Error",
  "documents.scans.again": "read before",
  "documents.scans.colFile": "File",
  "documents.scans.colPages": "Pages",
  "documents.scans.colOutcome": "What became of it",
  "documents.scans.error.NOT_A_PDF": "Not a pdf.",
  "documents.scans.error.SCAN_UNREADABLE": "The pdf does not open.",
  "documents.scans.error.CONFLICT": "Another file with this name was read from this folder already.",
  "documents.scans.error.DOCUMENT_TOO_LARGE": "Larger than 25 MB.",
  "documents.scans.error.DOCUMENT_STORAGE_OFF": "SharePoint is not set up: nothing can be stored.",
  "documents.scans.list.intro": "What the reader made of every file. Click a file for its pages and the file itself. A CMR from TALIS whose consignment is not in WLX goes to TALIS on its barcode.",
  "documents.scans.list.colReceived": "Read in",
  "documents.scans.list.colRead": "With barcode",
  "documents.scans.list.totals": "{{files}} files · {{pages}} pages · {{read}} with barcode · {{linked}} linked · {{inbox}} work queue · {{talis}} TALIS",
  "documents.scans.list.empty": "Nothing read in yet.",
  "documents.inbox.reason.candidates": "Possibly found: pick the consignment",
  "documents.scans.outcome.pending": "Being read",
  "documents.scans.pendingHint_one": "1 page without text is being read in the background (OCR). Look at Read in shortly.",
  "documents.scans.pendingHint_other": "{{count}} pages without text are being read in the background (OCR). Look at Read in shortly.",
  "documents.scans.list.colStatus": "Status",
  "documents.scans.status.reading": "Being read",
  "documents.scans.status.done": "Done",
  "documents.scans.status.failed": "Failed",
  "documents.scans.kind.cmr": "CMR",
  "documents.scans.kind.trip_sheet": "Trip sheet",
  "documents.scans.kind.loading_list": "Loading list",
  "documents.scans.kind.unloading_list": "Unloading list",
  "documents.scans.kind.warehouse_set": "Warehouse set",
  "documents.scans.kind.none": "No barcode of ours",
  "documents.scans.kind.blank": "Blank",
  "documents.scans.paper.checklist": "Checklist",
  "documents.scans.paper.pallet_list": "Pallet list",
  "documents.scans.paper.packing_slip": "Packing slip",
  "documents.scans.paper.inbound_checklist": "Inbound checklist",
  "documents.scans.paper.cmr": "CMR",
  "documents.scans.system.wlx": "of WLX",
  "documents.scans.system.talis": "of TALIS",
  "documents.scans.pageCount_one": "1 page",
  "documents.scans.pageCount_other": "{{count}} pages",
  "documents.scans.openOriginal": "Open the file",
  "documents.scans.page.title": "Page {{page}}",
  "documents.scans.page.open": "Open",
  "documents.scans.page.linked": "Linked to {{what}}, dossier {{dossier}}",
  "documents.scans.page.inbox": "In the work queue: {{why}}",
  "documents.scans.page.talis": "From TALIS: not found in WLX, left alone",
  "documents.scans.page.toTalis": "Not in WLX, sent to TALIS on its barcode (activity {{activity}})",
  "documents.scans.page.noTransport": "Set of delivery {{delivery}}: no transport by Willems and no dossier with this number, kept",
  "documents.scans.page.trip": "With trip {{trip}}",
  "documents.scans.page.pending": "Being read with OCR",
  "documents.scans.page.blank": "Blank, skipped",
  "documents.scans.page.toQueue": "to the work queue",
  "documents.scans.page.matchedOn": "Found on the {{field}} {{reference}} and postcode {{postcode}}",
  "documents.scans.page.barcodes": "Barcodes:",
  "documents.scans.page.textFrom.pdf": "Text from the pdf",
  "documents.scans.page.textFrom.ocr": "Text read with OCR",
  "documents.scans.page.noReferences": "(no numbers to look for)",
  "documents.scans.field.order": "reference of the order",
  "documents.scans.field.consignment": "reference of the consignment",
  "documents.scans.field.loading": "loading reference",
  "documents.scans.field.unloading": "unloading reference",
  "documents.addToOrder.title": "Put with an order",
  "documents.addToOrder.open": "Add",
  "documents.addToOrder.drop": "Drag a mail or file here, from WLX Mail, Outlook or the Explorer.",
  "documents.addToOrder.dropHere": "Release to put it with this order",
  "documents.addToOrder.order": "Order",
  "documents.addToOrder.searchOrder": "Order number, consignment number or reference",
  "documents.addToOrder.searchHint": "Type at least three characters.",
  "documents.addToOrder.noOrders": "No order found.",
  "documents.addToOrder.otherOrder": "Another order",
  "documents.addToOrder.wholeOrder": "The whole order",
  "documents.addToOrder.consignmentHelp": "A packing slip belongs to one consignment: WLX prints it behind that consignment's CMR.",
  "documents.addToOrder.slipNeedsConsignment": "Choose the consignment for the packing slip.",
  "documents.addToOrder.theMail": "The mail itself",
  "documents.addToOrder.loadingMail": "Fetching attachments…",
  "documents.addToOrder.attachmentsHelp": "The attachments are in the mail already. Tick one to put it with the order on its own as well, as a packing slip for instance.",
  "documents.addToOrder.internal": "Visible to Willems only. Until the go-live a packing slip goes to TALIS as well when the order is there too.",
  "documents.addToOrder.submit": "Add",
  "documents.addToOrder.added_one": "One document put with the order.",
  "documents.addToOrder.added_other": "{{count}} documents put with the order.",
  "documents.addToOrder.personalMailbox": "A mail from your own mailbox does not go into a dossier. Drag it from a shared mailbox, or send it there first.",
  "mail.addToOrder": "Put with an order",
  "mail.addedToOrder": "Put with order {{number}}.",
  "documents.upload.open": "Add file",
  "documents.upload.title": "Add a file to the dossier",
  "documents.upload.submit": "Add",
  "documents.upload.file": "File",
  "documents.upload.tooLarge": "Larger than 25 MB: that does not fit.",
  "documents.upload.visibleHint": "The customer sees it with the consignment in the portal.",
  "documents.upload.internalHint": "Visible to Willems only.",
  "documents.upload.chooseConsignment": "Choose the consignment",
  "documents.upload.noConsignment": "No consignment in particular",

  // Users
  "users.searchPlaceholder": "Search name or email…",
  "users.searchLabel": "Search users",
  "users.allRoles": "All roles",
  "users.allStatus": "All",
  "users.activeStatus": "Active",
  "users.inactiveStatus": "Inactive",
  "users.colNameEmail": "Name / Email",
  "users.colEmail": "E-mail",
  "users.colRoles": "Roles",
  "users.colStatus": "Status",
  "users.colLastLogin": "Last login",
  "users.colCreated": "Created",
  "users.noUsers": "No users found.",
  "users.noRoles": "No roles assigned.",
  "users.remove": "Remove",
  "users.removeRoleLabel": "Remove {{role}} role",
  "users.assignRole": "+ Assign role",
  "users.userId": "User ID",
  "users.lastLogin": "Last login",
  "users.details": "Details",
  "users.filterByRole": "Filter by role",
  "users.roles": "Roles",
  "users.failedAssignRole": "Failed to assign role",
  "users.failedRemoveRole": "Failed to remove role",
  "users.failedUpdateUser": "Failed to update user",

  // Parties
  "parties.searchPlaceholder": "Search name, code or reference…",
  "parties.searchLabel": "Search relations",
  "parties.sourceNote": "Relations are made and changed in AFAS; WLX takes them over by itself.",
  "parties.readOnlyNote": "Change this relation in AFAS. WLX takes over every change by itself.",
  "parties.allTypes": "All types",
  "parties.colName": "Name",
  "parties.colCode": "Code",
  "parties.colType": "Type",
  "parties.colIdentifiers": "System IDs",
  "parties.colStatus": "Status",
  "parties.colCreated": "Created",
  "parties.noParties": "No relations found.",
  "parties.nameLabel": "Name",
  "parties.relationLabel": "Kind of relation",
  "parties.relationSales": "Sales relation",
  "parties.relationPurchase": "Purchase relation",
  "parties.relationNone": "No debtor or creditor number",
  "parties.relationHelp": "Derived from the debtor and creditor numbers, as in AFAS.",
  "parties.wlxSettingsTitle": "In WLX",
  "parties.wlxSettingsHelp": "AFAS does not hold this, so it is set here.",
  "parties.wlxManagedHelp":
    "You manage this in WLX: AFAS does not have it. What is set here stays.",
  "parties.ownOrganizationLabel": "Own organisation",
  "parties.ownOrganizationHelp":
    "Willems itself. There is one: tick another relation and the mark moves there. This card then gets the Organisation tab, with the manager tree.",
  "parties.identifiersTitle": "System identifiers",
  "parties.identifiersHelp":
    "How other systems name this relation. Recorded by the integrations — reports and the TALIS link recognise the relation by these. TMS is the system orders go to (Qargo today); TALIS is the number from TALIS.",
  "parties.identifiersEmpty": "No system has named this relation yet.",
  "parties.systemTms": "TMS",
  "parties.systemWms": "WMS",
  "parties.systemErp": "ERP",
  "parties.systemTalis": "TALIS",
  "parties.systemAfas": "AFAS",
  "parties.parentHelp": "The group this relation belongs to.",
  "parties.parentNone": "No group",
  "parties.wmsOwnerLabel": "Owner in Scoretrace",
  "parties.wmsOwnerHelp": "This relation's number as owner of stock in Scoretrace. Warehouse orders and articles find the relation by it.",
  "parties.lastUpdated": "Last updated",

  // Party roles and the party card (docs/tms-stamdata.md §5)
  "parties.roleFilterLabel": "Role",
  "parties.roleAll": "All",
  "parties.roleCustomers": "Sales relations",
  "parties.roleCharters": "Purchase relations",
  "parties.colRoles": "Roles",
  "parties.roleCustomer": "Sales relation",
  "parties.roleCharter": "Purchase relation",
  "parties.roleEnded": "ended",
  "parties.chipBlocked": "blocked",
  "parties.tabGeneral": "General",
  "parties.tabCustomer": "Sales relation",
  "parties.tabCharter": "Purchase relation",
  "parties.tabCommunication": "Communication",
  "parties.tabPortal": "Portal",
  "parties.tabDossiers": "Dossiers",
  "parties.tabOrganization": "Organisation",
  "parties.notFound": "Relation not found",
  "parties.notFoundDesc": "This relation does not exist (any more), or you have no access to it.",
  "parties.shortNameLabel": "Short name",
  "parties.cocLabel": "Chamber of Commerce number",
  "parties.vatLabel": "VAT number",
  "parties.phoneLabel": "Phone",
  "parties.websiteLabel": "Website",
  "parties.contactHelp": "The company's general details, never those of a person.",
  "parties.parentLabel": "Part of",
  "parties.saved": "Saved",
  "parties.customerEmpty": "This relation is not a sales relation.",
  "parties.charterEmpty": "This relation is not a purchase relation.",
  "parties.roleActiveLabel": "Role active",
  "parties.debtorNumberLabel": "Debtor number (VR)",
  "parties.paymentTermLabel": "Payment term in days",
  "parties.vatCodeLabel": "VAT code",
  "parties.vat1": "1 · VAT high (21%)",
  "parties.vat2": "2 · VAT low (9%)",
  "parties.vat3": "3 · No VAT",
  "parties.vat35": "35 · VAT 0%, services within the EU (reverse charge)",
  "parties.vatShort1": "1 · 21%",
  "parties.vatShort2": "2 · 9%",
  "parties.vatShort3": "3 · 0%",
  "parties.vatShort35": "35 · reverse charge",
  "parties.invoiceAddressTitle": "Invoice address",
  "parties.invoiceStreetLabel": "Address or PO box",
  "parties.postalCodeLabel": "Postal code",
  "parties.cityLabel": "City",
  "parties.countryLabel": "Country",
  "parties.invoicingTitle": "Invoicing",
  "parties.referenceRequiredLabel": "Invoice reference required",
  "parties.referenceRequiredHelp": "An order cannot be entered without an invoice reference.",
  "parties.criticalWindowLabel": "Critical with a fixed unloading time (hours)",
  "parties.criticalWindowHelp": "When an unloading has a window of at most this many hours, the order becomes critical. Empty: not for this customer.",
  "parties.criticalWindowPlaceholder": "No",
  "parties.defaultReferenceLabel": "Fixed reference on the invoice",
  "parties.defaultReferenceHelp": "A fixed purchase order number of the customer, for instance.",
  "parties.selfBillingLabel": "Self-billing",
  "parties.selfBillingHelp": "The customer draws up the invoice itself.",
  "parties.transportTitle": "Transport",
  "parties.conversionLabel": "Conversion when invoicing",
  "parties.conversionWeightToLm": "Weight to loading metres",
  "parties.conversionLmToWeight": "Loading metres to weight",
  "parties.conversionHelp":
    "When invoicing, WLX converts weight into loading metres or the other way round, at the kilos per loading metre beside it. Not at order entry.",
  "parties.orderCutoffLabel": "Order cut-off",
  "parties.orderCutoffHelp":
    "Until when this customer may send an order on the day before loading. Empty = no agreement, and WLX holds nothing back. Only for orders that come in through a channel.",
  "parties.kgPerLmLabel": "Kilos per loading metre",
  "parties.kgPerLmHelp": "For the conversion when invoicing; 1.750 by default.",
  "parties.fuelGroupLabel": "Fuel surcharge group",
  "parties.goodsProfileLabel": "Default goods profile",
  "parties.creditorNumberLabel": "Creditor number (IR)",
  "parties.approvalLabel": "Assessment",
  "parties.approvalNone": "Not assessed",
  "parties.approvalApproved": "Approved",
  "parties.approvalDoubt": "Doubt",
  "parties.approvalBlocked": "Blocked",
  "parties.approvalHelp": "A blocked supplier cannot be chosen on the planning board.",
  "parties.certificatesTitle": "Certificates",
  "parties.certGmpFeed": "GMP+ Feed",
  "parties.certNvwaLabel": "NVWA registration number",
  "parties.certNvwaHelp": "The NVWA offers no link to look the number up; you find it in its public overview.",
  "parties.nvwaLookup": "NVWA overview",
  "parties.onPlanningBoardLabel": "On the planning board",
  "parties.onPlanningBoardHelp":
    "Ticked: the supplier is on the planning board, for instance because it drives for us every day. Unticked: it only receives transport orders.",
  "parties.communicationHelp": "The functional addresses per kind of message. No names of contact persons.",
  "parties.communicationNote": "These addresses are not in AFAS and are managed in WLX. Until 27 November the link fills them; what you change here stays.",
  "parties.addressesPlaceholder": "name@company.com, …",
  "parties.addressesInvalid": "This is not a valid e-mail address. Separate addresses with a comma.",
  "parties.contactActiveLabel": "{{purpose}} active",
  "parties.frequencyLabel": "{{purpose}}: how often",
  "parties.frequencyPerEvent": "Per loading and unloading, every 5 minutes",
  "parties.frequencyDaily": "One overview a day, at 07:45",
  "parties.frequencyNone": "Not chosen yet: no mail goes",
  "parties.colPurpose": "Message",
  "parties.colAddresses": "Addresses",
  "parties.colActive": "Active",
  "parties.colSource": "Source",
  "parties.sourceTalis": "TALIS",
  "parties.sourceWlx": "WLX",
  "parties.purposeInvoice": "Invoicing",
  "parties.purposePlanning": "Planning",
  "parties.purposeFreightDocuments": "Freight documents",
  "parties.purposeOrderConfirmation": "Order confirmation",
  "parties.purposePlanned": "Planning confirmation",
  "parties.purposeDelivered": "Delivery confirmation",
  "parties.purposeTransportOrder": "Transport order",
  "parties.purposeWarehouseIn": "Goods receipt confirmation",
  "parties.purposeWarehouseOut": "Dispatch confirmation",
  "parties.purposeEmballageIncomplete": "Emballage not fully returned",
  "parties.purposePreAdvice": "Pallet pre-advice to unloading place",
  "parties.toThePlace": "To the mail address of the unloading place, once per consignment after picking",
  "parties.dossiersEmpty": "No dossiers for this relation yet.",
  "parties.colDossier": "Dossier",
  "parties.colReference": "Reference",
  "parties.colUpdated": "Updated",
  "parties.colApproval": "Approval",
  "parties.approvalPending": "Awaiting approval",
  "parties.approvalDone": "Approved",
  "parties.awaitingApproval_one": "{{count}} new relation awaits approval",
  "parties.awaitingApproval_other": "{{count}} new relations await approval",
  "parties.pendingTitle": "New from AFAS, awaiting approval.",
  "parties.pendingText":
    "WLX uses this relation only once somebody approves it: until then you pick it nowhere, for no order, trip or dossier. An order of this customer that comes in all the same waits in the work queue until it is approved.",
  "parties.approveButton": "Approve",
  "parties.pendingNoRight": "Approving is for someone who may change relations.",
  "parties.approvedLabel": "Approved",
  "parties.approvedHelp":
    "WLX uses a new relation from AFAS only once this is on. Switch it off and the next order of this customer waits again; what is already accepted stays.",
  "parties.approvedBy": "Approved: {{date}} by {{name}}",
  "parties.approvedOn": "Approved: {{date}}",

  // Organisation hierarchy (Admin → Organisation)
  "org.count": "{{count}} nodes",
  "org.newNode": "New node",
  "org.newTitle": "New node",
  "org.colName": "Name",
  "org.colUser": "Linked user",
  "org.colChildren": "Under this node",
  "org.noNodes": "No organisation structure yet. Add the first node.",
  "org.nameLabel": "Name",
  "org.namePlaceholder": "e.g. Planning team or Jan Jansen",
  "org.parentLabel": "Manager",
  "org.parentNone": "— None (top level) —",
  "org.parentHelp": "The node directly above this one in the hierarchy.",
  "org.userLabel": "Linked WLX user",
  "org.userNone": "— None —",
  "org.userHelp":
    "Link this node to a person. Only then do their tasks count towards the manager overview. Leave empty for an intermediate layer (e.g. a department).",
  "org.userInactive": "inactive",
  "org.externalRefsTitle": "External references (time registration)",
  "org.externalRefsHelp": "Free fields bridging to the time-registration system. Optional; WLX does nothing with them yet.",
  "org.externalRefLabel": "External reference {{n}}",
  "org.deleteNode": "Delete node",
  "org.deleteConfirm": "Delete this node? Any child nodes will move up to the top level.",

  // Branches (Admin → Branches)
  "branches.paperTitle": "On paper",
  "branches.paperHelp": "How the branch stands on the CMR (box 16, 17 and 23) and on the trip sheet of a lorry of this branch. The address is that of its location.",
  "branches.documentName": "Name",
  "branches.documentLegalName": "Legal entity",
  "branches.documentCarrierCode": "Carrier code",
  "branches.documentApprovalNumber": "Approval number",
  "branches.documentPhone": "Phone",
  "branches.printLocations": "Print locations",
  "branches.printLocationsNone": "No print location at this branch.",
  "branches.printLocationDefault": "{{name}} (default)",
  "branches.printLocationsHelp": "Where the trip sheets and CMRs come out. A new print location goes with a printer in DataBridge: ask development.",
  "branches.count": "{{count}} branches",
  "branches.newBranch": "New branch",
  "branches.newTitle": "New branch",
  "branches.city": "City",
  "branches.location": "Location",
  "branches.locationHelp": "Where the branch is, from Locations: its place on the planning board's map, and the address of its depot when the branch is a depot.",
  "branches.depot": "Depot",
  "branches.depotHelp": "Depot and warehouse at this location. A vehicle based here unloads and loads here for a pickup and a delivery, and an order that loads or unloads here is a delivery or a pickup. Off for a base where the depot rules do not apply.",
  "branches.depotNeedsLocation": "Choose a location first: a depot is a place.",
  "branches.locationNoPosition": "This location's position is not known yet, so it is not on the map. Check the address on the location card.",
  "branches.locationClear": "Remove",
  "branches.headOffice": "Head office",
  "branches.noBranches": "No branches yet.",
  "branches.namePlaceholder": "e.g. Rijkevoort",
  "branches.codeHelp": "Two to four capital letters, such as RK. The code is fixed once the branch exists.",
  "branches.codeFixed": "Fixed: the TALIS link and the planning refer to it.",
  "branches.sortOrderLabel": "Order",
  "branches.sortOrderHelp": "Lower numbers come first in lists and pickers.",
  "branches.headOfficeHelp": "There is one head office. Ticking this makes this branch the head office instead.",
  "branches.headOfficeFixed": "This is the head office. To choose another, open that branch and tick it there.",
  "branches.deactivateConfirm": "Deactivate {{name}}? The branch stays, but can no longer be chosen as a home base.",

  // Integrations (Beheer → Koppelingen)
  "integrations.kindParties": "Relations",
  "integrations.kindLocations": "Locations",
  "integrations.kindFleet": "Transport units",
  "integrations.kindEmployees": "Drivers",
  "integrations.kindAfasEmployees": "Employees (AFAS)",
  "integrations.kindAfasShifts": "Shifts (AFAS)",
  "integrations.kindAfasLeaves": "Leave (AFAS)",
  "integrations.kindAfasIllness": "Illness (AFAS)",
  "integrations.kindAfasDebtors": "Sales relations (AFAS)",
  "integrations.kindAfasCreditors": "Purchase relations (AFAS)",
  "integrations.kindArticles": "Articles (Scoretrace)",
  "integrations.skipped": "{{count}} skipped",
  "integrations.removed": "{{count}} removed",
  "integrations.report": "Outcome",
  "integrations.reportDriversLinked": "Drivers linked",
  "integrations.reportMatchedOnNumber": "On personnel number",
  "integrations.reportMatchedWithoutLeadingZeros": "Of which without leading zeros",
  "integrations.reportMatchedOnBoardComputer": "On board computer number",
  "integrations.reportDriversNotInAfas": "Drivers not in AFAS",
  "integrations.reportDriversNotInAfasCodes": "Which",
  "integrations.reportFrom": "First day",
  "integrations.reportTo": "Last day",
  "integrations.reportShifts": "Shifts",
  "integrations.reportDrivers": "Drivers",
  "integrations.reportUnknownLocations": "Unknown locations",
  "integrations.reportAbsences": "Absences",
  "integrations.reportDriversAwayNow": "Away now",
  "integrations.processingLive": "Processed on arrival",
  "integrations.processingStored": "Kept for later",
  "integrations.processingRefused": "Not taken yet",
  "integrations.statusReceived": "Waiting",
  "integrations.statusProcessing": "Processing",
  "integrations.statusProcessed": "Processed",
  "integrations.statusFailed": "Failed",
  "integrations.lastReceived": "Last received",
  "integrations.lastProcessed": "Last processed",
  "integrations.countWaiting": "Waiting",
  "integrations.countProcessed": "Processed",
  "integrations.countFailed": "Failed",
  "integrations.purge": "Discard kept batches",
  "integrations.purgeConfirm_one":
    "Discard {{count}} {{kind}} batch that still holds rows (waiting or failed)? DataBridge sends it again in the next round.",
  "integrations.purgeConfirm_other":
    "Discard {{count}} {{kind}} batches that still hold rows (waiting or failed)? DataBridge sends them again in the next round.",
  "integrations.purged_one": "{{count}} batch discarded.",
  "integrations.purged_other": "{{count}} batches discarded.",
  "integrations.reprocess": "Process again",
  "integrations.processNow": "Process now",
  "integrations.reprocessed": "The batch was processed.",
  "integrations.reprocessKept": "The batch was not processed. The error is shown with it.",
  "integrations.filterKind": "Kind",
  "integrations.filterStatus": "Status",
  "integrations.allKinds": "All kinds",
  "integrations.allStatuses": "All statuses",
  "integrations.autoRefresh": "Refreshes every 30 seconds",
  "integrations.refresh": "Refresh",
  "integrations.colReceived": "Received",
  "integrations.colKind": "Kind",
  "integrations.colStatus": "Status",
  "integrations.colRows": "Rows",
  "integrations.colResult": "Result",
  "integrations.colActions": "Actions",
  "integrations.resultLine": "{{created}} new · {{updated}} updated · {{unchanged}} unchanged · {{rejected}} rejected",
  "integrations.notProcessed": "Not processed yet",
  "integrations.resultRejections": "With rejected rows",
  "integrations.resultWarnings": "With warnings",
  "integrations.resultClean": "Without findings",
  "integrations.hasError": "Processing error",
  "integrations.issues_one": "{{count}} note",
  "integrations.issues_other": "{{count}} notes",
  "integrations.empty": "Nothing received yet. Once DataBridge sends master data, every batch shows up here.",
  "integrations.colPk": "TALIS PK",
  "integrations.colCode": "Code",
  "integrations.colMessage": "Explanation",
  "integrations.rejections": "Rejected",
  "integrations.warnings": "Warnings",
  "integrations.processedAt": "Processed at",
  "integrations.correlationId": "Correlation ID",
  "integrations.batchId": "Batch ID",
  "integrations.detailHint": "Click a batch for its rejections and warnings.",

  // Address lookup (HERE)
  "addresses.searchLabel": "Search address",
  "addresses.searchPlaceholder": "Street and number, city…",
  "addresses.searchHelp": "Pick an address to fill in the fields below.",
  "addresses.placeLabel": "Find a business",
  "addresses.placePlaceholder": "Name and town, for example hema venray…",
  "addresses.placeHelp": "Pick a business to fill in the name, the address and the opening hours. Not a business? Fill in the address below.",
  "addresses.placeSearching": "Searching businesses…",
  "addresses.placeNone": "No business found. Fill in the address below.",
  "addresses.placeHasHours": "with opening hours",
  "addresses.mapAlt": "Map around {{label}}",
  "addresses.mapHelp": "Is the pin in the right place? If not, correct the address.",
  "addresses.mapUnavailable": "No map can be shown here; the coordinates are below.",
  "addresses.mapShow": "Show on the map",
  "addresses.mapNotFound": "The address lookup did not find this address on the map.",
  "addresses.lookupFailed": "Address search is not working right now. Enter the address yourself.",
  "addresses.lookupOff": "Address search is not available in this environment; enter the address yourself.",

  // Locations (Relaties → Locaties)
  "locations.searchPlaceholder": "Name, code, city, postal code…",
  "locations.searchLabel": "Search locations",
  "locations.hoursFilterLabel": "Opening hours",
  "locations.hoursAll": "All",
  "locations.hoursStatusKnown": "Known",
  "locations.hoursStatusUnknown": "Unknown",
  "locations.hoursStatusAlways": "Always open",
  "locations.requirementFilterLabel": "Requirement",
  "locations.requirementAll": "All requirements",
  "locations.countryFilterLabel": "Country",
  "locations.countryFilterPlaceholder": "Country",
  "locations.statusFilterLabel": "Status",
  "locations.newLocation": "New location",
  "locations.colName": "Name",
  "locations.colAddress": "Address",
  "locations.colCountry": "Country",
  "locations.colHours": "Opening hours",
  "locations.colRequirements": "Requirements",
  "locations.colAliases": "Aliases",
  "locations.colStatus": "Status",
  "locations.noLocations": "No locations found.",
  "locations.moreRequirements": "+{{count}}",
  "locations.newTitle": "New location",
  "locations.nameLabel": "Name",
  "locations.namePlaceholder": "E.g. Example DC Veghel",
  "locations.codeAuto": "WLX makes the code itself (WLX-000123). You search by name, town or postal code.",
  "locations.codeLabel": "Code",
  "locations.streetLabel": "Street",
  "locations.houseNumberLabel": "House number",
  "locations.additionLabel": "Addition",
  "locations.postalCodeLabel": "Postal code",
  "locations.cityLabel": "City",
  "locations.countryLabel": "Country",
  "locations.countryHelp": "Two letters, such as NL or DE.",
  "locations.detailLabel": "Additional information",
  "locations.detailHelp": "For example hall, unit, gate, dock or quay.",
  "locations.phoneLabel": "Phone",
  "locations.emailLabel": "Email",
  "locations.contactHelp": "Reception or dispatch, not a person.",
  "locations.glnLabel": "GLN",
  "locations.glnHelp": "GS1 location number, 13 digits.",
  "locations.addressAttachmentLabel": "Address attachment",
  "locations.addressAttachmentHelp": "The instruction for this address: choose or drop a pdf or film, or paste a link.",
  "locations.routeAttachmentLabel": "Route attachment",
  "locations.routeAttachmentHelp": "The route instruction: choose or drop a pdf or film, or paste a link.",
  "locations.addressAttachmentInfo": "The on-board computer opens this attachment as soon as the driver presses Arrival.",
  "locations.routeAttachmentInfo": "The on-board computer opens this attachment as soon as the driver presses Navigate.",
  "locations.attachmentPlaceholder": "Paste or drop a link: https://…",
  "locations.attachmentOpen": "Open",
  "locations.attachmentInvalid": "A link starts with http:// or https://.",
  "locations.attachmentChoose": "Choose file",
  "locations.attachmentReplace": "Replace",
  "locations.attachmentRemove": "Remove",
  "locations.attachmentRemoveConfirm": "Remove {{name}}? The link on the on-board computer stops working.",
  "locations.attachmentUploading": "Saving…",
  "locations.attachmentRemoving": "Removing…",
  "locations.attachmentStored": "Kept in WLX. Replace the file and the link on the on-board computer stays the same.",
  "locations.attachmentTooLarge": "An attachment is at most 100 MB.",
  "locations.notFound": "Location not found",
  "locations.notFoundDesc": "This location does not exist, or you have no access to it.",
  "locations.tabGeneral": "General",
  "locations.tabHours": "Opening hours",
  "locations.tabRequirements": "Requirements",
  "locations.tabAliases": "Aliases",
  "locations.talisNote":
    "This location comes from TALIS. Until the cutover on 16 November TALIS overwrites what it sends: a change here lasts until the next change there.",
  "locations.mergedInto": "Now part of",
  "locations.sameAddressTitle": "At the same address",
  "locations.sameAddressHelp": "TALIS sometimes made a location for every way a customer wrote the address. If it is the same place, join it into this one: its orders, stops, trips and branches come here, its code and address become aliases, and it becomes inactive. Leave another company at the same address as it is.",
  "locations.sameAddressNote": "{{count}} more location at this address",
  "locations.sameAddressNote_other": "{{count}} more locations at this address",
  "locations.activityCount": "{{count}} activity",
  "locations.activityCount_other": "{{count}} activities",
  "locations.mergeInto": "Join into this one",
  "locations.mergeConfirm": "{{name}} goes into {{into}}. This cannot be undone.",
  "locations.mergeConfirmYes": "Join",
  "locations.duplicatesTitle": "Duplicates",
  "locations.duplicatesIntro": "Addresses with more than one location. TALIS made a location for every way a customer wrote an address. Under Same name are locations with the same words in their name at one address: that is one place, and it can be joined in one go. Under Other names you decide per address: sometimes the same place written otherwise, as often different companies on one terrain. Proposed to stay is the location with the most orders; the others become its aliases.",
  "locations.duplicatesSame": "Same name",
  "locations.duplicatesDifferent": "Other names",
  "locations.duplicatesSearch": "Search by address, town or name…",
  "locations.duplicatesJoinAll": "Join all {{count}} duplicates",
  "locations.duplicatesJoinAllConfirm": "{{count}} locations go into the location with the same name at their address that stays. This cannot be undone.",
  "locations.duplicatesJoiningAll": "Working… {{count}} joined",
  "locations.duplicatesJoinedAll": "{{count}} location joined.",
  "locations.duplicatesJoinedAll_other": "{{count}} locations joined.",
  "locations.duplicatesJoined": "{{count}} location went into {{name}}.",
  "locations.ordersLinked": "{{count}} waiting order found its place by it.",
  "locations.ordersLinked_other": "{{count}} waiting orders found their place by it.",
  "locations.duplicatesJoined_other": "{{count}} locations went into {{name}}.",
  "locations.duplicatesKeep": "Stays",
  "locations.duplicatesJoin": "Join",
  "locations.duplicatesKeepPlace": "{{name}} stays",
  "locations.duplicatesJoinPlace": "Join {{name}}",
  "locations.duplicatesJoinGroup": "Join ({{count}})",
  "locations.duplicatesActivities": "Activities",
  "locations.duplicatesPlaces": "{{count}} location",
  "locations.duplicatesPlaces_other": "{{count}} locations",
  "locations.duplicatesNone": "No addresses with more than one location.",
  "locations.duplicatesRange": "{{from}}–{{to}} of {{total}} addresses",
  "locations.duplicatesPrevious": "← Previous",
  "locations.duplicatesNext": "Next →",
  "locations.addressTitle": "Address",
  "locations.contactTitle": "Contact",
  "locations.boardComputerTitle": "On-board computer",
  "locations.positionTitle": "Position",
  "locations.positionHelp": "From TALIS.",
  "locations.positionFromLookup": "From the address lookup (HERE): kept when Check address found the address right, or when it was taken over and saved.",
  "locations.positionNone": "No position yet. Check address adds it when the address is right; otherwise take over the suggestion and save.",
  "locations.talisPkLabel": "TALIS number",
  "locations.addressCheckTitle": "Address check",
  "locations.verdictValid": "Correct",
  "locations.verdictCorrected": "Written differently",
  "locations.verdictPartial": "Partly found",
  "locations.verdictNotFound": "Not found",
  "locations.verdictNone": "Not checked yet",
  "locations.checkedOn": "checked on {{date}}",
  "locations.sourceImport": "From TALIS",
  "locations.sourceHere": "From the address lookup",
  "locations.sourcePlanner": "By a planner",
  "locations.addressCheck": "Check address",
  "locations.checkDiffers": "Different: {{fields}}",
  "locations.checkCompletes": "Fills in: {{fields}}",
  "locations.checkTakeOver": "Take over",
  "locations.checkTakenOver": "Taken over into the fields. Save to keep it.",
  "locations.checkNothing": "The address lookup did not find this address.",
  "locations.hoursTitle": "Opening hours",
  "locations.hoursChoiceUnknown": "Unknown",
  "locations.hoursChoiceKnown": "Fixed hours",
  "locations.hoursChoiceAlways": "Always open",
  "locations.ruleDays": "Days",
  "locations.ruleOpen": "Opens",
  "locations.ruleClose": "Closes",
  "locations.ruleBreak": "Break",
  "locations.ruleBreakFrom": "Break from",
  "locations.ruleBreakTo": "to",
  "locations.ruleRemove": "Remove rule",
  "locations.ruleAdd": "Add other days",
  "locations.dayInOtherRule": "This day is already in another rule",
  "locations.dayShort1": "mon",
  "locations.dayShort2": "tue",
  "locations.dayShort3": "wed",
  "locations.dayShort4": "thu",
  "locations.dayShort5": "fri",
  "locations.dayShort6": "sat",
  "locations.dayShort7": "sun",
  "locations.hereHoursTitle": "According to HERE: {{place}}",
  "locations.hereHoursDistance": "{{meters}} m away",
  "locations.hereHoursHelp": "These are the opening hours of the business as HERE knows them, not necessarily the loading and unloading times. Take them over and correct what differs.",
  "locations.hereHoursTake": "Take over",
  "locations.hereHoursNone": "HERE knows no opening hours for this place.",
  "locations.hereHoursLooking": "Looking up opening hours at HERE…",
  "locations.hereLookup": "Look up at HERE",
  "locations.hereLookupName": "Search by name",
  "locations.hoursClosed": "closed",
  "locations.hoursPause": "break",
  "locations.hoursUnknown": "Opening hours unknown",
  "locations.hoursAlways": "Always open",
  "locations.hoursOvernight": "(into the next morning)",
  "locations.problemNoRules": "Add at least one rule, or choose Unknown.",
  "locations.problemNoDays": "Choose the days of every rule.",
  "locations.problemDayTwice": "A day is in two rules.",
  "locations.problemSameTime": "Opens and closes at the same time.",
  "locations.problemBreakOutside": "The break falls outside the opening hours.",
  "locations.problemInvalidTime": "Fill in every time, for example 8 or 16:30.",
  "locations.hoursCheckedOn": "Checked on {{date}}",
  "locations.hoursFromTalis": "From TALIS, not checked yet.",
  "locations.hoursNeverChecked": "Not checked yet.",
  "locations.requirementsTitle": "Requirements for vehicle, trailer or driver",
  "locations.requirementsHelp":
    "Only what the place itself asks. Route planning will work out weight and low-emission zones; a truck-mounted forklift is a transport requirement and sits on the consignment.",
  "locations.reqTailLift": "Tail lift",
  "locations.reqRigidWithTailLift": "Rigid truck with tail lift",
  "locations.reqNoRearTailLift": "No rear tail lift",
  "locations.reqCityTrailer": "City trailer",
  "locations.reqFcTraining": "FC-trained",
  "locations.fcTrainingFixed": "Comes with this address: FrieslandCampina only admits trained drivers here.",
  "locations.arrivalPopupLabel": "Arrival pop-up",
  "locations.arrivalPopupHelp": "On the on-board computer, when the driver starts a loading or unloading action here.",
  "locations.departurePopupLabel": "Departure pop-up",
  "locations.departurePopupHelp": "On the on-board computer, when the driver finishes a loading or unloading action here.",
  "locations.popupsAdminOnly": "Only an admin changes the pop-ups and the attachments: the driver sees them in the on-board computer.",
  "locations.preNotificationTitle": "Pre-notification",
  "locations.preNotificationHelp":
    "From TALIS. Pre-notification becomes a function in WLX later; until then the planner uses these details.",
  "locations.warehouseTitle": "Warehouse",
  "locations.noBatchPicking": "No batch picking",
  "locations.noBatchPickingHelp": "Orders to this address do not go into a round of batch picking; they are made pickable like any despatch. A return to the customer itself, say, or a dump order.",
  "locations.orderEntryTitle": "Order entry",
  "locations.tripMarkRequired": "Trip mark required",
  "locations.tripMarkRequiredHelp": "A channel order that unloads here waits in Needs attention until order entry gives it a trip mark: the trip it goes on.",
  "locations.deliveryWeekdays": "Fixed delivery days",
  "locations.deliveryWeekdaysHelp": "The days goods are delivered here. What of Hager's is not in goes to the next of these days. None ticked: every working day.",
  "locations.weekday1": "Monday",
  "locations.weekday2": "Tuesday",
  "locations.weekday3": "Wednesday",
  "locations.weekday4": "Thursday",
  "locations.weekday5": "Friday",
  "locations.preBookSlot": "Book a slot",
  "locations.preAnnounceTrip": "Announce the trip",
  "locations.preAlways": "For every order",
  "locations.preOnlyFor": "Only for {{debtors}}",
  "locations.preLinks": "Portal",
  "locations.preBookSlotEmails": "Slot mail",
  "locations.preAnnounceTripEmails": "Trip mail",
  "locations.preMemo": "Memo",
  "locations.preDemands": "Required",
  "locations.prePlateRequired": "licence plate",
  "locations.preEtaRequired": "ETA",
  "locations.aliasesHelp":
    "How orders and customers also name this place. An order with one of these codes or aliases lands on this location.",
  "locations.colAliasKind": "Kind",
  "locations.colAliasValue": "Alias",
  "locations.colSource": "Source",
  "locations.aliasKindCode": "Code",
  "locations.aliasKindAddress": "Address",
  "locations.aliasKindText": "Name",
  "locations.aliasesEmpty": "No aliases yet.",
  "locations.aliasRemove": "Remove",
  "locations.aliasKindLabel": "Kind",
  "locations.aliasValueLabel": "Alias",
  "locations.aliasAdd": "Add",
  "locations.aliasTooShort": "An alias has at least two characters.",

  // Transport orders (Transport → Opdrachten)
  "planning.openTrip": "Open the trip",
  "planning.fit.no_tail_lift": "No tail lift, and the place asks for one",
  "planning.fit.not_a_rigid": "Not a rigid, and the place asks for one",
  "planning.fit.has_rear_tail_lift": "Has a rear tail lift, which is not allowed there",
  "planning.fit.not_a_city_trailer": "No city trailer (a semi-trailer under 12 m), though the place asks for one",
  "planning.fit.driver_not_fc_trained": "Driver is not trained for FrieslandCampina",
  "planning.fit.no_adr_equipment": "No ADR equipment",
  "planning.fit.driver_no_adr": "Driver has no ADR",
  "planning.fit.no_forklift": "No truck-mounted forklift on the combination",
  "planning.fit.driver_no_forklift": "Driver is not qualified for the forklift",
  "planning.fit.no_cooling": "Not refrigerated, and the load asks for it",
  "planning.fit.not_a_tautliner": "No curtain sider",
  "planning.fit.missing_need": "The load asks for: {{need}}",
  "planning.fit.no_trailer": "Tractor without a trailer: the trip cannot be confirmed like this",
  "planning.fit.over_pallets": "{{load}} pallets in {{capacity}} places",
  "planning.fit.over_weight": "{{load}} kg on {{capacity}} kg payload",
  "planning.fit.over_meters": "{{load}} loading metres on {{capacity}}",
  "planning.fit.driver_ill": "Driver is ill",
  "planning.fit.driver_on_leave": "Driver is on leave",
  "planning.fit.driver_no_shift": "Driver has no shift that day",
  "planning.fit.driver_no_shift_on": "Driver has no shift on {{day}}",
  "planning.fit.driver_no_overnight": "Driver does not stay out overnight",
  "planning.fit.driver_no_vca": "Driver has no VCA",
  "planning.fit.driver_home_by": "Home by {{time}}, the trip is back later",
  "planning.fit.driver_start_after": "Not before {{time}}, the trip leaves earlier",
  "planning.fit.driver_restricted_day": "Restriction: not that day",
  "planning.fit.after_previous_load": "{{trip}} carried {{have}}: {{add}} may not follow",
  "planning.overnight": "Overnight",
  "planning.carriedFrom": "from {{day}}",
  "planning.sheet.uncouple": "Uncouple {{trailer}}",
  "planning.sheet.couple": "Couple {{trailer}}",
  "planning.conflictParked": "{{who}} is then uncoupled at {{depot}} ({{trip}}, {{range}})",
  "planning.conflictReload": "Reloading needed: the load is in {{who}} ({{trip}})",
  "planning.carriedHelp": "A trip of {{day}} that runs on today: it belongs to that day and counts in its day. What can go behind it is today's work.",
  "planning.overnightHelp": "The trip is back only after midnight: the driver stays out overnight, on the road or at the customer",
  "planning.dayNote": "Remark",
  "planning.dayNoteTitle": "Remark: {{text}}",
  "planning.filterByBranch": "Filter by branch",
  "planning.allBranches": "All branches",
  "planning.vehiclesOnBoard": "{{count}} vehicle",
  "planning.vehiclesOnBoard_other": "{{count}} vehicles",
  "planning.chartersInUse_one": "{{count}} in use",
  "planning.chartersInUse_other": "{{count}} in use",
  "planning.stopsShort_one": "{{count}} stop",
  "planning.stopsShort_other": "{{count}} stops",
  "planning.kpiClashes_one": "{{count}} double-booked",
  "planning.kpiClashes_other": "{{count}} double-booked",
  "planning.kpiAway_one": "{{count}} driver ill or on leave",
  "planning.kpiAway_other": "{{count}} drivers ill or on leave",
  "planning.kpiWaits_one": "{{count}} trip waits for the planner",
  "planning.kpiWaits_other": "{{count}} trips wait for the planner",
  "planning.waitsOnTrip_one": "Waits for the planner: {{count}} order",
  "planning.waitsOnTrip_other": "Waits for the planner: {{count}} orders",
  "planning.rowsCompose": "Compose",
  "planning.sheetPlanHere_one": "Put {{count}} leg on this one",
  "planning.sheetPlanHere_other": "Put {{count}} legs on this one",
  "planning.sheetDrivesLeftOut_one": "(1 drive without a position not counted)",
  "planning.sheetDrivesLeftOut_other": "({{count}} drives without a position not counted)",
  "planning.sheetByTime": "Propose the order",
  "planning.sheetByTimeHelp": "The order WLX proposes: as few stops late as can be, then the fewest kilometres",
  "planning.sheetPlanned_one": "{{count}} leg put on {{trip}}.",
  "planning.sheetPlanned_other": "{{count}} legs put on {{trip}}.",
  "planning.sheetMoved": "{{consignment}} is now on {{trip}}.",
  "planning.listNoTrip": "Pick a trip in the list.",
  "planning.listKvStops_one": "{{count}} stop",
  "planning.listKvStops_other": "{{count}} stops",
  "planning.listKvConsignments_one": "{{count}} consignment",
  "planning.listKvConsignments_other": "{{count}} consignments",
  "planning.listMoveStopHint": "Move a stop: drag, or",
  "planning.listReordered": "Order of {{trip}} changed.",
  "planning.listByTimeDone": "{{trip}} is in the order WLX proposes again.",
  "planning.listTakenOff": "{{consignment}} back to To plan, off {{trip}}.",
  "planning.undo": "Undo",
  "planning.undone": "Undone.",
  "planning.issueFitsNone_one": "fits no lorry",
  "planning.issueFitsNone_other": "fit no lorry",
  "planning.dropPreview_one": "+{{count}} consignment · peak {{from}} → ≈ {{to}}",
  "planning.dropPreview_other": "+{{count}} consignments · peak {{from}} → ≈ {{to}}",
  "planning.lmUnknown": "? m",
  "planning.scaleRigid": "{{lm}} small rigid",
  "planning.scaleTrailer": "{{lm}} trailer",
  "planning.reqCooling": "COOL",
  "planning.reqTailLift": "LIFT",
  "planning.reqRigid": "RIGID",
  "planning.reqNoRearLift": "NO REAR LIFT",
  "planning.reqCityTrailer": "CITY TRAILER",
  "planning.reqFc": "FC",
  "planning.lassoCaught_one": "1 leg",
  "planning.lassoCaught_other": "{{count}} legs",
  "planning.lassoWaitsForPickup_one": "1 still waits for its pickup",
  "planning.lassoWaitsForPickup_other": "{{count}} still wait for their pickup",
  "planning.crewTitleDriver": "Driver for {{trip}}",
  "planning.crewTitleTrailer": "Trailer for {{trip}}",
  "planning.crewOnLorry": "on {{code}}",
  "planning.crewSearchDriver": "Search name, number or place",
  "planning.crewSearchTrailer": "Search number, plate or place",
  "planning.crewCooled": "cooled",
  "planning.crewNoCapacity": "capacity unknown",
  "planning.crewCurrent": "on the trip now",
  "planning.crewNoQualifications": "no qualifications",
  "planning.crewHome": "same standplaats",
  "planning.crewHintDriver": "driver",
  "planning.crewHintTrailer": "trailer",
  "planning.crewPickDriver": "Pick a driver in the list.",
  "planning.crewPickTrailer": "Pick a trailer in the list.",
  "planning.crewAssign": "Put {{name}} on it",
  "planning.crewIsCurrent": "Already on this trip.",
  "planning.crewQualifications": "Qualified",
  "planning.crewMissing": "Missing",
  "planning.crewSwappedDriver_zero": "{{name}} now drives {{trip}}.",
  "planning.crewSwappedDriver_one": "{{name}} now drives {{trip}}, with 1 finding.",
  "planning.crewSwappedDriver_other": "{{name}} now drives {{trip}}, with {{count}} findings.",
  "planning.crewSwappedTrailer_zero": "Trailer {{name}} is now behind {{trip}}.",
  "planning.crewSwappedTrailer_one": "Trailer {{name}} is now behind {{trip}}, with 1 finding.",
  "planning.crewSwappedTrailer_other": "Trailer {{name}} is now behind {{trip}}, with {{count}} findings.",
  "planning.holding_one": "1 leg",
  "planning.holding_other": "{{count}} legs",
  "planning.capAssigned_zero": "{{trip}} is on {{what}}.",
  "planning.capAssigned_one": "{{trip}} is on {{what}}, with 1 finding.",
  "planning.capAssigned_other": "{{trip}} is on {{what}}, with {{count}} findings.",
  "planning.capBack": "Back",
  "planning.capError": "The lorries could not be read.",
  "planning.capGroupFree": "Fits and free",
  "planning.capGroupUnknown": "Unknown",
  "planning.capGroupFitsNot": "Does not fit",
  "planning.capGroupBusy": "Busy in this window",
  "planning.capMore_one": "{{count}} more that fits and is free",
  "planning.capMore_other": "{{count}} more that fit and are free",
  "planning.capNone": "No lorries found.",
  "planning.capCharterFree": "No trips on this day yet",
  "planning.capCharterTrips": "Already drives {{trips}}",
  "planning.capNoCharters": "No charters on the planning board.",
  "planning.capEffectLabel": "What changes",
  "planning.capIf": "If you choose {{code}}",
  "planning.capAssignNone": "Assign",
  "planning.capFits": "Fits",
  "planning.capFitsNot": "Does not fit",
  "planning.capUnknown": "Unknown",
  "planning.capBusy": "Busy",
  "planning.capFree": "Free",
  "planning.capIll": "ill",
  "planning.capLeave": "on leave",
  "planning.capNoShift": "no shift",
  "planning.capAvailable": "available",
  "planning.restriction.home_by": "home by {{time}}",
  "planning.restriction.start_after": "not before {{time}}",
  "planning.restriction.whole_day": "not that day",
  "planning.effShift": "Shift",
  "planning.effStill": "You can still assign.",
  "planning.effShiftFits": "Rostered that day: available all day.",
  "planning.effNoRoster": "No roster from AFAS for this day.",
  "planning.effShuttle_one": "a depot shuttle {{from}} → {{to}} for 1 consignment",
  "planning.effShuttle_other": "a depot shuttle {{from}} → {{to}} for {{count}} consignments",
  "planning.effFits": "Fits",
  "planning.effFitsUnknown": "Unknown: no capacity in the master data.",
  "planning.effBusy": "Busy",
  "planning.effBusyTrip": "{{trip}} ({{range}})",
  "planning.errorUnloadBeforeLoad": "{{consignment}} would be unloaded before it is loaded.",
  "planning.errorDepotStopFixed": "Loading at the depot stays the first stop and unloading there the last.",
  "planning.errorStopsChanged": "The trip changed in the meantime. Try again.",
  "planning.errorTractorWithoutTrailer": "{{vehicle}} is a tractor without a trailer. Give the trip a trailer first; then you can confirm it.",
  "planning.errorNothingToDecide": "Nothing is left to decide here. The card is read again.",
  "planning.v3.stepsLabel": "Steps of the planning",
  "planning.v3.step1": "Full deliveries",
  "planning.v3.step2": "Plan",
  "planning.v3.step3": "Overview",
  "planning.v3.step4": "Capacity",
  "planning.v3.countLoading": "…",
  "planning.v3.count1Open_one": "{{count}} full delivery",
  "planning.v3.count1Open_other": "{{count}} full deliveries",
  "planning.v3.count1Trips_one": "{{count}} trip · {{next}} with a follow-on",
  "planning.v3.count1Trips_other": "{{count}} trips · {{next}} with a follow-on",
  "planning.v3.count2_one": "{{count}} leg open",
  "planning.v3.count2_other": "{{count}} legs open",
  "planning.v3.count3": "{{trips}} trips · {{open}} open",
  "planning.v3.count4": "{{assigned}} of {{count}} on a lorry",
  "planning.v3.count4None": "lorry, driver, trailer",
  "planning.v3.dayLabel": "The day",
  "planning.v3.day": "The day",
  "planning.v3.estimate": "estimate",
  "planning.v3.panelResize": "Drag to make the panel wider or narrower; double-click puts it back",
  "planning.v3.overRoad": "over the road (HERE)",
  "planning.v3.trips": "Trips",
  "planning.v3.tripsOpen_one": "{{count}} leg open",
  "planning.v3.tripsOpen_other": "{{count}} legs open",
  "planning.v3.km": "Kilometres",
  "planning.v3.kmEmpty": "of which empty {{km}}",
  "planning.v3.hours": "Hours",
  "planning.v3.pendels": "Depot shuttles",
  "planning.v3.pendelRuns_one": "{{count}} shuttle run · {{km}} km",
  "planning.v3.pendelRuns_other": "{{count}} shuttle runs · {{km}} km",
  "planning.v3.pendelsMade_one": "{{count}} by the planning",
  "planning.v3.pendelsMade_other": "{{count}} by the planning",
  "planning.v3.deltaPendelPair": "+1 depot shuttle {{from}} → {{to}}",
  "planning.v3.deltaPendels": "{{value}} depot shuttles",
  "planning.v3.deltaRuns": "{{value}} shuttle run",
  "planning.v3.deltaKm": "{{value}} km",
  "planning.v3.deltaEmpty": "{{value}} km empty",
  "planning.v3.deltaTime": "{{value}}",
  "planning.v3.tomorrow": "tomorrow",
  "planning.v3.today": "today",
  "planning.v3.windowsFollow": "Main screen and map follow each other",
  "planning.v3.stepOf": "Step {{step}} of {{count}}",
  "planning.v3.next.adds": "then asks {{adds}}",
  "planning.v3.next.clash": "no {{add}} after {{have}} with the same lorry",
  "planning.v3.next.code": "{{code}}",
  "planning.v3.next.fits": "fits",
  "planning.v3.next.fitsWaits": "fits · waits",
  "planning.v3.next.full": "lorry full again",
  "planning.v3.next.inTheWay_one": "near {{count}} other consignment: perhaps a trip of its own",
  "planning.v3.next.inTheWay_other": "near {{count}} other consignments: perhaps a trip of its own",
  "planning.v3.next.late": "too late",
  "planning.v3.next.pendel": "+1 depot shuttle {{from}} → {{to}}",
  "planning.v3.next.tooBig": "does not fit in the lorry",
  "planning.v3.s1.alreadyBehindLead": "Behind it already:",
  "planning.v3.s1.endClosed": "With the pickup behind it the lorry drives on loaded to the depot: nothing more goes behind it.",
  "planning.v3.s1.endFull": "Nothing more behind it",
  "planning.v3.s1.endClosedOvernight": "The trip is only back after midnight: what goes behind it is for the next day.",
  "planning.v3.s1.endOvernight": "Back after midnight · nothing more behind it",
  "planning.v3.s1.behindAlready": "behind it: {{route}}",
  "planning.v3.s1.becomeText": "Every full delivery becomes a trip without a lorry. Factory shuttles follow the shuttle schedule: per route as many rounds back and forth on one trip as the schedule says, with the full shuttle load back in between; what is left stays in To plan. Then per trip you see where the lorry runs empty, and choose what goes behind it.",
  "planning.v3.s1.becomeTitle_one": "{{count}} full delivery becomes {{trips}}",
  "planning.v3.s1.becomeTitle_other": "{{count}} full deliveries become {{trips}}",
  "planning.v3.s1.tripsWord_one": "{{count}} trip",
  "planning.v3.s1.tripsWord_other": "{{count}} trips",
  "planning.v3.s1.toAndFroTitle": "Back and forth on one trip, without a shuttle schedule",
  "planning.v3.s1.toAndFroLine": "{{out}} out, {{back}} back",
  "planning.v3.s1.colKind": "Kind",
  "planning.v3.s1.colLoadAt": "Loading",
  "planning.v3.s1.rest": "left over",
  "planning.v3.s1.restHelp": "Does not fill a whole trip of the shuttle schedule: it stays in To plan for the regular planning, unless you tick it.",
  "planning.v3.s1.schemaTitle": "Shuttle schedule",
  "planning.v3.s1.schemaMixed": "Mixed: {{routes}}",
  "planning.v3.s1.restTitle_one": "1 factory shuttle stays in To plan",
  "planning.v3.s1.restTitle_other": "{{count}} factory shuttles stay in To plan",
  "planning.v3.s1.restLine_one": "1 left over",
  "planning.v3.s1.restLine_other": "{{count}} left over",
  "planning.v3.s1.warnLate": "a stop late",
  "planning.v3.s1.warnDriving": "over 9 hours driving in one day, maybe an overnight stop",
  "planning.v3.s1.editSchema": "View the shuttle schedule",
  "planning.v3.s1.clashCount_one": "{{count}} clashes with the requirement",
  "planning.v3.s1.clashCount_other": "{{count}} clash with the requirement",
  "planning.v3.s1.colBest": "Best behind it",
  "planning.v3.s1.colConsignment": "Consignment",
  "planning.v3.s1.colCustomer": "Customer",
  "planning.v3.s1.colDeltaKm": "Δ km",
  "planning.v3.s1.colEmptyFrom": "Empty from",
  "planning.v3.s1.colFrom": "From",
  "planning.v3.s1.colFull": "Full delivery",
  "planning.v3.s1.colKm": "Km",
  "planning.v3.s1.colLoad": "Load",
  "planning.v3.s1.colRequirements": "Requirements",
  "planning.v3.s1.colTo": "To",
  "planning.v3.s1.colTrip": "Trip",
  "planning.v3.s1.colUnload": "Unloading",
  "planning.v3.s1.depotLater": "unloads at a depot; which one follows from the lorry (step 4)",
  "planning.v3.s1.direct": "delivers straight, no depot",
  "planning.v3.s1.effectCritical_one": "{{count}} critical delivery",
  "planning.v3.s1.effectCritical_other": "{{count}} critical deliveries",
  "planning.v3.s1.effectDepot": "Depot",
  "planning.v3.s1.effectEmpty": "Empty",
  "planning.v3.s1.effectEmptyNoHome": "{{km}} km empty to {{city}}",
  "planning.v3.s1.effectEmptyText": "{{km}} km to {{city}} instead of {{back}} km back empty",
  "planning.v3.s1.effectKm": "{{km}} km, of which empty {{empty}}",
  "planning.v3.s1.effectNotice": "Notice",
  "planning.v3.s1.effectRequirements": "Requirements",
  "planning.v3.s1.effectRequirementsText_one": "{{count}} with a requirement: the lorry has to meet it",
  "planning.v3.s1.effectRequirementsText_other": "{{count}} with a requirement: the lorry has to meet them",
  "planning.v3.s1.effectTrips_one": "+{{count}} trip without a lorry",
  "planning.v3.s1.effectTrips_other": "+{{count}} trips without a lorry",
  "planning.v3.s1.emptyFrom": "Empty from {{time}} in {{city}}",
  "planning.v3.s1.endsTitle": "Open ends · {{count}}",
  "planning.v3.s1.filterCritical": "Critical",
  "planning.v3.s1.filterRequirement": "With a requirement",
  "planning.v3.s1.filter_fullDirect": "Full direct load fits behind",
  "planning.v3.s1.filter_clash": "Requirement clashes",
  "planning.v3.s1.filter_nothing": "Nothing near",
  "planning.v3.s1.fullTitle": "Full deliveries and factory shuttles · {{count}}",
  "planning.v3.s1.keyBehind": "behind it",
  "planning.v3.s1.keyCandidate": "choose",
  "planning.v3.s1.keyEnd": "open end",
  "planning.v3.s1.keyMake": "make trips",
  "planning.v3.s1.keyOpen": "leave open",
  "planning.v3.s1.keyRow": "row",
  "planning.v3.s1.keySpace": "Space",
  "planning.v3.s1.keyTick": "tick",
  "planning.v3.s1.leaveOpen": "Leave open",
  "planning.v3.s1.leftOpen": "left open",
  "planning.v3.s1.loadsThere": "What loads there",
  "planning.v3.s1.made_one": "{{count}} trip made.",
  "planning.v3.s1.made_other": "{{count}} trips made.",
  "planning.v3.s1.madeSkipped": "{{count}} trips made, {{skipped}} not: {{reason}}",
  "planning.v3.s1.makeTrips_one": "Make {{count}} trip",
  "planning.v3.s1.makeTrips_other": "Make {{count}} trips",
  "planning.v3.s1.modeEnds": "Open ends",
  "planning.v3.s1.modeFull": "Full deliveries and factory shuttles",
  "planning.v3.s1.modeLabel": "Full deliveries or open ends",
  "planning.v3.s1.noEnds": "No trips of full deliveries on this day yet.",
  "planning.v3.s1.noFull": "No full deliveries or factory shuttles waiting on this day.",
  "planning.v3.s1.noNewRequirement": "no requirement added",
  "planning.v3.s1.noneFits": "nothing that fits in time",
  "planning.v3.s1.noneInFilter": "Nothing in this selection.",
  "planning.v3.s1.nothingNear": "Nothing that loads within {{km}} km.",
  "planning.v3.s1.stretchTo": "Search up to {{km}} km",
  "planning.v3.s1.oneByOne": "One by one",
  "planning.v3.s1.openEnd": "Open end",
  "planning.v3.s1.previewBehind": "With {{city}} behind it",
  "planning.v3.s1.previewTrips_one": "With {{count}} trip",
  "planning.v3.s1.previewTrips_other": "With {{count}} trips",
  "planning.v3.s1.putBehind": "{{city}} is behind {{trip}}.",
  "planning.v3.s1.putBehindButton": "Put {{city}} behind it",
  "planning.v3.s1.previewBehindMany": "{{count}} behind it",
  "planning.v3.s1.putBehindMany": "{{count}} consignments put behind {{trip}}.",
  "planning.v3.s1.putBehindManyButton": "Put {{count}} behind",
  "planning.v3.s1.rankTitle": "Number {{rank}} by WLX; tick to put several behind at once",
  "planning.v3.s1.pickMore": "Add {{city}}",
  "planning.v3.s1.effectTogether_one": "In the lorry",
  "planning.v3.s1.effectTogether_other": "Together ({{count}})",
  "planning.v3.s1.togetherFits": "Highest load {{lm}} m of {{capacity}} m · {{kg}} kg of {{capacityKg}} kg",
  "planning.v3.s1.togetherTooMuch": "Does not fit: highest load {{lm}} m of {{capacity}} m · {{kg}} kg of {{capacityKg}} kg",
  "planning.v3.s1.togetherTooMuchShort": "Does not fit in the lorry: too many loading metres or too much weight",
  "planning.v3.s1.putBehindNone": "Put behind it",
  "planning.v3.s2.addedWithStop": "Added to {{trip}}, with a loading stop at depot {{depot}}.",
  "planning.v3.s2.depotBlock.title": "Delivery from another depot",
  "planning.v3.s2.depotBlock.text": "{{city}} loads at depot {{branch}}; the trip has depot {{home}} ({{why}}). It can, in two ways. You choose.",
  "planning.v3.s2.depotBlock.textStop": "{{city}} loads in {{branch}}, where the order itself loads: the trip collects it there.",
  "planning.v3.s2.depotBlock.stop": "Loading stop in {{city}}",
  "planning.v3.s2.depotBlock.stopText": "the lorry also loads in {{branch}}, before the first customer",
  "planning.v3.s2.depotBlock.pendel": "Depot shuttle {{from}} → {{to}}",
  "planning.v3.s2.depotBlock.pendelRides": "runs already; the delivery goes along",
  "planning.v3.s2.depotBlock.pendelNew": "a new depot shuttle run",
  "planning.v3.s2.depotBlock.runs_one": "+{{count}} depot shuttle run",
  "planning.v3.s2.depotBlock.runs_other": "+{{count}} depot shuttle runs",
  "planning.v3.s2.depotBlock.stays": "The depot stays {{home}}: most metres load there. Change it with Change depot.",
  "planning.v3.s2.depotBlock.becomes": "Note: that makes {{branch}} the depot with the most metres.",
  "planning.v3.s2.captionAll": "Step 2 · all consignments",
  "planning.v3.s2.captionSelection": "Step 2 · area",
  "planning.v3.s2.captionBuilding": "Step 2 · building a trip",
  "planning.v3.s2.titleAll": "Plan · all consignments",
  "planning.v3.s2.depotsLabel": "Lies at",
  "planning.v3.s2.depotsCustomer": "at the customer",
  "planning.v3.s2.depotsOpen": "depot still open",
  "planning.v3.s2.depotsHelp": "Per depot the number of consignments and the loading metres. A delivery lies where its goods are: the depot or warehouse it loads at, or where its pickup unloads. A pickup or a direct lies at the customer. Depot still open: the pickup has no depot yet.",
  "planning.v3.s2.textAll": "Draw the area you want to plan with the lasso on the map; this list then shows only that. All kinds: deliveries, pickups and direct loads. Farthest from a depot first.",
  "planning.v3.s2.textSelection": "Tick what becomes one trip. WLX sets the order (windows first, then the fewest kilometres) and reckons with the depot where the deliveries load the most metres.",
  "planning.v3.s2.textBuilding": "The rest of the area, per consignment whether it fits on the trip (metres, weight, requirements, time). To add: tick and Z, drag onto the trip, or click on the map.",
  "planning.v3.s2.lensOpen": "On the map: all open",
  "planning.v3.s2.lensFits": "On the map: fits the open trip",
  "planning.v3.s2.drawZone": "Draw an area",
  "planning.v3.s2.zonesLabel": "Areas",
  "planning.v3.s2.zoneAll": "All",
  "planning.v3.s2.zone": "Area {{n}}",
  "planning.v3.s2.zoneRemove": "Remove {{name}}",
  "planning.v3.s2.titleZone": "Plan · Area {{n}}",
  "planning.v3.s2.titleZones": "Plan · all areas",
  "planning.v3.s2.lassoHelp": "The lasso on the map, in the map window: every lasso becomes an area of its own, Area 1, Area 2, …, with a pill to filter the list on it; All shows the areas together. Coming from the board, a drag on the map draws an area straight away; a click in an area chooses it, a click outside lets go of everything.",
  "planning.v3.s2.search": "Search customer, place or consignment",
  "planning.v3.s2.checked_one": "{{count}} chosen · {{lm}} m",
  "planning.v3.s2.checked_other": "{{count}} chosen · {{lm}} m",
  "planning.v3.s2.newTrip": "New trip",
  "planning.v3.s2.putOn": "Put on {{trip}}",
  "planning.v3.s2.filter_fits": "Fits",
  "planning.v3.s2.filter_depot": "From another depot",
  "planning.v3.s2.filter_not": "Does not fit",
  "planning.v3.s2.colConsignment": "Consignment",
  "planning.v3.s2.colKind": "Kind",
  "planning.v3.s2.colFrom": "From",
  "planning.v3.s2.colTo": "To",
  "planning.v3.s2.colDistance": "Distance",
  "planning.v3.s2.distanceHelp": "Kilometres to the depot, estimated by road (as the crow flies × 1.3). In an area: from the farthest customer end in the area to the area's depot (the depot in it, else the depot nearest its middle). Outside one: from the farthest customer end of the consignment (for a delivery also where it came from, for a pickup where it goes) to the nearest depot",
  "planning.v3.s2.distanceFromArea": "{{city}} to {{depot}}, the depot of the area: {{km}} km",
  "planning.v3.s2.distanceFromNearest": "{{city}} to {{depot}}, the nearest depot: {{km}} km",
  "planning.v3.s2.colWindows": "Load · unload",
  "planning.v3.s2.colLdm": "Ldm",
  "planning.v3.s2.colPal": "Pal",
  "planning.v3.s2.colKg": "Kg",
  "planning.v3.s2.colRequirements": "Requirements",
  "planning.v3.s2.colCustomer": "Customer",
  "planning.v3.s2.sortBy": "Sort by {{column}}; again to reverse, a third time back to the order WLX gives",
  "planning.v3.s2.groupAll": "Farthest from a depot first",
  "planning.v3.s2.groupSelection": "In the area",
  "planning.v3.s2.groupSorted": "Everything open",
  "planning.v3.s2.tickAll": "Tick everything in the list",
  "planning.v3.s2.groupBuilding": "What fits first",
  "planning.v3.s2.groupBuildingSelection": "In the area · what fits first",
  "planning.v3.s2.noneOpen": "Nothing left to plan on this day.",
  "planning.v3.s2.noneFound": "Nothing found.",
  "planning.v3.s2.noneInArea": "Nothing in this area.",
  "planning.v3.s2.depot": "Depot",
  "planning.v3.s2.depotOpen": "follows from the trip",
  "planning.v3.s2.depotWindow": "depot",
  "planning.v3.fullOnWeight": "full on weight",
  "planning.markGroupHelp_one": "Trip mark: one consignment with {{numbers}}, {{metres}} m together. Planning one plans both",
  "planning.markGroupHelp_other": "Trip mark: one consignment with {{numbers}}, {{metres}} m together. Planning one plans them all",
  "planning.markTogether_one": "together, {{count}} consignment",
  "planning.markTogether_other": "together, {{count}} consignments",
  "planning.onTrailer": "on trailer {{code}}",
  "planning.uncoupledIn": "uncoupled in {{code}}",
  "planning.uncoupledHelp": "The load is in trailer {{code}}, uncoupled by {{trip}}: couple it, no reloading.",
  "planning.menuUncoupleAt": "Uncouple at {{depot}} ({{city}})",
  "planning.menuViaCrossdock": "Over the crossdock after all (no uncoupling)",
  "planning.noticeUncoupleAt": "{{consignment}} is uncoupled at {{depot}}: the load stays in the trailer, and the delivery couples it again.",
  "planning.onTrailerHelp": "The load is in the trailer of the pickup ({{trip}}).",
  "planning.v3.s4.loadTrailer": "load on trailer {{code}}",
  "planning.v3.s2.full": "full",
  "planning.v3.s2.keyTick": "tick",
  "planning.v3.s2.keyNew": "new trip",
  "planning.v3.s2.keyDragKey": "Drag",
  "planning.v3.s2.keyLasso": "draw an area",
  "planning.v3.s2.keyCharter": "to a charter",
  "planning.v3.s2.charter.menu_one": "Subcontract to a charter…",
  "planning.v3.s2.charter.menu_other": "Subcontract {{count}} consignments to a charter…",
  "planning.v3.s2.charter.title": "Subcontract to a charter",
  "planning.v3.s2.charter.summary_one": "{{count}} consignment · {{lm}} m · {{kg}} kg",
  "planning.v3.s2.charter.summary_other": "{{count}} consignments · {{lm}} m · {{kg}} kg",
  "planning.v3.s2.charter.more_one": "and {{count}} more",
  "planning.v3.s2.charter.more_other": "and {{count}} more",
  "planning.v3.s2.charter.search": "Search by name or code",
  "planning.v3.s2.charter.none": "No charter found. A blocked charter, or a relation not approved yet, is not in the list.",
  "planning.v3.s2.charter.onBoard": "On the planning board",
  "planning.v3.s2.charter.others": "Other charters",
  "planning.v3.s2.charter.after": "This becomes one new trip for this charter, with the price of the whole trip. Left empty, the order says (All-in). Send the transport order from the trip card afterwards.",
  "planning.v3.s2.charter.choose": "Choose a charter",
  "planning.v3.s2.charter.confirm": "Subcontract to {{charter}}",
  "planning.v3.s2.charter.done_one": "{{trip}} made for {{charter}} with {{count}} consignment. Send the transport order from the trip card.",
  "planning.v3.s2.charter.done_other": "{{trip}} made for {{charter}} with {{count}} consignments. Send the transport order from the trip card.",
  "planning.v3.s2.charter.partly": "{{trip}} was made, but {{charter}} is not on it: {{reason}} Choose the charter on the trip card.",
  "planning.v3.s2.charter.noTrip": "The trip was made, but WLX cannot find it on this day. Look in step 3.",
  "planning.v3.s2.charter.openTrip": "Open trip card {{trip}}",
  "planning.v3.s2.keyEsc": "let go",
  "planning.v3.s2.trips.viewLabel": "What the list shows",
  "planning.v3.s2.trips.viewHelp": "The consignments that wait, or the trips made so far; R switches",
  "planning.v3.s2.trips.viewLegs": "Consignments",
  "planning.v3.s2.trips.viewTrips": "Trips",
  "planning.v3.s2.trips.caption": "Step 2 · trips made",
  "planning.v3.s2.trips.titleAll": "Trips made",
  "planning.v3.s2.trips.text": "Every trip made so far, whatever the area. Click a trip to open it under the list, with Ctrl or Shift more trips on the map: take a consignment off with Delete, drag a stop to set the order or a consignment onto another trip here, or put more on it from Consignments (R).",
  "planning.v3.s2.trips.lens": "On the map: the trips",
  "planning.v3.s2.trips.withFull": "full deliveries too ({{count}})",
  "planning.v3.s2.trips.noneAll": "No trips made in step 2 yet.",
  "planning.v3.s2.trips.noneFiltered": "No trip for this filter or search.",
  "planning.v3.s2.trips.rowTitle": "Open {{trip}}, with Ctrl or Shift more trips on the map; right-click for its trip card or to delete it",
  "planning.v3.s2.trips.rowOpen": "{{trip}} is open, on the right",
  "planning.v3.s2.trips.keyView": "consignments · trips",
  "planning.v3.s2.trips.keyTrips": "trips",
  "planning.v3.s2.trips.keyMove": "open a trip",
  "planning.v3.s2.trips.keyMore": "trip on or off",
  "planning.v3.s2.waitsText_one": "{{count}} delivery waits for its pickup",
  "planning.v3.s2.waitsText_other": "{{count}} deliveries wait for their pickup",
  "planning.v3.s2.proposal": "Proposal",
  "planning.v3.s2.building": "Being built",
  "planning.v3.s2.newNumber": "new",
  "planning.v3.s2.depotChip": "Depot {{depot}}",
  "planning.v3.s2.stopsLine_one": "{{count}} stop · {{km}} km ({{empty}} empty) · {{from}}–{{to}} · driving {{driving}}",
  "planning.v3.s2.stopsLine_other": "{{count}} stops · {{km}} km ({{empty}} empty) · {{from}}–{{to}} · driving {{driving}}",
  "planning.v3.s2.departure": "Departure",
  "planning.v3.s2.departureAuto": "reckoned: as late as the windows allow",
  "planning.v3.s2.departureFixed": "set, the trip follows this time",
  "planning.v3.s2.departureReset": "Automatic",
  "planning.v3.s2.departureSet": "Departure of {{trip}} set to {{time}}; the stops move along.",
  "planning.v3.s2.departureCleared": "Departure of {{trip}} reckoned by WLX again.",
  "planning.sheet.label": "The stops of the trip",
  "planning.sheet.colSeq": "#",
  "planning.sheet.colTime": "Time",
  "planning.sheet.colWindow": "Window",
  "planning.sheet.colOpening": "Opening hours",
  "planning.sheet.openOwn": "Own branch: its opening hours do not hold our own lorries",
  "planning.sheet.openNone": "none",
  "planning.sheet.openNoneHelp": "No opening hours known: a free address, or a location without opening hours",
  "planning.sheet.openClosed": "closed",
  "planning.sheet.colPlace": "Place",
  "planning.sheet.colLocation": "Location",
  "planning.sheet.colWhat": "What",
  "planning.sheet.colConsignment": "Consignment",
  "planning.sheet.colCustomer": "Customer",
  "planning.sheet.colLdm": "Ldm",
  "planning.sheet.colKg": "Kg",
  "planning.sheet.colPal": "Pal",
  "planning.sheet.colOnBoard": "On board",
  "planning.sheet.colDrive": "Drive there",
  "planning.sheet.colNote": "Note",
  "planning.sheet.colStatus": "Status",
  "planning.sheet.consignments_one": "{{count}} consignment",
  "planning.sheet.consignments_other": "{{count}} consignments",
  "planning.sheet.more": "+{{count}}",
  "planning.sheet.actCount": "{{act}} {{count}}",
  "planning.sheet.departs": "departs",
  "planning.sheet.wait": "waits {{time}}",
  "planning.sheet.closed": "closed",
  "planning.sheet.slotLate": "{{time}} after the slot",
  "planning.sheet.windowLate": "{{time}} after the window, still open",
  "planning.sheet.breakOnRoad": "on the road, ± {{km}} km after {{place}}",
  "planning.sheet.breakOnRoadAfter": "on the road after {{place}}",
  "planning.sheet.breakAt": "at {{place}}",
  "planning.sheet.home": "Home",
  "planning.sheet.kmHome": "home {{km}} km",
  "planning.sheet.unloadsAt": "unloads at {{index}} {{place}}",
  "planning.sheet.loadedAt": "loaded at {{index}} {{place}}",
  "planning.sheet.lateOne": "1 stop late: {{city}} {{time}}",
  "planning.sheet.lateMany": "{{count}} stops late",
  "planning.sheet.departureAuto": "reckoned",
  "planning.sheet.departureFixed": "fixed",
  "planning.sheet.small": "Trip small",
  "planning.sheet.big": "Trip large",
  "planning.sheet.sizeHelp": "The trip under the list as a strip or as the whole sheet; WLX remembers it",
  "planning.sheet.resize": "Drag for more list or more trip; double-click: as high as the trip",
  "planning.sheet.moveTo": "To another trip",
  "planning.sheet.moveToLabel": "Which trip does {{consignment}} go to?",
  "planning.sheet.moveToBack": "Back",
  "planning.sheet.moveToNone": "No other trip on this day",
  "planning.sheet.moveToKm": "{{km}} km",
  "planning.sheet.barLine": "{{from}} → {{to}} · {{count}} stops · {{lm}} / {{capacity}} m",
  "planning.sheet.inMapWindow": "Trip sheet: in the map window",
  "planning.v3.s2.depotMetres": "Depot {{depot}} · most metres: {{metres}}",
  "planning.v3.s2.metresFrom": "{{lm}} m from {{branch}}",
  "planning.v3.s2.depotNearest": "Depot {{depot}} · no deliveries: nearest where it loads, until the lorry says",
  "planning.v3.s2.depotPlanner": "Depot {{depot}} · chosen by the planner",
  "planning.v3.s2.depotVehicle": "Depot {{depot}} · home base of the lorry",
  "planning.v3.s2.depotNone": "No depot yet: it follows from the lorry",
  "planning.v3.s2.depotChange": "Change depot",
  "planning.v3.s2.depotAuto": "As WLX reckons (most metres, then the lorry)",
  "planning.v3.s2.depotSet": "Depot of {{trip}}: {{depot}}.",
  "planning.timeline.activities": "Activities",
  "planning.timeline.drive": "Driving",
  "planning.timeline.wait": "Waiting",
  "planning.timeline.break": "Break",
  "planning.timeline.breakOrWait": "Break / waiting",
  "planning.timeline.breakLine": "break {{time}}",
  "planning.timeline.restLine": "daily rest {{time}}",
  "planning.timeline.load": "Loading",
  "planning.timeline.unload": "Unloading",
  "planning.timeline.loadLegend": "Loading metres (colour scale)",
  "planning.timeline.was": "Thin bar: the trip without what is ticked, {{from}}–{{to}}",
  "planning.timeline.band_full": "{{from}} – {{to}} lm",
  "planning.timeline.band_fair": "{{from}} – {{to}} lm",
  "planning.timeline.band_low": "{{from}} – {{to}} lm",
  "planning.timeline.band_poor": "{{from}} – {{to}} lm",
  "planning.timeline.bandEmpty": "0 lm",
  "planning.timeline.lm": "{{lm}} lm",
  "planning.timeline.blockTitle": "{{what}} {{from}}–{{to}} · {{duration}}",
  "planning.timeline.loadOnBoard": "{{lm}} lm on board, {{share}}% of {{capacity}} lm · {{from}}–{{to}}",
  "planning.timeline.leaves": "Leaves {{place}} · {{time}}",
  "planning.timeline.back": "Back at {{place}} · {{time}}",
  "planning.timeline.stopTitle": "{{index}}. {{name}}, {{city}}",
  "planning.v3.s2.peak": "Highest load",
  "planning.v3.s2.peakText": "{{lm}} of {{capacity}} m · {{kg}} kg of {{capacityKg}} kg",
  "planning.v3.s2.fits.button": "Fits anyway",
  "planning.v3.s2.fits.help": "The planner knows it fits in the lorry with the rest: WLX loads the consignment with the rest at the depot instead of in a second round, and does not count its loading metres against the lorry (P103).",
  "planning.v3.s2.fits.then": "Together in the lorry: {{reason}}",
  "planning.v3.s2.fits.added": "Fits anyway: {{consignment}} is on {{trip}} and loads with the rest",
  "planning.v3.s2.fits.set": "Fits anyway: {{consignment}} loads with the rest on {{trip}}",
  "planning.v3.s2.fits.unset": "{{consignment}} counts with its loading metres again on {{trip}}",
  "planning.v3.s2.fits.menuSet": "Fits anyway (together in the lorry)",
  "planning.v3.s2.fits.menuUnset": "Take back fits anyway",
  "planning.v3.s2.fits.peak": "· fits anyway: counts {{lm}} m",
  "planning.v3.s2.fits.chip": "fits anyway",
  "planning.v3.s2.fits.chipBy": "Fits anyway according to {{by}}, {{when}}: WLX does not count its loading metres against the lorry",
  "planning.v3.s2.withAdded_one": "with {{count}} added: {{km}} km · {{time}}",
  "planning.v3.s2.withAdded_other": "with {{count}} added: {{km}} km · {{time}}",
  "planning.v3.s2.stopsLabel": "Stops in the order of the trip",
  "planning.v3.s2.driveLine": "{{km}} km · {{time}}",
  "planning.v3.s2.driveUnknown": "position unknown: no km",
  "planning.v3.s2.depotOf": "Depot {{depot}}",
  "planning.v3.s2.actLoad": "Load",
  "planning.v3.s2.actUnload": "Unload",
  "planning.v3.s2.actLoadDepot": "Load at depot",
  "planning.v3.s2.actUnloadDepot": "Unload at depot",
  "planning.v3.s2.actBoth": "Load and unload",
  "planning.v3.s2.makeTrip": "New trip",
  "planning.v3.s2.cancel": "Let go",
  "planning.v3.s2.done": "Trip done",
  "planning.v3.s2.doneNotice": "{{trip}} is done for now; the area stays for the next one.",
  "planning.v3.s2.closedNotice": "{{trip}} is closed; what is on it stays on it.",
  "planning.v3.s2.made_one": "{{trip}} made with {{count}} consignment.",
  "planning.v3.s2.made_other": "{{trip}} made with {{count}} consignments.",
  "planning.v3.s2.added_one": "{{count}} consignment added to {{trip}}.",
  "planning.v3.s2.added_other": "{{count}} consignments added to {{trip}}.",
  "planning.v3.s2.removed_one": "{{count}} consignment taken off {{trip}}.",
  "planning.v3.s2.removed_other": "{{count}} consignments taken off {{trip}}.",
  "planning.v3.s2.previewNew_one": "With this trip ({{count}} consignment)",
  "planning.v3.s2.previewNew_other": "With this trip ({{count}} consignments)",
  "planning.v3.s2.previewAdd": "With {{city}} added",
  "planning.v3.s2.previewAddCount_one": "With {{count}} added",
  "planning.v3.s2.previewAddCount_other": "With {{count}} added",
  "planning.v3.s2.fit.onTrip": "On the trip",
  "planning.v3.s2.fit.fits": "Fits · {{km}} km",
  "planning.v3.s2.fit.fitsLate": "Fits · {{km}} km · {{city}} {{time}} after its window, still open",
  "planning.v3.s2.fit.fitsLateMany": "Fits · {{km}} km · {{count}} stops after their window, still open",
  "planning.v3.s2.fit.fits_on_the_way": "Fits · {{km}} km · on the way",
  "planning.v3.s2.fit.fits_on_the_way_back": "Fits · {{km}} km · on the way back",
  "planning.v3.s2.fit.fits_on_route": "Fits · {{km}} km · on the route",
  "planning.v3.s2.fit.depotPendel": "Fits · {{km}} km · from depot {{branch}}: depot shuttle to the trip's depot ({{rides}}, {{pendelKm}} km) or a loading stop in {{branch}} ({{stopKm}} km)",
  "planning.v3.s2.fit.depotStop": "Fits · {{km}} km · loads in {{branch}}: a loading stop there ({{stopKm}} km)",
  "planning.v3.s2.fit.rides": "runs already",
  "planning.v3.s2.fit.newRun": "a new depot shuttle run",
  "planning.v3.s2.fit.adds": "then asks {{adds}}",
  "planning.v3.s2.fit.waits": "Waits for its pickup",
  "planning.v3.s2.fit.waitsFrom": "Waits for its pickup in {{origin}}",
  "planning.v3.s2.fit.noPosition": "Position unknown: no km and no time",
  "planning.v3.s2.fit.clash": "Does not fit: {{add}} and {{have}} not on one trip",
  "planning.v3.s2.fit.overMeters": "Does not fit: {{over}} m too much ({{peak}} of {{capacity}} m)",
  "planning.v3.s2.fit.overWeight": "Does not fit: {{peak}} kg of {{capacity}} kg",
  "planning.v3.s2.fit.late": "Then {{city}} is late: {{arrival}}, window until {{windowEnd}}",
  "planning.v3.s2.fit.lateDay": "Then {{city}} only on {{at}}, window {{window}}",
  "planning.v3.s2.fit.lateMany": "Then {{count}} stops are late: {{stops}}",
  "planning.v3.s2.fit.lateManyDay": "Then {{count}} stops fall outside their window, {{other}} on another day: {{stops}}",
  "planning.v3.s2.fit.closed": "{{city}} would be closed: {{arrival}}, open {{open}}",
  "planning.v3.s2.fit.closedDay": "{{city}} would be closed: {{arrival}}",
  "planning.v3.s2.fit.slotMissed": "{{city}} would miss its slot: {{arrival}}, slot until {{windowEnd}}",
  "planning.v3.s2.late.addDay": "This pushes the trip into {{day}}",
  "planning.v3.s2.late.add_one": "This makes {{count}} stop late",
  "planning.v3.s2.late.add_other": "This makes {{count}} stops late",
  "planning.v3.s2.late.tripDay": "This trip runs into {{day}}",
  "planning.v3.s2.late.trip_one": "{{count}} stop on this trip is late",
  "planning.v3.s2.late.trip_other": "{{count}} stops on this trip are late",
  "planning.v3.s2.late.text": "Outside the window agreed with the customer:",
  "planning.v3.s2.late.stop": "{{city}} · {{act}} {{at}} · window {{window}}",
  "planning.v3.s2.late.stopClosed": "{{city}} · {{act}} {{at}} · closed, open {{open}}",
  "planning.v3.s2.late.stopSlot": "{{city}} · {{act}} {{at}} · slot {{window}}",
  "planning.v3.s2.late.load": "load",
  "planning.v3.s2.late.unload": "unload",
  "planning.v3.s2.fit.overDriving": "Too long a drive: {{time}} in one day, more than 9 h",
  "planning.v3.s3.title": "Overview of the day",
  "planning.v3.s3.text": "Every trip of the day. Depot shuttles are not listed as trips here; De dag counts them. On the right what is not planned yet, with the reason. Click a trip to see it under the list and on the map; with Ctrl or Shift you pick more trips, which the map shows together. The right mouse button gives the menu of the trip, with Plan further. In the trip under the list the consignments sit under their stops: drag a stop to change the order, or a consignment onto a trip in the list to move it.",
  "planning.v3.s3.lens": "On the map: Trips",
  "planning.v3.s3.filter_requirements": "With a requirement",
  "planning.v3.s3.filter_otherDepot": "Loading stop at another depot",
  "planning.v3.s3.filter_late": "Late",
  "planning.v3.s3.filter_markSplit": "Trip mark split",
  "planning.v3.s3.stageLabel": "Which trips",
  "planning.v3.s3.stage_all": "All",
  "planning.v3.s3.stage_1": "Step 1",
  "planning.v3.s3.stage_2": "Step 2",
  "planning.v3.s3.markSplit": "Trip mark split: {{marks}}",
  "planning.v3.s3.markOnTrip": "{{mark}} on trip {{trip}}",
  "planning.v3.s3.markWaiting": "{{mark}} not planned yet",
  "planning.v3.s3.colTrip": "Trip",
  "planning.v3.s3.colRoute": "From → to",
  "planning.v3.s3.colDepot": "Depot",
  "planning.v3.s3.colStops": "Stops",
  "planning.v3.s3.colPeak": "Peak",
  "planning.v3.s3.colKm": "Km",
  "planning.v3.s3.colTime": "Time",
  "planning.v3.s3.colDuration": "Duration",
  "planning.v3.s3.timeTitle": "From departure until back: {{range}}",
  "planning.v3.s3.durationTitle": "Trip duration from departure until back: {{time}}",
  "planning.v3.s3.daysLater_one": "the next day",
  "planning.v3.s3.daysLater_other": "{{count}} days later",
  "planning.v3.s3.daysEarlier_one": "the day before",
  "planning.v3.s3.daysEarlier_other": "{{count}} days earlier",
  "planning.v3.s3.colRequirements": "Requirements",
  "planning.v3.s3.consignments_one": "{{count}} consignment",
  "planning.v3.s3.consignments_other": "{{count}} consignments",
  "planning.v3.s3.more": "+{{count}}",
  "planning.v3.s3.depotSource_planner": "Depot chosen by the planner",
  "planning.v3.s3.depotSource_vehicle": "Depot: where the lorry is based",
  "planning.v3.s3.depotSource_provisional": "Provisional, until a lorry is on it: the departure in the pendelschema, where the deliveries load, or our own branch by the work",
  "planning.v3.s3.lateStops_one": "{{count}} stop late",
  "planning.v3.s3.lateStops_other": "{{count}} stops late",
  "planning.v3.s3.rowTitle": "Show {{trip}} on the right; right mouse button to plan it further",
  "planning.v3.s3.dragStop": "Drag to change the order, or Alt ↑ ↓",
  "planning.v3.s3.dragLeg": "Drag onto a trip on the left to move the consignment; right mouse button for more",
  "planning.v3.s3.moveLegHint": "Consignment to another trip: drag it onto the trip on the left",
  "planning.v3.s3.manualOrder": "Order set by hand",
  "planning.v3.s3.menuTakeOff": "Take off the trip",
  "planning.v3.s3.unloadFirst": "A consignment would be unloaded there before it is loaded.",
  "planning.v3.s3.showConsignments_one": "Show {{count}} consignment",
  "planning.v3.s3.showConsignments_other": "Show {{count}} consignments",
  "planning.v3.s3.planThis": "Plan further",
  "planning.v3.s3.closeTrip": "Close the trip",
  "planning.v3.s3.menuDelete": "Delete this trip…",
  "planning.v3.s3.deleteAsk": "Delete trip {{number}}?",
  "planning.v3.s3.deleteDo": "Yes, delete it",
  "planning.v3.s3.giveBack_one": "The consignment goes back to the work to plan.",
  "planning.v3.s3.giveBack_other": "The {{count}} consignments go back to the work to plan.",
  "planning.v3.s3.groupFull": "Full deliveries with what follows",
  "planning.v3.s3.groupPlanned": "Planned in step 2",
  "planning.v3.s3.groupKm": "{{km}} km",
  "planning.v3.s3.none": "No trips on this day yet.",
  "planning.v3.s3.noneFiltered": "No trip with this filter.",
  "planning.v3.s3.keyBack": "back to planning",
  "planning.v3.s3.keyOpen": "open the trip",
  "planning.v3.s3.keyMove": "trip",
  "planning.v3.s3.keyCapacity": "capacity",
  "planning.v3.s3.openCaption": "Not planned yet",
  "planning.v3.s3.openTitle_one": "{{count}} consignment",
  "planning.v3.s3.openTitle_other": "{{count}} consignments",
  "planning.v3.s3.openSub": "{{lm}} m · on no trip yet",
  "planning.v3.s3.allPlanned": "Everything of this day is on a trip.",
  "planning.v3.s3.reasonsError": "Why it is not planned yet could not be read.",
  "planning.v3.s3.reasonGroup.fits": "Fits on a trip",
  "planning.v3.s3.reasonGroup.waits_for_pickup": "After the pickup",
  "planning.v3.s3.reasonGroup.small": "Alone and small: fits no trip",
  "planning.v3.s3.reasonGroup.nowhere": "Fits nowhere",
  "planning.v3.s3.reasonText.fits": "There is a trip nearby it fits on, at most 60 km round. Click to open that trip in step 2 with the consignment chosen.",
  "planning.v3.s3.reasonText.waits_for_pickup": "The delivery can only be planned once its pickup is on a trip.",
  "planning.v3.s3.reasonText.small": "Too small for a trip of its own, and no trip nearby it fits on (time, lorry or requirements). Plan it with a trip, or through a depot.",
  "planning.v3.s3.reasonText.nowhere": "No trip nearby takes it in time, in the lorry or with the requirements. Make a trip of it in step 2.",
  "planning.v3.s3.reason.fits": "fits on {{trip}} · {{km}} km",
  "planning.v3.s3.reason.waits": "its pickup is on no trip yet",
  "planning.v3.s3.reason.waitsFrom": "its pickup in {{origin}} is on no trip yet",
  "planning.v3.s3.reason.noPosition": "address without a position",
  "planning.v3.s3.reason.noTrip": "no trip nearby",
  "planning.v3.s3.reason.longWay": "{{trip}} takes it, but {{km}} km round",
  "planning.v3.s3.reason.near": "{{trip}} · {{why}}",
  "planning.v3.s3.far": "{{km}} km from {{depot}}",
  "planning.v3.s3.openTrip": "Open in step 2, on this trip",
  "planning.v3.s3.openLeg": "Show in step 2",
  "planning.v3.s3.back": "Back to planning",
  "planning.v3.s3.toCapacity": "On to capacity",
  "planning.v3.s4.tripsTitle": "Trips without a lorry",
  "planning.v3.s4.assigned": "{{count}} put in already",
  "planning.v3.s4.sortLabel": "Sort",
  "planning.v3.s4.sort_earliest": "Earliest away",
  "planning.v3.s4.sort_bottlenecks": "Bottlenecks first",
  "planning.v3.s4.error": "The capacity could not be loaded.",
  "planning.v3.s4.noneOpen": "No trips without a lorry.",
  "planning.v3.s4.unknownFree_one": "Besides, 1 lorry is free with a capacity WLX does not know (a tractor without a fixed trailer, or no loading metres in the master data).",
  "planning.v3.s4.unknownFree_other": "Besides, {{count}} lorries are free with a capacity WLX does not know (a tractor without a fixed trailer, or no loading metres in the master data).",
  "planning.v3.s4.fits_one": "1 fits",
  "planning.v3.s4.fits_other": "{{count}} fit",
  "planning.v3.s4.keyTrip": "trip",
  "planning.v3.s4.keyPut": "put in",
  "planning.v3.s4.keySupply": "supply and demand",
  "planning.v3.s4.keyFleet": "fleet",
  "planning.v3.s4.fleetLabel": "Fleet for the trip",
  "planning.v3.s4.allAssigned": "Every trip of the day has a lorry or a charter.",
  "planning.v3.s4.toOverview": "To the overview",
  "planning.v3.s4.undo": "Undo",
  "planning.v3.s4.peak": "peak {{lm}} · {{kg}} kg",
  "planning.v3.s4.onLorry": "on {{what}}",
  "planning.v3.s4.depotChip": "Depot {{depot}}",
  "planning.v3.s4.depotNone": "No depot yet",
  "planning.v3.s4.depotFollows": "Loads at {{home}} · depot follows the lorry",
  "planning.v3.s4.depotFollowsTitle": "{{home}} is no depot: the trip gets the depot of the lorry's standplaats.",
  "planning.v3.s4.stripLoads": "loads here",
  "planning.v3.s4.depotSource_planner": "Depot {{depot}}, chosen by the planner",
  "planning.v3.s4.depotSource_vehicle": "Depot {{depot}}, the standplaats of the lorry",
  "planning.v3.s4.depotSource_provisional": "Depot {{depot}}, for now: the departure in the pendelschema or where the most metres load. A lorry brings its standplaats as the depot.",
  "planning.v3.s4.stripFree_one": "1 fits and is free",
  "planning.v3.s4.stripFree_other": "{{count}} fit and are free",
  "planning.v3.s4.stripDepot": "depot",
  "planning.v3.s4.stripSub": "{{all}} lorries · {{taken}} fit but are taken",
  "planning.v3.s4.segmentLabel": "Group",
  "planning.v3.s4.segment_all": "All",
  "planning.v3.s4.segment_free": "Fit",
  "planning.v3.s4.segment_taken": "Taken",
  "planning.v3.s4.segment_fitsNot": "Does not fit",
  "planning.v3.s4.chip_tractor": "Tractor",
  "planning.v3.s4.chip_rigid": "Rigid",
  "planning.v3.s4.chip_cooling": "Cooled",
  "planning.v3.s4.chip_home": "Standplaats {{depot}}",
  "planning.v3.s4.colLorry": "Lorry",
  "planning.v3.s4.colKind": "Kind · space",
  "planning.v3.s4.colBody": "Body",
  "planning.v3.s4.colDriver": "Driver · roster",
  "planning.v3.s4.colStand": "Standpl.",
  "planning.v3.s4.colStatus": "For this trip",
  "planning.v3.s4.noneFiltered": "No lorry with these filters.",
  "planning.v3.s4.group_free": "Fits and free",
  "planning.v3.s4.group_taken": "Fits, but taken or not on duty",
  "planning.v3.s4.group_fitsNot": "Does not fit",
  "planning.v3.s4.group_unknown": "Capacity unknown",
  "planning.v3.s4.groupMeta_free": "rostered first, then the fewest depot shuttles and km for the day",
  "planning.v3.s4.groupMeta_taken": "while the trip runs",
  "planning.v3.s4.groupMeta_fitsNot": "with the reason",
  "planning.v3.s4.groupMeta_unknown": "tractor without a fixed trailer, or no loading metres in the master data",
  "planning.v3.s4.more": "+{{count}} more",
  "planning.v3.s4.noDriver": "no usual driver",
  "planning.v3.s4.noTrailer": "{{kind}}, no trailer",
  "planning.v3.s4.st.free": "fits · free",
  "planning.v3.s4.st.freeAfter": "fits · free after {{trip}} ({{time}})",
  "planning.v3.s4.st.freeUntil": "fits · free until {{trip}} ({{time}})",
  "planning.v3.s4.st.busy": "taken {{trip}} {{start}}–{{end}}",
  "planning.v3.s4.st.fitsNot": "does not fit: {{reason}}",
  "planning.v3.s4.st.fitsNotPlain": "does not fit",
  "planning.v3.s4.st.noTrailer": "no fixed trailer: choose one with it",
  "planning.v3.s4.st.unknown": "capacity unknown",
  "planning.v3.s4.dep.none": "no standplaats",
  "planning.v3.s4.dep.chosen": "depot {{depot}} chosen",
  "planning.v3.s4.dep.stays": "depot stays {{depot}}",
  "planning.v3.s4.dep.open": "depot open: {{home}} is no depot",
  "planning.v3.s4.dep.becomes": "depot becomes {{depot}}",
  "planning.v3.s4.dep.pendels_one": "+1 depot shuttle {{pairs}}",
  "planning.v3.s4.dep.pendels_other": "+{{count}} depot shuttles {{pairs}}",
  "planning.v3.s4.dep.becomesPendels_one": "depot becomes {{depot}} · +1 depot shuttle {{pairs}}",
  "planning.v3.s4.dep.becomesPendels_other": "depot becomes {{depot}} · +{{count}} depot shuttles {{pairs}}",
  "planning.v3.s4.dayKm": "{{km}} km for the day",
  "planning.v3.s4.standplaats": "standplaats {{code}}",
  "planning.v3.s4.noStandplaats": "no standplaats",
  "planning.v3.s4.pickLorry": "Choose a lorry",
  "planning.v3.s4.pickCharter": "Choose a charter",
  "planning.v3.s4.charters": "Charters",
  "planning.v3.s4.chartersMeta": "who drive for us day in day out",
  "planning.v3.s4.ownFleet": "Own lorries",
  "planning.v3.s4.put": "Put {{code}} in",
  "planning.v3.s4.board.title": "Board",
  "planning.v3.s4.board.viewLabel": "View",
  "planning.v3.s4.board.view_board": "Board",
  "planning.v3.s4.board.view_fleet": "Per trip",
  "planning.v3.s4.board.view_supply": "Supply and demand",
  "planning.v3.s4.board.complete": "All {{count}} trips fully planned",
  "planning.v3.s4.board.onLorry": "{{count}} of {{all}} trips on a lorry",
  "planning.v3.s4.board.driverOpen": "{{count}} without a driver",
  "planning.v3.s4.board.trailerOpen": "{{count}} without a trailer",
  "planning.v3.s4.board.kindLabel": "Which lorries",
  "planning.v3.s4.board.kind_all": "All",
  "planning.v3.s4.board.kind_tractor": "Tractors",
  "planning.v3.s4.board.kind_rigid": "Rigids",
  "planning.v3.s4.board.search": "Find a lorry, plate, driver or trailer",
  "planning.v3.s4.board.colTrailer": "Trailer",
  "planning.v3.s4.board.driver": "Driver",
  "planning.v3.s4.board.open": "open",
  "planning.v3.s4.board.open_driver": "driver open",
  "planning.v3.s4.board.open_trailer": "trailer open",
  "planning.v3.s4.board.pickTrip": "Choose a trip on the left and then a lorry, or drag the trip onto the lorry. A click on a trip on the board shows what is still open.",
  "planning.v3.s4.board.pickRow": "Choose a lorry",
  "planning.v3.s4.board.chooseDriver": "Choose driver",
  "planning.v3.s4.board.otherDriver": "Another driver",
  "planning.v3.s4.board.chooseTrailer": "Choose trailer",
  "planning.v3.s4.board.otherTrailer": "Another trailer",
  "planning.v3.s4.board.driverChosen": "{{what}} drives {{trip}}.",
  "planning.v3.s4.board.trailerChosen": "{{what}} goes with {{trip}}.",
  "planning.v3.s4.board.crewOpenTitle": "Driver or trailer open",
  "planning.cap.boardOff": "No board",
  "planning.cap.boardWindow": "Board apart",
  "planning.cap.windowTitle": "Board · {{date}}",
  "planning.cap.listTitle": "Trips of the day",
  "planning.cap.tabsLabel": "Which trips",
  "planning.cap.tab_all": "All",
  "planning.cap.tab_vehicle": "Without lorry",
  "planning.cap.tab_driver": "Without driver",
  "planning.cap.tab_trailer": "Without trailer",
  "planning.cap.tab_done": "Done",
  "planning.cap.chosenElsewhere": "Chosen on the board: a trip of another day",
  "planning.cap.otherDay": "{{trip}} is a trip of {{day}}; the list stays this day",
  "planning.cap.openBoard": "The board with the drivers and trailers is in the second window: choose Board apart at the top right.",
  "planning.cap.colPick": "Chosen",
  "planning.cap.colTime": "Departure – back",
  "planning.cap.colLorry": "Lorry",
  "planning.cap.colDriver": "Driver",
  "planning.cap.colTrailer": "Trailer",
  "planning.cap.colUsualDriver": "Usual driver",
  "planning.cap.colUsualTrailer": "Usual trl.",
  "planning.cap.noneInTab": "No trips under this tab.",
  "planning.cap.open": "open",
  "planning.cap.keyNextOpen": "next trip with something open",
  "planning.cap.keyLists": "drivers, trailers",
  "planning.cap.keyUnassign": "off the lorry",
  "planning.cap.keyUndo": "undo",
  "planning.cap.keySheet": "trip sheet small or whole",
  "planning.cap.keyClose": "close trip",
  "planning.cap.closeTrip": "Close trip",
  "planning.cap.unassign": "Off the lorry",
  "planning.cap.unassigned": "{{trip}} came off its lorry and waits under Without lorry again",
  "planning.cap.driverRemoved": "Driver taken off {{trip}}",
  "planning.cap.trailerRemoved": "Trailer taken off {{trip}}",
  "planning.cap.noRoster": "no roster",
  "planning.cap.noUsualDriver": "no usual driver",
  "planning.cap.box.toLorry": "Drag to a lorry",
  "planning.cap.box.lorryHint": "on the board, or choose it there and click a free row",
  "planning.cap.box.standplaats": "based in {{city}}",
  "planning.cap.box.charter": "charter, with its own driver and trailer",
  "planning.cap.box.charterCrew": "the charter drives itself",
  "planning.cap.box.choose": "Choose",
  "planning.cap.box.driverHint": "beside the board, or drag one onto the bar",
  "planning.cap.box.trailerHint": "beside the board, or drag one onto the bar",
  "planning.cap.box.lorryFirst": "a lorry first",
  "planning.cap.box.rigid": "a rigid has no trailer",
  "planning.cap.box.toList": "To the list beside the board",
  "planning.cap.box.removeDriver": "Take the driver off",
  "planning.cap.box.removeTrailer": "Take the trailer off",
  "planning.cap.putHere": "put {{trip}} here",
  "planning.cap.driverOpen": "Driver open",
  "planning.cap.trailerOpen": "Trailer open",
  "planning.cap.driverOpenLower": "driver open",
  "planning.cap.trailerOpenLower": "trailer open",
  "planning.cap.charter": "Charter",
  "planning.cap.charters": "Charters",
  "planning.cap.noCharters": "No regular charters. Tick On the planning board on a charter's relation card and it is here every day.",
  "planning.cap.handed": "Handed out",
  "planning.cap.onCharter": "On {{name}}",
  "planning.cap.onLorry": "On {{code}}",
  "planning.cap.onVehicle": "on {{code}}",
  "planning.cap.noLorryYet": "no lorry yet",
  "planning.cap.begins": "begins in {{city}}",
  "planning.cap.daysLabel": "Days on the board",
  "planning.cap.dayLess": "One day less (−)",
  "planning.cap.dayMore": "One day more (+)",
  "planning.cap.days_one": "1 day",
  "planning.cap.days_other": "{{count}} days",
  "planning.cap.along.comes": "{{name}} comes along",
  "planning.cap.along.none_driver": "no usual driver: driver stays open",
  "planning.cap.along.none_trailer": "no usual trailer: trailer stays open",
  "planning.cap.along.busy_driver": "{{name}} is busy: driver stays open",
  "planning.cap.along.busy_trailer": "{{name}} is busy: trailer stays open",
  "planning.cap.along.away_driver": "usual driver {{reason}}: driver stays open",
  "planning.cap.along.away_trailer": "{{name}} {{reason}}: trailer stays open",
  "planning.cap.along.reason_ill": "ill",
  "planning.cap.along.reason_leave": "on leave",
  "planning.cap.along.reason_noShift": "without a shift",
  "planning.cap.placed": "{{trip}} is on {{what}}",
  "planning.cap.came_one": "{{names}} came along",
  "planning.cap.came_other": "{{names}} came along",
  "planning.cap.and": " and ",
  "planning.cap.mind": "mind: {{text}}",
  "planning.cap.crewPlaced": "{{name}} is on {{trip}}",
  "planning.cap.onTo": "on to {{trip}}",
  "planning.cap.allDone": "every trip is fully planned",
  "planning.cap.listsLabel": "Drivers and trailers",
  "planning.cap.forTrip": "For {{trip}} · {{time}}",
  "planning.cap.pickTrip": "Choose a trip",
  "planning.cap.pickTripText": "Without a trip chosen: who has a shift that day and is on no trip, and which trailers are on no trip",
  "planning.cap.drivers": "Drivers",
  "planning.cap.trailers": "Trailers",
  "planning.cap.group.current": "On this trip",
  "planning.cap.group.available_driver": "Available",
  "planning.cap.group.available_trailer": "Available · stands in {{city}}",
  "planning.cap.group.elsewhere": "Available · stands elsewhere",
  "planning.cap.group.warn": "Available, mind",
  "planning.cap.group.busy": "Busy",
  "planning.cap.group.away": "Not available",
  "planning.cap.group.cannot": "Cannot",
  "planning.cap.group.free": "Available, on no trip yet",
  "planning.cap.group.onTrip": "On a trip already",
  "planning.cap.group.show": "show",
  "planning.cap.group.fold": "fold",
  "planning.cap.lists.charter": "A charter drives with its own driver and trailer",
  "planning.cap.lists.lorryFirst": "Put the trip on a lorry first: then you can choose",
  "planning.cap.lists.rigid": "A rigid has no trailer",
  "planning.cap.lists.open_driver": "Open on {{trip}}: choose a driver",
  "planning.cap.lists.open_trailer": "Open on {{trip}}: choose a trailer",
  "planning.cap.lists.alsoOpen_driver": "Also open on {{trip}}: the driver",
  "planning.cap.lists.alsoOpen_trailer": "Then: the trailer is open too",
  "planning.cap.lists.free": "available",
  "planning.cap.lists.freeFrom": "available from {{time}}",
  "planning.cap.lists.freeAfter": "available from {{time}} after {{trip}}",
  "planning.cap.lists.standplaats": "home base",
  "planning.cap.lists.elsewhere": "stands in {{city}} → {{to}}",
  "planning.cap.lists.placeUnknown": "place unknown",
  "planning.cap.lists.onTrips": "on {{trips}}",
  "planning.cap.lists.busyOn": "on {{trip}} until {{time}}",
  "planning.cap.lists.awayUntil": "{{reason}} until {{time}}",
  "planning.cap.lists.cooled": "cooled",
  "planning.cap.lists.tailLift": "tail lift",
  "planning.cap.lists.freeCount": "{{count}} available",
  "planning.cap.lists.searchDriver": "Find driver",
  "planning.cap.lists.searchTrailer": "Find trailer",
  "planning.cap.lists.none": "Nobody found.",
  "planning.cap.lists.goesAlong": "goes with {{code}}",
  "planning.cap.lists.fixedOn": "usual on {{code}}",
  "planning.cap.lists.fixedBehind": "usual behind {{code}}",
  "planning.cap.lists.choose": "Choose",
  "planning.cap.lists.off": "Off",
  "planning.cap.override.title": "Cannot:",
  "planning.cap.override.text": "Beheer → Vervoerseisen says this cannot. Go on anyway? Say why: it goes into the trip's log.",
  "planning.cap.override.reason": "Why anyway",
  "planning.cap.override.go": "Go on anyway",
  "planning.v3.s4.putCharter": "Put {{name}} in",
  "planning.v3.s4.need.refrigerated": "cooled",
  "planning.v3.s4.need.tautliner": "tautliner",
  "planning.v3.s4.need.adr_equipment": "ADR",
  "planning.v3.s4.need.truck_mounted_forklift": "forklift",
  "planning.v3.s4.need.tail_lift": "lift",
  "planning.v3.s4.need.box": "box",
  "planning.v3.s4.need.curtain": "curtain",
  "planning.v3.s4.supplyTitle": "Supply and demand per depot",
  "planning.v3.s4.supplyText": "free = lorry with a driver on duty, on no trip yet · needed = trips without a lorry",
  "planning.v3.s4.colDepot": "Depot",
  "planning.v3.s4.colOpen": "Without lorry",
  "planning.v3.s4.colLong": "Long · needed / free",
  "planning.v3.s4.colShort": "Short · needed / free",
  "planning.v3.s4.total": "Total",
  "planning.v3.s4.tripsWord_one": "trip",
  "planning.v3.s4.tripsWord_other": "trips",
  "planning.v3.s4.subLong": "tractor",
  "planning.v3.s4.subShort": "rigid",
  "planning.v3.s4.hoursTitle": "Over the day",
  "planning.v3.s4.hoursText": "per hour: trips on the road against lorries with a driver on duty",
  "planning.v3.s4.withLorry": "with a lorry",
  "planning.v3.s4.withoutLorry": "no lorry yet",
  "planning.v3.s4.available": "available",
  "planning.v3.s4.hourTitle": "{{hour}}:00 · {{assigned}} with a lorry · {{open}} without · {{available}} lorries available",
  "planning.v3.s4.knelTitle": "Bottlenecks",
  "planning.v3.s4.knelMeta": "trips with 0 to 2 lorries that fit and are free",
  "planning.v3.s4.knelNone": "No bottlenecks: every trip has three or more lorries that fit and are free.",
  "planning.v3.s4.tripsCount_one": "1 trip",
  "planning.v3.s4.tripsCount_other": "{{count}} trips",
  "planning.v3.s4.knel.missing": "{{need}}: no lorry in the master data",
  "planning.v3.s4.knel.missingText": "No lorry or trailer has this in the master data. Is the master data wrong, or does it become a charter?",
  "planning.v3.s4.knel.noneFits": "No lorry that fits",
  "planning.v3.s4.knel.noneFitsText": "Too long, too heavy or the wrong body, for every lorry with its fixed trailer.",
  "planning.v3.s4.knel.noneFree": "No lorry that fits and is free",
  "planning.v3.s4.knel.noneFreeText": "Lorries fit, but they drive already or their driver is not on duty.",
  "planning.v3.s4.knel.few": "One or two lorries that fit",
  "planning.v3.s4.knel.fewText": "Put these in first, or the lorry that fits is gone.",
  "planning.v3.s1.stepCaption": "Step 1",
  "planning.v3.s1.tick": "Take {{number}}",
  "planning.v3.s1.anywayTitle": "Does not fit in the lorry",
  "planning.v3.s1.anywayIntro": "With {{what}} behind it, {{trip}} is too full:",
  "planning.v3.s1.anywayMany": "{{count}} consignments",
  "planning.v3.s1.anywayMeters": "{{over}} m too many: highest load {{lm}} m of {{capacity}} m",
  "planning.v3.s1.anywayWeight": "{{over}} kg too heavy: highest load {{kg}} kg of {{capacityKg}} kg",
  "planning.v3.s1.anywayAsk": "Are you sure?",
  "planning.v3.s1.anywayConfirm": "Put it behind anyway",
  "planning.v3.s1.arrives": "arrives ± {{time}}",
  "planning.v3.s1.closerHome": "nearer {{home}}",
  "planning.v3.s1.emptyKmHelp": "Driving empty from {{city}} to {{to}}",
  "planning.v3.s1.emptyThere": "empty there",
  "planning.v3.s1.extra": "extra",
  "planning.v3.s1.extraDirect": "{{empty}} km empty to {{city}}, unloading in {{to}} and then on to {{home}}: {{km}} km against {{back}} km back empty",
  "planning.v3.s1.extraNoHome": "{{km}} km on the day",
  "planning.v3.s1.extraPickup": "{{empty}} km empty to {{city}} and then {{after}} km to {{home}}: {{km}} km against {{back}} km back empty",
  "planning.v3.day.same": "The plan day, {{day}}",
  "planning.v3.day.later_one": "One day after the plan day ({{day}})",
  "planning.v3.day.later_other": "{{count}} days after the plan day ({{day}})",
  "planning.v3.day.earlier_one": "One day before the plan day ({{day}})",
  "planning.v3.day.earlier_other": "{{count}} days before the plan day ({{day}})",
  "planning.v3.s1.goesToDepot": "depot",
  "planning.v3.s1.markAlong_one": "{{mark}}: {{along}} comes along",
  "planning.v3.s1.markAlong_other": "{{mark}}: {{along}} come along",
  "planning.v3.s1.markFull_one": "{{mark}}, {{count}} consignment: {{lm}} m · {{kg}} kg",
  "planning.v3.s1.markFull_other": "{{mark}}, {{count}} consignments together: {{lm}} m · {{kg}} kg",
  "planning.v3.s1.goesViaDepot": "{{city}}, through the depot",
  "planning.v3.s1.legend": "Empty there: km empty from {{city}} to where it loads. Extra: what the day gains against driving back empty to {{home}} ({{back}} km); minus is less. Nearer {{code}}: afterwards the lorry is nearer home than in {{city}}.",
  "planning.v3.s1.legendNoHome": "Empty there: km empty from {{city}} to where it loads. Without a lorry the trip has no depot yet; what a choice does to the depot shows in step 4.",
  "planning.v3.s1.pallets_one": "{{count}} pallet",
  "planning.v3.s1.pallets_other": "{{count}} pallets",
  "planning.v3.s1.headEmpty": "km empty there",
  "planning.v3.s1.headExtra": "extra km against {{km}} km back empty",
  "planning.v3.s1.headTime": "in time",
  "planning.v3.s1.headWhat": "what loads, for whom and where to",
  "planning.v3.s1.withoutBehindShort": "with nothing behind it {{km}} km back empty to {{home}}",
  "planning.v3.s1.cancelAskMany_one": "Cancel {{count}} trip?",
  "planning.v3.s1.cancelAskMany_other": "Cancel {{count}} trips?",
  "planning.v3.s1.cancelFailed_one": "{{count}} trip not cancelled ({{trip}}): {{reason}}",
  "planning.v3.s1.cancelFailed_other": "{{count}} trips not cancelled, the first {{trip}}: {{reason}}",
  "planning.v3.s1.cancelGivesBack_one": "The full delivery waits again under Full deliveries.",
  "planning.v3.s1.cancelGivesBack_other": "The full deliveries wait again under Full deliveries.",
  "planning.v3.s1.cancelGivesBackBehind_one": "The full delivery waits again under Full deliveries, what was behind it in step 2.",
  "planning.v3.s1.cancelGivesBackBehind_other": "The full deliveries wait again under Full deliveries, what was behind them in step 2.",
  "planning.v3.s1.cancelOne": "Cancel {{number}}",
  "planning.v3.s1.colVehicle": "Lorry",
  "planning.v3.s1.colWeight": "Weight",
  "planning.v3.s1.keepTrips": "Keep them",
  "planning.v3.s1.keyOneMore": "one more",
  "planning.v3.s1.keyRun": "run",
  "planning.v3.s1.menuAll": "Tick all",
  "planning.v3.s1.menuCancelMany_one": "Cancel {{count}} trip…",
  "planning.v3.s1.menuCancelMany_other": "Cancel {{count}} trips…",
  "planning.v3.s1.menuCopyNumber": "Copy the consignment number",
  "planning.v3.s1.menuCopyNumbers_one": "Copy {{count}} consignment number",
  "planning.v3.s1.menuCopyNumbers_other": "Copy {{count}} consignment numbers",
  "planning.v3.s1.menuCopyTrips_one": "Copy {{count}} trip number",
  "planning.v3.s1.menuCopyTrips_other": "Copy {{count}} trip numbers",
  "planning.v3.s1.menuLeaveOpen_one": "Leave open",
  "planning.v3.s1.menuLeaveOpen_other": "Leave {{count}} open",
  "planning.v3.s1.menuMakeMany_one": "Make a trip of {{count}} delivery",
  "planning.v3.s1.menuMakeMany_other": "Make trips of {{count}} deliveries",
  "planning.v3.s1.menuMakeOne": "Make the trip",
  "planning.v3.s1.menuNone": "Untick all",
  "planning.v3.s1.menuOnly": "Tick only this one",
  "planning.v3.s1.menuReopen_one": "No longer leave open",
  "planning.v3.s1.menuReopen_other": "No longer leave {{count}} open",
  "planning.v3.s1.menuRoute_one": "Tick all from {{from}} to {{to}} ({{count}})",
  "planning.v3.s1.menuRoute_other": "Tick all from {{from}} to {{to}} ({{count}})",
  "planning.v3.s1.menuTick": "Tick",
  "planning.v3.s1.menuUntick": "Untick",
  "planning.v3.s1.menuUntickMany_one": "Untick {{count}}",
  "planning.v3.s1.menuUntickMany_other": "Untick {{count}}",
  "planning.v3.s1.tickAll": "Tick all full deliveries",
  "planning.v3.s1.tickAllTrips": "Tick all trips",
  "planning.v3.s1.tickTrip": "Tick {{number}}",
  "planning.v3.s1.ticked_one": "{{count}} ticked",
  "planning.v3.s1.ticked_other": "{{count}} ticked",
  "planning.v3.s1.tickedOf_one": "{{count}} of {{total}} ticked",
  "planning.v3.s1.tickedOf_other": "{{count}} of {{total}} ticked",
  "planning.v3.s1.unloadsHome": "unloads in {{home}}, where the lorry is at home",
  "planning.v3.s1.waits": "waits {{time}}",
  "planning.v3.s1.within_one": "{{count}} within {{km}} km",
  "planning.v3.s1.within_other": "{{count}} within {{km}} km",
  "planning.v3.s1.radiusKm": "{{km}} km",
  "planning.v3.s1.radiusLabel": "Search within",
  "planning.v3.s1.bestFirst": "best first",
  "planning.v3.card.clash": "Does not fit: no {{add}} after {{have}} with the same lorry (Beheer → Vervoerseisen)",
  "planning.v3.card.depot": "depot",
  "planning.v3.card.fits": "Fits · {{km}} km for the day · {{empty}} km empty",
  "planning.v3.card.goods": "Load",
  "planning.v3.card.late": "Not in time",
  "planning.v3.card.load": "Loading",
  "planning.v3.card.requirements": "Requirements",
  "planning.v3.card.unload": "Unloading",
  "planning.times.load": "loads {{window}}",
  "planning.times.unload": "unloads {{window}}",
  "planning.times.window": "window {{window}}",
  "planning.times.slot": "time slot {{window}}",
  "planning.times.slotAsked": "time slot {{window}} (customer asked {{asked}})",
  "planning.times.open": "open {{times}}",
  "planning.times.closed": "closed that day",
  "planning.times.always": "always open",
  "planning.times.hoursUnknown": "opening hours unknown",
  "planning.times.help":
    "Open: the place's opening hours that day. A window is shown only when the order has a time of its own; a time slot was booked at the place (Mark as announced): planning plans on it, the price goes by what the customer asked.",
  "planning.v3.lens.barAdd": "{{city}} added: {{km}} km",
  "planning.v3.lens.barAddCount_one": "{{count}} consignment added",
  "planning.v3.lens.barAddCount_other": "{{count}} consignments added",
  "planning.v3.lens.barBuilding": "{{trip}} being built: click what goes on, Z puts it on the trip",
  "planning.v3.lens.barFits": "{{count}} fit · {{not}} do not · Alt-click takes off the trip",
  "planning.v3.lens.barOrder": "WLX sets the order: windows first, then the fewest kilometres",
  "planning.v3.tally.unload": "Unloading · deliveries",
  "planning.v3.tally.load": "Loading · pickups",
  "planning.v3.tally.direct": "Direct",
  "planning.v3.tally.unloadShort": "Unloading",
  "planning.v3.tally.loadShort": "Loading",
  "planning.v3.tally.stopsWord_one": "stop",
  "planning.v3.tally.stopsWord_other": "stops",
  "planning.v3.tally.consignmentsWord_one": "consignment",
  "planning.v3.tally.consignmentsWord_other": "consignments",
  "planning.v3.tally.elsewhereDeliveries_one": "and 1 delivery that loads here and unloads elsewhere",
  "planning.v3.tally.elsewhereDeliveries_other": "and {{count}} deliveries that load here and unload elsewhere",
  "planning.v3.tally.elsewherePickups_one": "and 1 pickup from elsewhere to a depot here",
  "planning.v3.tally.elsewherePickups_other": "and {{count}} pickups from elsewhere to a depot here",
  "planning.v3.tally.choose": "Click chooses {{zone}}",
  "planning.v3.tally.selection": "Selection",
  "planning.v3.tally.checked_one": "{{count}} ticked",
  "planning.v3.tally.checked_other": "{{count}} ticked",
  "planning.v3.tally.together": "together {{lm}} m · depot {{depot}}",
  "planning.v3.tally.keys": "click ticks or unticks · Alt-click takes off the trip · Esc to All, then the areas away",
  "planning.v3.lens.barLasso": "Draw an area around what you want to plan",
  "planning.v3.lens.barTickZone_one": "{{count}} in {{zone}}: a click ticks or unticks",
  "planning.v3.lens.barTickZone_other": "{{count}} in {{zone}}: a click ticks or unticks",
  "planning.v3.lens.barTickAll_one": "All areas, {{count}}: a click ticks or unticks",
  "planning.v3.lens.barTickAll_other": "All areas, {{count}}: a click ticks or unticks",
  "planning.v3.lens.barZones": "A lasso is a new area; a click in an area chooses it, outside lets go of everything",
  "planning.v3.lens.barZone": "Every lasso becomes an area of its own · a click picks one consignment, Ctrl-click adds or removes",
  "planning.v3.lens.lasso": "Draw an area",
  "planning.v3.lens.openTrip": "Open trip",
  "planning.v3.lens.barBehind": "{{city}} behind {{trip}}: {{km}} km",
  "planning.v3.lens.barEnd": "Open end of {{trip}} in {{city}}",
  "planning.v3.lens.barEnds_one": "{{count}} trip chosen",
  "planning.v3.lens.barEnds_other": "{{count}} trips chosen, together on the map",
  "planning.v3.lens.barEndsOne": "Choose one trip for what can follow it, with the radius",
  "planning.v3.lens.barFull": "Each a trip without a lorry, factory shuttles by the shuttle schedule; then what goes behind it",
  "planning.v3.lens.barLabel": "What can be done now",
  "planning.v3.lens.barWithin_one": "{{count}} loads within {{km}} km of {{city}}",
  "planning.v3.lens.barWithin_other": "{{count}} load within {{km}} km of {{city}}",
  "planning.v3.map.adds": "asks {{adds}}",
  "planning.v3.map.chosen": "chosen · {{km}} km",
  "planning.v3.map.clash": "✕ {{add}} · after {{have}}",
  "planning.v3.map.fromDepot": "from {{branch}} · {{km}} km",
  "planning.v3.map.fits": "fits · {{km}} km",
  "planning.v3.map.late": "not in time",
  "planning.v3.map.legendOpen": "Not planned yet",
  "planning.v3.map.roadNote": "Over the road (HERE): {{road}} of {{count}} trips · the rest a straight line, estimated",
  "planning.v3.map.kindShown": "What the map shows",
  "planning.v3.map.kindAll": "Everything",
  "planning.v3.map.kindDeliveries": "Deliveries",
  "planning.v3.map.kindPickups": "Pickups",
  "planning.v3.map.kindDirects": "Direct",
  "planning.v3.map.kindHelp": "Click: only this kind · Ctrl+click: more kinds at once",
  "planning.nextRange": "Later days",
  "planning.previousRange": "Earlier days",
  "planning.rangeDays_other": "{{count}} days",
  "planning.rangeDays_one": "{{count}} day",
  "planning.rangeFrom": "From",
  "planning.legsCount_one": "{{count}} to plan",
  "planning.legsCount_other": "{{count}} to plan",
  "planning.legsBehind_one": "{{count}} late",
  "planning.legsBehind_other": "{{count}} late",
  "planning.legColGoods": "Goods",
  "planning.legColPallets": "Pal",
  "planning.legsDragged_one": "{{count}} consignment · {{totals}}",
  "planning.legsDragged_other": "{{count}} consignments · {{totals}}",
  "planning.legsPicked_one": "{{count}} picked",
  "planning.legsPicked_other": "{{count}} picked",
  "planning.kindDirect": "Direct",
  "planning.kindPickup": "Pickup",
  "planning.kindShuttle": "Depot shuttle",
  "planning.kindFactoryShuttle": "Factory shuttle",
  "planning.kindDelivery": "Delivery",
  "planning.depotOpen": "Depot",
  "planning.waitsForPickup": "After pickup",
  "planning.routeViaDepot": "Via depot",
  "trips.depotUnload": "Unload at depot",
  "trips.depotLoad": "Load at depot",
  "trips.uncouple": "Uncouple",
  "trips.couple": "Couple",
  "branches.depotThresholdLabel": "Loading and unloading on different days: below this many loading metres through a depot",
  "branches.depotThresholdHelp": "Applies to orders that come in from now on. The planner can decide otherwise per consignment.",
  "branches.depotThresholdSaved": "Saved",
  "branches.sameDayDirectLabel": "Loading and unloading on one day: direct",
  "branches.sameDayDirectHelp": "A consignment that loads and unloads on the same day goes direct, also below the threshold. The planner can still send it through a depot by hand. Applies to orders that come in from now on.",
  "planning.menuLoadAt": "Load at depot {{depot}} ({{city}})",
  "planning.menuUnloadAt": "Unload at depot {{depot}} ({{city}})",
  "planning.menuFollowTrip": "Depot follows the trip again",
  "planning.noticeLoadsAt": "{{consignment}} loads at depot {{depot}}.",
  "planning.noticeUnloadsAt": "{{consignment}} unloads at depot {{depot}}.",
  "planning.noticeFollowsTrip": "{{consignment}} follows the trip's depot again.",
  "planning.errorNotThroughDepot": "{{consignment}} does not go through a depot on this leg.",
  "planning.menuLabel": "Leg of {{consignment}}",
  "planning.menuDeliverDirect": "Deliver directly, no depot",
  "planning.menuDirectNoDepot": "Direct, no depot",
  "planning.menuOpenOrder": "Open order",
  "planning.menuOpenOrderNewTab": "Open order in a new tab",
  "planning.noticeShuttleAdded": "Depot shuttle {{consignment}} needed: the pickup unloads at {{from}}, the delivery loads at {{to}} — waiting to be planned",
  "planning.noticeShuttleRemoved": "Depot shuttle {{consignment}} dropped",
  "planning.noticeShuttleOffNotNeeded": "Depot shuttle {{consignment}} taken off {{trip}}: no longer needed",
  "planning.noticeShuttleOffMoved": "Depot shuttle {{consignment}} taken off {{trip}}: between other depots now, plan it again",
  "planning.menuViaDepot": "Via depot (the trip's depot)",
  "planning.menu.giveBackAll": "What is on it goes back to Te plannen.",
  "planning.menu.tripsLabel_one": "{{count}} trip",
  "planning.menu.tripsLabel_other": "{{count}} trips",
  "planning.menu.deleteMany_one": "Delete {{count}} trip…",
  "planning.menu.deleteMany_other": "Delete {{count}} trips…",
  "planning.menu.letGoMany_one": "Delete or cancel {{count}} trip…",
  "planning.menu.letGoMany_other": "Delete or cancel {{count}} trips…",
  "planning.menu.deleteAskMany_one": "Delete {{count}} trip?",
  "planning.menu.deleteAskMany_other": "Delete {{count}} trips?",
  "planning.menu.letGoAskMany_one": "Delete or cancel {{count}} trip?",
  "planning.menu.letGoAskMany_other": "Delete or cancel {{count}} trips?",
  "planning.menu.letGoDo": "Yes, take them away",
  "planning.menu.deleteManyButton_one": "Delete {{count}} trip",
  "planning.menu.deleteManyButton_other": "Delete {{count}} trips",
  "planning.menu.cancelManyButton_one": "Cancel {{count}} trip",
  "planning.menu.cancelManyButton_other": "Cancel {{count}} trips",
  "planning.menu.letGoManyButton_one": "Delete or cancel {{count}} trip",
  "planning.menu.letGoManyButton_other": "Delete or cancel {{count}} trips",
  "planning.menu.deleteOne": "Delete {{number}}",
  "planning.menu.gone_delete_one": "{{count}} trip deleted: the full delivery waits again under Full deliveries.",
  "planning.menu.gone_delete_other": "{{count}} trips deleted: the full deliveries wait again under Full deliveries.",
  "planning.menu.gone_cancel_one": "{{count}} trip cancelled: the full delivery waits again under Full deliveries.",
  "planning.menu.gone_cancel_other": "{{count}} trips cancelled: the full deliveries wait again under Full deliveries.",
  "planning.menu.gone_both_one": "{{count}} trip deleted or cancelled: the full delivery waits again under Full deliveries.",
  "planning.menu.gone_both_other": "{{count}} trips deleted or cancelled: the full deliveries wait again under Full deliveries.",
  "planning.menu.stopLabel_one": "Stop with {{count}} consignment",
  "planning.menu.stopLabel_other": "Stop with {{count}} consignments",
  "planning.menu.stopMoveTo_one": "The whole stop to another trip",
  "planning.menu.stopMoveTo_other": "The whole stop to another trip",
  "planning.menu.openOrderOf": "Open the order of {{consignment}}",
  "planning.menu.stopTakeOff_one": "Take the whole stop off the trip ({{count}})",
  "planning.menu.stopTakeOff_other": "Take the whole stop off the trip ({{count}})",
  "planning.menu.stopMoved_one": "Moved {{count}} consignment to {{trip}}.",
  "planning.menu.stopMoved_other": "Moved {{count}} consignments to {{trip}}.",
  "planning.menu.stopTakenOff_one": "Took {{count}} consignment off {{trip}}.",
  "planning.menu.stopTakenOff_other": "Took {{count}} consignments off {{trip}}.",
  "planning.menu.newTripOf_one": "New trip of {{count}}",
  "planning.menu.newTripOf_other": "New trip of {{count}}",
  "planning.menu.openInStepTwo": "Open in step 2",
  "planning.menu.lorryHere": "Put {{trip}} on this lorry",
  "planning.menu.openLorry": "Open the lorry card",
  "planning.menu.openDriver": "Open the driver card",
  "planning.menu.openTrailer": "Open the trailer card",
  "planning.menu.chooseFor": "Choose for {{trip}}",
  "planning.menu.driverOff": "Driver off",
  "planning.menu.trailerOff": "Trailer off",
  "planning.menu.chooseDriver": "Choose a driver",
  "planning.menu.chooseTrailer": "Choose a trailer",
  "planning.menu.chooseLorry": "Choose a lorry on the board",
  "planning.menu.tick": "Tick",
  "planning.menu.untick": "Untick",
  "planning.menu.areaChoose": "Choose {{name}}",
  "planning.v3.s2.putOnN_one": "Put on {{trip}} ({{count}})",
  "planning.v3.s2.putOnN_other": "Put on {{trip}} ({{count}})",
  "planning.v3.s2.trips.keyAll": "all trips",
  "planning.v3.s1.keyAll": "all",
  "planning.v3.s1.keyDouble": "Double-click",
  "planning.sheetKeys.put": "put on the trip",
  "planning.sheetKeys.done": "trip done",
  "planning.sheetKeys.depot": "change the depot",
  "planning.sheetKeys.size": "trip small or large",
  "planning.sheetKeys.move": "move a stop",
  "planning.sheetKeys.takeOff": "take off the trip",
  "planning.sheetKeys.drag": "onto a trip in the list",
  "planning.sheetKeys.undo": "undo",
  "planning.sheetKeys.new": "new trip",
  "planning.sheetKeys.release": "let go",
  "planning.sheetKeys.close": "close the trip",
  "planning.sheetKeys.menu": "Right mouse button: the menu",
  "planning.cap.boardKeys.lorry": "lorry",
  "planning.cap.boardKeys.put": "trip on the lorry, or choose the driver or trailer",
  "planning.cap.boardKeys.days": "days",
  "planning.cap.boardKeys.release": "let go",
  "planning.cap.boardKeys.double": "trip on it or choose",
  "planning.noticeViaDepotAt": "{{consignment}} now goes via depot {{depot}}: the pickup unloads there.",
  "planning.errorViaDepotAt": "{{consignment}} now goes via the trip's depot; unloading at depot {{depot}} did not work. {{reason}}",
  "planning.errorTripClosed": "{{consignment}} is on {{trip}}, which is on the road or completed: nothing changes there any more.",
  "planning.errorLegDone": "This handling of {{consignment}} on {{trip}} is done already.",
  "planning.errorPickupNotPlanned": "Plan the pickup of {{consignment}} first.",
  "planning.errorBeforeDepotArrival": "{{consignment}} would load at the depot before it is unloaded there: plan it later.",
  "planning.errorConsignmentPlanned": "{{consignment}} is on a trip already: take it off first.",
  "planning.errorLegPlanned": "{{consignment}} is on a trip already.",
  "planning.takeOffTitle": "Deliver {{consignment}} directly?",
  "planning.takeOffIntro": "{{consignment}} now goes through depot {{depot}}. Delivering directly changes two trips:",
  "planning.takeOffPickupTrip": "the pickup no longer unloads at {{depot}} but drives on to {{place}} and delivers there.",
  "planning.takeOffDeliveryTrip": "the delivery comes off: no loading at {{depot}}, no unloading at {{place}}.",
  "planning.takeOffThisTrip": "(this trip)",
  "planning.takeOffLogged": "Both trips record it in their log, and so does the order.",
  "planning.takeOffConfirm": "Deliver directly",
  "planning.noticeDeliversDirect": "{{trip}} now delivers {{consignment}} directly at {{place}}, no longer via {{depot}}",
  "planning.noticeUnloadsAtDepot": "{{trip}} now unloads {{consignment}} at {{depot}}; the delivery to {{place}} waits to be planned",
  "planning.noticeDeliveryRemoved": "The delivery came off {{trip}}",
  "planning.noticeNowViaDepot": "{{consignment}} now goes through a depot: the pickup and the delivery wait to be planned",
  "planning.noticeNowDirect": "{{consignment}} now goes directly: one leg, waiting to be planned",
  "planning.menuLoadInWarehouse": "Load in warehouse {{warehouse}}, no shuttle",
  "planning.menuWarehouseViaDepot": "Through a depot: a shuttle to the trip's depot",
  "planning.noticeLoadsAtWarehouse": "{{trip}} now loads {{consignment}} in warehouse {{depot}}; the depot shuttle is dropped",
  "planning.noticeLoadsAtDepot": "{{trip}} now loads {{consignment}} at depot {{depot}}; a depot shuttle from the warehouse is waiting to be planned",
  "planning.noticeWarehouseViaDepot": "{{consignment}} now goes through a depot: when the trip has another depot, a depot shuttle takes it there",
  "planning.noticeWarehouseDirect": "{{consignment}} now loads in the warehouse: the trip picks it up there",
  "planning.noticeShuttleAddedWarehouse": "Depot shuttle {{consignment}} needed: from the warehouse in {{from}} to {{to}}, where the trip loads — waiting to be planned",
  "planning.errorWarehouseOrder": "{{consignment}} loads in our warehouse: choose Direct (load in the warehouse) or Through a depot (by shuttle).",
  "planning.errorOpenEndOvernight": "{{trip}} is only back after midnight: what goes behind it is for the next day.",
  "planning.errorDeliveryPlanned": "The delivery of {{consignment}} is on {{trip}}: take it off first.",
  "trips.logDeliversDirect": "Now delivers directly at {{place}}, no longer via {{depot}}",
  "trips.logDeliveryOffOther": "The delivery came off {{otherTrip}}",
  "trips.logUnloadsAtDepot": "Now unloads at {{depot}}; the delivery to {{place}} waits to be planned",
  "trips.logDeliveredDirectBy": "Delivery off: {{trip}} delivers directly at {{place}}",
  "planning.legLoad": "Loading",
  "planning.legUnload": "Unloading",
  "planning.legPart": "{{nr}}/{{count}}",
  "planning.droppedLegs_one": "{{count}} consignment on {{trips}} ({{on}}).",
  "planning.droppedLegs_other": "{{count}} consignments on {{trips}} ({{on}}).",
  "planning.droppedSkipped_one": "{{count}} stayed behind, planned already or no longer plannable: {{legs}}.",
  "planning.droppedSkipped_other": "{{count}} stayed behind, planned already or no longer plannable: {{legs}}.",
  "planning.planPickedHere_one": "Click to plan the picked consignment on this one",
  "planning.planPickedHere_other": "Click to plan the {{count}} picked consignments on this one",
  "planning.legsNothingInScope_one": "Nothing here. {{count}} still waits for a trip: see Earlier, Later or All.",
  "planning.legsNothingInScope_other": "Nothing here. {{count}} still wait for a trip: see Earlier, Later or All.",
  "planning.tripsOnDay_other": "{{count}} trips",
  "planning.viewLabel": "View",
  "planning.mapLabel": "Map",
  "planning.mapOff": "No map",
  "planning.mapWindow": "Map apart",
  "planning.mapWindowHelp": "The map in a window of its own, for a second screen",
  "planning.mapWindowRefused": "The browser blocked the window. Allow pop-ups for WLX, or put the map beside the board.",
  "planning.boardElsewhere.title": "The planning board is already open in another tab",
  "planning.boardElsewhere.text": "Two planning boards in one browser steer each other and the detached map, so there is one. Carry on in the other tab, or open the board here: the other tab stops.",
  "planning.boardTaken.title": "The planning board was opened in another tab",
  "planning.boardTaken.text": "You carry on there now, with the detached map. To carry on here, open the board here again: the other tab stops.",
  "planning.boardHere": "Open here",
  "planning.mapWindowTitle": "Map · {{date}}",
  "planning.mapFollowsBoard": "Follows the planning board",
  "planning.mapNoAccess": "You have no access to the planning board.",
  "planning.mapTilesDown": "The map itself cannot be loaded right now; the trips and what is to plan are still on it.",
  "planning.mapOpenOrder": "Open order",
  "planning.mapStops_one": "{{count}} stop",
  "planning.mapStops_other": "{{count}} stops",
  "planning.mapLegend": "Legend",
  "planning.mapPanelMove": "Move {{panel}}",
  "planning.mapPanelMoveHelp": "Drag to move it within the map; double-click puts it back",
  "planning.mapFleet": "Show the lorries ({{count}})",
  "planning.tripsPicked_one": "{{count}} trip picked",
  "planning.tripsPicked_other": "{{count}} trips picked",
  "planning.mapLorryNoTrip": "No trip today",
  "planning.mapLorrySeen": "Last seen {{time}}",
  "planning.mapLasso": "Lasso: drag a shape to pick legs (or hold Shift and drag). Hold Ctrl or ⌘ to add, Alt or Option to remove; Ctrl- or ⌘-click a mark to add or remove one leg",
  "planning.mapLassoHolds": "{{count}} in the shape · {{meters}} ldm",
  "planning.mapComesFrom": "Comes from",
  "planning.mapPickupOpen": "Pickup, depot still open",
  "planning.mapDirect": "Direct",
  "planning.mapKeyLoad": "Loading",
  "planning.mapKeyUnload": "Unloading",
  "planning.mapKeyBranch": "Branch",
  "planning.mapTonesDay": "Trips and work by branch",
  "planning.mapFleetCount": "Lorries ({{count}})",
  "planning.mapKeyLorryTrip": "Trip today",
  "planning.mapKeyLorryIdle": "No trip",
  "planning.mapKeyLorryStale": "Position older than {{minutes}} min",
  "planning.mapPlaceLegs_one": "{{count}} leg · {{meters}} ldm",
  "planning.mapPlaceLegs_other": "{{count}} legs · {{meters}} ldm — a click picks them all",
  "planning.mapPlaceMore_one": "and {{count}} more",
  "planning.mapPlaceMore_other": "and {{count}} more",
  "planning.mapUnplaced": "Without a position, not on the map: {{what}}",
  "planning.mapUnplacedLegs_one": "{{count}} to plan",
  "planning.mapUnplacedLegs_other": "{{count}} to plan",
  "planning.mapUnplacedStops_one": "{{count}} stop",
  "planning.mapUnplacedStops_other": "{{count}} stops",
  "planning.mapUnplacedBranches_one": "{{count}} branch",
  "planning.mapUnplacedBranches_other": "{{count}} branches",
  "planning.viewDay": "Day",
  "planning.viewDrivers": "Drivers",
  "planning.previousWeek": "Previous week",
  "planning.nextWeek": "Next week",
  "planning.driversCount_other": "{{count}} drivers",
  "planning.doubleBooked": "Double-booked",
  "planning.conflict": "{{who}} is also on {{trip}} then ({{range}})",
  "trips.colNumber": "Trip number",
  "trips.colStatus": "Status",
  "trips.menuLabel": "Trip {{number}}",
  "trips.menuOpen": "Open the trip",
  "trips.menuOpenNewTab": "Open in a new tab",
  "trips.menuOnBoard": "Show on the planning board",
  "trips.menuConfirm": "Confirm",
  "trips.menuConfirmHint": "to on-board computer on the day",
  "trips.menuSendToBoard": "Now to on-board computer",
  "trips.boardSent": "{{trip}} went to the on-board computer of {{plate}}.",
  "trips.boardAlreadyOn": "{{trip}} is on the on-board computer of {{plate}} as it is already.",
  "trips.boardSendOff": "Sending to the on-board computer is not switched on here.",
  "trips.boardSendNotConfirmed": "Confirm {{trip}} first: only a confirmed trip goes to the on-board computer.",
  "trips.boardSendNoVehicle": "{{trip}} has no lorry with a plate.",
  "trips.menuBackToDraft": "Back to concept",
  "trips.menuCancel": "Cancel this trip…",
  "trips.menuCancelAsk": "Cancel trip {{number}}?",
  "trips.menuCancelGivesBack": "{{count}} stops go back to the work to plan.",
  "trips.menuCancelEmpty": "There is nothing on this trip.",
  "trips.menuCancelDo": "Yes, cancel it",
  "trips.menuDelete": "Delete this trip",
  "trips.menuCopyNumber": "Copy the trip number",
  "trips.colWindow": "Leaves – back",
  "trips.colVehicle": "Vehicle",
  "trips.colDriver": "Driver",
  "trips.colEquipment": "Trailer",
  "trips.colStops": "Stops",
  "trips.colDriving": "Driving",
  "trips.colKm": "Km",
  "trips.colName": "Name",
  "trips.statusDraft": "Being planned",
  "trips.statusConfirmed": "Confirmed",
  "trips.statusInTransit": "On the road",
  "trips.statusCompleted": "Completed",
  "trips.statusCancelled": "Cancelled",
  "trips.stopOpen": "To do",
  "trips.stopArrived": "Arrived",
  "trips.stopDone": "Done",
  "trips.newTrip": "New trip",
  "trips.today": "Today",
  "trips.day": "Day",
  "trips.previousDay": "Previous day",
  "trips.nextDay": "Next day",
  "trips.searchPlaceholder": "Trip number, vehicle, driver...",
  "trips.searchLabel": "Search trips",
  "trips.filterByStatus": "Filter by status",
  "trips.allStatuses": "All statuses",
  "trips.noneOnDay": "No trips on {{day}}.",
  "trips.noneFiltered": "No trips match the filter.",
  "trips.hoursUnit": "hours",
  "trips.noTrailer": "No trailer",
  "trips.noVehicle": "No vehicle",
  "trips.noDriver": "No driver",
  "trips.illMark": "ill",
  "trips.leaveMark": "on leave",
  "trips.noShiftMark": "no shift",
  "trips.dayNote": "Remark {{name}}: {{text}}",
  "trips.busyOn": "busy: {{trip}}",
  "trips.charter": "Charter",
  "trips.depot": "Depot",
  "trips.charterNone": "No charter",
  "trips.charterPrice": "Purchase price trip (€)",
  "trips.charterRemark": "Remark for the charter",
  "trips.charterRemarkPlaceholder": "Empty: (All-in)",
  "trips.allIn": "(All-in)",
  "trips.transportOrderSend": "Send transport order",
  "trips.transportOrderSendAgain": "Send again",
  "trips.transportOrderSendNow": "Send",
  "trips.transportOrderTo": "To",
  "trips.transportOrderNoPrice": "No purchase price",
  "trips.transportOrderNoAddress": "The charter has no address for transport orders under Communication; enter one here.",
  "trips.transportOrderNotConfigured": "Sending is not set up here",
  "trips.transportOrderSaveFirst": "Save the price and the remark first",
  "trips.transportOrderMaking": "Transport order is being made…",
  "trips.transportOrderSent": "Transport order sent {{when}} by {{who}} to {{to}}",
  "trips.transportOrderFailed": "Transport order not sent",
  "trips.transportOrderChanged": "Changed since sent",
  "trips.logTransportOrderRequested": "Transport order sent",
  "trips.logTransportOrderSent": "Transport order mailed",
  "trips.logTransportOrderFailed": "Transport order failed",
  "trips.legOf": "leg {{nr}} of {{count}}",
  "trips.legMenu": "More for {{consignment}}",
  "trips.depotOfVehicle": "Home base of the vehicle",
  "trips.logTitle": "Log",
  "trips.logEmpty": "Nothing recorded yet.",
  "trips.logCreated": "Trip created",
  "trips.logUpdated": "Trip changed",
  "trips.logConfirmed": "Confirmed",
  "trips.logBackToDraft": "Back to draft",
  "trips.logCancelled": "Trip cancelled",
  "trips.logAssigned": "Put on the board",
  "trips.logOverride": "Put on anyway against: {{what}}. Why: {{reason}}",
  "trips.logWarnings": "With the finding: {{what}}",
  "trips.logLegPlanned": "Leg put on",
  "trips.logLegUnplanned": "Leg taken off",
  "trips.logRouteChanged": "Route changed",
  "trips.logDepotChanged": "Depot chosen",
  "trips.logLegFits": "Fits anyway",
  "trips.logLegFitsUnset": "Fits anyway taken back",
  "trips.logDeleted": "Trip deleted",
  "trips.logPrinted": "Printed",
  "trips.logCrossdockMarked": "Crossdock",
  "trips.logScoretraceSent": "Sent to Scoretrace",
  "trips.logNote": "Note",
  "trips.logFollowUpTaken": "Deviation taken up",
  "trips.logFollowUpReleased": "Deviation let go",
  "trips.logOrderReplaced": "Provisional order replaced",
  "trips.logOrderReplacedLine": "{{order}} in the place of {{provisional}}, on the same stops",
  "trips.logOrderReplacedDayMoved": "On another day: waits for the planner",
  "trips.logOrderReplacedByItself": "By itself, when the customer's order came in: the stops stayed as they were",
  "trips.logScoretraceShipments_one": "{{count}} consignment",
  "trips.logScoretraceShipments_other": "{{count}} consignments",
  "trips.logCrossdockIncoming": "incoming",
  "trips.logCrossdockOutgoing": "outgoing",
  "trips.logCrossdockDock": "dock {{dock}}",
  "trips.logCrossdockNoDock": "no dock",
  "trips.logCrossdockUnloaded": "unloaded",
  "trips.logCrossdockLoaded": "loaded",
  "trips.logCrossdockUndone": "undone",
  "trips.logLegKept": "Kept on another day",
  "trips.logStopsReordered": "Order changed",
  "trips.logStopsByHand": "Set by hand; WLX proposes no order until Propose the order",
  "trips.logStopsProposed": "Back to the order WLX proposes",
  "trips.logBoardDispatched": "Sent to the on-board computer",
  "trips.logBoardDispatchedLine": "{{plate}}, {{count}} line(s)",
  "trips.logBoardHowDay": "On the day it leaves, by itself",
  "trips.logBoardHowChange": "Again, after a change",
  "trips.logBoardHowManual": "Straight away, by hand",
  "trips.logBoardRemoved": "Taken off the on-board computer",
  "trips.logBoardRemovedLine": "Off {{plate}}",
  "trips.logBoardReport": "Driver's report",
  "trips.logBoardNotFullyUnloaded": "Not fully unloaded",
  "trips.logBoardNotFullyLoaded": "Not fully loaded",
  "trips.logBoardReason": "Reason: {{reason}}",
  "trips.logBoardDeviations": "Deviations: {{deviations}}",
  "trips.logBoardWaited": "Waiting: {{remark}}",
  "trips.logBoardEmballageScans_one": "1 emballage barcode scanned",
  "trips.logBoardEmballageScans_other": "{{count}} emballage barcodes scanned",
  "trips.logBoardStarted": "Trip started (on-board computer)",
  "trips.logBoardEnded": "Trip ended (on-board computer)",
  "trips.logStopSignedOff": "Stop signed off",
  "trips.logStopSignedOffLine": "Stop {{stop}}: arrived {{arrived}}, departed {{departed}}",
  "trips.logStopSignedOffEvents": "{{count}} status message(s) to the customer",
  "trips.logReportSent": "Trip report to customer sent",
  "trips.logReportSentLine": "{{customer}}: {{count}} consignment, message {{number}}",
  "trips.logReportSentLine_other": "{{customer}}: {{count}} consignments, message {{number}}",
  "trips.logDriverMessageSent": "Message with trip sheet to driver sent",
  "trips.logDriverMessageSentAgain": "{{driver}}, once more",
  "trips.logDriverMessageFailed": "Message with trip sheet to driver failed",
  "trips.logLegKeptDays": "the order asks {{days}}",
  "trips.logShuttleNotNeeded": "Depot shuttle no longer needed: taken off by the planning",
  "trips.logShuttleDepotsChanged": "Depot shuttle between other depots: taken off by the planning",
  "trips.logFieldVehicle": "vehicle",
  "trips.logFieldDriver": "driver",
  "trips.logFieldTrailer": "trailer",
  "trips.logFieldCharter": "charter",
  "trips.logFieldDepot": "depot",
  "trips.logFieldStatus": "status",
  "trips.logFieldName": "name",
  "trips.logFieldDate": "date",
  "trips.logDeliveredDirect": "The pickup delivers directly: the delivery was no longer needed",
  "trips.load": "Load",
  "trips.unload": "Unload",
  "trips.pallets": "{{count}} pallet",
  "trips.pallets_other": "{{count}} pallets",
  "trips.stopsCount": "{{count}} stop",
  "trips.stopsCount_other": "{{count}} stops",
  "trips.sharedStop": "one stop for {{count}} consignments — the driver stands here once",
  "trips.noStops": "Nothing is on this trip yet.",
  "trips.cancelledEmpty": "This trip is cancelled. What was on it is back under To plan.",
  "trips.addConsignment": "Add a consignment",
  "trips.addTitle": "Waiting for a trip",
  "trips.nothingWaiting": "Everything of this day is already on a trip.",
  "trips.putOnTrip": "Onto this trip",
  "trips.addSearch": "Search by consignment, order, reference or customer",
  "trips.nothingFound": "Nothing found that is still waiting for a trip.",
  "trips.signOff": "Sign off",
  "trips.signOffChange": "Change times",
  "trips.arrivedAt": "Arrived",
  "trips.departedAt": "Departed",
  "trips.arrivedAtValue": "Arrived {{time}}",
  "trips.departedAtValue": "Departed {{time}}",
  "trips.signOffHelp": "Until the on-board computer does it, the planner signs the stop off here. The first arrival and departure go to the customers that get status messages (P&O); a changed time does not go again.",
  "trips.takeOff": "Take off the trip",
  "trips.sheetMenuHint": "Right mouse button on a stop or consignment: the menu, also to another trip",
  "trips.notFound": "This trip does not exist",
  "trips.notFoundDesc": "It may have been removed, or the link is wrong.",
  "trips.planned": "Planned",
  "trips.window": "Window",
  "trips.windowOwnPlace": "none, own place",
  "trips.windowOwnPlaceHelp": "The order asks {{asked}}. At a place of our own the planning reckons without a window: the lorry goes to the dock or the parking (P35).",
  "trips.windowDepot": "none, depot",
  "trips.planWait": "waits {{time}} for the window",
  "trips.lateBy": "{{time}} late",
  "trips.lateByHelp": "How far past the end of the window the planning has the trip here: with the drive from home, the stops before and the breaks, as on the Planbord.",
  "trips.planSpan": "Leaves {{from}} · back {{to}}",
  "trips.planSpanFixed": "Leaves {{from}} (set) · back {{to}}",
  "trips.planKm": "{{km}} km ({{empty}} empty)",
  "trips.planDriving": "driving {{time}}",
  "trips.lateStops": "{{count}} stop late",
  "trips.lateStops_other": "{{count}} stops late",
  "trips.otherDay": "Another day",
  "trips.otherDayHelp": "The order now asks for another day than this trip. It stays until the planner decides.",
  "trips.waitsTitle": "Waits for the planner",
  "trips.waitsHelp": "A change to an order takes nothing off this trip by itself. Choose per order what happens.",
  "trips.waitsReadOnly": "A change to an order takes nothing off this trip by itself: the planner decides.",
  "trips.waitBy": "by {{who}}, {{when}}",
  "trips.waitByCustomer": "by the customer, {{when}}",
  "trips.waitMovedDay": "{{activity}} goes to {{window}}",
  "trips.waitTakeOff": "Take off the trip",
  "trips.waitKeep": "Keep it here",
  "trips.waitCancelled": "Cancelled",
  "trips.waitChange": "Change from the customer",
  "trips.waitChanged": "Changed",
  "trips.print": "Print…",
  "trips.printTitleOne": "Print trip {{number}}",
  "trips.printTitleMany": "Print {{count}} trips",
  "trips.printTitleCmr": "Print the CMR of {{number}}",
  "trips.printTripSheet": "Trip sheet",
  "trips.printCmrs": "CMRs (per unloading address, two copies)",
  "trips.printLocation": "Print location",
  "trips.printLocationNone": "There is no print location yet. An admin sets them up.",
  "trips.printLeftOutCancelled": "{{count}} cancelled trip is not printed.",
  "trips.printLeftOutCancelled_other": "{{count}} cancelled trips are not printed.",
  "trips.printSubmit": "Print",
  "trips.printBusy": "Working…",
  "trips.printDone": "To {{place}}: {{sheets}} and {{cmrs}}.",
  "trips.printDoneCmr": "The CMR goes to {{place}}.",
  "trips.printSheets": "{{count}} trip sheet",
  "trips.printSheets_other": "{{count}} trip sheets",
  "trips.printCmrCount": "{{count}} CMR",
  "trips.printCmrCount_other": "{{count}} CMRs",
  "trips.printSkippedAdr": "No CMR for {{consignment}}: ADR, the customer supplies the transport document.",
  "trips.printSkippedCustomer": "No CMR for {{consignment}}: this customer makes its own CMR.",
  "trips.printErrorNotConfigured": "Printing is not switched on here yet: the link with DataBridge is missing.",
  "trips.printErrorCancelled": "One of the trips is cancelled; nothing was printed.",
  "trips.printErrorNotPlanned": "This consignment is on no trip that delivers it yet.",
  "trips.printErrorNoCmr": "WLX makes no CMR for this consignment: ADR, or the customer makes its own.",
  "trips.printed": "Printed {{when}}",
  "trips.changedSincePrinted": "Changed since printed",
  "trips.printSelected": "{{count}} trip selected",
  "trips.printSelected_other": "{{count}} trips selected",
  "trips.selectAll": "Select all trips",
  "trips.selectTrip": "Select trip {{number}}",
  "trips.clearSelection": "Clear selection",
  "trips.printMax": "At most {{count}} trips at a time.",
  "trips.colPrinted": "Paper",
  "trips.colAttention": "Waits for planner",
  "trips.attentionCount_one": "{{count}} order",
  "trips.attentionCount_other": "{{count}} orders",
  "trips.attentionHelp": "For this many orders something waits for the planner: another day, a cancellation or change, or something that changed. The trip card says what.",
  "trips.printedState": "Printed",
  "trips.notPrinted": "Not printed",
  "trips.colScoretrace": "Scoretrace",
  "trips.notToScoretrace": "Not sent to Scoretrace",
  "trips.scoretraceSentState": "Sent to Scoretrace",
  "trips.scoretraceSentAt": "Sent to Scoretrace {{when}}",
  "trips.changedSinceScoretrace": "Changed since it was sent",
  "trips.toScoretrace": "To Scoretrace",
  "trips.toScoretraceHelp": "Sends what these trips load in Rijkevoort to Scoretrace: the trip, the lorry and the trailer on each order there",
  "trips.scoretraceSent_one": "{{count}} trip sent to Scoretrace.",
  "trips.scoretraceSent_other": "{{count}} trips sent to Scoretrace.",
  "trips.scoretraceSkipped": "Not sent, because they load nothing in Rijkevoort or are cancelled: {{trips}}.",
  "trips.report": "Trip report to customer…",
  "trips.reportsOfDay": "Trip reports to customers…",
  "trips.menuReport": "Trip report to customer",
  "trips.reportTitleOne": "Trip report to the customer · {{number}}",
  "trips.reportTitleDay": "Trip reports to the customers · {{day}}",
  "trips.reportIntro": "The trip report (IFCSUM) tells the customer which of its consignments a trip unloads. WLX sends it by itself once the trip is over; after that it can be sent again here. A customer that gets it beforehand gets it from Needs attention.",
  "trips.reportNoneDay": "No trip on this day unloads anything for a customer with a trip report.",
  "trips.reportNoneTrip": "This trip unloads nothing for a customer with a trip report.",
  "trips.reportColTrip": "Trip",
  "trips.reportColCustomer": "Customer",
  "trips.reportColMode": "When",
  "trips.reportColConsignments": "Consignments",
  "trips.reportColLast": "Sent",
  "trips.reportModeBefore": "Before",
  "trips.reportModeAfter": "Afterwards",
  "trips.reportWithoutCodes": "{{count}} without a place code",
  "trips.reportWithoutCodes_other": "{{count}} without a place code",
  "trips.reportWithoutCodesHelp": "Without the customer's place code at loading or unloading, a consignment is left out of the trip report.",
  "trips.reportSentAt": "Sent {{when}}",
  "trips.reportSentByItself": "Sent by itself {{when}}",
  "trips.reportChangedSince": "Changed since sent",
  "trips.reportWaitsForTrip": "Goes by itself after the trip",
  "trips.reportNotSent": "Not yet",
  "trips.reportNothingNow": "There is nothing to send now.",
  "trips.reportSubmit": "Send {{count}} trip report",
  "trips.reportSubmit_other": "Send {{count}} trip reports",
  "trips.reportBusy": "Busy…",
  "trips.reportDone": "{{count}} trip report sent.",
  "trips.reportDone_other": "{{count}} trip reports sent.",
  "trips.reportSkippedAfterTrip": "{{trip}} · {{customer}}: goes by itself after the trip.",
  "trips.reportSkippedNoCodes": "{{trip}} · {{customer}}: no consignment with the customer's place codes.",
  "trips.reportSkippedCancelled": "{{trip}}: cancelled, nothing goes.",
  "trips.reportSkippedNoCustomer": "{{trip}}: no customer with a trip report.",
  "trips.reportErrorNotConfigured": "Trip reports are not switched on here yet: the link with DataBridge is missing.",
  "trips.driverMessage": "Message with trip sheet to driver…",
  "trips.driverMessagesOfDay": "Messages with trip sheet to drivers…",
  "trips.menuDriverMessage": "Message with trip sheet to driver",
  "trips.driverMessageSelected": "Message with trip sheet to drivers…",
  "trips.driverMessageTitleDay": "Message with trip sheet to the drivers · {{day}}",
  "trips.driverMessageTitleOne": "Message with trip sheet to the driver · {{number}}",
  "trips.driverMessageTitleMany": "Message with trip sheet to the drivers · {{count}} trip",
  "trips.driverMessageTitleMany_other": "Message with trip sheet to the drivers · {{count}} trips",
  "trips.driverMessageIntro": "Every driver gets a message in the Welder app about the first trip of the day, with a link to the trip sheet, once that trip is confirmed. Click a row for the text.",
  "trips.driverMessageOff": "Messages with trip sheet are not switched on here.",
  "trips.driverMessageTestOnly": "In this environment the message goes to the test drivers only.",
  "trips.driverMessageNoneDay": "No driver has a trip on this day.",
  "trips.driverMessageNoneTrips": "No trips.",
  "trips.driverMessageWithoutAppId": "{{count}} driver has no Welder id and gets no message. Fill it in on the driver card.",
  "trips.driverMessageWithoutAppId_other": "{{count}} drivers have no Welder id and get no message. Fill it in on the driver card.",
  "trips.driverMessageColDriver": "Driver",
  "trips.driverMessageColTrip": "Trip",
  "trips.driverMessageColDeparture": "Departure",
  "trips.driverMessageColVehicle": "Lorry",
  "trips.driverMessageColState": "State",
  "trips.driverMessagePick": "Message for {{number}}",
  "trips.driverMessagePickAll": "All drivers",
  "trips.driverMessagePreview": "The message to {{name}}",
  "trips.driverMessageNotSent": "Not sent yet",
  "trips.driverMessageSentAt": "Sent {{when}}",
  "trips.driverMessageDelivered": "Delivered, sent {{when}}",
  "trips.driverMessageFailed": "Failed, sent {{when}}",
  "trips.driverMessageChangedSince": "Trip changed since sent",
  "trips.driverMessageBlockCancelled": "Trip cancelled",
  "trips.driverMessageBlockNoDriver": "No driver on the trip",
  "trips.driverMessageBlockNotFirst": "Not the driver's first trip that day",
  "trips.driverMessageBlockNotFirstOf": "Not the first trip; that is {{trip}}",
  "trips.driverMessageBlockNotConfirmed": "Not confirmed yet",
  "trips.driverMessageBlockNoAppId": "No Welder id",
  "trips.driverMessageBlockAppIdInvalid": "Welder id is not a number",
  "trips.driverMessageBlockBeforeStart": "No messages before {{day}}",
  "trips.driverMessageBlockTestOnly": "Not a test driver",
  "trips.driverMessageBlockAlreadySent": "Had the message already",
  "trips.driverMessageConfirmAgain": "{{names}} got the message already. Send it again?",
  "trips.driverMessageConfirmAgain_other": "{{names}} got the message already. Send it again?",
  "trips.driverMessageSubmit": "Send {{count}} message",
  "trips.driverMessageSubmit_other": "Send {{count}} messages",
  "trips.driverMessageSubmitAgain": "Yes, send {{count}} message",
  "trips.driverMessageSubmitAgain_other": "Yes, send {{count}} messages",
  "trips.driverMessageBusy": "Sending…",
  "trips.driverMessageDone": "{{count}} message sent.",
  "trips.driverMessageDone_other": "{{count}} messages sent.",
  "orders.tabBlocked": "Needs attention",
  "orders.tabAccepted": "Accepted",
  "orders.tabRejected": "Rejected",
  "orders.tabCancelled": "Cancelled",
  "orders.statusCancelled": "Cancelled",
  "orders.cancel": "Cancel order",
  "orders.cancelTitle": "Cancel this order",
  "orders.cancelHelp":
    "The order leaves the planning and stays readable. Cancelling is not rejecting: rejecting is ours, cancelling is the customer's.",
  "orders.cancelReasonLabel": "Reason (goes in the log)",
  "orders.cancelReasonPlaceholder": "Customer called: not going ahead",
  "orders.cancelSubmit": "Cancel order",
  "orders.cancelledBecause": "Cancelled: {{reason}}",
  "orders.hold": "Hold",
  "orders.holdTitle": "Put order on hold",
  "orders.holdHelp": "The order stays as it is, but cannot be planned until someone releases it. If any of it is on a trip, the planner takes it off first.",
  "orders.holdReasonLabel": "Reason",
  "orders.holdReasonPlaceholder": "For example: customer pays first, waiting for documents",
  "orders.holdSubmit": "Put on hold",
  "orders.release": "Release",
  "orders.onHold": "On hold",
  "orders.onHoldBecause": "On hold, not plannable: {{reason}}",
  "orders.onHoldBy": "by {{name}} on {{date}}",
  "orders.holdOnTrip": "This order is on {{trips}}: the planner takes it off first.",
  "orders.priorityByRule": "Priority set by a rule: only an admin changes it.",
  "orders.logHeld": "Put on hold",
  "orders.logReleased": "Released",
  "orders.callOffRefused":
    "This order is on a trip that is already on its way or completed. Such a trip keeps its work, so the order cannot come off it now.",
  "orders.cancelWaits_one": "On trip {{trips}}. The cancellation waits for the planner, who takes the order off the trip or keeps it there.",
  "orders.cancelWaits_other": "On trips {{trips}}. The cancellation waits for the planner, who takes the order off the trips or keeps it there.",
  "orders.rejectOnTrips_one": "On trip {{trips}}. Rejecting is possible once the planner has taken it off the trip; otherwise: cancel.",
  "orders.rejectOnTrips_other": "On trips {{trips}}. Rejecting is possible once the planner has taken it off the trips; otherwise: cancel.",
  "orders.rejectOnTrip": "This order is on trip {{trips}}. Rejecting is possible once the planner has taken it off; cancelling is, and waits for the planner.",
  "orders.pickOrder": "Tick order {{number}}",
  "orders.bulkPicked": "{{count}} order ticked",
  "orders.bulkPicked_other": "{{count}} orders ticked",
  "orders.bulkOnReason": "{{count}} orders wait only on: {{reason}}",
  "orders.bulkAcceptPicked": "Accept {{count}} as asked",
  "orders.bulkAcceptAll": "Accept all {{count}} as asked",
  "orders.bulkClear": "Clear selection",
  "orders.bulkConfirm": "Accept {{count}} orders as asked?",
  "orders.bulkConfirmHelp": "Every order gets this reason in its own log and keeps showing what it was accepted in spite of.",
  "orders.bulkDone": "{{count}} orders accepted.",
  "orders.bulkHeldAddress": "{{count}} waits for a location",
  "orders.bulkHeldAddress_other": "{{count}} wait for a location",
  "orders.bulkHeldApproval": "{{count}} waits for an approved customer",
  "orders.bulkHeldApproval_other": "{{count}} wait for an approved customer",
  "orders.bulkHeldLoadingMeters": "{{count}} has no loading meters",
  "orders.bulkHeldLoadingMeters_other": "{{count}} have no loading meters",
  "orders.bulkHeldTripMark": "{{count}} waits for a trip mark",
  "orders.bulkHeldTripMark_other": "{{count}} wait for a trip mark",
  "orders.bulkHeldDates": "{{count}} unloads before it loads and needs another date or time",
  "orders.bulkHeldDates_other": "{{count}} unload before they load and need another date or time",
  "orders.bulkHeldDecision": "{{count}} waits for the planner (a change or cancellation)",
  "orders.bulkHeldDecision_other": "{{count}} wait for the planner (a change or cancellation)",
  "orders.bulkHeldPicked": "Not taken along by accepting: {{reasons}}. Solve that per order.",
  "orders.bulkNotThrough": "Not taken: {{reasons}}.",
  "orders.linkRemembersSpelling": "WLX remembers how the customer wrote this address, so the next order lands on it by itself. Other orders waiting on this place go along.",
  "orders.alsoLinked": "{{count}} other order waiting on this place was linked too.",
  "orders.alsoLinked_other": "{{count}} other orders waiting on this place were linked too.",
  "orders.logLinkedAlong": "Linked along with {{order}}: the same place",
  "orders.logLinkedByAddressBook": "Linked by itself: the address book knows this place now",
  "orders.logRememberedSpelling": "Spelling remembered: {{spelling}}",
  "orders.logContext": "From the message: {{values}}",
  "orders.freeAddressHeadsUp": "This address is not in the address book yet.",
  "orders.makeLocationNeedsName": "Fill in a name first.",
  "orders.makeLocationNeedsCity": "Fill in a place first.",
  "orders.addressVerdictValid": "Address found",
  "orders.addressVerdictCorrected": "Written differently elsewhere",
  "orders.addressVerdictPartial": "Address not fully found",
  "orders.addressVerdictNotFound": "This address was not found anywhere",
  "orders.addressVerdictHelp": "The order can go ahead; this is a heads-up, not a blockade.",
  "orders.addressTakeOver": "Take over",
  "orders.tabAll": "All",
  "orders.filterByStatus": "Choose the status",
  "orders.statusBlocked": "Needs attention",
  "orders.statusAccepted": "Accepted",
  "orders.statusRejected": "Rejected",
  "orders.statusHistory": "History",
  "orders.searchPlaceholder": "Number, reference, customer…",
  "orders.searchLabel": "Search orders",
  "orders.filterByPriority": "Filter by priority",
  "orders.allPriorities": "All priorities",
  "orders.newOrder": "New order",
  "orders.newOrderHelp": "Customer, reference and priority; the consignments below.",
  "orders.colNumber": "Number",
  "orders.colPriority": "Prio",
  "orders.colCustomer": "Customer",
  "orders.colReference": "Invoice reference",
  "orders.colFrom": "From",
  "orders.colTo": "To",
  "orders.colUnloadDate": "Unloading date",
  "orders.colLoadingMeters": "Loading metres",
  "orders.colWeight": "Weight",
  "orders.colTransportRequirements": "Transport requirements",
  "orders.colConsignments": "Consignments",
  "orders.colBlockers": "Blocked by",
  "orders.colWarnings": "Note",
  "orders.colDriverReport": "Driver report",
  "orders.driverReportStateOpen": "Open",
  "orders.driverReportStateHandled": "Handled",
  "orders.driverReportsOpen_one": "1 open",
  "orders.driverReportsOpen_other": "{{count}} open",
  "orders.driverReportsTitle": "Driver report",
  "orders.driverReportsAllHandled": "handled",
  "orders.driverReportByPlanner": "by the planner",
  "orders.driverReportHandledBy": "Handled by {{who}}, {{when}}",
  "orders.driverReportReopen": "Open again",
  "orders.driverReportEarlierNote": "Earlier note: {{note}}",
  "orders.driverReportNoteLabel": "Note",
  "orders.driverReportNotePlaceholder": "What was decided, e.g. customer called, delivered tomorrow",
  "orders.driverReportHandle": "Handled",
  "orders.driverNotFullyUnloaded": "Not fully unloaded",
  "orders.driverNotFullyLoaded": "Not fully loaded",
  "orders.driverAmountUnloaded": "{{amount}} unloaded",
  "orders.driverAmountLoaded": "{{amount}} loaded",
  "orders.driverColliHeadline_one": "1 collo {{what}}",
  "orders.driverColliHeadline_other": "{{count}} colli {{what}}",
  "orders.driverColliMixed_one": "1 collo not delivered",
  "orders.driverColliMixed_other": "{{count}} colli not delivered",
  "orders.driverReportedAllWell": "Reported as all well",
  "orders.driverReason": "Reason: {{reason}}",
  "orders.driverColli": "Colli: {{colli}}",
  "orders.driverDeviations": "Deviations: {{deviations}}",
  "orders.colloWhat.MANCO": "missing",
  "orders.colloWhat.NIEAAN": "nobody there",
  "orders.colloWhat.TELAAT": "too late",
  "orders.colloWhat.WEIGER": "refused",
  "orders.colloWhat.SCHADE": "damaged",
  "orders.colloWhat.delivered": "delivered",
  "orders.logDriverReported": "Driver report",
  "orders.logDriverReportHandled": "Driver report handled",
  "orders.logDriverReportReopened": "Driver report open again",
  "orders.logEmballageReturned": "Emballage returned (driver)",
  "orders.logDriverNoLongerIssue": "No longer a report: the driver later reported it as all well",
  "orders.logDriverReopenedByReport": "Was handled; open again after a new report",
  "orders.logDriverReportNote": "Note: {{note}}",
  "orders.logEmballageScans_one": "1 barcode scanned (CHEP {{chep}}, other {{other}})",
  "orders.logEmballageScans_other": "{{count}} barcodes scanned (CHEP {{chep}}, other {{other}})",
  "orders.logEmballageNotAllReturned": "Not all emballage returned: {{amount}} · {{reason}}",
  "orders.logEmballageAllReturned": "All emballage returned",
  "orders.scanStatus.scanned": "OK",
  "orders.scanStatus.missing": "Missing",
  "orders.scanStatus.not_delivered": "Not delivered",
  "orders.scanStatus.refused": "Refused",
  "orders.scanStatus.damaged": "Damaged",
  "orders.scanStatus.other": "Other",
  "orders.scanStatusTitle": "What the driver reported for this collo",
  "orders.scanCode.MANCO": "Missing",
  "orders.scanCode.NIEAAN": "Nobody there",
  "orders.scanCode.TELAAT": "Too late",
  "orders.scanCode.WEIGER": "Refused",
  "orders.scanCode.SCHADE": "Damaged",
  "orders.colReceived": "Received",
  "orders.colStatus": "Status",
  "orders.andMore": "+{{count}} more",
  "orders.queueEmpty": "Nothing waiting for you. Orders without a blocker were accepted straight away.",
  "orders.noOrders": "No orders in this list.",
  "orders.notFound": "Order not found",
  "orders.notFoundDesc": "This order does not exist, or you have no access to it.",
  "orders.blockedTitle_one": "This order is waiting for you: 1 reason",
  "orders.blockedTitle_other": "This order is waiting for you: {{count}} reasons",
  "orders.blockedHelp": "Solve the reason and the order goes on by itself, or accept it as the customer asked it.",
  "orders.whereConsignment": "Consignment {{consignment}}",
  "orders.whereActivity": "Consignment {{consignment}}, activity {{activity}}",
  "orders.openTwin": "Open {{order}}",
  "orders.openLocation": "Go to the location",
  "orders.linkLocation": "Link a location",
  "orders.linkLocationTitle": "Which location is this?",
  "orders.linkLocationSearch": "Search the address book",
  "orders.makeLocation": "Or make it a location",
  "orders.newLocationHours": "Fill in opening hours",
  "orders.newLocationHoursDrop": "Leave out",
  "orders.makeLocationHelp":
    "The address of the order is taken over and WLX hands the location a code. Opening hours and requirements go on the location card afterwards.",
  "orders.makeLocationSubmit": "Create and link",
  "orders.acceptAsAsked": "Accept as asked",
  "orders.acceptSubmit": "Accept",
  "orders.acceptNeedsLocation": "Link or make the location first \u2014 the order then goes through by itself.",
  "orders.bulkNeedsLocation": "These wait on a location, not on a decision: link or make the address per order.",
  "orders.acceptNeedsApproval": "Approve the customer on its relation card first \u2014 the order then goes through by itself.",
  "orders.acceptNeedsLoadingMeters": "Without loading meters WLX does not plan: fill them in on the consignment first.",
  "orders.acceptNeedsDates": "No lorry can unload before it loads: change the date or time first.",
  "orders.acceptNeedsLocationAnnounced": "Link or make the location first — the order then still waits for the customer's definitive one.",
  "orders.acceptNeedsApprovalAnnounced": "Approve the customer on its relation card first — the order then still waits for the customer's definitive one.",
  "orders.bulkNeedsApproval": "These wait on an approved customer, not on a decision: approve the customer on its relation card.",
  "orders.bulkNeedsLoadingMeters": "These have no loading meters: fill them in per order; accepting as asked is not possible.",
  "orders.bulkNeedsTripMark": "These wait for their trip: tick the orders of one trip and give them a trip mark, or send the trip report. Accepting as asked is not possible.",
  "orders.bulkNeedsDates": "These unload before they load: change the date or time per order; accepting as asked is not possible.",
  "orders.acceptReasonLabel": "Reason (goes in the log)",
  "orders.acceptReasonPlaceholder": "E.g. customer is sure of the address",
  "orders.acceptedDespite_one": "Accepted despite 1 blocker.",
  "orders.acceptedDespite_other": "Accepted despite {{count}} blockers.",
  "orders.reject": "Reject",
  "orders.rejectTitle": "Reject order {{number}}",
  "orders.rejectReasonLabel": "Reason for rejecting",
  "orders.rejectReasonPlaceholder": "E.g. entered twice",
  "orders.rejectSubmit": "Reject",
  "orders.rejectedBecause": "Rejected: {{reason}}",
  "orders.noticeQuestion": "What goes to the customer? That is not decided yet.",
  "orders.noticeMail": "Mail the customer",
  "orders.noticeCall": "We call the customer",
  "orders.noticeNone": "Nothing",
  "orders.noticeUndecided": "WLX sends nothing here yet. Your choice goes in the log, so the decision can be made on real cases.",
  "orders.noticeWas": "To the customer: {{notice}}",
  "orders.receivedOn": "Received {{date}}",
  "orders.acceptedOn": "Accepted {{date}}",
  "orders.channelEdi": "Through EDI",
  "orders.channelMail": "Through mail",
  "orders.channelPortal": "Through the portal",
  "orders.enteredByPartner": "entered by {{name}}",
  "orders.talisCopy": "also sent to TALIS",
  "orders.warningsCount_one": "{{count}} exception",
  "orders.warningsCount_other": "{{count}} exceptions",
  "orders.consignmentTitle": "Consignment {{number}}",
  "orders.palletsValue_one": "{{count}} pallet",
  "orders.palletsValue_other": "{{count}} pallets",
  "orders.weightValue": "{{value}} kg",
  "orders.loadingMetersValue": "{{value}} ldm",
  "orders.temperatureValue": "{{min}} to {{max}} °C",
  "orders.adrValue": "ADR",
  "orders.forkliftValue": "Truck-mounted forklift",
  "orders.colActivity": "Activity",
  "orders.colPlace": "Place",
  "orders.colWindow": "Window",
  "orders.colRequirements": "Requirements",
  "orders.colInstruction": "Instruction",
  "orders.activityLoad": "Load",
  "orders.activityUnload": "Unload",
  "orders.activityWarning": "Activity {{number}}: {{text}}",
  "orders.noWarnings": "No exceptions.",
  "orders.givenAddress": "Address as given",
  "orders.customerLabel": "Customer",
  "orders.customerSearchPlaceholder": "Search a customer by name or number…",
  "orders.customerChange": "Other customer",
  "orders.customerNothingFound": "No customer found.",
  "orders.referenceLabel": "Invoice reference",
  "orders.referenceHelp": "Printed on the consignment note and the invoice.",
  "orders.priorityLabel": "Priority",
  "orders.priorityCritical": "Critical",
  "orders.priorityRegular": "Regular",
  "orders.priorityFlexible": "Flexible",
  "orders.priorityHelp": "Once an order is critical, only an admin changes its dates or times.",
  "orders.priorityByRuleCritical_one": "Critical by this customer's rule: an unloading with a window of at most 1 hour.",
  "orders.priorityByRuleCritical_other": "Critical by this customer's rule: an unloading with a window of at most {{count}} hours.",
  "orders.priorityByRuleFlexible": "Flexible by the rule: a consignment with the transport requirement Emballage.",
  "orders.priorityByRuleShort": "by rule",
  "orders.pendelLabel": "Factory shuttle",
  "orders.tripMarkLabel": "Trip mark",
  "orders.tripMarkAdd": "+ Trip mark",
  "orders.tripMarkChange": "Change trip mark",
  "orders.tripMarkSave": "Save",
  "orders.tripMarkPlaceholder": "1VR",
  "orders.tripMarkHelp": "Orders of this customer with the same mark that unload on the same day go on one trip together. The mark names the trip: everything with 1VR is one trip, 2VR another.",
  "orders.pendelShort": "factory shuttle",
  "orders.pendelHelp": "Factory shuttle: full loads one lorry drives back and forth between a factory and our warehouse, such as Nutrifeed Veghel and Haps. Its consignments get the kind Factory shuttle, and step 1 divides them by the shuttle schedule.",
  "orders.talisCopyLabel": "To TALIS as well",
  "orders.talisCopyHelp":
    "Until the go-live the order goes to TALIS as well, and so does every change, cancellation or rejection made here afterwards. Untick it when the order is in TALIS already.",
  "orders.criticalAdminOnly": "Critical order: only an admin changes the dates, times and priority.",
  "orders.printCmr": "Print CMR…",
  "orders.editConsignment": "Change consignment",
  "orders.editSave": "Save changes",
  "orders.editHelp": "The checks run again when you save, and every change goes in the log.",
  "orders.editHelpNoWindows": "Only an admin changes the date and time of a critical order; the rest you can update.",
  "orders.colActivityReference": "Reference",
  "orders.customerLocationCodeLabel": "Customer code",
  "orders.loadReferenceLabel": "Loading reference",
  "orders.unloadReferenceLabel": "Unloading reference",
  "orders.logShow": "Show the log",
  "orders.logHide": "Hide the log",
  "orders.logEmpty": "Nothing has happened to this order yet.",
  "orders.logCreated": "Order came in",
  "orders.logUpdated": "Changed",
  "orders.logAccepted": "Accepted",
  "orders.logRejected": "Rejected",
  "orders.logCancelled": "Cancelled",
  "orders.logDepotPinned": "Depot chosen",
  "orders.logDepotLoadsAt": "loads at depot {{depot}}, not by the trip's depot",
  "orders.logDepotUnloadsAt": "unloads at depot {{depot}}, not at the trip's depot",
  "orders.logDepotFollowsTrip": "follows the trip's depot again",
  "orders.logRouteChanged": "Route changed",
  "orders.logRouteLine": "{{from}} → {{to}}",
  "orders.logRouteLegs": "Now: {{legs}}",
  "orders.logRouteTrips_one": "Touched trip {{trips}}",
  "orders.logRouteTrips_other": "Touched trips {{trips}}",
  "orders.logRouteByRule": "By the rule, after a change to loading metres or a date",
  "orders.logRouteMark_one": "Trip mark {{mark}}: {{count}} consignment, {{metres}} m",
  "orders.logRouteMark_other": "Trip mark {{mark}}: {{count}} consignments together {{metres}} m, as one consignment",
  "orders.logOffTrips_one": "Taken off trip {{trips}}",
  "orders.logOffTrips_other": "Taken off trips {{trips}}",
  "orders.logTripFollowed_one": "Trip {{trips}} moved along",
  "orders.logTripFollowed_other": "Trips {{trips}} moved along",
  "orders.logTripOff_one": "Taken off trip {{trips}}; waits for a trip again",
  "orders.logTripOff_other": "Taken off trips {{trips}}; waits for a trip again",
  "orders.logTripWaiting_one": "Another day on trip {{trips}}; waits for the planner",
  "orders.logTripWaiting_other": "Another day on trips {{trips}}; waits for the planner",
  "orders.moveFollowsTrip": "On trip {{trip}}: within the day the trip moves along. To another day the consignment stays on the trip and the planner decides.",
  "orders.moveTripClosed": "On trip {{trip}}, which is already on its way or completed: this window no longer changes.",
  "orders.dayMovedOnTrip": "Another day asked · still on {{trip}}",
  "orders.dayMovedHelp": "The order now asks for another day than the trip. Nothing comes off the trip by itself: the planner takes it off or keeps it there.",
  "orders.logConfirmed": "Confirmed (the old gate)",
  "orders.logCreatedAndConfirmed": "Created and confirmed (the old gate)",
  "orders.logCreatedAccepted": "Came in with nothing blocking it, accepted at once",
  "orders.logCreatedBlocked": "Blocked on arrival: {{reasons}}",
  "orders.logCreatedBlockedBare": "Blocked on arrival",
  "nav.consignmentRequirements": "Transport requirements",
  "nav.pendelRoutes": "Shuttle schedule",
  "requirements.intro":
    "What a consignment asks of the transport: tail-lift truck, feed, temperature. What the place itself asks lives on the location and appears on the stop by itself.",
  "requirements.new": "New requirement",
  "requirements.save": "Save",
  "requirements.edit": "Change",
  "requirements.activate": "Put back in use",
  "requirements.deactivate": "Take out of use",
  "requirements.active": "In use",
  "requirements.inactive": "Not in use",
  "requirements.empty": "No transport requirements yet.",
  "requirements.colName": "Name",
  "requirements.colCode": "Code",
  "requirements.colDescription": "Description",
  "requirements.colSortOrder": "Order",
  "requirements.colStatus": "Status",
  "requirements.colActions": "",
  "requirements.viewLabel": "View",
  "requirements.viewList": "Requirements",
  "requirements.viewPlanning": "Vehicle and combinations",
  "requirements.planningIntro":
    "What a requirement asks of the vehicle, and which requirements can go together or one after the other. Planning uses this in every choice: which lorry fits, what fits on a trip and what can follow a full delivery.",
  "requirements.allBranches": "Applies to every branch",
  "requirements.unsaved": "Not saved",
  "requirements.saved": "Saved",
  "requirements.restoreDefaults": "Restore defaults",
  "requirements.needsTitle": "Per requirement: what the vehicle needs",
  "requirements.needsSubtitle": "A lorry without what the requirement asks does not fit; planning says why.",
  "requirements.needsNote":
    "A consignment without a requirement can go with any vehicle. When a consignment with a requirement joins a trip without it, the trip asks for it from then on (a chilled pickup after a full delivery without one, for example).",
  "requirements.colRequirement": "Requirement",
  "requirements.colKind": "Kind",
  "requirements.colVehicleNeeds": "Vehicle needs",
  "requirements.colDriverNeeds": "Driver must have",
  "requirements.colWhenMissing": "When missing",
  "requirements.whenMissing_warn": "Warning",
  "requirements.whenMissing_cannot": "Cannot",
  "requirements.colTomorrow": "Tomorrow",
  "requirements.consignmentsCount_one": "{{count}} cons.",
  "requirements.consignmentsCount_other": "{{count}} cons.",
  "requirements.kind.body": "Body",
  "requirements.kind.equipment": "Equipment",
  "requirements.kind.goods": "Goods",
  "requirements.needNone": "Nothing",
  "requirements.need.refrigerated": "Refrigerated body",
  "requirements.need.box": "Box body",
  "requirements.need.curtain": "Curtain body",
  "requirements.need.tautliner": "Tautliner body",
  "requirements.need.tail_lift": "Tail lift",
  "requirements.togetherTitle": "Together on one trip",
  "requirements.togetherSubtitle": "Works both ways. Planning uses it for what fits on a trip. Click a cell to switch it.",
  "requirements.afterTitle": "One after the other with the same lorry",
  "requirements.afterSubtitle": "From row (first) to column (after). Planning uses it for what can follow a full delivery, and for two trips on one lorry.",
  "requirements.afterCorner": "first ↓ · after →",
  "requirements.can": "can",
  "requirements.cannot": "cannot",
  "requirements.togetherCell": "{{first}} and {{second}} together on one trip: {{verdict}}",
  "requirements.afterCell": "First {{first}}, then {{second}} with the same lorry: {{verdict}}",
  "parties.defaultRequirementsLabel": "Standard transport requirements",
  "parties.defaultRequirementsHelp": "Every new consignment of this relation starts with these; a planner can take one off.",
  "orders.requirementsLabel": "Transport requirements",
  "orders.executionLabel": "Execution",
  "orders.executionOpen": "To be driven",
  "orders.executionLoaded": "Loaded",
  "orders.executionInTransit": "On the road",
  "orders.executionUnloaded": "Unloaded",
  "orders.executionCompleted": "Completed",
  "orders.executionCancelled": "Cancelled",
  "orders.issueLabel": "Issue",
  "orders.issueNone": "None",
  "orders.issueShortage": "Shortage",
  "orders.issueDamage": "Damage",
  "orders.issueRefused": "Refused",
  "orders.issueRemarkLabel": "Note",
  "orders.partiesTitle": "Parties",
  "orders.partiesNone": "No other shipper, consignee or party to notify.",
  "orders.editParties": "Change parties",
  "orders.entryPartiesAdd": "Other parties: shipper, consignee, notify",
  "orders.entryUnitsAdd": "Goods lines: barcodes to scan",
  "orders.consignmentWord": "Consignment",
  "orders.fromLocation": "Asked by the location itself",
  "orders.addRequirement": "Add a requirement…",
  "orders.stopRequirementsPlaceholder": "Requirements at this stop: type or choose…",
  "orders.stopRequirements": "Requirements at this stop",
  "orders.removeRequirement": "Remove {{name}}",
  "orders.partiesHelp": "Only fill these in when they differ from the customer. Choose a location, or give an address that is not a known location; empty is the customer.",
  "orders.partyName": "Name",
  "orders.partyReference": "Reference",
  "orders.roleShipper": "Sender",
  "orders.roleConsignee": "Consignee",
  "orders.roleNotify": "To notify",
  "orders.requirementsNone": "No transport requirements set up yet.",
  "orders.requirementsPlaceholder": "Type or choose…",
  "orders.requirementsNothingFound": "No transport requirement found.",
  "orders.requirementRemove": "Remove {{name}}",
  "orders.requirementsChosen_one": "1 chosen",
  "orders.requirementsChosen_other": "{{count}} chosen",
  "orders.requirementsNoneChosen": "none chosen",
  "orders.unitsTitle": "To scan",
  "orders.unitsCount_one": "{{count}} barcode",
  "orders.unitsCount_other": "{{count}} barcodes",
  "orders.unitsEmpty": "Nothing from the WMS yet.",
  "orders.unitBarcode": "Barcode",
  "orders.unitKind": "Kind",
  "orders.unitDescription": "Description",
  "orders.unitQuantity": "Quantity",
  "orders.unitWeight": "Weight (kg)",
  "orders.unitBatch": "Batch",
  "orders.contentBestBeforeOn": "Best before {{date}}",
  "orders.contentPalletNumber": "Pallet {{number}}",
  "orders.unitSource": "Source",
  "orders.unitFromWms": "WMS",
  "orders.unitWarehouseIn": "In {{at}}",
  "orders.unitWarehouseOut": "Loaded {{at}}",
  "orders.unitLoadDegree": "{{value}} loading metre",
  "orders.unitByHand": "By hand",
  "orders.unitRemove": "Remove",
  "orders.unitPallet": "Pallet",
  "orders.unitIbc": "IBC",
  "orders.unitBox": "Box",
  "orders.unitRollContainer": "Roll container",
  "orders.unitTank": "Tank",
  "orders.unitOther": "Other",
  // What stands on the pallet places of a consignment: "3 pallets · 2 IBCs" (30-09-2026).
  "orders.carriersLabel": "Carriers",
  "orders.carrierPallet_one": "{{count}} pallet",
  "orders.carrierPallet_other": "{{count}} pallets",
  "orders.carrierIbc_one": "{{count}} IBC",
  "orders.carrierIbc_other": "{{count}} IBCs",
  "orders.carrierBox_one": "{{count}} box",
  "orders.carrierBox_other": "{{count}} boxes",
  "orders.carrierRollContainer_one": "{{count}} roll container",
  "orders.carrierRollContainer_other": "{{count}} roll containers",
  "orders.carrierTank_one": "{{count}} tank",
  "orders.carrierTank_other": "{{count}} tanks",
  "orders.carrierOther_one": "{{count}} other",
  "orders.carrierOther_other": "{{count}} other",
  "orders.unitsAddLabel": "Add barcodes",
  "orders.unitsAddPlaceholder": "One barcode per line",
  "orders.unitsAddHelp": "Pasting works: one per line, optionally barcode;description;quantity.",
  "orders.unitsAdd": "Add to the list",
  "orders.logUnits": "Barcodes: {{summary}}",
  "orders.logUnitsAdded_one": "1 added",
  "orders.logUnitsAdded_other": "{{count}} added",
  "orders.logUnitsRemoved_one": "1 removed",
  "orders.logUnitsRemoved_other": "{{count}} removed",
  "orders.logUnitsChanged_one": "1 changed",
  "orders.logUnitsChanged_other": "{{count}} changed",
  "orders.shortFreeAddress": "unknown address",
  "orders.shortLocationInactive": "location switched off",
  "orders.shortFirstNotLoad": "does not start with loading",
  "orders.shortLastNotUnload": "does not end with unloading",
  "orders.shortUnloadBeforeLoad": "unloads before loading",
  "orders.shortDuplicateOrder": "duplicate reference",
  "orders.shortEnteredTooLate": "after the cut-off",
  "orders.shortCustomerNotApproved": "customer not approved",
  "orders.shortOutsideHours": "outside opening hours",
  "orders.shortHoursUnknown": "opening hours unknown",
  "orders.shortClosedThatDay": "closed that day",
  "orders.shortWindowInPast": "date in the past",
  "orders.shortWindowBeforePrevious": "before the previous stop",
  "orders.logAcceptedAsAsked": "Accepted as asked",
  "orders.logAcceptedSolved": "The last blocker was solved",
  "orders.logReason": "Reason: {{reason}}",
  "orders.logNotice": "To the customer: {{notice}}",
  "orders.logLocationLinked": "Location linked: {{location}}",
  "orders.logBySystem": "through a channel",
  "orders.logByNobody": "automatically",
  "orders.errorOrderChanged":
    "Someone else just changed this order. Close the edit and open it again — you will see what changed and can save your own change after that.",
  "orders.errorTripClosed":
    "An activity is on a trip that is already on its way or completed. Such a trip keeps its work, so the window was not changed.",
  "orders.errorIncompleteWindows": "Give every activity a date. A time may stay empty, but what is typed must be a time.",
  "orders.changePlace": "Other address",
  "orders.keepPlace": "Keep address",
  "orders.rememberSpelling": "Same address: remember how the customer writes it",
  "orders.errorPlaceMissing": "Choose an address for every stop you move, with a name, a city and a country, or keep the old one.",
  "orders.consignmentRemove": "Remove consignment",
  "orders.consignmentAdd": "Add consignment",
  "orders.serviceTypeLabel": "Service",
  "orders.descriptionLabel": "Goods",
  "orders.descriptionPlaceholder": "E.g. 20 euro pallets of fruit",
  "orders.palletsLabel": "Pallet places",
  "orders.weightLabel": "Weight (kg)",
  "orders.loadingMetersLabel": "Loading metres",
  "orders.volumeLabel": "Volume (m³)",
  "orders.adrCodeLabel": "ADR code",
  "orders.adrCodeHelp": "The code of the dangerous goods, from the list under Beheer → ADR codes.",
  "orders.adrCodePlaceholder": "Code or name…",
  "orders.adrCodeNone": "No ADR codes yet. An admin adds them under Beheer → ADR codes.",
  "orders.adrClass": "class {{value}}",
  "orders.adrPackingGroup": "PG {{value}}",
  "orders.adrLinesLabel": "ADR lines",
  "orders.adrPackingGroupLabel": "Packing group",
  "orders.adrPackingGroupChoose": "Choose",
  "orders.adrGroupOption": "PG {{group}} · cat. {{category}}",
  "orders.adrQuantityLabel": "Quantity",
  "orders.adrUnitLabel": "Unit",
  "orders.adrRemoveLine": "Remove line",
  "orders.adrAddLine": "Add ADR line",
  "orders.adrPointsUnknown": "Points unknown: without category or quantity ADR applies to the trip.",
  "orders.adrPointsUnder": "{{points}} ADR points: exempt as long as the trip stays at 1,000 or below.",
  "orders.adrPointsOver": "{{points}} ADR points: over 1,000, ADR applies to the trip.",
  "orders.adrGroupShort": "PG {{group}}",
  "orders.adrCategoryShort": "cat. {{category}}",
  "planning.fit.adr_exempt": "ADR exempt: {{points}} points (1.1.3.6)",
  "planning.v3.adrExempt": "ADR exempt · {{points}} pts",
  "planning.v3.adrPoints": "ADR · {{points}} pts",
  "planning.v3.adrUnknown": "ADR · points unknown",
  "adrCodes.colVariants": "Category per PG",
  "adrCodes.variantsHelp": "Per packing group the transport category and, if any, the tunnel code, e.g. II:2:E III:3:E. Without a packing group: -:2.",
  "adrCodes.variantsInvalid": "Write the categories as II:2 III:3 (packing group I, II, III or -, category 0 to 4).",
  "nav.adrCodes": "ADR codes",
  "adrCodes.intro": "The ADR codes order entry picks from for a consignment with ADR. Take a code out of use when it is no longer used: a consignment keeps its code.",
  "adrCodes.new": "New code",
  "adrCodes.save": "Save",
  "adrCodes.edit": "Change",
  "adrCodes.activate": "Put back in use",
  "adrCodes.deactivate": "Take out of use",
  "adrCodes.active": "In use",
  "adrCodes.inactive": "Not in use",
  "adrCodes.empty": "No ADR codes yet.",
  "adrCodes.colCode": "Code",
  "adrCodes.colDescription": "Description",
  "adrCodes.colClass": "Class",
  "adrCodes.colClassification": "Classification",
  "adrCodes.colPackingGroup": "Packing group",
  "adrCodes.colStatus": "Status",
  "adrCodes.colActions": "",
  "orders.meters.calculate": "Calculate",
  "orders.meters.title": "Calculate loading metres",
  "orders.meters.count": "Count",
  "orders.meters.carrier": "Carrier",
  "orders.meters.lengthCm": "Length cm",
  "orders.meters.widthCm": "Width cm",
  "orders.meters.europallet": "Euro pallet",
  "orders.meters.blockPallet": "Block pallet",
  "orders.meters.ibc": "IBC",
  "orders.meters.bigBag": "Big bag",
  "orders.meters.size": "Own size",
  "orders.meters.perPiece": "{{carrier}} · {{meters}} m",
  "orders.meters.sizeHint": "Own size: count × length × width, divided by the 2.40 m load floor. Stacking is not counted.",
  "orders.meters.addRow": "Add row",
  "orders.meters.removeRow": "Remove row",
  "orders.meters.total": "Total",
  "orders.meters.cancel": "Cancel",
  "orders.meters.take": "Take over",
  "orders.loadingMetersFromScans": "From the warehouse's scans",
  "orders.partsTitle": "WMS orders in this consignment",
  "orders.partsHelp": "A collective consignment: Willems drives to the unloading address, where each order goes on to its own address. Printing the trip gives each order a CMR of its own.",
  "orders.partWmsOrder": "WMS order",
  "orders.partReceiverOrder": "Receiver's order",
  "orders.partTo": "To",
  "orders.partPallets": "Pallets",
  "orders.partLoadingMeters": "Loading metres",
  "orders.partWeight": "Weight (kg)",
  "orders.partState": "Status",
  "orders.partEstimated": "Estimated from the order lines",
  "orders.partPicked": "Picked {{at}}",
  "orders.partNoAddress": "address not from the WMS yet",
  "orders.loadingMetersFromParts": "Added up from the WMS orders",
  "resources.searchLabel": "Search",
  "resources.searchPlaceholderDrivers": "Name or personnel number…",
  "resources.searchPlaceholderUnits": "Fleet number, plate, make, category…",
  "resources.typeFilter": "Kind",
  "resources.typeAll": "All",
  "resources.typeVehicles": "Vehicles",
  "resources.typeEquipment": "Trailers",
  "resources.noUnits": "No transport units found.",
  "resources.newUnit": "New transport unit",
  "resources.newUnitTitle": "New transport unit",
  "resources.newUnitType": "Vehicle or trailer",
  "resources.newUnitVehicle": "Vehicle",
  "resources.newUnitEquipment": "Trailer",
  "resources.newUnitCodeHelp": "Fixed afterwards. No other vehicle or trailer may have the same fleet number.",
  "resources.newUnitRest": "Body, dimensions, equipment and the regular links follow on the card.",
  "resources.newDriver": "New driver",
  "resources.newDriverTitle": "New driver",
  "resources.newDriverHelp":
    "For a self-employed driver who is not in AFAS. Willems's own drivers come from AFAS. A self-employed driver has no base.",
  "resources.newDriverRest": "Qualifications, staying overnight and the Welder id follow on the card.",
  "resources.newDriverBcNumber": "Gets the next number by itself, from 90000 to 99999.",
  "resources.colCoupled": "Regularly coupled",
  "resources.unitNote": "This unit came from TALIS. TALIS filled it once and does not overwrite it: what you change here stays.",
  "resources.driverNote":
    "Name, personnel number, employment and base come from AFAS, until 16 November through TALIS; the duty roster straight from AFAS. They are changed there.",
  "resources.driverWlxHelp": "You manage this in WLX. TALIS fills it in once, for a new driver; after that, what is set here stays.",
  "resources.driverWlxNote":
    "This driver was made in WLX and is not in AFAS. Everything but the number is changed here.",
  "resources.driverActiveHelp": "An inactive driver is kept, but no longer chosen for a trip.",
  "resources.fieldLoadingMeters": "Loading metres",
  "resources.fieldEmissionHelp": "EURO VI or BEV, for instance.",
  "resources.fieldTalisNumber": "TALIS number",
  "resources.bodyNone": "Not given",
  "resources.noneChosen": "None",
  "resources.branchFilter": "Base",
  "resources.branchAll": "All bases",
  "resources.sourceNote":
    "Willems's own drivers are made and taken out of service in AFAS, through TALIS until 16 November. A self-employed driver who is not in AFAS is made here.",
  "resources.colCode": "Fleet number",
  "resources.colKind": "Kind",
  "resources.colMakeModel": "Make and model",
  "resources.colBranch": "Base",
  "resources.colSpace": "Loading space",
  "resources.colTailLift": "Tail lift",
  "resources.colFeatures": "Equipment",
  "resources.colPersonnelNumber": "Staff no.",
  "resources.colFirstName": "First name",
  "resources.colLastName": "Last name",
  "resources.colLastNamePrefix": "Prefix",
  "resources.colEmployment": "Employment",
  "resources.colQualifications": "Qualifications",
  "resources.colVehicles": "Regular vehicle",
  "resources.colOvernight": "Overnight stays",
  "resources.noDrivers": "No drivers found.",
  "resources.notFound": "Not found",
  "resources.notFoundDesc": "This does not exist (any more), or you have no access to it.",
  "resources.fieldPlate": "Plate",
  "resources.fieldKind": "Kind",
  "resources.fieldSubType": "Kind",
  "resources.fieldCategory": "Category in TALIS",
  "resources.fieldMake": "Make",
  "resources.fieldModel": "Model",
  "resources.fieldBody": "Body",
  "resources.fieldTailLift": "Tail lift",
  "resources.fieldAxles": "Axles",
  "resources.fieldTare": "Tare weight",
  "resources.fieldPayload": "Payload",
  "resources.fieldEmission": "Emission class",
  "resources.fieldZone": "Low-emission zone",
  "resources.fieldFeatures": "Equipment",
  "resources.fieldDriver": "Regular driver",
  "resources.fieldTrailer": "Regular trailer",
  "resources.fieldCoupledTo": "Pulled by",
  "resources.fieldPersonnelNumber": "Personnel number",
  "resources.fieldFirstName": "First name",
  "resources.fieldLastNamePrefix": "Prefix",
  "resources.fieldLastName": "Last name",
  "resources.fieldBcNumber": "BC number",
  "resources.fieldAfasNumber": "AFAS number",
  "resources.fieldEmployment": "Employment",
  "resources.fieldOvernight": "Stays overnight",
  "resources.fieldAppId": "Welder app",
  "resources.fieldAppIdHelp": "The id WLX reaches the driver by in the Welder app.",
  "resources.fieldVehicles": "Regular vehicle",
  "resources.fieldQualifications": "Qualifications",
  "resources.blockGeneral": "General",
  "resources.blockInspection": "Inspection",
  "resources.blockLoading": "Loading space",
  "resources.blockMasses": "Weight",
  "resources.blockDimensions": "Dimensions",
  "resources.blockDeployment": "Deployment",
  "resources.blockSystems": "Other systems",
  "resources.sectionBody": "Body and dimensions",
  "resources.sectionEnvironment": "Environment",
  "resources.sectionLinks": "Regularly coupled",
  "resources.sectionAvailability": "Duty roster",
  "resources.cooled": "Refrigerated",
  "resources.zoneAllowed": "Allowed",
  "resources.zoneNotAllowed": "Not allowed",
  "resources.zoneUnknown": "Unknown",
  "resources.spaceMeters": "{{meters}} m",
  "resources.sectionInspection": "Inspection, mass and dimensions",
  "resources.fieldApk": "Inspection (APK) until",
  "resources.fieldTachograph": "Tachograph until",
  "resources.fieldMaxMass": "Permitted maximum mass",
  "resources.fieldTechnicalMaxMass": "Technical maximum mass",
  "resources.fieldCombinationMass": "Maximum train mass",
  "resources.fieldCombinationMassHelp": "What tractor, trailer and load may weigh together.",
  "resources.fieldLength": "Length",
  "resources.fieldWidth": "Width",
  "resources.fieldLengthM": "Length (m)",
  "resources.fieldWidthM": "Width (m)",
  "resources.kgValue": "{{value}} kg",
  "resources.metersValue": "{{value}} m",
  "resources.inspectionKind.apk": "APK",
  "resources.inspectionKind.tachograph": "Tachograph",
  "resources.colPayload": "Payload",
  "resources.colMaxMass": "Max. mass",
  "resources.colDriver": "Regular driver",
  "resources.colEmission": "Emissions",
  "resources.colInspection": "Inspection",
  "resources.bodyCooled": "{{body}}, refrigerated",
  "resources.zoneNotAllowedShort": "Not in low-emission zones",
  "resources.inspectionDue": "{{kind}} {{date}}",
  "resources.inspectionExpired": "{{kind}} expired {{date}}",
  "resources.inspectionSoonHint": "Expires within a month",
  "resources.inspectionExpiredHint": "Expired: do not use it for a trip",
  "resources.rdwTitle": "RDW",
  "tracking.branch": "Branch",
  "tracking.allBranches": "All branches",
  "tracking.activityLabel": "Activity",
  "tracking.allActivities": "All activities",
  "tracking.search": "Search",
  "tracking.searchPlaceholder": "Trip, place, driver or lorry",
  "tracking.updated": "Updated {{time}}",
  "tracking.limits": "Behind from {{behind}} min · uncertain after {{stale}} min without a position",
  "tracking.tilesLabel": "How the trips stand",
  "tracking.tile.all": "Running trips",
  "tracking.tile.onTime": "On schedule",
  "tracking.tile.behind": "Behind schedule",
  "tracking.tile.late": "Expected late",
  "tracking.tile.uncertain": "Status uncertain",
  "tracking.tileText.all": "Active right now",
  "tracking.tileText.onTime": "Within the plan",
  "tracking.tileText.behind": "Still within the window",
  "tracking.tileText.late": "Outside the window",
  "tracking.tileText.uncertain": "No recent position",
  "tracking.tile.reports": "Driver reports",
  "tracking.tileText.reports": "Missing, damaged, not complete",
  "tracking.listTitle": "Running trips",
  "tracking.listText": "By urgency: what the lorry does and the deviation apart",
  "tracking.sortLabel": "Order",
  "tracking.sort.urgency": "Urgency first",
  "tracking.sort.departure": "Next arrival",
  "tracking.sort.number": "Trip number",
  "tracking.error": "Trip follow-up could not be loaded.",
  "tracking.colTrip": "Trip / lorry",
  "tracking.colNow": "Now",
  "tracking.colNext": "Next stop",
  "tracking.colArrival": "Arrival",
  "tracking.colSchedule": "Schedule",
  "tracking.none": "No trips are running now.",
  "tracking.noneFiltered": "No trip with these filters.",
  "tracking.ftl": "FTL",
  "tracking.ltl": "LTL",
  "tracking.activity.driving": "On the road",
  "tracking.activity.loading": "Loading",
  "tracking.activity.unloading": "Unloading",
  "tracking.activity.waiting": "Waiting",
  "tracking.activity.still": "Standing still",
  "tracking.activity.returning": "On the way home",
  "tracking.activity.unknown": "Unknown",
  "tracking.update": "Update {{time}}",
  "tracking.noPosition": "No position",
  "tracking.noNext": "All stops done",
  "tracking.progress": "{{done}}/{{total}} stops done",
  "tracking.plan": "plan {{time}}",
  "tracking.until": "until {{time}}",
  "tracking.onPlan": "On time",
  "tracking.later": "+{{minutes}} min",
  "tracking.earlier": "−{{minutes}} min",
  "tracking.pastWindow": "{{minutes}} min outside the window",
  "tracking.slack": "{{minutes}} min to spare",
  "tracking.takenBy": "Taken up: {{name}}",
  "tracking.openReport": "Open report",
  "tracking.driverReports_one": "{{count}} driver report",
  "tracking.driverReports_other": "{{count}} driver reports",
  "tracking.ended": "Trip ended",
  "tracking.mapLabel": "Map with the lorries",
  "tracking.stageLabel": "Which trips",
  "tracking.stage_all": "All",
  "tracking.stage_1": "FTL and factory shuttles",
  "tracking.stage_2": "LTL",
  "tracking.mapPlaceLabel": "Map",
  "tracking.mapPlace_off": "No map",
  "tracking.mapPlace_beside": "Map beside",
  "tracking.mapPlace_window": "Map apart",
  "tracking.mapWindowRefused": "The browser stopped the map window. Allow pop-up windows for WLX and try again.",
  "tracking.mapWindowTitle": "Trip follow-up · map",
  "tracking.mapFollows": "The map follows Trip follow-up; go to the planning board and it follows that again.",
  "tracking.mapChosen": "{{lorry}} · {{trip}}",
  "tracking.mapNoTrip": "no running trip",
  "tracking.mapRelease": "Let go",
  "tracking.mapHint": "Click a lorry or a stop for the route of that lorry and what it still has to do.",
  "tracking.mapLegend": "Stops: dark = done, teal = to come · triangle and square: orders that load today and are not planned yet · solid: driven today · dashed: the planned rest and home",
  "tracking.mapStops": "Show stops",
  "tracking.noRunningTrip": "This lorry drives no running trip now. The map shows its route today.",
  "tracking.mapSeen": "seen {{time}}",
  "tracking.detailLabel": "The trip chosen",
  "tracking.pickTrip": "Choose a trip in the list or a lorry on the map.",
  "tracking.alertLate": "Expected late at {{place}}: arrival {{eta}}, {{later}} against the plan, {{past}}.",
  "tracking.alertBehind": "Behind schedule: {{later}} at the next stop, still within the window.",
  "tracking.alertUncertain": "No recent position (last {{time}}): where the lorry is and what it does is uncertain.",
  "tracking.nextStop": "Next: {{name}} · {{city}}",
  "tracking.planLabel": "Plan",
  "tracking.expectedLabel": "Expected",
  "tracking.differenceLabel": "Difference",
  "tracking.window": "Customer window {{from}}–{{to}}",
  "tracking.expectedEnd": "Expected back at {{time}}",
  "tracking.followUp": "Deviation follow-up",
  "tracking.takenSince": "{{name}} since {{time}}",
  "tracking.take": "Take up",
  "tracking.release": "Let go",
  "tracking.course": "Course of the trip",
  "tracking.now": "Now {{time}}",
  "tracking.expectedAt": "{{time}} expected",
  "tracking.courseKind.load": "Loading",
  "tracking.courseKind.drive": "Driving",
  "tracking.courseKind.unload": "Unloading",
  "tracking.courseKind.wait": "Waiting",
  "tracking.courseLight": "Light = expected",
  "tracking.tabStops": "Stops · {{count}}",
  "tracking.tabLog": "Log",
  "tracking.notePlaceholder": "Internal note on this trip",
  "tracking.addNote": "Add note",
  "tracking.depot": "Depot",
  "tracking.load": "Loading",
  "tracking.unload": "Unloading",
  "tracking.nextWord": "Next",
  "tracking.arrived": "arrived {{time}}",
  "tracking.expected": "expected {{time}}",
  "tracking.departed": "left {{time}}",
  "tracking.windowFrom": "window from {{time}}",
  "tracking.stopLate": "Expected {{minutes}} min after the window ({{time}})",
  "resources.unavailability.title": "Not available",
  "resources.unavailability.help": "A period this lorry or trailer cannot be planned. The planning board shows it, and a lorry does not take a trailer that is away onto a trip.",
  "resources.unavailability.from": "From",
  "resources.unavailability.to": "Until",
  "resources.unavailability.reason": "Reason",
  "resources.unavailability.remark": "Remark",
  "resources.unavailability.add": "Add",
  "resources.unavailability.remove": "Remove",
  "resources.unavailability.none": "No period planned.",
  "resources.unavailability.reason_workshop": "Workshop",
  "resources.unavailability.reason_damage": "Damage",
  "resources.unavailability.reason_inspection": "Inspection",
  "resources.unavailability.reason_other": "Other",
  "resources.rdwHelp": "Compare with what the RDW registers for this plate. You choose what to take over.",
  "resources.rdwNoPlate": "Without a plate there is nothing to fetch from the RDW.",
  "resources.rdwUnsaved": "Save your changes first; then you can compare with the RDW.",
  "resources.rdwCheckedAt": "Last taken over from the RDW on {{date}}.",
  "resources.rdwCompare": "Compare with RDW",
  "resources.rdwCompareAll": "Compare with RDW",
  "resources.rdwAsking": "Asking the RDW…",
  "resources.rdwLookup": "Fetch from RDW",
  "resources.rdwFound": "Found at the RDW",
  "resources.rdwNotFound": "The RDW does not know plate {{plate}}: a foreign plate, or a typo.",
  "resources.rdwFirstAdmission": "first registered {{date}}",
  "resources.rdwExported": "According to the RDW this vehicle has been exported.",
  "resources.rdwNothingDifferent": "Everything the RDW registers is already in WLX.",
  "resources.rdwColTake": "Take over",
  "resources.rdwColField": "Field",
  "resources.rdwColWlx": "In WLX",
  "resources.rdwColRdw": "RDW",
  "resources.rdwColUnit": "Unit",
  "resources.rdwSame": "Same",
  "resources.rdwTakeField": "Take {{field}} over",
  "resources.rdwTakeFieldOf": "Take {{field}} of {{unit}} over",
  "resources.rdwTakeUnit": "Take all differences of {{unit}} over",
  "resources.rdwApplyCount_one": "Take {{count}} field over",
  "resources.rdwApplyCount_other": "Take {{count}} fields over",
  "resources.rdwApplied_one": "{{count}} field taken over from the RDW.",
  "resources.rdwApplied_other": "{{count}} fields taken over from the RDW.",
  "resources.rdwFactPayload": "payload {{value}}",
  "resources.rdwFactCombination": "train mass {{value}}",
  "resources.rdwFactApk": "APK until {{date}}",
  "resources.rdwFill": "Take the RDW's data over",
  "resources.rdwFillHelp": "Make, model, weights, axles, inspections and dimensions then come from the RDW.",
  "resources.rdwUnavailable": "The RDW cannot be reached right now. Try again in a moment.",
  "resources.rdwOff": "Fetching from the RDW is switched off.",
  "resources.rdwRetry": "Try again",
  "resources.rdwOverviewIntro":
    "Every active unit beside what the RDW registers for its plate. What differs is ticked; only what stays ticked is taken over.",
  "resources.rdwSummary":
    "{{found}} found at the RDW · {{withDifferences}} with differences · {{notFound}} not found · {{noPlate}} without a plate",
  "resources.rdwSelectAll": "Tick every difference",
  "resources.rdwSelectNone": "Untick all",
  "resources.rdwApplySelection": "Take over: {{fields}} fields of {{units}} units",
  "resources.rdwAppliedUnits_one": "Taken over for {{count}} unit.",
  "resources.rdwAppliedUnits_other": "Taken over for {{count}} units.",
  "resources.rdwNoDifferences": "No differences: what the RDW registers is already in WLX.",
  "resources.rdwDifferences_one": "{{count}} difference",
  "resources.rdwDifferences_other": "{{count}} differences",
  "resources.rdwSameUnits_one": "{{count}} unit already matches the RDW.",
  "resources.rdwSameUnits_other": "{{count}} units already match the RDW.",
  "resources.rdwNotFoundList": "Not found at the RDW ({{count}}):",
  "resources.rdwNoPlateList": "Without a plate ({{count}}):",
  "resources.featuresNone": "No special equipment.",
  "resources.rosterHelp": "From AFAS, read-only. With a shift the driver is available for planning all that day.",
  "resources.rosterUnknown": "AFAS does not know this driver: there is no duty roster.",
  "resources.rosterState_shift": "Shift",
  "resources.rosterState_noShift": "No shift",
  "resources.rosterState_ill": "Ill",
  "resources.rosterState_leave": "Leave",
  "resources.rosterState_away": "Away",
  "resources.rosterState_unknown": "—",
  "resources.branchLabel": "Base",
  "resources.branchNone": "No base",
  "resources.branchSelfEmployedHelp": "A self-employed driver has no base: they stand on the planning board of every branch.",
  "resources.branchHelpVehicle": "The branch where the vehicle is based. You choose it here; WLX no longer derives it.",
  "resources.choiceOnVehicle": "now on {{codes}}",
  "resources.weekdayNoteBy": "{{name}}, {{when}}",
  "resources.restriction.title": "Restrictions",
  "resources.restriction.help":
    "What the driver cannot do on a day, beside his roster from AFAS: every week, even or odd weeks, or once. Planning sees it in Capacity and gets a warning when a trip goes against it. No health reasons: illness and leave come from AFAS.",
  "resources.restriction.none": "No restrictions.",
  "resources.restriction.new": "New restriction",
  "resources.restriction.add": "+ Restriction",
  "resources.restriction.remove": "Remove",
  "resources.restriction.repeat": "When",
  "resources.restriction.repeat_weekly": "Every week",
  "resources.restriction.repeat_even_weeks": "Even weeks",
  "resources.restriction.repeat_odd_weeks": "Odd weeks",
  "resources.restriction.repeat_once": "Once",
  "resources.restriction.days": "Days",
  "resources.restriction.from": "From",
  "resources.restriction.onDay": "On",
  "resources.restriction.untilOptional": "Until (optional)",
  "resources.restriction.untilDay": "Through (optional)",
  "resources.restriction.kind": "What",
  "resources.restriction.kind_home_by": "Home by",
  "resources.restriction.kind_start_after": "Not before",
  "resources.restriction.kind_whole_day": "Not that day",
  "resources.restriction.kind_note": "Remark",
  "resources.restriction.time": "Time",
  "resources.restriction.why": "Why (no health)",
  "resources.restriction.when_weekly": "every {{days}}",
  "resources.restriction.when_even_weeks": "even weeks: {{days}}",
  "resources.restriction.when_odd_weeks": "odd weeks: {{days}}",
  "resources.restriction.onceSpan": "{{from}} to {{to}}",
  "resources.restriction.until": "until {{date}}",
  "resources.driverOneVehicleHelp": "A driver is the regular driver of one vehicle. Choose one who is on another vehicle and he comes off that one.",
  "resources.trailerOneVehicleHelp": "A trailer is the regular trailer of one vehicle. Choose one that belongs to another vehicle and it comes off that one.",
  "resources.activeHelp": "An inactive unit is kept, but no longer chosen for a trip.",
  "resources.kind.tractor": "Tractor",
  "resources.kind.rigid": "Rigid truck",
  "resources.kind.van": "Van",
  "resources.kind.shunter": "Shunter",
  "resources.kind.other": "Other",
  "resources.subType.semi": "Semi-trailer",
  "resources.subType.drawbar": "Drawbar trailer",
  "resources.body.box": "Box",
  "resources.body.curtain": "Curtain",
  "resources.body.tautliner": "Tautliner",
  "resources.tailLift.none": "None",
  "resources.tailLift.rear": "Rear lift",
  "resources.tailLift.under": "Under-ride lift",
  "resources.employment.permanent": "Permanent",
  "resources.employment.on_call": "On call",
  "resources.employment.agency": "Agency",
  "resources.employment.self_employed": "Self-employed",
  "resources.feature.steering_axle": "Steering axle",
  "resources.feature.sliding_roof": "Sliding roof",
  "resources.feature.roller_door": "Roller door",
  "resources.feature.adr_equipment": "ADR equipment",
  "resources.feature.truck_mounted_forklift": "Truck-mounted forklift",
  "resources.feature.extra_support_legs": "Extra support legs",
  "resources.feature.cargo_bars": "Cargo bars",
  "resources.feature.shoring_planks": "Shoring planks",
  "resources.feature.shoring_props": "Shoring props",
  "resources.qualification.adr": "ADR",
  "resources.qualification.vca": "VCA",
  "resources.qualification.truck_mounted_forklift": "Truck-mounted forklift",
  "resources.qualification.fc_training": "FC-trained",
  "resources.day1": "Mon",
  "resources.day2": "Tue",
  "resources.day3": "Wed",
  "resources.day4": "Thu",
  "resources.day5": "Fri",
  "resources.day6": "Sat",
  "resources.day7": "Sun",
  "orders.temperatureMinLabel": "Temperature from (°C)",
  "orders.temperatureMaxLabel": "to (°C)",
  "orders.adrLabel": "ADR (dangerous goods)",
  "orders.forkliftLabel": "Truck-mounted forklift",
  "orders.consignmentReferenceLabel": "Consignment reference",
  "orders.remarkLabel": "Remark on the consignment note",
  "orders.activitiesTitle": "Activities",
  "orders.activitiesHelp": "Load first, unload last, in order. Type times as you say them: 8 becomes 08:00.",
  "orders.activityTypeLabel": "Activity",
  "orders.activityPlaceLabel": "Place",
  "orders.activityPlaceNameLabel": "Name of the place",
  "orders.activityDateLabel": "Date",
  "orders.pickDate": "Pick a date from the calendar",
  "orders.activityFromLabel": "From",
  "orders.activityToLabel": "To",
  "orders.activityInstructionLabel": "Instruction",
  "orders.contactLabel": "Contact",
  "orders.contactNameLabel": "Contact person",
  "orders.contactPhoneLabel": "Phone",
  "orders.arrivalPopupLabel": "Popup on arrival",
  "orders.activityRemove": "Remove",
  "orders.activityAdd": "Add activity",
  "orders.placeSearchPlaceholder": "Search a location: name, code, city, postal code…",
  "orders.placeNothingFound": "No location found.",
  "orders.placeGiveAddress": "Enter an address that is not a known location",
  "orders.placeChange": "Other place",
  "orders.placeFromBook": "A known location after all",
  "orders.givenAddressTitle": "Address as given",
  "orders.placeNameLabel": "Name",
  "orders.dayOpen": "{{date}}: open {{hours}}",
  "orders.dayClosed": "{{date}}: closed",
  "common.and": "and",
  "orders.fromMessageCustomerNote": "You pick the relation yourself in step 1 — a name in a mail is not a customer.",
  "orders.tabDrafts": "Drafts",
  // Transport → Orders → Aanmelden (docs/tms-aanmelden.md)
  "preNotify.tab": "Pre-notify",
  "preNotify.kindSlot": "Time slot",
  "preNotify.kindTrip": "Trip",
  "preNotify.load": "Loading",
  "preNotify.unload": "Unloading",
  "preNotify.colKind": "Kind",
  "preNotify.colDate": "Date and window",
  "preNotify.colPlace": "Place",
  "preNotify.colHow": "Pre-notify via",
  "preNotify.colTrip": "Trip",
  "preNotify.colPallets": "Pallets",
  "preNotify.colAction": "Pre-notified",
  "preNotify.openLink": "The place's portal",
  "preNotify.noPlate": "Lorry without a licence plate; the place requires one",
  "preNotify.plateRequired": "Licence plate required",
  "preNotify.etaRequired": "ETA required",
  "preNotify.mark": "Mark pre-notified",
  "preNotify.waiting": "To pre-notify",
  "preNotify.count": "{{slots}} time slot(s) to book · {{trips}} trip(s) to pre-notify",
  "preNotify.none": "Nothing waits to be pre-notified.",
  "preNotify.markTitle": "Pre-notified at {{place}}",
  "preNotify.markHelp": "{{order}}, asked for {{date}} between {{from}} and {{to}}. Fill in the time slot if the place gave one: WLX then plans on the slot. The price stays with what the customer asked.",
  "preNotify.slotDate": "Date",
  "preNotify.slotFrom": "Time slot from",
  "preNotify.slotTo": "to",
  "preNotify.slotHelp": "No time slot? Leave the times empty.",
  "preNotify.note": "Reference or agreement",
  "preNotify.notePlaceholder": "For example the booking number",
  "preNotify.slotIncomplete": "A time slot has a date, a start and an end.",
  "preNotify.slotBackwards": "The time slot ends after it starts.",
  "preNotify.markSubmit": "Pre-notified",
  "preNotify.stopDone": "Pre-notified",
  "preNotify.stopSlot": "Pre-notified, time slot {{from}}–{{to}}",
  "preNotify.stopRequested": "Asked by the customer: {{date}} {{from}}–{{to}}",
  "preNotify.stopMailed": "Trip pre-notified by mail, {{when}}",
  "preNotify.stopMailLater": "The trip is pre-notified by mail once it is confirmed",
  "preNotify.stopTodoSlot": "Time slot still to book",
  "preNotify.stopTodoTrip": "Trip still to pre-notify",
  "preNotify.stopTodoHelp": "Book it at the place and mark it under Transport → Orders → Pre-notify.",
  "preNotify.undo": "Undo",
  "preNotify.colReference": "Reference",
  "preNotify.logMarked": "Pre-notified at the place",
  "preNotify.logCleared": "Pre-notification undone",
  "preNotify.logTripMailed": "Trip pre-notified to the place, by mail",
  "preNotify.logSlot": "Time slot {{date}} {{from}}–{{to}}",
  "preNotify.logTripChanged": "Changed pre-notification: another day, lorry or trailer",
  "orders.draftRoute": "Route",
  "orders.draftChanged": "Last changed",
  "orders.draftDiscard": "Discard",
  "orders.draftNoCustomer": "No customer chosen yet",
  "orders.draftsEmpty": "You have no drafts. What you save halfway appears here — for you alone.",
  "orders.makeLocationFromAddress": "Create from this address",
  // ── The order entry in four steps, and taking an order over from a message
  "orders.stepsLabel": "Steps",
  "orders.stepCustomer": "Customer & order",
  "orders.stepShipment": "Goods & stops",
  "orders.stepStops": "Stops & times",
  "orders.stepCheck": "Check & create",
  "orders.stepNext": "Next: {{step}}",
  "orders.stepPrevious": "Previous",
  "orders.whoOrders": "Who is ordering",
  "orders.howFixed": "How fixed is it",
  "orders.windowLabel": "Window",
  "orders.windowAllDay": "all day",
  "orders.windowFromOnly": "from {{time}}",
  "orders.windowToOnly": "until {{time}}",
  "orders.windowToNextDay": "{{from}}–{{to}} (+1 day)",
  "orders.windowNextDay": "to the next day",
  "orders.windowEndsBeforeStart": "Ends before it starts",
  "orders.cityLabel": "Town",
  "orders.swapActivity": "Swap",
  "orders.addStop": "Add stop",
  "orders.oneLoadOneUnload": "Loaded once, unloaded once. Another address? Add a consignment; it loads where this one does.",
  "orders.solveDuringEntry": "Pick a known location above, or make one from this address now.",
  "orders.saveDraft": "Save as draft",
  "orders.draftSavedAt": "Draft saved {{time}}",
  "orders.draftGone": "This draft no longer exists. You are starting an empty order.",
  "orders.orderInProgress": "Order in progress",
  "orders.checkTitle": "Check",
  "orders.checkLive": "runs along while you type",
  "orders.checkNothingYet": "nothing checked yet",
  "orders.checkNothingFound": "nothing blocks it",
  "orders.blockCount_one": "1 blockade",
  "orders.blockCount_other": "{{count}} blockades",
  "orders.noteCount_one": "1 note",
  "orders.noteCount_other": "{{count}} notes",
  "orders.checkAllGood": "Nothing blocks this order. It is accepted at once and can be planned.",
  "orders.checkBlockedTitle_one": "1 blockade — this order goes to the work queue",
  "orders.checkBlockedTitle_other": "{{count}} blockades — this order goes to the work queue",
  "orders.checkBlockedHelp": "Solve them in the step they belong to and the order can be planned straight away. Create it anyway and it waits in the work queue.",
  "orders.checkNoteTitle_one": "1 note — travels along, does not block",
  "orders.checkNoteTitle_other": "{{count}} notes — travel along, do not block",
  "orders.checkPreviewTitle": "This is what the order will look like",
  "orders.footClean": "Ready to create; this order can be planned straight away.",
  "orders.footBlocked": "{{what}}. You can solve it right here.",
  "orders.footNotes_one": "1 note. You can create the order; it travels along.",
  "orders.footNotes_other": "{{count}} notes. You can create the order; they travel along.",
  "orders.planFeasibility": "Plannability",
  "orders.planFeasibilityHelp": "Which vehicles are free comes with the planning board.",
  "orders.fromMessageTitle": "Order from a message",
  "orders.fromMessageIntro":
    "Paste the customer's mail. WLX reads what it recognises and you check it. The channel becomes mail instead of manual.",
  "orders.fromMessagePrompt": "Have you got the customer's mail?",
  "orders.fromMessageHint": "Paste it here and WLX fills in the steps for you.",
  "orders.fromMessageOpen": "Take over from a message",
  "orders.fromMessageSource": "Source",
  "orders.fromMessageFrom": "Sender",
  "orders.fromMessageFromPlaceholder": "e.g. planning@customer.com",
  "orders.fromMessagePlaceholder": "Paste the customer's mail here.",
  "orders.fromMessageReadAgain": "Read again",
  "orders.fromMessageResult": "What WLX read out of it",
  "orders.fromMessageCounts": "{{sure}} of {{total}} fields certain · {{check}} to check",
  "orders.fromMessageNothingYet": "Paste a message; what WLX recognises appears here.",
  "orders.fromMessageFooter": "After taking it over the entry screen opens filled in. Every field stays editable.",
  "orders.fromMessageApply": "Take over into a new order",
  "orders.confidenceSure": "Certain",
  "orders.confidenceCheck": "Check",
  "orders.confidenceGuess": "Assumption",
  "orders.confidenceMissing": "Not found",
  // ── The order card, rebuilt around the consignment (handoff 18-09-2026)
  "orders.tabConsignment": "Consignment",
  "orders.tabConsignments": "Consignments",
  "orders.tabGoods": "Goods",
  "orders.tabPallets": "Pallets",
  "orders.tabTariff": "Tariff",
  "orders.tariffPriced": "Priced",
  "orders.tariffReview": "To review",
  "orders.tariffNoPrice": "No tariff",
  "orders.tariffCancelled": "Void",
  "orders.tariffCounted": "Added up",
  "orders.tariffGroupCarries": "Added up on trip {{trip}} with {{others}}: this consignment bears the billable loading metres, weight and pallets of all of them.",
  "orders.tariffGroupCounted": "Added up with {{carrier}} on trip {{trip}}, which bears the billable loading metres, weight and pallets of the group.",
  "orders.tariffNotYet": "Not priced yet.",
  "orders.tariffNoteNoAccount": "The customer is not a sales relation: there is no debtor to take the tariff from.",
  "orders.tariffNoteNoAgreement": "This customer has no price agreement for this day.",
  "orders.tariffNoteNothingApplies": "No line of the billing method fits this consignment.",
  "orders.tariffNoteLineUndecided": "Line \"{{line}}\": cannot tell whether it applies — a condition WLX cannot read (yet), or opening hours that are unknown.",
  "orders.tariffNoteLineNeedsReview": "Line \"{{line}}\" is to be reviewed: someone checks it in the price agreement.",
  "orders.tariffNoteLineNoPrice": "Line \"{{line}}\": the tariff has no price here.",
  "orders.tariffNoteBeyondRows": "Line \"{{line}}\": {{quantity}} is above the tariff's last bound (up to {{last}}). Change the tariff or set a price by hand.",
  "orders.tariffNoteBeyondColumns": "Line \"{{line}}\": zone {{quantity}} is outside the tariff's matrix (up to {{last}}).",
  "orders.tabPrices": "Price approval",
  "orders.tariffAwaitingApproval": "Awaiting approval",
  "orders.tariffByHand": "By hand",
  "orders.tariffByAgreement": "Price agreement",
  "orders.priceByHand": "Price by hand",
  "orders.priceByHandHint": "No agreement for this route or customer? Set a price by hand; planning approves it.",
  "orders.priceDescription": "Description",
  "orders.priceAmount": "Amount",
  "orders.priceSurcharges": "Surcharges",
  "orders.priceWithSurcharges": "Plus surcharges",
  "orders.priceAllIn": "All-in",
  "orders.priceSource": "Where the price comes from",
  "orders.priceSourceNoAgreement": "No agreement for this route or customer",
  "orders.priceSourceTransportOrder": "From the transport order",
  "orders.priceSourcePlanner": "As the planner said",
  "orders.priceNote": "Note",
  "orders.priceNotePlaceholder": "For example: agreed with the customer by phone",
  "orders.priceSave": "Save price",
  "orders.priceWaitsHint": "The price takes the place of what the agreement charges, and waits for planning to approve it.",
  "orders.priceNoneByHand": "No price by hand",
  "orders.entryTariffWaiting": "What the agreement charges shows here once the customer and every stop are filled in.",
  "orders.priceIncomplete": "Give the price by hand a description and an amount, or remove it.",
  "orders.priceDefaultDescription": "Transport {{route}}",
  "orders.priceByHandLine": "Price by hand: {{amount}}, {{surcharges}}",
  "orders.priceSetBy": "set by {{name}} on {{when}}",
  "orders.priceApprovedBy": "Approved by {{name}} on {{when}}.",
  "orders.priceAwaits": "Waiting for planning to approve it. Until then the consignment goes on no invoice.",
  "orders.priceAwaitsOther": "Waiting for planning to approve it. A price you set, someone else approves.",
  "orders.priceApprove": "Approve",
  "orders.priceChange": "Change",
  "orders.priceRemove": "Remove",
  "orders.priceErrorOwn": "A price you set, someone else approves.",
  "orders.priceErrorChanged": "The price changed in the meantime. Look at it again, then approve it.",
  "orders.priceErrorInvoiced": "This consignment is on a final invoice: a change goes through a credit invoice.",
  "orders.priceErrorClosed": "The order is cancelled or rejected.",
  "orders.priceColUnloadDate": "Unloading date",
  "orders.priceColTotal": "With surcharges",
  "orders.priceColSetBy": "Set by",
  "orders.priceColSetAt": "Set on",
  "orders.priceColApproval": "Approval",
  "orders.priceStateWaiting": "Awaiting approval",
  "orders.priceStateWaitingOther": "Awaiting someone else",
  "orders.priceStateApproved": "Approved",
  "orders.pricesCount_one": "1 price awaits approval",
  "orders.pricesCount_other": "{{count}} prices await approval",
  "orders.pricesCountAll_one": "1 price by hand",
  "orders.pricesCountAll_other": "{{count}} prices by hand",
  "orders.pricesAlsoApproved": "Approved ones too",
  "orders.pricesNone": "No price awaits approval.",
  "orders.pricesNoneAll": "No price has been set by hand yet.",
  "orders.logPriceSet": "Price set by hand",
  "orders.logPriceChanged": "Price by hand changed",
  "orders.logPriceApproved": "Price by hand approved",
  "orders.logPriceRemoved": "Price by hand removed",
  "orders.logPalletsChanged": "Pallets changed",
  "orders.logPalletsChecked": "Pallets checked",
  "orders.logPalletsReopened": "Pallet check reopened",
  "orders.logCustomerMail": "Mail to the customer",
  "orders.logPackingSlipAdded": "Packing slip added on the portal",
  "orders.logRepeated": "Repeated",
  "orders.logRepeatedLine": "{{count}} order made: {{orders}}",
  "orders.logRepeatedLine_other": "{{count}} orders made: {{orders}}",
  "orders.logRepeatedProvisional": "{{count}} provisional order made: {{orders}}",
  "orders.logRepeatedProvisional_other": "{{count}} provisional orders made: {{orders}}",
  "orders.logReplacedProvisional": "Provisional order replaced",
  "orders.logReplacedProvisionalLine": "In the place of {{order}}",
  "orders.logTookPlaceOnTrips": "Took its place on trip {{trips}}",
  "orders.logTookPlaceOnTrips_other": "Took its place on the trips {{trips}}",
  "orders.logReplacedByLine": "Replaced by {{order}}, which took its place on the trip",
  "orders.logReplacedByItself": "By itself, when the customer's order came in",
  "orders.logProvisionalDismissed": "Replaces no provisional order",
  "orders.logFromList": "Updated from a list of the customer",
  "orders.logPackingSlipLine": "Consignment {{consignment}}: {{name}}",
  "orders.logPackingSlipReprint": "If the trip was printed already, it is not with it: printing again takes it along",
  "orders.logCustomerMailConfirmation": "Order confirmation",
  "orders.logCustomerMailDelivered": "Done message",
  "orders.logCustomerMailPlanned": "Planned shipments of the day",
  "orders.logCustomerMailEmballage": "Emballage not fully returned (evening mail)",
  "orders.logCustomerMailPreAdvice": "Pallet pre-advice to the unloading place",
  "orders.logCustomerMailTo": "To {{to}}",
  "orders.logPriceAwaits": "Waiting for planning to approve it",
  "orders.logPriceStillApproved": "Same price: stays approved",
  "orders.tariffNoteQuantityUnknown": "Line \"{{line}}\": WLX does not know the quantity ({{quantity}}) yet.",
  "orders.tariffNoteNoDate": "Line \"{{line}}\": the consignment has no date to choose the tariff period by.",
  "orders.tariffNoteSurchargeWithoutRate": "Surcharge \"{{surcharge}}\" has no percentage on {{date}}.",
  "orders.tariffNotInvoiced": "Not invoiced",
  "orders.tariffNoteWaitingNotPriced": "{{quantity}} waiting hours, but the price agreement has no waiting hours. Add them to the agreement, set a price by hand or remove the waiting hours.",
  "orders.tariffNoteViaWarehouse": "Not invoiced: this customer's transport is on the invoice of the warehouse week.",
  "orders.setByWhen": "Set by {{name}} on {{when}}.",
  "orders.waitingAdd": "Waiting hours",
  "orders.waitingHours": "Waiting hours",
  "orders.waitingNote": "Note",
  "orders.waitingNotePlaceholder": "E.g. waited 1.5 hours at unloading",
  "orders.waitingSave": "Save",
  "orders.waitingHint": "Priced by the waiting hours of the price agreement.",
  "orders.waitingLine": "Waiting hours: {{hours}} h",
  "orders.waitingChange": "Change",
  "orders.waitingRemove": "Remove",
  "orders.noInvoiceAdd": "Do not invoice",
  "orders.noInvoiceLine": "Not invoiced: {{reason}}",
  "orders.noInvoiceReason": "Reason",
  "orders.noInvoiceReasonPlaceholder": "E.g. delivered again after a refusal",
  "orders.noInvoiceSave": "Do not invoice",
  "orders.noInvoiceHint": "The consignment goes on no invoice and not under Not invoiceable.",
  "orders.noInvoiceUndo": "Invoice after all",
  "orders.logWaitingSet": "Waiting hours set",
  "orders.logWaitingChanged": "Waiting hours changed",
  "orders.logWaitingRemoved": "Waiting hours removed",
  "orders.logNoInvoiceSet": "Not invoiced",
  "orders.logNoInvoiceRemoved": "Invoiced after all",
  "orders.logNoCmrReturnSet": "No CMR back",
  "orders.logNoCmrReturnRemoved": "A CMR back after all",
  "orders.signedCmr": "Signed CMR",
  "orders.signedCmrState.signed": "in",
  "orders.signedCmrState.waiting": "not in yet",
  "orders.signedCmrState.none": "does not come back",
  "orders.logWaitingHours": "{{hours}} h",
  "orders.tariffNoteOther": "Note: {{code}}",
  "orders.tariffColDescription": "Description",
  "orders.tariffColQuantity": "Quantity",
  "orders.tariffColPrice": "Price",
  "orders.tariffColAmount": "Amount",
  "orders.tariffPricePer": "{{price}} per {{per}}",
  "orders.tariffTotal": "Total excluding VAT",
  "orders.tariffCalculatedAt": "Calculated on {{when}}; WLX recalculates as soon as the order or the planning changes.",
  "orders.tabParties": "Parties",
  "orders.tabDocuments": "Documents",
  "orders.tabLog": "Log",
  "orders.consignmentOfTotal": "Consignment {{index}} of {{total}}",
  "orders.consignmentCount_one": "1 consignment",
  "orders.consignmentCount_other": "{{count}} consignments",
  "orders.stopCount_one": "1 stop",
  "orders.stopCount_other": "{{count}} stops",
  "orders.stopNumber": "Stop {{number}}",
  "orders.now": "Now",
  "orders.nextHandling": "Next handling",
  "orders.goodsTogether": "Goods together",
  "orders.trip": "Trip",
  "orders.trips": "Trips",
  "orders.tripNotPlanned": "Not planned yet",
  "orders.tripsWaiting_one": "{{count}} still to plan",
  "orders.tripsWaiting_other": "{{count}} still to plan",
  "orders.calledOffAt": "on {{when}}",
  "orders.addressLabel": "Address",
  "orders.distanceLabel": "Distance and driving time",
  "orders.viaDepotLabel": "Via a depot",
  "orders.openingHoursOn": "open {{day}} {{hours}}",
  "orders.openingHoursUnknown": "opening hours unknown",
  "orders.stateExpected": "Expected",
  "orders.stateBlockedStop": "Blocked",
  "orders.palletsShort_one": "1 pal",
  "orders.palletsShort_other": "{{count}} pal",
  "orders.referenceShort": "Invoice ref.",
  "orders.referenceAdd": "+ Invoice reference",
  "orders.referenceChange": "Change invoice reference",
  "orders.referenceSave": "Save",
  "orders.referenceLockedEdi": "Came from the customer through EDI: the customer's changes find the order on this reference, so it stays.",
  "orders.referenceLockedInvoiced": "On a final invoice. Credit that first to change the invoice reference.",
  "orders.customerPhone": "Phone",
  "orders.customerPhoneUnknown": "No phone number on this relation",
  "orders.changePriority": "Change priority",
  "orders.railFindings": "What is on it now",
  "orders.cardAllGood": "Nothing blocks this order. It can be planned.",
  "orders.cardNoBlockers": "Nothing blocks this order. The notes below travel along with it.",
  "orders.cardCancelled": "Cancelled. This order is no longer planned.",
  "orders.cardRejected": "Rejected. This order is not planned.",
  "orders.checkBlocks": "Blocks",
  "orders.checkNote": "Note",
  "orders.noteTravelsAlong": "Travels along with the order; does not block it.",
  "orders.solveNowHint": "Solve it now and the order can be planned straight away.",
  "orders.documents": "Documents",
  "orders.documentsCount_one": "One document in the dossier",
  "orders.documentsCount_other": "{{count}} documents in the dossier",
  "orders.documentsAdd": "Add a mail or document",
  "orders.documentsOpen": "To the documents",
  "orders.lastEvent": "Last event",
  "orders.wholeLog": "The whole log",
  "orderNotes.commentsTitle": "Remarks",
  "orderNotes.commentsEmpty": "No remarks yet.",
  "orderNotes.commentsAll_one": "All remarks",
  "orderNotes.commentsAll_other": "All {{count}} remarks",
  "orderNotes.commentsFewer": "Show fewer",
  "orderNotes.commentPlaceholder": "Write a remark… @ asks a colleague",
  "orderNotes.commentLabel": "Remark on the order",
  "orderNotes.commentPlace": "Place",
  "orderNotes.commentHint": "or Ctrl+Enter",
  "orderNotes.error": "That did not work. Please try again.",
  "orderNotes.withdraw": "Withdraw",
  "orderNotes.withdrawAsk": "Withdraw this remark? The log keeps it.",
  "orderNotes.withdrawYes": "Yes, withdraw",
  "orderNotes.askedOf": "Asked of {{names}}",
  "orderNotes.tasksTitle": "Tasks",
  "orderNotes.taskNew": "Task",
  "orderNotes.tasksNone": "No open tasks.",
  "orderNotes.tasksClosedShow_one": "1 finished or cancelled",
  "orderNotes.tasksClosedShow_other": "{{count}} finished or cancelled",
  "orderNotes.tasksClosedHide_one": "Hide the finished one",
  "orderNotes.tasksClosedHide_other": "Hide the finished ones",
  "orderNotes.taskClosedToYou": "A task of a mailbox you are not a member of",
  "orderNotes.taskDue": "by {{date}}",
  "orderNotes.logCommentAdded": "Remark",
  "orderNotes.logCommentWithdrawn": "Remark withdrawn",
  "orderNotes.logWithImage": "With an image",
  "orderNotes.logTaskCreated": "Task created",
  "orderNotes.logTaskAssigned": "Task handed over",
  "orderNotes.logTaskDone": "Task finished",
  "orderNotes.logTaskCancelled": "Task cancelled",
  "orderNotes.logTaskReopened": "Task reopened",
  "orderNotes.logTaskLinked": "Task linked",
  "orderNotes.logTaskUnlinked": "Task unlinked",
  "orderNotes.logTaskFor": "For {{name}}",
  "orderNotes.logTaskMailbox": "Mailbox {{name}}",
  "orderNotes.logTaskReview": "Back with its maker to check",
  "orderNotes.colTasks": "Tasks",
  "orderNotes.taskStateOpen": "Open task",
  "orderNotes.taskStateDone": "Finished",
  "orderNotes.tasksOpenCount_one": "1 open",
  "orderNotes.tasksOpenCount_other": "{{count}} open",
  "orders.toPlanboard": "To the planning board",
  // A place that is designed but has nothing behind it yet: the chip says so, and no
  // value is invented beside it (handoff §10).
  "orders.future": "Future",
  "orders.futureValue": "not available yet",
  "orders.previewCount_one": "{{count}} exception found",
  "orders.previewCount_other": "{{count}} exceptions found",
  "orders.previewNone": "No exceptions",
  "orders.previewBlocked_one": "1 blocker: this order goes to the work queue",
  "orders.previewBlocked_other": "{{count}} blockers: this order goes to the work queue",
  "orders.previewWaiting": "The check follows once every activity has a place, a date and times.",
  "orders.create": "Create order",
  "orders.gapCustomer": "Choose a customer.",
  "orders.gapReference": "Fill in the invoice reference.",
  "orders.gapReferenceTaken": "This invoice reference is already on {{order}} of this customer. An invoice reference occurs once per customer.",
  "orders.gapReferenceTakenOpen": "View order",
  "orders.gapGoods": "Fill in the loading meters. Pallets, weight and a description may come along, but are not required.",
  "orders.gapGoodsHere": "Still needed: the loading meters.",
  "orders.stopMissing": "Still needed: {{what}}",
  "orders.stopMissingPlace": "place",
  "orders.stopMissingDate": "date",
  "orders.stopMissingWindow": "a valid time",
  "orders.errorReferenceTaken": "This invoice reference is already on an order of this customer.",
  "orders.findingGoTo": "To {{step}}",
  "orders.leaveTitle": "Save as draft?",
  "orders.leaveBody": "You are entering an order. Keep it as a draft and finish it later from Orders → Drafts.",
  "orders.leaveDiscard": "Don't save",
  "orders.leaveStay": "Keep entering",
  "orders.legDepot": "Depot",
  "orders.legDepotFollows": "follows from the vehicle",
  "orders.legNotPlanned": "Not planned yet",
  "orders.errorNoCustomer": "Choose a customer first.",
  "orders.errorIncompleteActivities": "Give every activity a place, a date and a start and end time.",
  "orders.errorUnloadBeforeLoad": "The unloading date is before the loading date. A consignment is loaded first and unloaded after.",
  "orders.errorWindowReversed": "A window ends before it starts. Change the time, or tick ‘to the next day’ if it is a night window.",
  "orders.warnFirstNotLoad": "The first activity is not loading",
  "orders.warnLastNotUnload": "The last activity is not unloading",
  "orders.warnWindowInPast": "{{date}} has passed",
  "orders.warnWindowBeforePrevious": "Starts before the previous activity",
  "orders.warnUnloadBeforeLoad": "Unloads on {{date}}, before loading on {{loadDate}}",
  "orders.warnUnloadClosedBeforeLoad": "Unloading on {{date}} until {{until}}, before loading starts at {{loadFrom}}",
  "orders.warnFreeAddress": "This address is not a known location",
  "orders.warnLocationInactive": "This location is inactive",
  "orders.warnHoursUnknown": "Opening hours unknown",
  "orders.warnClosedThatDay": "Closed on {{date}}",
  "orders.warnOutsideHours": "Outside the opening hours on {{date}}: {{hours}}",
  "orders.warnDuplicateOrder": "This reference is already on {{order}}",
  "orders.warnEnteredTooLate": "After the cut-off for {{date}}",
  "orders.warnCustomerNotApproved": "The customer is new from AFAS and not approved yet",
  "orders.warnChangeWaiting": "The customer sent a change on {{date}} while the trip is on the road; it waits for you",
  "orders.warnCancelWaiting": "The customer cancelled on {{date}} while the trip is on the road; it waits for you",
  "orders.warnChannelChanged": "Updated by the customer through EDI on {{date}} {{time}}",
  "orders.shortChangeWaiting": "change waiting",
  "orders.shortAnnounced": "announced",
  "orders.shortNoPreAnnouncement": "no pre-announcement",
  "orders.warnNoPreAnnouncement": "No pre-announcement ({{reference}}): on this route the customer announces the order beforehand, and that announcement did not come",
  "orders.helpNoPreAnnouncement": "When the pre-announcement comes after all, the order goes through by itself. If it was agreed without one, accept it as asked.",
  "orders.warnAnnounced": "Announced by the customer on {{date}} at {{time}}; not to plan until the definitive order comes",
  "orders.shortNoLoadingMeters": "no loading meters",
  "orders.warnNoLoadingMeters": "No loading meters; WLX does not estimate them and plans only once they are there",
  "orders.helpNoLoadingMeters": "Fill in the loading meters on the consignment (Edit). The order then goes through by itself.",
  "orders.shortNoTripMark": "waits for trip",
  "orders.warnNoTripMark": "Waits for its trip: give the trip a trip mark",
  "orders.warnNoTripMarkCustomer": "Waits for its trip: send the trip report, or give the customer's trip number",
  "orders.warnNoTripMarkSent": "Trip report {{report}} sent on {{date}} at {{time}}; waits for the customer's trip number",
  "orders.helpNoTripMark": "Tick the orders of one trip and give them a trip mark. They then go through by themselves.",
  "orders.helpNoTripMarkCustomer": "Tick the orders of one trip and send the trip report. The trip number the customer sends back becomes the trip mark; if you know it already, give it yourself.",
  "orders.shortProvisionalMatch": "provisional order",
  "orders.warnProvisionalMatch": "There is a provisional order for this load: {{order}}",
  "orders.warnProvisionalMatch_other": "There are {{count}} provisional orders for this load, the nearest: {{order}}",
  "orders.helpProvisionalMatch": "Choose which provisional order this order replaces. This order then takes its place on the trip, and the provisional one is cancelled.",
  "orders.acceptNeedsProvisionalChoice": "Choose first: replace or not.",
  "orders.provisionalChip": "Provisional",
  "orders.repeatMade": "{{count}} order made.",
  "orders.repeatMade_other": "{{count}} orders made.",
  "orders.repeatFailed": "{{count}} row not made; it is below with the reason.",
  "orders.repeatFailed_other": "{{count}} rows not made; they are below with the reason.",
  "orders.repeatWeek": "Week of",
  "orders.repeatPrefix": "Reference starts with",
  "orders.repeatPerPallet": "Loading meters per pallet",
  "orders.repeatColReference": "Reference",
  "orders.repeatColLoad": "Loading",
  "orders.repeatColUnload": "Unloading",
  "orders.repeatColPallets": "Pallets",
  "orders.repeatColMetres": "Loading meters",
  "orders.repeatProvisional": "Provisional",
  "orders.repeatProvisionalHelp": "When the customer's own order for this load comes in, WLX asks whether it replaces the provisional one. The provisional one gets no confirmation, no planned notice and no trip report.",
  "orders.repeatNoInvoice": "Do not invoice",
  "orders.repeatNoInvoiceReason": "Reason not to invoice",
  "orders.repeatNoInvoiceDefault": "Provisional order",
  "orders.repeatSubmit": "Make {{count}} order",
  "orders.repeatSubmit_other": "Make {{count}} orders",
  "orders.repeatFailedDuplicate": "This reference is already on an order of the customer.",
  "orders.repeatFailedInvalid": "This row is not right: check the dates and times.",
  "orders.repeatFailedOther": "This row was not made.",
  "orders.provisionalMatchTitle": "This order can replace a provisional order",
  "orders.provisionalMatchTitle_other": "This order can replace one of {{count}} provisional orders",
  "orders.provisionalMatchHelp": "Replace: this order takes the provisional one's place on the trip, with the same stops, and the provisional one is cancelled. If it replaces none of them, it goes on as it came in.",
  "orders.provisionalLoads": "loading {{date}} {{time}}",
  "orders.provisionalUnloads": "unloading {{date}} {{time}}",
  "orders.provisionalPallets": "{{count}} pallet",
  "orders.provisionalPallets_other": "{{count}} pallets",
  "orders.provisionalOnTrip": "on trip {{trip}}",
  "orders.provisionalNotPlanned": "not planned yet",
  "orders.provisionalReplace": "Replace",
  "orders.provisionalDismiss": "Replaces none of these",
  "orders.provisionalReplacedReason": "Replaced by {{order}}",
  "orders.provisionalReplacedBy": "Provisional order, replaced by",
  "orders.provisionalNotice": "Provisional order, made {{when}}. When the customer's order for this load comes, it replaces this one.",
  "orders.provisionalNoticeBy": "Provisional order, made by {{by}} {{when}}. When the customer's order for this load comes, it replaces this one.",
  "orders.provisionalReplaces": "This order replaced the provisional order",
  "orders.replaceBlocked": "This order still waits for something else. Solve that first; until then the provisional order keeps its place.",
  "orders.replaceDifferentRoute": "This order goes another way than the provisional one on its trip. Plan it yourself and cancel the provisional one.",
  "orders.replacePlanned": "This order is on a trip already. Take it off first.",
  "orders.replaceGone": "That provisional order is no longer there: it was replaced or cancelled already.",
  "orders.mailTitle": "Read orders · {{subject}}",
  "orders.mailFrom": "From {{from}}",
  "orders.mailForwardedFrom": "forwarded, originally from {{from}}",
  "orders.mailChannel": "Order mail",
  "orders.mailChannelNone": "Choose an order mail",
  "orders.mailChannelEdit": "Edit order mail",
  "orders.mailChannelNew": "New order mail",
  "orders.mailList": "Table",
  "orders.mailBodyTable": "Table in the mail",
  "orders.mailRowCount": "{{count}} row",
  "orders.mailRowCount_other": "{{count}} rows",
  "orders.mailNoChannel": "There is no order mail for this sender yet. Choose one, or ask an admin to make it on the relation card (tab Order mail).",
  "orders.mailNoList": "This mail holds no table: no Excel or CSV attachment and no table in the mail.",
  "orders.mailUnreadable": "WLX cannot read this attachment: {{files}}. Saving an old Excel file (.xls) as .xlsx helps.",
  "orders.mailChannelNewTitle": "New order mail",
  "orders.mailChannelEditTitle": "Order mail {{name}}",
  "orders.mailChannelNamePlaceholder": "for example IDP deliveries",
  "orders.mailChannelSenders": "Senders",
  "orders.mailChannelCarriers": "Loading meters per carrier type",
  "orders.mailChannelLoadDay": "Loading day when the table does not name it",
  "orders.mailChannelLoadDayList": "The loading date from the table",
  "orders.mailChannelLoadDayBefore": "The working day before the unloading day",
  "orders.ordermailShipper": "Sender on the CMR",
  "orders.ordermailShipperHelp": "Empty: the loading address, as on any CMR. Choose a place of Locaties to put it as the sender in box 1.",
  "orders.mailChannelLoadDayMail": "Loading day when the mail does not name it",
  "orders.mailChannelLoadDayFromMail": "The date from the mail",
  "orders.mailChannelFilter": "Only rows in which",
  "orders.mailChannelFilterNone": "All rows",
  "orders.mailChannelFilterText": "is",
  "orders.mailChannelProvisionalHelp": "The customer's own order replaces it later.",
  "orders.mailChannelCreate": "Make order mail",
  "orders.mailChannelDeleteConfirm": "Remove order mail {{name}}? The orders made with it stay.",
  "orders.mailChannelInvalid": "Something in the order mail is not right: a sender is an address or @domain, the loading meters per carrier type are a number.",
  "nav.orderMails": "Order mails",
  "parties.tabOrdermail": "Order mail",
  "mail.toIntake": "To order intake",
  "mail.toIntakeHelp": "Put this mail in the order intake, where order entry and planning make its orders.",
  "mail.inIntake": "In the order intake",
  "mail.toIntakeFailed": "Failed, again",
  "orders.mailChannelReadAs": "How WLX reads the mail",
  "orders.mailChannelReadAsList": "Table: every row an order",
  "orders.mailChannelReadAsMail": "Text or pdf: the model reads the mail",
  "orders.mailChannelSubjectFilter": "Only when the subject holds",
  "orders.mailChannelSubjectFilterPlaceholder": "empty: every mail",
  "orders.mailChannelAutoIntake": "Into the order intake by itself",
  "orders.mailChannelAutoIntakeHelp": "A new mail of these senders goes into the tray by itself.",
  "orders.mailChannelProposeWarehouse": "Propose a warehouse order",
  "orders.mailChannelProposeWarehouseHelp": "When the order loads at or unloads to our warehouse, the warehouse order comes with it.",
  "orders.mailChannelOrderOptional": "Starts from order (may stay empty)",
  "orders.mailChannelCustomer": "Customer",
  "orders.mailChannelSourceRequired": "WLX reads a list on an order: name an order of the customer.",
  "orders.mailChannelPartyRequired": "Choose the customer, or name an order of the customer.",
  "intake.title": "Order intake",
  "intake.tabTodo": "To do",
  "intake.tabAttention": "Needs attention",
  "intake.empty": "The order intake is empty.",
  "intake.attentionEmpty": "Nothing waits in Needs attention.",
  "intake.keys": "Arrows through the tray, Enter opens the mail on the main screen.",
  "intake.why": "Why here",
  "intake.whyManual": "by {{name}}",
  "intake.whyFolder": "from the folder Invoerbak",
  "intake.whySender": "known sender {{name}}",
  "intake.urgent": "Urgent",
  "intake.waitingCustomer": "Waits for customer",
  "intake.waitingPlanning": "Waits for planning",
  "intake.proposalReady": "Proposal ready",
  "intake.noSubject": "(no subject)",
  "intake.due": "needed {{day}}",
  "intake.attachments_one": "{{count}} attachment",
  "intake.attachments_other": "{{count}} attachments",
  "intake.claimedMe": "yours",
  "intake.claimedBy": "{{name}} has it",
  "intake.takenBy": "{{name}} has this row. You can look along; after half an hour without work it is free.",
  "intake.back": "To the order intake",
  "intake.outcome.made": "Made",
  "intake.outcome.changed": "Changed",
  "intake.outcome.no_order": "No order",
  "intake.markUrgent": "Urgent",
  "intake.packingSlipTitle": "Packing slip from the mail",
  "intake.packingSlipHelp": "Ticked, the pdf goes with the consignment as packing slip: it is printed behind the CMR.",
  "intake.packingSlipWith": "{{name}} as packing slip with the transport order (printed behind the CMR)",
  "intake.shipperFromOrdermail": "Sender on the CMR: {{name}} (from the ordermail)",
  "intake.notUrgent": "Not urgent",
  "intake.waitCustomer": "Wait for customer",
  "intake.waitPlanning": "Wait for planning",
  "intake.stopWaiting": "Stop waiting",
  "intake.waitNotePlaceholder": "for example: call the customer about the window",
  "intake.waitUntil": "Back on",
  "intake.waitSave": "Let it wait",
  "intake.noOrderReason": "Why no order",
  "intake.noOrderPick": "No order, because…",
  "intake.reason.question": "a question",
  "intake.reason.quote": "a quote",
  "intake.reason.duplicate": "a duplicate",
  "intake.reason.status": "a status",
  "intake.reason.other": "something else",
  "intake.noOrder": "No order",
  "intake.finish": "Done",
  "intake.release": "Let go",
  "intake.mailFrom": "From {{from}}",
  "intake.mailIn": "Came to {{mailboxes}}",
  "intake.madeTitle": "Made from this mail:",
  "intake.madeOrder": "transport order",
  "intake.madeWarehouse": "warehouse order",
  "intake.undo": "Undo",
  "intake.undoPlanned": "This order is on a trip already: the planner decides. Cancel it on the order card.",
  "intake.undoWarehouse": "A warehouse order is in Scoretrace already: cancel it there.",
  "intake.customer": "Customer",
  "intake.ordermail": "Order mail {{name}}",
  "intake.noOrdermail": "There is no order mail for this sender yet.",
  "intake.mail": "The mail",
  "intake.ordermailOnCard": "Order mail on the relation card",
  "intake.partyTabAdminOnly": "An admin makes and changes the order mails.",
  "intake.readAs": "Read as",
  "intake.asList": "Table",
  "intake.asSingle": "Single order",
  "intake.aiOff": "AI is not on in this environment. Enter the order yourself.",
  "intake.propose": "Make proposal",
  "intake.proposeAgain": "Propose again",
  "intake.typeYourself": "Enter it yourself",
  "intake.reading": "WLX is reading the mail…",
  "intake.proposeHelp": "AI reads the mail and its pdf attachments and fills in what they say. What they do not say stays empty: you fill it in. You check everything before there is an order.",
  "intake.proposalEmpty": "WLX found no order in this mail.",
  "intake.state.found": "found",
  "intake.state.not_found": "not found",
  "intake.state.missing": "missing",
  "intake.state.standard": "standard",
  "intake.state.stock": "from stock",
  "intake.load": "Load",
  "intake.unload": "Unload",
  "intake.place": "place",
  "intake.date": "date",
  "intake.window": "Order intake",
  "intake.time": "time",
  "intake.reference": "reference",
  "intake.instruction": "remark",
  "intake.orderN": "Order {{n}} of {{count}}",
  "intake.orderOne": "Order",
  "intake.duplicate.order": "Already there: {{number}}",
  "intake.duplicate.warehouse_order": "Warehouse order already there: {{number}}",
  "intake.duplicate.wms": "Scoretrace has it already: {{number}}",
  "intake.customerReference": "Reference",
  "intake.pallets": "Pallets",
  "intake.loadingMeters": "Loading metres",
  "intake.weight": "Weight",
  "intake.description": "Description",
  "intake.remark": "On the CMR",
  "intake.temperature": "Temperature",
  "intake.warehouseTitle": "Warehouse order · to Scoretrace",
  "intake.warehouseOutbound": "Outbound from {{warehouse}}",
  "intake.warehouseInbound": "Inbound to {{warehouse}}",
  "intake.warehouseOutboundUnknown": "Outbound from stock: choose the warehouse on the warehouse order",
  "intake.warehouseNoLines": "The mail names no articles: choose them on the warehouse order.",
  "intake.warehouseHelp": "The warehouse chooses the pallets. Check article and quantity on the warehouse order.",
  "intake.openWarehouse": "Open as warehouse order with transport",
  "intake.openOrderOnly": "Transport only",
  "intake.openOrder": "Open as order",
  "intake.aboutTitle": "Is this mail about an order that is there already?",
  "intake.aboutHelp": "For a change or a cancellation: open the order, change it on the order card, then click Changed.",
  "intake.aboutSearch": "Search on order number or reference",
  "intake.aboutNone": "No order found.",
  "intake.changedDone": "Changed, done",
  "intake.panelHelp": "What order entry and planning still have to enter. The button Order intake puts it in a window of its own on your second screen.",
  "intake.windowHelp": "The order intake in a window of its own, for a second screen",
  "intake.windowRefused": "The browser held the window back. Allow pop-ups for WLX, or work with the tray here.",
  "intake.windowTitle": "Order intake",
  "intake.noRight": "The order intake needs the right Order intake.",
  "intake.partyTabHelp": "How this customer mails its orders: senders, whether the mail goes into the order intake by itself, and whether WLX reads it as a table (every row an order) or as text or pdf (the model reads the mail).",
  "intake.partyTabEmpty": "This customer has no order mail yet.",
  "intake.subjectHas": "subject holds {{text}}",
  "intake.adminMailboxes": "Mailboxes that feed the order intake",
  "intake.adminMailboxesHelp": "From these mailboxes the mail in the folder Invoerbak and from known senders goes into the tray by itself.",
  "intake.adminOrdermails": "Order mails",
  "intake.adminOrdermailsHelp": "Every order mail of every customer. A sender that often gets No order needs a stricter filter.",
  "intake.adminCustomer": "Customer",
  "intake.adminMails": "Mails",
  "intake.adminOpen": "Open",
  "intake.adminNoOrder": "No order",
  "orders.mailColumnsNone": "No columns recognised.",
  "orders.mailColumnsOnCard": "A column not right? An admin changes it in the ordermail on the relation card.",
  "orders.mailChannelColumns": "Which column is what",
  "orders.mailChannelColumnsHelp": "Choose a mail of this customer: you see the headers to choose from, and how WLX reads every row. A change below shows here at once.",
  "orders.mailChannelSampleNone": "Choose a mail",
  "orders.mailChannelSampleNoParty": "Name the customer or an order of the customer first",
  "orders.mailChannelSampleEmpty": "No mail of this customer is in the invoerbak yet. Put one in with To invoerbak in the mail, or choose a file.",
  "orders.mailChannelSampleFile": "Or a file (Excel, CSV)",
  "orders.mailChannelSamplePdf": "A pdf is no table with columns: set How WLX reads the mail to Text or pdf, and the model proposes from the text.",
  "orders.mailChannelSampleUnread": "WLX found no table with a header row in {{file}}.",
  "orders.ordermailUnsaved": "Not saved",
  "orders.ordermailLeaveTitle": "Save the order mail?",
  "orders.ordermailLeaveBody": "You changed the order mail and have not saved it yet. Save the changes?",
  "orders.ordermailLeaveBodyIncomplete": "You changed the order mail and have not saved it yet. It is not complete (a name and the customer), so it cannot be saved yet: stay to finish it.",
  "orders.ordermailLeaveStay": "Back to the order mail",
  "orders.ordermailLeaveDiscard": "Do not save",
  "orders.ordermailRoute": "Load → unload",
  "orders.ordermailPerRow": "per row",
  "orders.ordermailOrderHelpList": "This is what every order of this order mail becomes. Choose per field where its value comes from: the file (which column) or standard (what you type here). What the file says goes first; the standard fills in.",
  "orders.ordermailOrderHelpMail": "The model fills in what the mail says. What the mail does not say, the standard fills in; the proposal shows it as standard, not as found.",
  "orders.ordermailMailFields": "Reference, dates, times, pallets and weight always come from the mail, by the model.",
  "orders.ordermailSourceStandard": "Standard",
  "orders.ordermailSourceNone": "Not",
  "orders.ordermailSourceFile": "From the file",
  "orders.ordermailSourceMail": "From the mail",
  "orders.ordermailSourceMailOrStandard": "From the mail, else standard",
  "orders.ordermailColumn": "Column: {{header}}",
  "orders.ordermailExample": "Example: {{value}}",
  "orders.ordermailPlace": "Address",
  "orders.ordermailPlaceStandard": "Fixed address",
  "orders.ordermailPlaceFile": "Per row from the file",
  "orders.ordermailPlaceBook": "Choose an address from the address book: a loose address cannot be a fixed one.",
  "orders.ordermailPlaceNoneLoad": "No fixed loading address: every row needs one.",
  "orders.ordermailPlaceNoneUnload": "No fixed unloading address: every row needs one.",
  "orders.ordermailPlaceGone": "A fixed address no longer exists in the address book.",
  "orders.ordermailPlaceText": "By a text in a column",
  "orders.ordermailRuleColumn": "Column",
  "orders.ordermailRuleContains": "Contains",
  "orders.ordermailRulePlace": "Address for this text",
  "orders.ordermailRuleAdd": "Add a text",
  "orders.ordermailRuleElse": "When no text fits, this address:",
  "orders.ordermailRowsTo_one": "{{count}} row to {{place}}",
  "orders.ordermailRowsTo_other": "{{count}} rows to {{place}}",
  "orders.ordermailNoPlace": "no address",
  "orders.ordermailStepMail": "The mail",
  "orders.ordermailStepMailHelp": "Which mail of this customer belongs to this ordermail, and whether WLX reads it as a table or as text.",
  "orders.ordermailStepOrder": "The order",
  "orders.ordermailStepEvery": "Every order",
  "orders.ordermailSampleTitle": "Example",
  "orders.ordermailPreviewOrders_one": "{{count}} order from {{rows}} rows",
  "orders.ordermailPreviewOrders_other": "{{count}} orders from {{rows}} rows",
  "orders.ordermailPreviewSkipped": "{{count}} not for us",
  "orders.ordermailPreviewProblems_one": "{{count}} misses something",
  "orders.ordermailPreviewProblems_other": "{{count}} miss something",
  "orders.ordermailUnusedColumns": "Not used: {{columns}}",
  "orders.ordermailMoreFields_one": "More fields ({{count}})",
  "orders.ordermailMoreFields_other": "More fields ({{count}})",
  "orders.ordermailFewerFields": "Only the fields in use",
  "orders.ordermailColPalletsMetres": "Pallets · ldm",
  "orders.ordermailLoadWhen": "Loading date and time",
  "orders.ordermailUnloadWhen": "Unloading date and time",
  "orders.ordermailDateNone": "Date: from the mail",
  "orders.ordermailTimeNone": "Time: none",
  "orders.ordermailPerPallet": "m per pallet",
  "orders.ordermailRequirements": "Transport requirements",
  "orders.ordermailStopRequirements": "Vehicle requirements",
  "orders.ordermailNoHistory": "A change to the order mail changes no orders that exist already.",
  "orders.ordermailWmsTitle": "Scoretrace (WMS)",
  "orders.ordermailWmsToggle": "Also prepare a warehouse order for Scoretrace",
  "orders.ordermailWmsOff": "Nothing goes to Scoretrace: WLX makes the transport order only.",
  "orders.ordermailWmsOutbound": "Loads in {{warehouse}}, a Willems warehouse. Beside the transport order WLX prepares an outbound order for Scoretrace: warehouse {{warehouse}}, for {{customer}}.",
  "orders.ordermailWmsInbound": "Unloads in {{warehouse}}, a Willems warehouse. Beside the transport order WLX prepares an inbound order for Scoretrace: warehouse {{warehouse}}, for {{customer}}.",
  "orders.ordermailWmsNoWarehouse": "No fixed address is a Willems warehouse. Should an order load or unload at one, WLX prepares the outbound or inbound order for it.",
  "orders.ordermailWmsLines": "The model takes the articles and quantities from the mail. Order entry checks the warehouse order: nothing goes to Scoretrace until they make it.",
  "orders.ordermailWmsList": "Not yet: from a table WLX makes transport orders only, nothing goes to Scoretrace. Warehouse orders from a table come later.",
  "orders.mailColumnsRemembered": "columns of the order mail",
  "orders.mailColumnsGuessed": "the order mail has no columns yet: proposed from the header",
  "orders.mailLoadDate": "Loading date",
  "orders.mailUnloadDate": "Unloading date",
  "orders.mailDatesHelp": "For the rows that have no date of their own. From the subject of the mail when it is there.",
  "orders.mailColumns": "Which column is what",
  "orders.mailGroupOrder": "Order and goods",
  "orders.mailGroupLoad": "Loading",
  "orders.mailGroupUnload": "Unloading",
  "orders.mailLoadPlacePerRow": "+ Loading address per row",
  "orders.mailTake": "Read in",
  "orders.mailColWeight": "Weight",
  "orders.mailColNote": "Note",
  "orders.mailRowFiltered": "Not ours (the order mail's filter)",
  "orders.mailRowMade": "Made: {{number}}",
  "orders.mailRowWaiting": "Made: {{number}}, waits in Needs attention",
  "orders.mailWaiting": "{{count}} waits in Needs attention, mostly for an address WLX does not know yet.",
  "orders.mailWaiting_other": "{{count}} wait in Needs attention, mostly for an address WLX does not know yet.",
  "orders.mailSubmitHelp": "The mail goes with every order. An address WLX does not know waits in Needs attention.",
  "orders.mailCompareBusy": "WLX is comparing the rows with the customer's orders…",
  "orders.mailCompareFailed": "WLX could not compare the rows with the customer's orders: {{message}}",
  "orders.mailRowNew": "New",
  "orders.mailRowExists": "Exists: {{number}}",
  "orders.mailRowSame": "Exists: {{number}}, nothing differs",
  "orders.mailRowClosed": "Exists: {{number}} ({{status}}). This row is not made.",
  "orders.mailRowInvalid": "This row is not right: {{message}}",
  "orders.mailRowHeld": "On trip {{trips}}, which is on the road: the change waits for the planner.",
  "orders.mailRowOnTrip": "On trip {{trips}}: the trip follows, and the planner sees what changed.",
  "orders.mailUpdateAgree": "Update",
  "orders.mailUpdateAll": "Agree to all",
  "orders.mailUpdateNone": "Agree to none",
  "orders.mailChangedCount": "{{count}} row changes an order that exists. Check the differences and tick Update where they are right.",
  "orders.mailChangedCount_other": "{{count}} rows change an order that exists. Check the differences and tick Update where they are right.",
  "orders.mailRowUpdated": "Updated: {{number}}",
  "orders.mailRowUpdatedHeld": "Updated: {{number}}, waits for the planner",
  "orders.mailRowUpdatedSame": "{{number}} was like this already",
  "orders.mailUpdated": "{{count}} order updated.",
  "orders.mailUpdated_other": "{{count}} orders updated.",
  "orders.mailUpdatedHeld": "{{count}} waits for the planner, as that trip is on the road.",
  "orders.mailUpdatedHeld_other": "{{count}} wait for the planner, as those trips are on the road.",
  "orders.mailSubmitUpdate": "Update {{count}} order",
  "orders.mailSubmitUpdate_other": "Update {{count}} orders",
  "orders.mailSubmitBoth": "Make {{made}}, update {{updated}}",
  "orders.repeatFailedNothingToUpdate": "No open order has this reference any more.",
  "orders.mailField.reference": "Invoice reference",
  "orders.mailField.name": "Name of the load",
  "orders.mailField.loadDate": "Loading date",
  "orders.mailField.loadTime": "Loading time",
  "orders.mailField.loadReference": "Loading reference",
  "orders.mailField.loadInstruction": "Remark at loading",
  "orders.mailField.loadName": "Loading name",
  "orders.mailField.loadStreet": "Loading street",
  "orders.mailField.loadPostalCode": "Loading postal code",
  "orders.mailField.loadCity": "Loading place",
  "orders.mailField.loadCountry": "Loading country",
  "orders.mailField.unloadDate": "Unloading date",
  "orders.mailField.unloadTime": "Unloading time",
  "orders.mailField.unloadReference": "Unloading reference",
  "orders.mailField.unloadInstruction": "Remark at unloading",
  "orders.mailField.unloadName": "Unloading name",
  "orders.mailField.unloadStreet": "Unloading street",
  "orders.mailField.unloadPostalCode": "Unloading postal code",
  "orders.mailField.unloadCity": "Unloading place",
  "orders.mailField.unloadCountry": "Unloading country",
  "orders.mailField.pallets": "Pallets",
  "orders.mailField.carrier": "Carrier type",
  "orders.mailField.loadingMeters": "Loading meters",
  "orders.mailField.weightKg": "Weight (kg)",
  "orders.mailField.description": "Description",
  "orders.mailField.remark": "Remark on the consignment note",
  "orders.mailProblem.reference": "no reference",
  "orders.mailProblem.loadDate": "no loading date",
  "orders.mailProblem.unloadDate": "no unloading date",
  "orders.mailProblem.loadingMeters": "no loading meters",
  "orders.mailProblem.unloadBeforeLoad": "unloading before loading",
  "orders.copyOrder": "Copy",
  "orders.tripMarkSetLabel": "Trip mark",
  "orders.tripMarkSet": "Set trip mark",
  "orders.tripMarkSetDone": "{{count}} order got trip mark {{mark}}.",
  "orders.tripMarkSetDone_other": "{{count}} orders got trip mark {{mark}}.",
  "orders.tripReportSend": "Send trip report",
  "orders.tripReportSendDone": "Trip report {{report}} sent with {{count}} consignment.",
  "orders.tripReportSendDone_other": "Trip report {{report}} sent with {{count}} consignments.",
  "orders.tripReportWithoutCodes": "{{count}} without a place code did not go along.",
  "orders.tripReportWithoutCodes_other": "{{count}} without a place code did not go along.",
  "orders.tripReportNotOneCustomer": "A trip report is for the orders of one customer that gets it beforehand.",
  "orders.tripReportNoCodes": "None of these orders has the customer's place codes where it loads and unloads.",
  "orders.copyOneAtATime": "Copy one order at a time.",
  "orders.copyHelp": "The copy opens as a new order, with the same customer, addresses and goods; you fill in the dates and the reference.",
  "orders.listReadOnly": "Only someone who enters orders can read a list in.",
  "orders.listTemplateFrom": "from {{order}}",
  "orders.listTemplateOrderNotFound": "Order {{order}} does not exist.",
  "orders.listTemplateNotPlain": "That order does not load once and unload once at an address from the address book. Choose an order with one consignment.",
  "orders.listTemplateOtherCustomer": "That order is of another customer than the template.",
  "orders.listTemplateNameTaken": "There is a template with this name already.",
  "orders.listTemplateName": "Name",
  "orders.listTemplateOrder": "From order",
  "orders.listTemplateRefill": "Again from order",
  "orders.listTemplatePrefixPlaceholder": "Lattiz wk{week}",
  "orders.listTemplatePerPalletPlaceholder": "from the order",
  "orders.listTemplateSave": "Save",
  "orders.listTemplateDelete": "Remove",
  "orders.helpAnnounced": "Nothing to do: when the customer's definitive order comes, it is on To plan by itself. If it has to go sooner, accept it as asked.",
  "orders.announcedLabel": "Announced",
  "orders.shortChannelChanged": "updated through EDI",
  "orders.helpChangeWaiting": "Read on the order what the customer changes, and carry it out or let it go.",
  "orders.logFromChannel": "Updated by the customer through EDI",
  "orders.logChannelHeld": "Change or cancellation from the customer through EDI; waits for the planner, as the order is on a trip",
  "orders.logCancelWaiting": "Cancellation asked; waits for the planner",
  "orders.logCancelWaitingOn_one": "On trip {{trips}}",
  "orders.logCancelWaitingOn_other": "On trips {{trips}}",
  "orders.logChannelCarriedOut": "Change from the customer carried out",
  "orders.logChannelLetGo": "Change from the customer let go",
  "orders.logConsignmentCount": "Number of consignments",
  "orders.unitFromChannel": "Customer",
  "orders.pendingChangeTitle": "The customer sent a change on {{when}}, while this order is on a trip",
  "orders.pendingCancelTitle": "{{who}} cancelled this order on {{when}}, while it is on a trip",
  "orders.pendingHelp": "WLX takes nothing off a trip by itself: you decide. Ring the driver if needed, then choose: carry it out or let it go.",
  "orders.pendingCarryOut": "Carry out the change",
  "orders.pendingCarryOutCancel": "Carry out the cancellation",
  "orders.pendingLetGo": "Let it go",
  "orders.pendingApplyRefused": "Part of the change moves the trip, and that trip is on the road or driven. Set the trip back to confirmed first, or let the change go.",
  "orders.channelChangedNotice": "Updated by the customer through EDI on {{when}}. Check whether the planning still holds; what changed is in the log.",
  "orders.channelChangedSeen": "Seen",
  "orders.theCustomer": "The customer",
  "orders.pendingForPlanner": "Waits for the planner, who carries it out or lets it go. Nothing comes off the trip by itself.",
  "orders.planChangeTitle": "Changed while the order is on a trip",
  "orders.planChangeBy": "{{who}}, {{when}}",
  "orders.planChangeHelp": "The trip followed where it could within the day. Check that the planning still holds and mark it seen.",
  "orders.planChangeForPlanner": "The planner sees this on the trip card too.",
  "orders.acceptNeedsDecision": "Waits for the planner: they carry out the change or cancellation, or let it go",
  "orders.helpFreeAddress": "Link the address to a location, or make one: planning needs the location, and later the ETA does too.",
  "orders.helpLocationInactive": "Switch the location back on, or pick another place.",
  "orders.helpActivityOrder": "A consignment starts with loading and ends with unloading. Reject the order and enter it again.",
  "orders.helpUnloadBeforeLoad": "Put the unloading after the loading: the unloading date on or after the loading date, and an unloading window still open when loading starts.",
  "orders.helpDuplicateOrder": "Check whether this is the same order. If it is, reject this one.",
  "orders.helpEnteredTooLate":
    "This order came in after the cut-off agreed with this customer. The time is on the relation card, tab Sales relation; empty means no agreement.",
  "orders.helpCustomerNotApproved":
    "WLX uses a new relation from AFAS only once approved. Approve the customer on its relation card: the order then goes through by itself.",

  // Dossiers
  "dossiers.searchPlaceholder": "Number, reference, relation…",
  "dossiers.searchLabel": "Search dossiers",
  "dossiers.allParties": "All relations",
  "dossiers.allStatuses": "All statuses",
  "dossiers.filterByParty": "Filter by relation",
  "dossiers.filterByStatus": "Filter by status",
  "dossiers.newDossier": "New dossier",
  "dossiers.editDossier": "Edit dossier",
  "dossiers.colDossier": "Dossier",
  "dossiers.colPrimaryRef": "Primary reference",
  "dossiers.colParts": "Orders",
  "dossiers.part.transport": "Transport",
  "dossiers.part.outbound": "Outbound",
  "dossiers.part.inbound": "Inbound",
  "dossiers.part.warehouse": "Warehouse order",
  "dossiers.part.wms": "WMS",
  "dossiers.part.tms": "TMS",
  "dossiers.part.other": "External",
  "dossiers.colParty": "Relation",
  "dossiers.colStatus": "Status",
  "dossiers.colCreated": "Created",
  "dossiers.noDossiers": "No dossiers found.",
  "dossiers.statusOpen": "Open",
  "dossiers.statusInProgress": "In progress",
  "dossiers.statusCompleted": "Completed",
  "dossiers.statusArchived": "Archived",
  "dossiers.newTitle": "New Dossier",
  "dossiers.partyLabel": "Relation",
  "dossiers.primaryRefLabel": "Primary Reference",
  "dossiers.primaryRefPlaceholder": "e.g. PO-2026-00123",
  "dossiers.primaryRefHelp": "Customer or order reference for this dossier.",
  "dossiers.descriptionLabel": "Description",
  "dossiers.descriptionPlaceholder": "Optional — short description of the shipment or job",
  "dossiers.statusLabel": "Status",
  "dossiers.dossierNumber": "Dossier number",
  "dossiers.errorGeneric": "An error occurred",
  "dossiers.createButton": "Create dossier",
  "dossiers.createAriaLabel": "Create dossier",
  "dossiers.closeAriaLabel": "Close",
  "dossiers.loading": "Loading dossier…",
  "dossiers.notFound": "Dossier not found",
  "dossiers.notFoundDesc": "This dossier does not exist or you do not have access to it.",
  "dossiers.createdLabel": "Created {{date}}",
  "dossiers.updatedLabel": "Updated {{date}}",
  "dossiers.sharePointFolder": "SharePoint folder ↗",
  "dossiers.sharePointPending": "SharePoint folder pending…",
  "dossiers.sharePointFailed": "SharePoint folder failed",
  "dossiers.primaryReference": "Primary reference",
  "dossiers.party": "Relation",
  "dossiers.description": "Description",
  "dossiers.noAccess": "No access to dossiers",
  "dossiers.noAccessDesc": "You do not have the Dossiers permission, so WLX cannot open this dossier for you. Ask whoever manages permissions (Beheer → Rechten).",
  "dossiers.orderLink": "Dossier {{number}}",
  "dossiers.orderLinkTitle": "The dossier of the customer order: where its documents are",

  // Dossier tabs
  "dossierTabs.documents": "Documents",
  "dossierTabs.orders": "Orders",
  "dossierTabs.wlxColKind": "Kind",
  "dossierTabs.wlxColNumber": "Number",
  "dossierTabs.wlxColReference": "Customer reference",
  "dossierTabs.wlxColStatus": "Status",
  "dossierTabs.wlxColDetail": "Details",
  "dossierTabs.wlxKind.transport": "Transport",
  "dossierTabs.wlxKind.outbound": "Outbound",
  "dossierTabs.wlxKind.inbound": "Inbound",
  "dossierTabs.wlxKind.warehouse_outbound": "Warehouse order, outbound",
  "dossierTabs.wlxKind.warehouse_inbound": "Warehouse order, inbound",
  "dossierTabs.wlxConsignments_one": "{{count}} consignment",
  "dossierTabs.wlxConsignments_other": "{{count}} consignments",
  "dossierTabs.wlxOutbound.open": "Open",
  "dossierTabs.wlxOutbound.picking": "Being picked",
  "dossierTabs.wlxOutbound.picked": "Picked",
  "dossierTabs.wlxOutbound.shipped": "Shipped",
  "dossierTabs.wlxOutbound.cancelled": "Cancelled",
  "dossierTabs.otherSystems": "In other systems",
  "dossierTabs.log": "Log",
  "dossierTabs.docColDocument": "Document",
  "dossierTabs.docColType": "Type",
  "dossierTabs.docColVisibility": "Visibility",
  "dossierTabs.docColStatus": "Status",
  "dossierTabs.docColVersion": "Version",
  "dossierTabs.docColCreated": "Created",
  "dossierTabs.noDocuments": "No documents yet.",
  "dossierTabs.ordColSource": "Source",
  "dossierTabs.ordColSourceRef": "Source reference",
  "dossierTabs.ordColTargetSystem": "Target system",
  "dossierTabs.ordColExternalNumber": "External number",
  "dossierTabs.ordColExternalId": "External ID",
  "dossierTabs.ordColExternalStatus": "External status",
  "dossierTabs.ordChanged": "changed",
  "dossierTabs.ordChangedTitle": "Changed in the target system since anyone last looked",
  "dossierTabs.ordColStatus": "Status",
  "dossierTabs.ordColSnapshot": "Snapshot",
  "dossierTabs.orderTitle": "Order",
  "dossierTabs.ordSyncedAt": "Last fetched",
  "dossierTabs.snapshotTitle": "The target system's answer",
  "dossierTabs.snapshotNone": "No snapshot yet. One arrives with the next report.",
  "dossierTabs.snapshotFailed": "The snapshot could not be loaded.",
  "dossierTabs.snapshotCaptured": "{{system}}, fetched {{when}}",
  "dossierTabs.snapshotOpenHint": "Click the row for the target system's full answer",
  "dossierTabs.ordColCreated": "Created",
  "dossierTabs.noOrders": "No orders yet.",
  "dossierTabs.logColEvent": "Event",
  "dossierTabs.logColDetails": "Details",
  "dossierTabs.logColSource": "Source",
  "dossierTabs.logColActor": "By",
  "dossierTabs.logColWhen": "When",
  "dossierTabs.noLog": "Nothing recorded on this dossier yet.",
  "dossierTabs.evtDossierCreated": "Dossier created",
  "dossierTabs.evtDossierUpdated": "Dossier updated",
  "dossierTabs.evtDossierStatusChanged": "Status changed",
  "dossierTabs.evtDossierArchived": "Dossier archived",
  "dossierTabs.evtFolderCreated": "SharePoint folder created",
  "dossierTabs.evtFolderFailed": "SharePoint folder failed",
  "dossierTabs.evtOrderReceived": "Order received",
  "dossierTabs.evtOrderExternalId": "External order ID assigned",
  "dossierTabs.evtExternalEvent": "Event from target system",
  "dossierTabs.evtExternalState": "Order refreshed from target system",
  "dossierTabs.evtDocumentDownloaded": "Document downloaded",
  "dossierTabs.evtOrderAdded": "Order added",
  "dossierTabs.evtDossierMerged": "Dossier merged",
  "dossierTabs.detPrimaryReference": "Reference",
  "dossierTabs.detParty": "Relation",
  "dossierTabs.detSourceReference": "Order reference",
  "dossierTabs.detTargetSystem": "Target system",
  "dossierTabs.detExternalOrderId": "External order ID",
  "dossierTabs.detExternalOrderNumber": "External order number",
  "dossierTabs.detExternalStatus": "External status",
  "dossierTabs.detEventType": "Event type",
  "dossierTabs.detConsignment": "Consignment",
  "dossierTabs.detOrderNumber": "Order",
  "dossierTabs.detMergedFrom": "Merged from",
  "dossierTabs.detOccurredAt": "Timestamp",
  "dossierTabs.detStatus": "Status",
  "dossierTabs.detError": "Error",
  "dossierTabs.detChange": "{{from}} → {{to}}",
  "dossierTabs.sourceDataBridge": "DataBridge",
  "dossierTabs.sourceWlx": "WLX",
  "dossierTabs.actorInternal": "staff",
  "dossierTabs.actorPartner": "partner",
  "dossierTabs.actorSystem": "system",
  "dossierTabs.ordStatusReceived": "Received",
  "dossierTabs.ordStatusProcessing": "Processing",
  "dossierTabs.ordStatusCompleted": "Completed",
  "dossierTabs.ordStatusCancelled": "Cancelled",
  "dossierTabs.docStatusDraft": "Draft",
  "dossierTabs.docStatusActive": "Active",
  "dossierTabs.docStatusReplaced": "Replaced",
  "dossierTabs.docStatusArchived": "Archived",

  // Calendar (Agenda) — your own Outlook calendar (delegated)
  "calendar.view_month": "Month",
  "calendar.view_week": "Week",
  "calendar.view_day": "Day",
  "calendar.view_agenda": "Agenda",
  "calendar.prev": "Previous",
  "calendar.next": "Next",
  "calendar.today": "Today",
  "calendar.pickDate": "Pick a date",
  "calendar.newEvent": "New event",
  "calendar.empty": "No events in this period.",
  "calendar.colTime": "Time",
  "calendar.colSubject": "Subject",
  "calendar.colLocation": "Location",
  "calendar.colStatus": "Status",
  "calendar.allDay": "All day",
  "calendar.teamsLink": "Teams",
  "calendar.statusInvited": "Invited",
  "calendar.statusOrganizer": "Organiser",
  "calendar.statusDeclined": "Declined",
  "calendar.statusTentative": "Tentative",
  "calendar.statusAccepted": "Accepted",
  "calendar.notConfiguredTitle": "Calendar not available yet",
  "calendar.notConfiguredDesc": "The calendar link is not configured on this environment yet. Contact your administrator.",
  "calendar.connectTitle": "Link your Outlook calendar",
  "calendar.connectDesc":
    "Allow WLX to show your own Outlook calendar and manage appointments on your behalf. You sign in with your own Microsoft account; WLX stores no calendar data — only an encrypted key you can revoke at any time.",
  "calendar.reconnectTitle": "Reconnect your calendar",
  "calendar.reconnectDesc":
    "Your Outlook link is still missing calendar access (or has expired). Reconnect once to use your calendar in WLX — your mail keeps working.",
  "calendar.connectConsentAccept":
    "I agree that WLX may show my Outlook calendar, manage appointments on my behalf, and look up colleagues' free/busy status. WLX stores no calendar data (only an encrypted key), it is voluntary, and I can unlink it at any time.",
  "calendar.connectButton": "Link calendar",
  "calendar.reconnectButton": "Reconnect",
  "calendar.disconnectButton": "Unlink calendar",
  "calendar.connect_ok": "Your calendar is linked.",
  "calendar.connect_cancelled": "Linking cancelled — nothing changed.",
  "calendar.connect_mismatch":
    "The Microsoft account you consented with is not your WLX account. Sign in at Microsoft with your own account and try again.",
  "calendar.connect_consent_required": "Tick the agreement first to link your calendar.",
  "calendar.connect_error": "Linking failed. Please try again.",
  "calendar.drawerTitleCreate": "New event",
  "calendar.drawerTitleEvent": "Event",
  "calendar.loadError": "The event could not be loaded.",
  "calendar.occurrenceHint": "This is one occurrence of a recurring series. Changes apply to this occurrence only.",
  "calendar.seriesHint": "This belongs to a recurring series. What do you want to apply this to?",
  "calendar.scopeOccurrence": "This event",
  "calendar.scopeSeries": "Whole series",
  "calendar.seriesTimeHint":
    "For 'whole series' you change subject, location, Teams and notes. A different time applies to this event only.",
  "calendar.seriesTimeBlocked": "Choose 'this event' to change the time — a whole series isn't rescheduled here.",
  "calendar.deleteConfirmSeries": "Delete the entire recurring series? Every attendee receives a cancellation.",
  "calendar.subjectLabel": "Subject",
  "calendar.subjectPlaceholder": "What is the appointment about?",
  "calendar.allDayLabel": "All day",
  "calendar.startLabel": "From",
  "calendar.endLabel": "To",
  "calendar.locationLabel": "Location",
  "calendar.locationPlaceholder": "Room, address or link",
  "calendar.teamsLabel": "Add a Teams meeting",
  "calendar.attendeesTitle": "Attendees",
  "calendar.attendeePlaceholder": "Name or e-mail address…",
  "calendar.responsesTitle": "Responses",
  "calendar.responseAccepted": "Accepted",
  "calendar.responseDeclined": "Declined",
  "calendar.responseTentative": "Tentative",
  "calendar.responsePending": "No reply yet",
  "calendar.responseOrganizer": "Organiser",
  "calendar.responseSummaryAccepted": "{{n}} of {{total}} accepted",
  "calendar.responseSummaryDeclined": "{{n}} declined",
  "calendar.responseSummaryTentative": "{{n}} tentative",
  "calendar.responseSummaryPending": "{{n}} awaiting reply",
  "calendar.responseRoomDeclined": "{{rooms}} declined the invitation — the room is not booked. The appointment itself stays as it is.",
  "calendar.findSlot": "Find a time",
  "calendar.findSlotBusy": "Searching…",
  "calendar.findSlotNone": "No time found where everyone is free. Adjust the duration or the attendees.",
  "calendar.availabilityTitle": "Availability",
  "calendar.attendeeBusy": "Busy in the chosen window",
  "calendar.attendeeFree": "Free in the chosen window",
  "calendar.taskChipTitle": "WLX task",
  "calendar.taskPlanned": "time blocked",
  "calendar.taskDue": "Due",
  "calendar.weekShort": "wk {{week}}",
  "calendar.weekNumberTitle": "Week number",
  "calendar.weekHead": "wk",
  "calendar.roomsTitle": "Meeting room",
  "calendar.roomAdd": "Add a room…",
  "calendar.roomFree": "free",
  "calendar.roomBusy": "busy",
  "calendar.roomBusyWarning": "A selected room is busy in this window. The room will decline the invitation automatically.",
  "calendar.roomPastWarning": "You cannot book a room in the past — the room declines it automatically.",
  "calendar.roomsEmpty": "No rooms available",
  "calendar.privateLabel": "Private",
  "calendar.privateHint": "Others see only 'busy' — not the subject or details.",
  "calendar.privateShort": "Private",
  "calendar.statusPrivate": "Private",
  "calendar.repeatWeekly": "Repeat weekly",
  "calendar.repeatEvery": "Every",
  "calendar.repeatInterval": "Repeat interval",
  "calendar.repeatWeeks": "weeks",
  "calendar.repeatUntil": "Until",
  "calendar.repeatPickDay": "Pick at least one weekday.",
  "calendar.day_monday": "Mon",
  "calendar.day_tuesday": "Tue",
  "calendar.day_wednesday": "Wed",
  "calendar.day_thursday": "Thu",
  "calendar.day_friday": "Fri",
  "calendar.day_saturday": "Sat",
  "calendar.day_sunday": "Sun",
  "calendar.notesLabel": "Notes",
  "calendar.notesPlaceholder": "Optional description…",
  "calendar.deleteButton": "Delete",
  "calendar.deleteConfirm": "Delete this appointment?",
  "calendar.deleteConfirmMeeting": "Deleting sends a cancellation to every attendee. Continue?",
  "calendar.deleteConfirmYes": "Yes, delete",
  "calendar.showDay": "Show this day",
  "calendar.createButton": "Create event",
  "calendar.saveButton": "Save",
  "calendar.errorSubject": "Enter a subject.",
  "calendar.errorTime": "Enter a valid start and end time.",
  "calendar.errorEndTime": "The end time must be after the start time.",
  "calendar.errorRoomTooLong": "A meeting room or desk accepts at most 24 hours in one go; anything longer it declines automatically. Shorten the appointment or remove the room.",
  "calendar.errorGeneric": "Something went wrong. Please try again.",
  "calendar.organizedBy": "Organised by {{name}}",
  "calendar.joinTeams": "Join via Teams",
  "calendar.attachmentsTitle": "Attachments",
  "calendar.attachmentsNone": "No attachments on this appointment.",
  "calendar.attachmentsFailed": "The attachments could not be loaded.",
  "calendar.attachmentNotDownloadable": "This is a linked item (a mail or a OneDrive link), not a file to download.",
  "calendar.rsvpTitle": "Your response",
  "calendar.rsvpAccept": "Accept",
  "calendar.rsvpTentative": "Tentative",
  "calendar.rsvpDecline": "Decline",
  "calendar.proposeToggle": "Propose another time",
  "calendar.proposeHint": "Suggest a different window. The organizer receives your proposal and can accept or reject it.",
  "calendar.proposeTentative": "Tentative + proposal",
  "calendar.proposeDecline": "Decline + proposal",
  "calendar.roomInviteeHint":
    "Someone else organises this appointment, so the room is booked as a separate reservation in your calendar at the same time — the organizer's invitation stays unchanged.",
  "calendar.forwardTitle": "Forward",
  "calendar.forwardToggle": "Forward…",
  "calendar.forwardHintOrganizer":
    "Send the invitation to someone who has not been invited yet. Only the recipient is notified; the other attendees are not.",
  "calendar.forwardHintInvitee":
    "Send the invitation to someone who has not been invited yet. {{name}} is told that you forwarded it; the other attendees are not.",
  "calendar.forwardTheOrganizer": "The organizer",
  "calendar.forwardRecipients": "To",
  "calendar.forwardComment": "Message (optional)",
  "calendar.forwardCommentPlaceholder": "For example: could you join this one too?",
  "calendar.forwardAlreadyInvited": "{{names}} is already on the guest list and would receive the invitation again.",
  "calendar.forwardPickRecipient": "Choose at least one recipient.",
  "calendar.forwardSend": "Send",
  "calendar.forwardSending": "Sending…",
  "calendar.forwardSent": "Forwarded to {{names}}.",
  "calendar.yourDayTitle": "Your agenda that day",
  "calendar.yourDayConflict": "You already have {{count}} appointment in this window.",
  "calendar.yourDayConflict_other": "You already have {{count}} appointments in this window.",
  "calendar.yourDayEmpty": "No other appointments on this day.",
  "calendar.yourDayError": "Your agenda could not be read.",
  "calendar.yourDayFree": "Still free — click to plan there:",
  "calendar.yourDayNoFree": "No free time left between {{from}} and {{to}}.",
  "calendar.yourDayTakenAllDay": "No free time: an all-day appointment keeps this day taken.",
  "calendar.yourDayFreePick": "Start at {{time}}",

  // Reservations
  "reservations.pageEyebrow": "Reservations",
  "reservations.viewWeek": "Week",
  "reservations.viewDay": "Day",
  "reservations.viewAgenda": "Agenda",
  "reservations.prev": "Previous",
  "reservations.today": "Today",
  "reservations.next": "Next",
  "reservations.pickDate": "Pick date",
  "reservations.filterType": "Filter by type",
  "reservations.allTypes": "All types",
  "reservations.filterBranch": "Filter by branch",
  "reservations.allBranches": "All branches",
  "reservations.typeRoomPlural": "Meeting rooms",
  "reservations.typeWorkplacePlural": "Workplaces",
  "reservations.mineOnly": "My reservations only",
  "reservations.visibilityAll": "All",
  "reservations.visibilityAllHint": "All on, or all off when all are on already",
  "reservations.noResourceSelected": "No room or workplace chosen. Click one above.",
  "reservations.showOutlook": "Show my calendar",
  "reservations.showOutlookTitle": "Overlay your own calendar on the room availability",
  "reservations.loading": "Loading…",
  "reservations.newReservation": "New reservation",
  "reservations.legendOwn": "My reservation",
  "reservations.legendBusy": "Busy",
  "reservations.legendOption": "Tentative",
  "reservations.legendOutlook": "My calendar",
  "reservations.legendBlocked": "Unavailable (shared space)",
  "reservations.blockedTitle": "Taken by {{name}}",
  "reservations.blockedHint": 'Shares its space with "{{name}}", so it cannot be booked.',
  "reservations.confirmCancel": 'Cancel reservation "{{subject}}"?',
  "reservations.periodAgenda": "From {{date}}",
  "reservations.periodWeek": "Week of {{date}}",
  "reservations.noRoomsSelected": "No rooms selected. Check one on the left.",
  "reservations.noReservations": "No reservations in this period. Create one with '+ New reservation'.",
  "reservations.outlookMyAgenda": "My calendar",
  "reservations.outlookYourAgenda": "Your calendar",
  "reservations.moreItems": "+{{count}} more",
  "reservations.statusOwn": "Mine",
  "reservations.statusBusy": "Busy",
  "reservations.statusOption": "Tentative",
  "reservations.statusOutlook": "Calendar",
  "reservations.statusBlocked": "Unavailable",
  "reservations.tableTime": "Time",
  "reservations.tableRoom": "Room / spot",
  "reservations.tableSubject": "Subject",
  "reservations.tableStatus": "Status",
  "reservations.editButton": "Edit",
  "reservations.cancelButton": "Cancel",
  "reservations.outlookLocation": "My calendar",
  "reservations.teamsLink": "· Teams",
  "reservations.drawerTitleCreate": "New reservation",
  "reservations.drawerTitleEdit": "Edit reservation",
  "reservations.drawerTitleOutlook": "Book a room for this meeting",
  "reservations.outlookBookHint": "The selected room will be invited to this meeting. Subject and time stay the same.",
  "reservations.outlookBookHintAttendee":
    "You are not the organizer of this meeting, so a separate room reservation will be made for the same time. Any Teams link is carried over.",
  "reservations.bookRoomButton": "Book room",
  "reservations.drawerClose": "Close",
  "reservations.detailsSection": "Details",
  "reservations.subjectLabel": "Subject",
  "reservations.subjectPlaceholder": "e.g. Team logistics meeting",
  "reservations.noSubject": "(no subject)",
  "reservations.whenLabel": "When",
  "reservations.roomLabel": "Room / workplace",
  "reservations.roomReadOnly": "The room cannot be changed when editing.",
  "reservations.roomChangeHint": "Choosing another room books the new one and cancels this reservation.",
  "reservations.roomsUnavailable":
    "The occupancy of these rooms could not be loaded: {{rooms}}. They are missing from the overview below — do not assume they are free.",
  "reservations.confirmCancelSeries":
    "“{{subject}}” is a repeating reservation. This cancels EVERY occurrence in the series, not just this one. Continue?",
  "reservations.deleteSeriesButton": "Cancel whole series",
  "reservations.deleteOccurrenceButton": "Cancel this one",
  "reservations.confirmCancelOccurrence": "Cancel only this occurrence of “{{subject}}”? The rest of the series stays as it is.",
  "reservations.seriesOccurrenceOnly":
    "This is one occurrence of a repeating series. What you change here applies to this occurrence only — the rest of the series is left alone.",
  "reservations.capacityShort": "{{count}} ppl",
  "reservations.roomChecking": "Checking availability…",
  "reservations.roomFreeSlot": "This room is free for the selected time.",
  "reservations.roomBusySlot": "This room is already booked for the selected time.",
  "reservations.slotBlockedShared": 'Unavailable: "{{name}}" is booked for this time and shares the same space.',
  "reservations.sharesSpaceWith":
    "Shares its space with {{names}} \u2014 while that is booked this one cannot be, and the other way round.",
  "reservations.bookedBy": "Booked by {{name}}",
  "reservations.askMoveButton": "Ask to move",
  "reservations.askMoveTooltip": "Click to ask whether this can move",
  "reservations.otherTitle": "Reservation by {{name}}",
  "reservations.otherTitleNoName": "Reservation",
  "reservations.organizerUnknown": "Unknown",
  "reservations.bookedByLabel": "Booked by",
  "reservations.askMoveSeries": "One occurrence of a repeating series; you are asking about this one only.",
  "reservations.askMoveOver": "This reservation is already over.",
  "reservations.askMoveSection": "Ask to move it",
  "reservations.askMoveHint": "WLX mails {{name}} with a button that opens this reservation in WLX. Any answer comes back to you.",
  "reservations.askMoveSuggestLabel": "Suggest another room",
  "reservations.askMoveNoSuggestion": "No suggestion",
  "reservations.askMoveSuggestHelp": "Only rooms that are free at that time, those of the same site first.",
  "reservations.askMoveNoneFree": "No other room is free at that time.",
  "reservations.askMoveMessageLabel": "Message (optional)",
  "reservations.askMoveMessagePlaceholder": "For example: I have a customer here at 13:00.",
  "reservations.askMoveSend": "Send request",
  "reservations.askMoveSending": "Sending…",
  "reservations.askMoveSentOwn": "Sent to {{name}} from your own mailbox.",
  "reservations.askMoveSentSystem": "Sent to {{name}} via WLX. You are on cc, and any answer comes back to you.",
  "reservations.openNotFound": "The reservation from the link is no longer there: it was moved or cancelled.",
  "reservations.suggestedRoom": "Suggested in the request: {{room}}. It is already selected.",
  "reservations.startLabel": "Start",
  "reservations.endLabel": "End",
  "reservations.addTeams": "Add Teams meeting",
  "reservations.repeatWeekly": "Repeat weekly",
  "reservations.repeatEvery": "Every",
  "reservations.repeatInterval": "Repeat interval",
  "reservations.repeatWeeks": "week(s)",
  "reservations.repeatUntil": "Until",
  "reservations.repeatHorizon": "No later than {{date}} (booking window)",
  "reservations.repeatPickDay": "Pick at least one weekday.",
  "reservations.repeatCalculating": "Calculating availability…",
  "reservations.repeatTooManyBusy": "Too many occurrences busy — the room declines the whole series. Adjust the time, room or end date.",
  "reservations.repeatAllFree": "All {{count}} occurrences free.",
  "reservations.repeatFreeCount": "Free {{free}}/{{total}} occurrences — the busy ones are skipped.",
  "reservations.repeatCappedWarn": "This series runs past the booking window; only occurrences until {{date}} are booked.",
  "reservations.repeatPastSkipped": "{{count}} occurrence(s) already passed (skipped).",
  "reservations.repeatBusy": "busy",
  "reservations.day_monday": "Mo",
  "reservations.day_tuesday": "Tu",
  "reservations.day_wednesday": "We",
  "reservations.day_thursday": "Th",
  "reservations.day_friday": "Fr",
  "reservations.day_saturday": "Sa",
  "reservations.day_sunday": "Su",
  "reservations.deleteButton": "Cancel (delete)",
  "reservations.saveButton": "Save",
  "reservations.createButton": "Reserve",
  "reservations.errorSubject": "Please enter a subject.",
  "reservations.errorEndTime": "End time must be after start time.",
  "reservations.errorTooLong": "A room or desk accepts at most 24 hours in one go; anything longer it declines automatically. Choose a shorter time or make more than one booking.",
  "reservations.errorPast": "You cannot book a time in the past.",
  "reservations.errorGeneric": "Something went wrong.",
  "reservations.personalConflict": 'Note: you already have "{{subject}}" ({{from}}–{{to}}) in Outlook at that time.',

  // Resource administration (admin-only)
  "reservations.manageResources": "Manage resources",
  "reservations.resBackToOverview": "Back to occupancy overview",
  "reservations.resTypeRoom": "Meeting room",
  "reservations.resTypeWorkplace": "Workplace",
  "reservations.resNewTitle": "New resource",
  "reservations.resNew": "New resource",
  "reservations.resNameLabel": "Name",
  "reservations.resNamePlaceholder": "e.g. Meeting room Haps",
  "reservations.resMailboxLabel": "Mailbox (e-mail address)",
  "reservations.resMailboxPlaceholder": "room@willemslogistics.com",
  "reservations.resMailboxHelp": "The room's Exchange mailbox address in Microsoft 365.",
  "reservations.resTypeLabel": "Type",
  "reservations.resBranchLabel": "Branch",
  "reservations.resBranchNone": "No branch",
  "reservations.resCapacityLabel": "Capacity",
  "reservations.resBuildingLabel": "Building",
  "reservations.resFloorLabel": "Floor",
  "reservations.resAmenitiesLabel": "Amenities",
  "reservations.resAmenitiesPlaceholder": "projector, whiteboard",
  "reservations.resAmenitiesHelp": "Comma-separated.",
  "reservations.resTeamsLabel": "Teams meeting capable",
  "reservations.resParentLabel": "Stands in",
  "reservations.resParentNone": "Nothing \u2014 stands on its own",
  "reservations.resParentHelp":
    "Pick the room this spot physically stands in. While that room is booked this spot cannot be \u2014 and the other way round. Two spots in the same room do not block each other.",
  "reservations.resParentHoldsOthers": "Other spots stand in this room, so it cannot stand in anything itself.",
  "reservations.resLastSynced": "Last synced",
  "reservations.resSearchPlaceholder": "Search by name, mailbox or building…",
  "reservations.resSync": "Sync with Microsoft 365",
  "reservations.resSyncing": "Syncing…",
  "reservations.resSyncDone": "Sync complete: {{created}} added, {{updated}} updated, {{deactivated}} deactivated.",
  "reservations.resSyncKeptInactive": "{{count}} resource stays inactive (switched off here).",
  "reservations.resSyncKeptInactive_other": "{{count}} resources stay inactive (switched off here).",
  "reservations.resColName": "Name",
  "reservations.resColType": "Type",
  "reservations.resColMailbox": "Mailbox",
  "reservations.resColCapacity": "Capacity",
  "reservations.resColLocation": "Location",
  "reservations.resColSharedSpace": "Shared space",
  "reservations.resSharedIn": "Stands in {{name}}",
  "reservations.resSharedHolds": "Holds {{names}}",
  "reservations.resColStatus": "Status",
  "reservations.resEmpty": "No resources yet. Sync with Microsoft 365 or add one manually.",

  // Tasks (personal + shared-mailbox tasks)
  "tasks.scopeAll": "All",
  "tasks.scopeMine": "My tasks",
  "tasks.searchPlaceholder": "Search by title or description…",
  "tasks.searchLabel": "Search tasks",
  "tasks.filterByStatus": "Filter by status",
  "tasks.statusActive": "Active (everything still running)",
  "tasks.allStatuses": "All statuses",
  "tasks.statusOpen": "Open",
  "tasks.statusInProgress": "In progress",
  "tasks.statusWaiting": "Waiting for reply",
  "tasks.statusReplied": "Replied",
  "tasks.statusRepliedHint": "This task was waiting; a reply has since come in.",
  "tasks.statusReview": "Finished, to review",
  "tasks.reviewBanner": "{{actor}} finished this task. You handed it out, so you close it.",
  "tasks.reviewClose": "Close",
  "tasks.reviewReopen": "Not done after all",
  "tasks.reviewWaiting": "Waiting to be reviewed by {{name}}",
  "tasks.statusDone": "Done",
  "tasks.statusCancelled": "Cancelled",
  "tasks.manageMailboxes": "Manage mailboxes",
  "tasks.newTask": "New task",
  "tasks.colTitle": "Title",
  "tasks.colMailbox": "Mailbox",
  "tasks.colStatus": "Status",
  "tasks.colAssignee": "Assignee",
  "tasks.colDueDate": "Due date",
  "tasks.colLastActivity": "Last activity",
  "tasks.sortBy": "Sort by {{column}} · drag to move the column",
  "tasks.noTasks": "No tasks found.",
  "tasks.periodLabel": "Period (follow-up date)",
  "tasks.periodAll": "All",
  "tasks.periodDay": "Day",
  "tasks.periodWeek": "Week",
  "tasks.periodMonth": "Month",
  "tasks.groupOverdue": "Overdue",
  "tasks.groupToday": "Today",
  "tasks.groupTomorrow": "Tomorrow",
  "tasks.groupThisWeek": "This week",
  "tasks.groupThisMonth": "This month",
  "tasks.groupLater": "Later",
  "tasks.groupNoDate": "No follow-up date",
  "tasks.fromMail": "From e-mail",
  "tasks.hasReply": "reply",
  "tasks.onlyUnread": "With reply",
  "tasks.onlyUnreadHint": "Show only tasks with an unread reaction (within this page).",
  "tasks.noUnread": "No tasks with an unread reaction on this page.",
  "tasks.hasReplyTitle": "New internal reply on this task",
  "tasks.personal": "Personal",
  "tasks.newTitle": "New task",
  "tasks.createAriaLabel": "Create new task",
  "tasks.createButton": "Create task",
  "tasks.errorGeneric": "Something went wrong. Please try again.",
  "tasks.scopeLabel": "For",
  "tasks.scopePersonal": "Personal (only me)",
  "tasks.scopeHelp": "A mailbox task is visible to all members of that mailbox.",
  "tasks.titleLabel": "Title",
  "tasks.titlePlaceholder": "e.g. Call customer back about quote",
  "tasks.completeButton": "Complete",
  "tasks.editButton": "Edit",
  "tasks.editButtonHelp": "Edit title and description",
  "tasks.editTitleTooShort": "Enter a title of at least 2 characters.",
  "tasks.unplanButton": "Remove time block",
  "tasks.unplanHelp": "Clears the time block here; the appointment itself stays in your Outlook calendar.",
  "tasks.descriptionLabel": "Description",
  "tasks.attachmentsLabel": "Attachments",
  "tasks.mailAttachmentsLabel": "From the mails",
  "tasks.mailAttachmentsLoading": "Fetching the attachments from the mails…",
  "tasks.mailAttachmentsUnavailable_one":
    "The attachments of {{count}} mail could not be fetched: moved, deleted, or in a mailbox you cannot open.",
  "tasks.mailAttachmentsUnavailable_other":
    "The attachments of {{count}} mails could not be fetched: moved, deleted, or in a mailbox you cannot open.",
  "tasks.mailAttachmentHint": "{{name}} — from the mail ‘{{subject}}’",
  "tasks.mailAttachmentUnnamed": "Attachment",
  "tasks.attachmentDropHint": "Drag files here or click to choose",
  "tasks.attachmentUploading": "Uploading…",
  "tasks.attachmentTooLarge": "{{name}} is larger than 100 MB",
  "tasks.attachmentUploadFailed": "Upload failed",
  "tasks.attachmentDeleteFailed": "Delete failed",
  "tasks.attachmentDeleteConfirm": "Delete {{name}}?",
  "tasks.attachmentRemove": "Remove",
  "tasks.descriptionPlaceholder": "Optional details…",
  "tasks.assigneeLabel": "Assignee",
  "tasks.assigneeNone": "No assignee yet",
  "tasks.participantsLabel": "Involved",
  "tasks.participantsHelp": "Colleagues who follow along: they see the task and get the comments. The assignee stays responsible.",
  "tasks.participantsSearchPlaceholder": "Add a colleague…",
  "tasks.participantsNoMatch": "No colleague found",
  "tasks.participantsRemove": "Stop involving {{name}}",
  "tasks.participantsTooltip": "Involved: {{names}}",
  "tasks.activityParticipantAdded": "{{actor}} involved {{name}} in the task",
  "tasks.activityParticipantRemoved": "{{actor}} took {{name}} off the task",
  "tasks.activityParticipantLeft": "{{actor}} is no longer involved",
  "tasks.removeMail": "Remove from this task",
  "tasks.removeMailConfirm": "The e-mail stays in the mailbox; it only disappears from this task.",
  "tasks.removeMailConfirmYes": "Yes, remove it from the task",
  "tasks.activityMailRemoved": "{{actor}} removed an e-mail from the task",
  "tasks.activityMailRemovedSubject": "{{actor}} removed the e-mail ‘{{subject}}’ from the task",
  "tasks.assigneeNoMembers": "This mailbox has no members yet — add them under Beheer → Postvakken to pick one as assignee.",
  "tasks.dueDateConfirmHint": "Enter to confirm, Esc to cancel",
  "tasks.dueDateEditHint": "Click to change the follow-up date",
  "tasks.dueDateLabel": "Due date",
  "tasks.dueWeekLabel": "Your open tasks this week",
  "tasks.dueDayCount": "{{date}}: {{count}} open task",
  "tasks.dueDayCount_other": "{{date}}: {{count}} open tasks",
  "tasks.dueDayNone": "No open tasks of yours on {{date}} yet.",
  "tasks.dueDaySome": "On {{date}} you already have {{count}} open task:",
  "tasks.dueDaySome_other": "On {{date}} you already have {{count}} open tasks:",
  "tasks.dueDayWith": "with {{name}}",
  "tasks.dueDayMore": "and {{count}} more",
  "tasks.dueDayError": "Your tasks for that week could not be loaded.",
  "tasks.statusLabel": "Status",
  "tasks.notFound": "Task not found",
  "tasks.notFoundDesc": "This task does not exist or you do not have access to it.",
  "tasks.backToOverview": "Back to tasks",
  "tasks.createdByLabel": "Created by {{name}} on {{date}}",
  "tasks.tabActivity": "Activity & comments",
  "tasks.tabMessages": "Messages",
  "tasks.systemActor": "System",
  "tasks.activityCreated": "{{actor}} created the task",
  "tasks.activityStatusChanged": "{{actor}} changed the status from {{from}} to {{to}}",
  "tasks.activityAssigned": "{{actor}} assigned {{assignee}}",
  "tasks.activityUnassigned": "{{actor}} removed the assignee",
  "tasks.activityMailAdded": "E-mail added to the task",
  "tasks.activityMailAddedSubject": "E-mail added: {{subject}}",
  "tasks.activityMailHistoryAdded_one": "{{count}} mail from the same conversation added",
  "tasks.activityMailHistoryAdded_other": "{{count}} mails from the same conversation added",
  "tasks.activityMailReplied": "{{actor}} sent a reply",
  "tasks.activityMailRepliedSubject": "{{actor}} replied: {{subject}}",
  "tasks.activityMergedFrom": "{{actor}} merged {{number}} into this task",
  "tasks.activityMergedInto": "{{actor}} merged this task into {{number}}",
  "tasks.messageOutgoing": "Sent",
  "tasks.noActivity": "No activity yet.",
  "tasks.mentionedLabel": "Asked of",
  // Under your own comment: did it reach the people you meant?
  "tasks.seenBy": "Seen by {{names}}",
  "tasks.notSeenBy": "not yet by {{names}}",
  "tasks.seenByNobody": "Not seen yet",
  "tasks.mentionHint": "Type @ to tag a colleague",
  "tasks.commentLabel": "Add a comment",
  "tasks.commentPlaceholder": "Write an internal comment…",
  "tasks.commentSubmit": "Comment",
  "tasks.commentAddImage": "Image",
  "tasks.commentImageHint": "Paste or add",
  "tasks.commentImageTooLarge": "Image is too large (max {{mb}} MB)",
  "tasks.commentImageType": "Images only (PNG, JPG, GIF, WEBP)",
  "tasks.noMessages": "No e-mails linked to this task.",
  "tasks.noMessageBody": "No message body available.",
  "tasks.openInOutlook": "Open in Outlook",
  "tasks.openInWlx": "Open in WLX",
  "tasks.openInWlxFailed": "This mail can no longer be found in the mailbox — it may have been moved or deleted.",
  // Recurring tasks (schedules that spawn a task per occurrence)
  "tasks.manageRecurring": "Recurring tasks",
  "tasks.planNowLabel": "Block time in my calendar",
  "tasks.planNowHelp": "Optional — blocks this time in your own Outlook calendar.",
  "tasks.planFromLabel": "From",
  "tasks.planToLabel": "To",
  "tasks.planInvalid": "The end time must be after the start time.",
  "tasks.repeatLabel": "Repeat",
  "tasks.repeatNone": "Do not repeat",
  "tasks.repeatDaily": "Daily",
  "tasks.repeatWeekly": "Weekly",
  "tasks.repeatMonthly": "Monthly",
  "tasks.repeatHelp": "On every scheduled date a task with its own number is created automatically.",
  "tasks.repeatIntervalLabel": "Every",
  "tasks.repeatUnitDays": "day(s)",
  "tasks.repeatUnitWeeks": "week(s)",
  "tasks.repeatUnitMonths": "month(s)",
  "tasks.repeatOnDaysLabel": "On days",
  "tasks.repeatPickDay": "Pick at least one day.",
  "tasks.repeatDayOfMonthLabel": "Day of the month",
  "tasks.repeatDayOfMonthHelp": "Months without this day are skipped (e.g. day 31 in February).",
  "tasks.repeatStartLabel": "First occurrence on",
  "tasks.repeatUntilLabel": "Repeat until (optional)",
  // Calendar link ("Tijd plannen")
  "tasks.planTimeButton": "Block time",
  "tasks.planTimeAgainButton": "Reschedule",
  "tasks.planTimeHelp": "Block time for this task in your own Outlook calendar.",
  "tasks.planDueHint": "Follow-up date: {{date}}",
  "tasks.planStart": "From",
  "tasks.planEnd": "To",
  "tasks.planConfirm": "Block time",
  "tasks.planErrorTime": "Enter a valid start and end time.",
  "tasks.planErrorEnd": "The end time must be after the start time.",
  "tasks.plannedBadge": "Planned",
  "tasks.plannedBadgeHelp": "Time for this task is blocked in your calendar.",
  "tasks.recurringBadge": "Recurring task",
  "tasks.recurringBadgeHelp": "Created automatically from a recurring schedule.",
  "tasks.recPageTitle": "Recurring tasks",
  "tasks.recColSchedule": "Schedule",
  "tasks.recColPattern": "Pattern",
  "tasks.recColNext": "Next occurrence",
  "tasks.recColActions": "Actions",
  "tasks.recActive": "Active",
  "tasks.recPaused": "Paused",
  "tasks.recFinished": "Finished",
  "tasks.recPause": "Pause",
  "tasks.recResume": "Resume",
  "tasks.recDelete": "Delete",
  "tasks.recDeleteConfirm": "Delete this recurring schedule? Tasks that were already created will remain.",
  "tasks.recEmpty": "No recurring tasks yet.",
  "tasks.recCreateHint": "Create a recurring task via “New task” on the task overview — pick a pattern under “Repeat”.",
  "tasks.patDaily": "Daily",
  "tasks.patEveryNDays": "Every {{n}} days",
  "tasks.patWeekly": "Weekly on {{days}}",
  "tasks.patEveryNWeeks": "Every {{n}} weeks on {{days}}",
  "tasks.patMonthly": "Monthly on day {{day}}",
  "tasks.patEveryNMonths": "Every {{n}} months on day {{day}}",
  "tasks.patUntil": "until {{date}}",
  "mail.mbNew": "New mailbox",
  "mail.mbNewTitle": "Register mailbox",
  "mail.mbColName": "Name",
  "mail.mbColEmail": "E-mail address",
  "mail.mbColMembers": "Members",
  "mail.mbColTag": "Tag",
  "mail.mbColStatus": "Status",
  "mail.mbEmpty": "No shared mailboxes registered yet.",
  "mail.mbActive": "Active",
  "mail.mbInactive": "Inactive",
  "mail.mbNameLabel": "Name",
  "mail.mbNamePlaceholder": "e.g. Support",
  "mail.mbTagLabel": "Tag (short label)",
  "mail.mbTagPlaceholder": "e.g. Support",
  "mail.mbTagHint": "Short label on the mail rows in the “All” list. Empty = the name is used.",
  "mail.mbTagColorLabel": "Tag colour",
  "mail.mbTagColorHint": "Colour of the chip on the mail rows — handy to recognise mailboxes at a glance.",
  "mail.mbAiLabel": "AI house-style",
  "mail.mbAiPlaceholder":
    "e.g. Write formally and concisely. On any delay, always mention our 24-hour follow-up. Reference the order number when it is known.",
  "mail.mbAiHint":
    "Standing writing instructions for the AI assistant on this mailbox (tone, form of address, stock phrases). The greeting and signature are added automatically — do not put them here. Passed as trusted guidance. Empty = default style only.",
  "mail.tagColorNone": "No colour",
  "mail.tagColorSlate": "Grey",
  "mail.tagColorNavy": "Blue",
  "mail.tagColorTeal": "Teal",
  "mail.tagColorGreen": "Green",
  "mail.tagColorAmber": "Amber",
  "mail.tagColorRed": "Red",
  "mail.tagsHeader": "Tags",
  "mail.tagsNone": "No tags yet",
  "mail.tagsManage": "Manage tags…",
  "mail.tagsError_one": "The tag was not set. Please try again.",
  "mail.tagsError_other": "The tag was not set on {{count}} mails. Please try again.",
  "mail.tagFilter": "Tag",
  "mail.tagFilterHint": "Only the mails with a tag. With All folders across the whole mailbox.",
  "mail.tagFilterHeader": "Filter by tag",
  "mail.tagFilterAll": "All mail",
  "mail.tagButton": "Tag",
  "mail.tagButtonHint": "Put a tag on this mail or take one off",
  "mail.tagsTitle": "Tags",
  "mail.tagsHelpShared": "The tags everyone in this mailbox chooses from. A tag is a category on the mail, so Outlook shows it too. Change a name and the mails with that tag follow on their own, for everyone in this mailbox.",
  "mail.tagsHelpOwn": "Your own tags for your own mailbox. A tag is a category on the mail, so Outlook shows it too. Change a name and the mails with that tag follow on their own.",
  "mail.tagsShortcut": "Shortcut",
  "mail.tagsShortcutPress": "Press a key…",
  "mail.tagsShortcutHint": "A key of its own for {{name}}: puts the tag on the open or selected mail, or takes it off. Click and press a letter, a digit or Shift with a letter. Delete removes the key, Esc cancels.",
  "mail.tagsShortcutInvalid": "Choose a letter, a digit or Shift with a letter.",
  "mail.tagsShortcutReserved": "{{key}} already does something in the mail. Choose another key, or add Shift.",
  "mail.tagsShortcutTaken": "{{key}} is already on {{name}}.",
  "mail.tagsRename": "Change the name of {{name}}",
  "mail.tagsRenaming": "The mails with {{name}} are moving to this name. This can take a while.",
  "mail.tagsColor": "Colour",
  "mail.tagsUp": "Move {{name}} up",
  "mail.tagsDown": "Move {{name}} down",
  "mail.tagsRemove": "Remove from list",
  "mail.tagsRemoveHint": "Take it off the list. Mails with this tag keep it, without a colour.",
  "mail.tagsRemoveConfirm": "Take {{name}} off the list? Mails with this tag keep it, without a colour.",
  "mail.tagsPlaceholder": "E.g. Invoicing",
  "mail.tagsAddLabel": "New tag",
  "mail.tagsAdd": "Add",
  "mail.tagsDuplicate": "{{name}} is already in the list.",
  "mail.tagsNoComma": "A tag cannot contain a comma.",
  "mail.mbEmailLabel": "E-mail address",
  "mail.mbEmailPlaceholder": "support@willemslogistics.com",
  "mail.mbEmailHelp": "The shared mailbox address in Microsoft 365.",
  "mail.mbPhoneLabel": "Phone number",
  "mail.mbPhonePlaceholder": "e.g. +31 (0) 882081010",
  "mail.mbPhoneHint": "Appears as the T line in this mailbox's signature, exactly as typed here. Empty = no phone line.",
  "mail.mbAddressLabel": "Address",
  "mail.mbAddressPlaceholder": "Hoogeindsestraat 32\n5447 PE Rijkevoort",
  "mail.mbAddressHint": "Appears under the logo in the signature, one line per line typed here. Empty = no address.",
  "mail.focusLabel": "Focus area:",
  "mail.focusAll": "All areas",
  "mail.focusAllHint": "Show mail from all of your focus areas",
  "mail.focusSwitchHint": "Switch to this focus area — your administrator decides which ones you have",
  "mail.mbActiveLabel": "Active",
  "mail.mbCreateButton": "Add mailbox",
  "mail.ownFoldersButton": "Folders",
  "mail.ownFoldersHint": "Folders of your own beside Processed in your own mailbox",
  "mail.ownFoldersTitle": "Folders in your own mailbox",
  "mail.ownFoldersHelp":
    "Extra folders beside Inbox, Processed, CC and Sent Items. They appear above after Processed, and you can move mail into them: with the right mouse button, by dragging a mail onto the folder, or with Move to. E still files into Processed. WLX creates the folder in Outlook under the Inbox the first time mail goes into it. If it already exists there, WLX shows what is in it right away. Write a folder further down as its path, for example Inkoopfacturen/WLX verwerkt.",
  "mail.moveTo": "Move to…",
  "mail.moveToHint": "Put this mail in another folder",
  "mail.moveToHeader": "Move to",
  "mail.moveError": "The mail could not be moved.",
  "mail.movedUndoText": "Moved to {{folder}}.",
  "mail.folderDropHint": "Drag a mail here to move it to {{folder}}",
  "mail.foldersTitle": "Folders",
  "mail.foldersEmpty": "No folders of its own yet.",
  "mail.foldersMax": "At most {{count}} folders of its own.",
  "mail.foldersPlaceholder": "Folder name, e.g. Complaints",
  "mail.foldersAddLabel": "New folder",
  "mail.foldersAdd": "Add",
  "mail.foldersHide": "Hide",
  "mail.foldersHideHint": "Takes the folder out of WLX. In Outlook the folder and the mail in it stay where they are.",
  "mail.foldersUp": "Move {{name}} up",
  "mail.foldersDown": "Move {{name}} down",
  "mail.foldersFixed": "{{name}} is already a folder in WLX or Outlook.",
  "mail.foldersDuplicate": "{{name}} is already in the list.",
  "mail.mbFoldersHelp":
    "Extra folders beside Inbox, Processed and Sent Items, for everyone in this mailbox. They appear in the mail after Processed, and members can move mail into them; E still files into Processed. WLX creates the folder in Outlook under the Inbox the first time mail goes into it. If it already exists there, WLX shows what is in it right away. Write a folder further down as its path, for example Inkoopfacturen/WLX verwerkt.",
  "mail.mbMembersTitle": "Members",
  "mail.mbNoMembers": "No members yet — only administrators see this mailbox's tasks.",
  "mail.mbRemoveMember": "Remove {{name}}",
  "mail.mbAddMemberLabel": "Add member",
  "mail.mbAddMemberPlaceholder": "Choose an employee…",
  "mail.mbAddMember": "Add",
  "mail.mbSyncLast": "Last mail sync: {{date}}",
  "mail.mbSyncNever": "No mail sync has run yet.",
  "mail.mbSyncError": "Mail sync is failing: {{error}}",
  // Visibility groups (admin)
  "mail.backToMail": "Back to mail",
  "mail.noMailboxes": "You are not a member of any shared mailbox yet. Ask an administrator to add you.",
  "mail.listEmpty": "No messages in this mailbox.",
  "mail.searchPlaceholder": "Search mail…",
  "mail.searchLabel": "Search this mailbox",
  "mail.searchEmpty": "No results for “{{q}}”.",
  "mail.searchAllFolders": "All folders",
  "mail.searchAllFoldersHint": "Search every folder of this mailbox at once; each mail shows which folder it is in",
  "mail.selectMessage": "Select a message to read.",
  "mail.noSubject": "(no subject)",
  "mail.olderMessages": "Older messages",
  "mail.moreMessages": "More messages",
  "mail.colFrom": "From",
  "mail.colTo": "To",
  "mail.colSubject": "Subject",
  "mail.colTag": "Tag",
  "mail.colReceived": "Received",
  "mail.colSent": "Sent",
  "mail.sortBy": "Sort by {{column}} — another click reverses the order",
  "mail.sortHintCombined": "All shows the newest mail first. Sorting works within one mailbox",
  "mail.sortHintSearch": "Search results are by date, newest first",
  "mail.sortHintTo": "Recipients cannot be sorted on",
  "mail.newestMessages": "← Newest messages",
  "mail.tabAll": "All",
  "mail.tabReorderHint": "Drag to change the order of your mailboxes",
  "mail.tabAllHint": "Inboxes of several mailboxes in one list",
  "mail.allPickerLabel": "Mailboxes:",
  "mail.allSoloHint": "Click to switch on or off · double-click for this mailbox only",
  "mail.allSelectAll": "all mailboxes",
  "mail.allMaxSources": "At most {{count}} mailboxes at once in All",
  "mail.allMinOne": "At least one mailbox always stays on",
  "mail.allEmpty": "No messages in the selected mailboxes.",
  "mail.allSourceError": "Could not load: {{names}}. The list is therefore incomplete.",
  "mail.allIncomplete": "Cannot page back further here. Open the mailbox itself for older messages.",
  "mail.hasTask": "Task",
  "mail.hasTaskTitle": "This conversation already has a task",
  "mail.makeTask": "Create task",
  "mail.addToTask": "Add to task",
  "mail.openTask": "Open task",
  "mail.loadImages": "Load images ({{count}})",
  "mail.showText": "Plain text",
  "mail.showHtml": "Show formatting",
  "mail.toLabel": "To",
  "mail.ccLabel": "Cc",
  "mail.fromLabel": "From",
  "mail.dateLabel": "Date",
  "mail.attachmentsLabel": "Attachments",
  "mail.print": "Print",
  "mail.printHint": "Print, or save as PDF",
  "mail.attachmentKindImage": "Image",
  "mail.attachmentKindPdf": "PDF document",
  "mail.attachmentKindDoc": "Text document",
  "mail.attachmentKindSheet": "Spreadsheet",
  "mail.attachmentKindSlides": "Presentation",
  "mail.attachmentKindArchive": "Archive (zip)",
  "mail.attachmentKindAudio": "Audio file",
  "mail.attachmentKindVideo": "Video file",
  "mail.attachmentKindCode": "Data file",
  "mail.attachmentKindMail": "Embedded message",
  "mail.attachmentKindEvent": "Appointment",
  "mail.attachmentKindContact": "Contact",
  "mail.attachmentKindLink": "Link",
  "mail.attachmentKindFile": "File",
  "mail.attachmentFallback": "attachment",
  "mail.spam": "Spam",
  "mail.spamHint": "Move to Rapporteer SPAM — where security picks it up",
  "mail.spamFolderMissing":
    "This mailbox has no “Rapporteer SPAM” folder. Ask IT to create it; WLX deliberately does not create it itself.",
  "mail.spamUndoText": "Reported as spam.",
  "mail.attachmentEmbedded": "embedded message",
  "mail.folderCc": "CC",
  "mail.rulesButton": "Rules",
  "mail.rulesHint": "Mail rules for your own mailbox",
  "mail.rulesTitle": "Mail rules",
  "mail.rulesIntro": "WLX sorts your own mail by these rules — also while you are not in WLX.",
  "mail.rulesFirstMatchNote": "The topmost rule that fits wins; the rest are skipped.",
  "mail.rulesEmpty": "You have no rules yet.",
  "mail.rulesCondLabel": "When",
  "mail.rulesCondCcOnly": "I am only in CC",
  "mail.rulesCondSenderContains": "Sender contains",
  "mail.rulesCondSubjectContains": "Subject contains",
  "mail.rulesValueLabel": "Text",
  "mail.rulesValuePlaceholder": "e.g. berkhout",
  "mail.rulesNeedValue": "Fill in what this rule should look for.",
  "mail.rulesActionLabel": "Move to",
  "mail.rulesFolderCc": "CC folder",
  "mail.rulesFolderProcessed": "Processed",
  "mail.rulesFolderNone": "Do not move",
  "mail.rulesMarkRead": "Mark as read",
  "mail.rulesNeedEffect": "A rule must move the mail, mark it read, or both.",
  "mail.rulesAdd": "Add rule",
  "mail.rulesPause": "Turn off",
  "mail.rulesResume": "Turn on",
  "mail.rulesDeleteConfirm": "Delete this rule?",
  "mail.rulesApplyNow": "Apply to Inbox now",
  "mail.rulesApplyNowHint": "New rules apply from now on. To tidy up the mail already sitting there, do it here.",
  "mail.rulesApplyResult": "{{scanned}} looked at, {{moved}} moved, {{markedRead}} marked read.",
  "mail.rulesApplyCapped": "There was more waiting than fits in one run — run it again.",
  "mail.rulesServerSideNote":
    "For this WLX looks only at sender, recipients and subject — never at the contents of your mail — and only while you have a rule of your own.",
  "mail.rulesAliasNote": "Only your own address counts. If you are CC'd through an alias or a group address, the rule will not see it.",
  "mail.attachmentEmbeddedHint": "Embedded message — click to read",
  "mail.attachmentLink": "link",
  "mail.embeddedTitle": "Embedded message",
  "mail.embeddedNoSender": "Sender unknown",
  "mail.embeddedNoBody": "This embedded message has no content.",
  "mail.embeddedHasAttachments":
    "This message has attachments of its own, but WLX could not fetch them just now — open the mail in Outlook to reach them.",
  "mail.embeddedUnreadable": "This embedded message cannot be opened.",
  "mail.embeddedKindEvent": "Embedded appointment",
  "mail.embeddedKindContact": "Embedded contact",
  "mail.embeddedKindOther": "Embedded item",
  "mail.openInOutlook": "Open in Outlook",
  "mail.replied": "Replied",
  "mail.waitingRowTitle": "No reply and no task yet — this customer is still waiting on us",
  "mail.waitingCount_one": "{{count}} waiting on us",
  "mail.waitingCount_other": "{{count}} waiting on us",
  "mail.waitingOldest": "oldest {{age}}",
  "mail.waitingCapped": "at least — older mail was not scanned",
  "mail.waitingNone": "All answered or picked up",
  "mail.repliedTitle": "You have replied to this mail",
  "mail.forwarded": "Forwarded",
  "mail.forwardedTitle": "You have forwarded this mail",
  "mail.attachmentOpen": "Open",
  "mail.attachmentDownload": "Download",
  "mail.attachmentDragHint": "Drag to a folder or the desktop. A website cannot take a drag: download it (⤓) and drag it from the browser's downloads",
  "mail.attachmentDragHintCopy": "Drag to a folder or the desktop. A website cannot take a drag: copy it and paste with Ctrl+V",
  "mail.attachmentCopyImage": "Copy image — paste with Ctrl+V in a website or app",
  "mail.attachmentCopyText": "Copy contents as text — paste with Ctrl+V in a website or app",
  "mail.attachmentCopied": "Copied — paste with Ctrl+V",
  "mail.attachmentCopyFailed": "Copying did not work",
  "mail.unreadCount": "{{count}} unread",
  "mail.markRead": "Mark read",
  "mail.markUnread": "Mark unread",
  "mail.readError": "Could not change the read status — the write permission (Mail.ReadWrite) may not be granted yet.",
  "mail.reply": "Reply",
  "mail.replyAll": "Reply all",
  "mail.forward": "Forward",
  "mail.forwardManyHint": "In one new mail, with the mails attached",
  "mail.forwardManyMailboxes": "Mails can only be forwarded together from one mailbox",
  "mail.forwardManyTooMany": "At most {{count}} mails can be forwarded together",
  "mail.replyPlaceholder": "Type your reply…",
  "mail.forwardPlaceholder": "Type your message…",
  // Reply greetings are CONTENT for the customer, not interface text: the
  // language follows the INCOMING mail (detectGreeting), never the UI locale.
  // Hence identical values in nl.ts and en.ts — do not "translate" these.
  "mail.greetNl": "Hoi {{name}},",
  "mail.greetNlNoName": "Hoi,",
  "mail.greetNlAll": "Hoi allemaal,",
  "mail.greetNlFormal": "Beste {{name}},",
  "mail.greetNlFormalNoName": "Beste,",
  "mail.greetNlFormalAll": "Beste allen,",
  "mail.greetEn": "Hi {{name}},",
  "mail.greetEnNoName": "Hi,",
  "mail.greetEnAll": "Hi all,",
  "mail.greetEnFormal": "Dear {{name}},",
  "mail.greetEnFormalNoName": "Dear,",
  "mail.greetEnFormalAll": "Dear all,",
  "mail.greetingPrefSet": "Address this sender differently?",
  "mail.greetingPrefEdit": "Change how this sender is addressed",
  "mail.greetingPrefTitle": "How we address this sender from now on",
  "mail.greetingPrefNamePlaceholder": "First name",
  "mail.greetingPrefTone": "Salutation",
  "mail.greetingPrefAuto": "Automatic",
  "mail.greetingPrefHelp": "Leave everything empty to detect it again. Applies to this mailbox only.",
  "mail.presenceReading": "{{name}} also has this mail open",
  "mail.presenceReplying": "{{name}} is replying to this mail — check before you send your own",
  "mail.templatesLabel": "Quick replies:",
  "mail.signatureAuto": "Your name and the house-style signature are added automatically on send.",
  "mail.historyEdit": "Edit original message",
  "mail.historyLabel": "Original message",
  "mail.historyRevert": "Send the original unchanged",
  "mail.historyRevertConfirm": "Your changes to the original message will be lost. Continue?",
  "mail.historyImagesHelp": "Pictures shown here as an empty frame are sent along all the same.",
  "mail.historyError": "The original message could not be loaded.",
  "mail.forwardOriginalAttachments": "The attachments of the original go along: {{names}}",
  "mail.historyFrom": "From:",
  "mail.historySent": "Sent:",
  "mail.historyTo": "To:",
  "mail.historyCc": "Cc:",
  "mail.historySubject": "Subject:",
  "mail.signatureOwn": "You send under your own name; your own signature is added automatically.",
  "mail.makeAppointment": "Create appointment",
  "mail.makeAppointmentHelp": "Creates an appointment in your own calendar with the people on this mail.",
  // Meeting invitation received as mail
  "mail.invite.label": "Meeting invitation",
  "mail.invite.series": "whole series",
  "mail.invite.sending": "Working…",
  "mail.invite.outOfDate": "There is a newer version of this invitation. Respond to the latest one instead.",
  "mail.invite.isResponse": "This is a reply to your invitation.",
  "mail.invite.cancelled": "This meeting has been cancelled.",
  "mail.invite.youOrganised": "You organised this meeting.",
  "mail.invite.alreadyAccepted": "You already accepted this invitation.",
  "mail.invite.alreadyDeclined": "You already declined this invitation.",
  "mail.invite.alreadyTentative": "You responded tentatively.",
  "mail.invite.done_accept": "Accepted. The invitation leaves your inbox.",
  "mail.invite.done_tentative": "Responded tentatively. The invitation leaves your inbox.",
  "mail.invite.done_decline": "Declined. The invitation leaves your inbox.",
  "mail.invite.response_accepted": "Reply to your invitation: accepted.",
  "mail.invite.response_tentativelyAccepted": "Reply to your invitation: tentative.",
  "mail.invite.response_declined": "Reply to your invitation: declined.",
  "mail.invite.proposedTime": "Proposed time:",
  "mail.invite.proposalApplied": "Your calendar already has this time.",
  "mail.invite.acceptProposal": "Accept proposal",
  "mail.invite.acceptProposalHelp": "The meeting moves to this time; the attendees get an updated invitation.",
  "mail.invite.done_proposal": "Proposal accepted. The attendees get an updated invitation.",
  // Calendar sources
  "calendar.sourcesTitle": "Calendars",
  "calendar.sourceOwn": "Own calendar",
  "calendar.sourceSharedBy": "shared by {{name}}",
  "calendar.sourceReadOnly": "read-only",
  "calendar.sourceFailed": "{{count}} calendar could not be loaded — the list may be incomplete.",
  "calendar.sourceFailed_plural": "{{count}} calendars could not be loaded — the list may be incomplete.",
  "calendar.readOnlyEvent": "This appointment lives in a calendar you may only read.",
  "mail.openInWindow": "Open in a separate window",
  "mail.windowNoAccess": "You do not have access to the mail module.",
  "mail.windowMissing": "This link does not point at a mail.",
  "mail.windowClose": "Close window ({{seconds}})",
  "mail.windowGone": "This mail is gone — it may have been moved or deleted.",
  "mail.windowBlocked": "Your browser blocked the new window. Allow pop-ups for WLX and try again.",
  "mail.composeWindowMissing": "This link does not point to a new mail.",
  "mail.composeWindowNoMailbox": "You cannot send from this mailbox here: you are no longer a member, or your own mailbox is not linked.",
  "mail.composeWindowNoStorage": "This browser keeps no drafts (a private window?), so the mail cannot move to a window of its own.",
  "mail.composeWindowFilesLost_one": "1 attachment did not come along from the main window. Add it here again.",
  "mail.composeWindowFilesLost_other": "{{count}} attachments did not come along from the main window. Add them here again.",
  "mail.composeWindowSent": "Sent. You can close this window.",
  "mail.composeWindowClosed": "You can close this window.",
  "mail.myMailbox": "My mailbox",
  "mail.connectTitle": "Link your own mailbox",
  "mail.connectDesc":
    "Allow WLX to show your Outlook (mail and calendar) and act on your behalf — sending mail and managing appointments. You sign in with your own Microsoft account; WLX stores no mail or calendar data — only an encrypted key you can revoke here at any time.",
  "mail.connectButton": "Link mailbox",
  "mail.connectConsentAccept":
    "I agree that WLX may show my work Outlook (mail and calendar), send mail on my behalf, and manage appointments. WLX stores no mail or calendar data (only an encrypted key), it is voluntary, and I can unlink it at any time.",
  "mail.connectConsentRequired": "Tick the agreement first to link your mailbox.",
  "mail.reconnectTitle": "Link expired",
  "mail.reconnectDesc": "The link to your mailbox has expired (for example after a password change). Reconnect to see your mail again.",
  "mail.reconnectButton": "Reconnect",
  "mail.autoReplyButton": "Out of office",
  "mail.autoReplyHint": "Automatic out-of-office reply for your own mailbox",
  "mail.autoReplyTitle": "Out-of-office reply",
  "mail.autoReplyDesc": "Outlook sends the reply and switches it on and off itself — nothing to remember.",
  "mail.autoReplyStatus": "Reply",
  "mail.autoReplyOff": "Off",
  "mail.autoReplyOn": "On, until I turn it off",
  "mail.autoReplyScheduled": "On during a period",
  "mail.autoReplyFrom": "From",
  "mail.autoReplyUntil": "Until (inclusive)",
  "mail.autoReplyInternal": "Message to colleagues",
  "mail.autoReplyInternalPlaceholder": "I am away until… For anything urgent please contact…",
  "mail.autoReplyExternalAudience": "Senders outside Willems",
  "mail.autoReplyExternalNone": "Get no reply",
  "mail.autoReplyExternalContacts": "My contacts only",
  "mail.autoReplyExternalAll": "Anyone who mails me",
  "mail.autoReplyExternal": "Message to external senders",
  "mail.autoReplyExternalPlaceholder": "I am currently out of office. For urgent matters please contact…",
  "mail.autoReplyExternalHint": "This one goes to customers and suppliers — keep it short and businesslike.",
  "mail.autoReplyInternalRequired":
    "An auto-reply that is switched on needs a message — without one, everybody who mails you gets an empty reply.",
  "mail.autoReplyExternalRequired": "You chose to reply to senders outside Willems, so that message cannot be empty.",
  "mail.autoReplyNeedsReconnect":
    "WLX may not manage your out-of-office reply yet. Reconnect your mailbox; WLX asks for that permission as part of it.",
  "mail.disconnectButton": "Unlink mailbox",
  "mail.disconnectHint": "Removes WLX's access to your own mailbox",
  "mail.connectOk": "Your mailbox is linked.",
  "mail.connectCancelled": "Linking cancelled — nothing was changed.",
  "mail.connectMismatch":
    "The Microsoft account that gave consent is not your WLX account. Sign in to Microsoft with your own account and try again.",
  "mail.connectError": "Linking failed. Please try again.",
  "mail.bold": "Bold",
  "mail.italic": "Italic",
  "mail.underline": "Underline",
  "mail.textColour": "Font colour",
  "mail.textColourMore": "Choose another font colour",
  "mail.textColourAutomatic": "Automatic",
  "mail.highlight": "Highlight",
  "mail.highlightMore": "Choose another highlight colour",
  "mail.highlightNone": "No colour",
  "mail.colourDarkRed": "Dark red",
  "mail.colourRed": "Red",
  "mail.colourOrange": "Orange",
  "mail.colourYellow": "Yellow",
  "mail.colourLightGreen": "Light green",
  "mail.colourGreen": "Green",
  "mail.colourBrightGreen": "Bright green",
  "mail.colourLightBlue": "Light blue",
  "mail.colourBlue": "Blue",
  "mail.colourDarkBlue": "Dark blue",
  "mail.colourPurple": "Purple",
  "mail.colourTurquoise": "Turquoise",
  "mail.colourPink": "Pink",
  "mail.colourTeal": "Teal",
  "mail.colourViolet": "Violet",
  "mail.colourDarkYellow": "Dark yellow",
  "mail.colourGray50": "Grey 50%",
  "mail.colourGray25": "Grey 25%",
  "mail.colourBlack": "Black",
  "mail.bulletList": "Bulleted list",
  "mail.numberList": "Numbered list",
  "mail.link": "Insert link",
  "mail.formatPainter": "Format painter",
  "mail.formatPainterHint":
    "Format painter: picks up bold, italic, underline, text colour and highlight from the text your caret or selection is in. Then select the text that should look like it, or click in a word. Double-click to apply it to more text; Esc stops.",
  "mail.noSpacing": "No Spacing",
  "mail.noSpacingHint":
    "The No Spacing style, as in Outlook: single line spacing and no space between paragraphs. Applies to the paragraphs your caret or selection is in; click again to undo.",
  "mail.imageBorder": "Border",
  "mail.imageBorderHint": "A thin grey line around the picture. Click again to remove it.",
  "mail.imageOriginalSize": "Original size",
  "mail.imageOriginalSizeHint": "Puts the picture back at its own size, but never wider than the text.",
  "mail.imageResizeHint": "Drag to make the picture bigger or smaller",
  "mail.mentionSuggestions": "Recipient suggestions",
  "mail.linkPrompt": "Enter a URL (https://…):",
  "mail.send": "Send",
  "mail.sending": "Sending…",
  "mail.discardConfirm": "This mail hasn't been sent yet. Discard it?",
  "mail.discardReplyConfirm": "This reply hasn't been sent yet. Discard it?",
  "mail.replyParkHint": "Park — the answer stays with this mail in this browser, and you can answer other mails meanwhile",
  "mail.replyParked": "Your reply to this mail is waiting as a draft.",
  "mail.replyParkedForward": "Your forward of this mail is waiting as a draft.",
  "mail.replyResume": "Continue writing",
  "mail.replyDiscard": "Discard",
  "mail.replyParkedReplace": "This mail already has a draft. Discard it and start over?",
  "mail.draftRow": "Draft",
  "mail.draftRowTitle": "You started an answer to this mail and have not sent it yet",
  "mail.processedUndoText": "Moved to Processed.",
  "mail.processedUndo": "Undo",
  "mail.replyError": "Could not send — the send permission (Mail.Send) may not be granted yet.",
  "mail.polish": "Tidy up",
  "mail.polishing": "Working…",
  "mail.polishHint": "Improve spelling, capitalisation and tone with AI; the greeting adapts to the customer.",
  "mail.polishError": "Tidy up didn't work. Please try again.",
  "mail.aiButton": "AI",
  "mail.toneNetjes": "Tidy up",
  "mail.toneVriendelijk": "Friendlier",
  "mail.toneZakelijk": "More formal",
  "mail.toneInformeel": "More casual",
  "mail.toneDwingend": "More assertive",
  "mail.aiHint": "AI: draft a reply or polish your text",
  "mail.aiGroupReply": "Draft a reply",
  "mail.aiGroupPolish": "My text",
  "mail.aiPolishNeedsText": "Type your reply first",
  "mail.styleZakelijk": "Formal",
  "mail.styleVriendelijk": "Friendly",
  "mail.styleInformeel": "Casual",
  "mail.aiGroupTranslate": "Translate to",
  "mail.langNl": "Dutch",
  "mail.langEn": "English",
  "mail.langDe": "German",
  "mail.langFr": "French",
  "mail.assistant": "AI assistant",
  "mail.assistantHint": "Open the AI assistant — draft a reply, refine, translate, summarize",
  "mail.assistantTitle": "AI assistant",
  "mail.assistantClose": "Close",
  "mail.assistantConcept": "Draft",
  "mail.assistantSuggestionsLabel": "Quick replies",
  "mail.translateMailGroup": "This email",
  "mail.translateDraftGroup": "My draft",
  "mail.assistantVariants": "Multiple drafts",
  "mail.assistantVariantsIntro": "Three drafts with a different angle — pick one:",
  "mail.assistantSummarize": "Summarize",
  "mail.assistantTranslate": "Translate",
  "mail.assistantEmpty": "Pick an action above or ask a question. The assistant reads this email and your draft.",
  "mail.assistantThinking": "AI is thinking…",
  "mail.assistantInsert": "Insert",
  "mail.assistantReplace": "Replace draft",
  "mail.assistantCopy": "Copy",
  "mail.assistantCopied": "Copied",
  "mail.assistantRefinePlaceholder": "Refine or ask something — e.g. “shorter”, “add that we can deliver on Tuesday”",
  "mail.assistantStop": "Stop",
  "mail.assistantSend": "Send",
  "mail.assistantEnterHint": "Enter = send · Shift+Enter = new line",
  "mail.checking": "Checking…",
  "mail.checkTitle": "Check before sending — worth a look:",
  "mail.checkSendAnyway": "Send anyway",
  "mail.checkBack": "Back",
  "mail.taskAiPropose": "AI proposal",
  "mail.taskAiBusy": "Working…",
  "mail.taskAiSummaryLabel": "AI summary",
  "mail.taskDescriptionLabel": "Description",
  "mail.taskDescriptionPlaceholder": "Short description of the task (the AI proposal fills this from the mail).",
  "mail.manageMailboxes": "Manage mailboxes",
  "mail.summarize": "Summarize",
  "mail.summarizing": "Working…",
  "mail.summarizeHint": "Summarize this mail with AI",
  "mail.summarizeError": "Could not summarize. Please try again.",
  "mail.summaryTitle": "Summary",
  "mail.summaryClose": "Close",
  "mail.delete": "Delete",
  "mail.deleteHint": "Move this mail to Deleted Items — undo is right there. Shortcut: Delete.",
  "mail.deletedUndoText": "Moved to Deleted Items.",
  "mail.bulkDelete": "Delete",
  "mail.bulkDeleteConfirm_one": "Move {{count}} mail to Deleted Items?",
  "mail.bulkDeleteConfirm_other": "Move {{count}} mails to Deleted Items?",
  "mail.process": "Mark processed",
  "mail.processing": "Processing…",
  "mail.processHint": "Move this mail to the Processed folder",
  "mail.processError": "Could not file the mail — the write permission (Mail.ReadWrite) may not be granted yet.",
  "mail.bulkHint": "Shift-click for a range · Ctrl-click for individual mails · Ctrl+A for all",
  "mail.bulkSelected_one": "{{count}} selected",
  "mail.bulkSelected_other": "{{count}} selected",
  "mail.bulkMarkRead": "Mark read",
  "mail.bulkMarkUnread": "Mark unread",
  "mail.bulkProcess": "File as handled",
  "mail.bulkReadProcess": "Mark read + file",
  "mail.bulkToInbox": "Back to Inbox",
  "mail.bulkClear": "Clear selection",
  "mail.bulkDone_one": "{{count}} mail updated.",
  "mail.bulkDone_other": "{{count}} mails updated.",
  "mail.bulkPartial": "{{ok}} updated, {{failed}} failed — those may have just been moved or deleted.",
  "mail.rowMenuLabel": "Actions for this email",
  "mail.relatedHeader": "Find related messages",
  "mail.relatedFromSender": "From this sender",
  "mail.relatedSubject": "With this subject",
  "mail.downloadAllAttachments": "Download all {{count}} attachments (zip)",
  "mail.toInbox": "Back to Inbox",
  "mail.toInboxHint": "Move this mail back to the Inbox",
  "mail.movingToInbox": "Moving…",
  "mail.shortcutSend": "Ctrl + Enter",
  "mail.expectReply": "Expect reply",
  "mail.expectReplyHint": "Sending leaves a task on Waiting for reply; when the answer comes in, it turns into Replied",
  "mail.expectReplyCreated": "Sent. Task {{number}} is waiting for a reply.",
  "mail.expectReplyExisting": "Sent. Task {{number}} is back on Waiting for reply.",
  "mail.expectReplyFailed": "Sent, but the task for the reply could not be made. Make it with Create task on the sent mail.",
  "mail.expectReplyOpenTask": "Open task",
  "mail.composeNew": "New mail",
  "mail.expand": "Expand",
  "mail.collapse": "Collapse",
  "mail.composeFullscreen": "Full screen",
  "mail.composeExitFullscreen": "Leave full screen",
  "mail.composeMinimize": "Park",
  "mail.composeMinimizeHint": "Park at the bottom of the screen — the mail stays as it is, and you can write another meanwhile",
  "mail.composePopOut": "Separate window",
  "mail.composePopOutHint": "Move to a window of its own, to drag to the other screen — the text, the recipients and the attachments come along",
  "mail.composeTray": "Parked mails",
  "mail.composeTrayOpen": "Continue writing",
  "mail.composeTitle": "Compose a new mail",
  "mail.composeFrom": "From",
  "mail.composeTo": "To",
  "mail.composeToPlaceholder": "name@company.com (separate multiple with a comma)",
  "mail.composeBcc": "Bcc",
  "mail.composeBccPlaceholder": "name@company.com — other recipients cannot see this",
  "mail.addBcc": "Bcc",
  "mail.addBccHint": "Add a blind copy — other recipients cannot see these addresses",
  "mail.composeCc": "Cc",
  "mail.composeCcPlaceholder": "optional",
  "mail.addCcHint": "Add a copy",
  "mail.recipientRemove": "Remove {{address}}",
  "mail.recipientEditHint": "Double-click to correct; Backspace removes the address before the caret",
  "mail.recipientInvalid": "This is not a valid e-mail address — double-click to correct it",
  "mail.composeSubject": "Subject",
  "mail.composeBody": "Message",
  "mail.attachAdd": "Add attachment",
  "mail.attachDropHere": "Drop here to attach",
  "mail.attachRemove": "Remove attachment",
  "mail.attachTooMany": "At most {{count}} attachments.",
  "mail.attachFileTooLarge": "{{name}} is larger than {{max}} MB and was skipped.",
  "mail.attachTotalTooLarge": "Attachments may not exceed {{max}} MB in total.",
  "mail.attachImageTooLarge": "That image is larger than {{max}} MB and does not fit in the mail.",
  "mail.attachReadFailed": "{{name}} could not be read.",
  "mail.attachMail": "Attach mail",
  "mail.attachClipboardUnreadable":
    "The clipboard holds a file the browser cannot read — copied in another session, for instance. Save it first and add it with the attachment button.",
  "mail.attachMailWrongMailbox": "You can only attach a mail from the same mailbox.",
  "mail.attachMailTooMany": "You can attach at most 10 mails.",
  "mail.attachMailRemove": "Remove attached mail",
  "mail.mailPickerTitle": "Attach a mail",
  "mail.mailPickerSearch": "Search by subject or sender…",
  "mail.mailPickerAdd": "Add",
  "mail.mailPickerEmpty": "No mails found.",
  "mail.mailPickerAlreadyAdded": "Added",
  "notif.bellLabel": "Notifications",
  "notif.unreadPill_one": "{{count}} notification",
  "notif.unreadPill_other": "{{count}} notifications",
  "notif.title": "Notifications",
  "notif.markAllRead": "Mark all read",
  "notif.empty": "No notifications",
  "notif.reactedOn": "{{actor}} commented on {{ref}}",
  "notif.askedYou": "{{actor}} asked you something on {{ref}}",
  "notif.forYou": "For you",
  "notif.assignedToYou": "{{actor}} gave you {{ref}}",
  "notif.finishedForYou": "{{actor}} finished {{ref}} — you can close it",
  "notif.involvedYou": "{{actor}} involved you in {{ref}}",
  "notif.someone": "Someone",
  // Outside the bell — the Taken tab counter, the tab title and the desktop
  // notification (docs/notifications.md).
  "notif.waitingForYou_one": "{{count}} notification is waiting for you",
  "notif.waitingForYou_other": "{{count}} notifications are waiting for you",
  "notif.desktopOn": "You get a notification on your desktop",
  "notif.desktopOff": "Notify me on my desktop, also when WLX is in the background",
  "notif.desktopBlocked": "Your browser blocks notifications from WLX",
  "notif.desktopEnable": "Turn on",
  "notif.desktopDisable": "Turn off",
  "notif.desktopBurstTitle_one": "{{count}} new notification in WLX",
  "notif.desktopBurstTitle_other": "{{count}} new notifications in WLX",
  "notif.desktopBurstBody": "Open WLX to see them",
  "mail.folderInbox": "Inbox",
  "mail.folderProcessed": "Processed",
  "mail.folderSent": "Sent items",
  "mail.folderJunk": "Junk Email",
  "mail.folderDeleted": "Deleted items",
  "mail.purge": "Delete permanently",
  "mail.purgeHint": "Take it out of Deleted items. This cannot be undone in WLX; in Outlook, Recover deleted items still brings it back",
  "mail.purgeConfirm": "Delete this mail permanently? You cannot undo this in WLX. Outlook can still bring it back for a while with Recover deleted items.",
  "mail.bulkPurge": "Delete permanently",
  "mail.bulkPurgeConfirm_one": "Delete this mail permanently? You cannot undo this in WLX. Outlook can still bring it back for a while with Recover deleted items.",
  "mail.bulkPurgeConfirm_other": "Delete these {{count}} mails permanently? You cannot undo this in WLX. Outlook can still bring them back for a while with Recover deleted items.",
  "mail.junkNotice":
    "This mail is in Junk Email. Links do not work here and pictures stay off; each link shows where it leads. If it is not junk, move it back to the Inbox.",
  "mail.groupConversations": "Group conversations",
  "mail.viewListPreview": "Show preview text",
  "mail.keepUnread": "Keep unread",
  "mail.previousMessage": "Previous mail",
  "mail.nextMessage": "Next mail",
  "mail.tasksPanelTitle": "Tasks",
  "mail.tasksPanelResizeHint": "Drag the edge to make the tasks wider or narrower — double-click for the default",
  "mail.tasksPanelToggle": "Tasks",
  "mail.tasksPanelToggleHint": "Show your tasks beside the mail",
  "mail.tasksPanelScope": "Whose",
  "mail.tasksPanelMine": "My tasks",
  "mail.tasksPanelArrange": "Arrange by: follow-up date",
  "mail.tasksPanelOrderHint": "Reverse the order",
  "mail.tasksPanelEarliestFirst": "Earliest first",
  "mail.tasksPanelLatestFirst": "Latest first",
  "mail.tasksPanelNew": "Type a new task",
  "mail.tasksPanelNewHintMine": "Type a title and press Enter: a task of your own, without a follow-up date",
  "mail.tasksPanelNewHintMailbox": "Type a title and press Enter: a task in this mailbox, without a follow-up date",
  "mail.tasksPanelComplete": "Mark complete",
  "mail.tasksPanelCompleted": "Completed: {{title}}",
  "mail.tasksPanelSentForReview": "Back for review with whoever handed it on: {{title}}",
  "mail.tasksPanelUndo": "Undo",
  "mail.tasksPanelEmpty": "No open tasks.",
  "mail.tasksPanelMore": "There are more tasks — see them in Tasks",
  "mail.tasksPanelError": "The tasks could not be loaded.",
  "mail.viewMenu": "View",
  "mail.viewMenuHint": "How the mail screen looks — reading pane, list, composing",
  "mail.viewPaneLabel": "Reading pane",
  "mail.viewPaneRight": "Right of the list",
  "mail.viewPaneBottom": "Below the list",
  "mail.viewPaneOff": "Off — mail fills the screen",
  "mail.viewListLabel": "List",
  "mail.viewComposeLabel": "Compose",
  "mail.viewComposeWindow": "New mail in a separate window",
  "mail.viewComposeWindowHint": "A new mail opens in a window of its own, to drag to the other screen; after that it opens where it stood last time",
  "mail.viewReset": "Restore the default view",
  "mail.viewResizeHint": "Drag to change the split — double-click for the default",
  "mail.assistantResizeHint": "Drag to make the AI panel wider or narrower — double-click for the default",
  "mail.keepUnreadHint": "Don't auto-mark a mail as read on open (useful while triaging). Shortcuts: J next, K previous.",
  "mail.groupHint": "Merge messages in the same conversation (per loaded page)",
  "mail.threadCount": "{{count}} messages in this conversation",
  "mail.toggleThread": "Expand/collapse conversation",
  "mail.messageGone": "This message has been moved or deleted.",
  "mail.createTaskTitle": "Create a task from this mail",
  "mail.taskAlreadyExisted": "There already was a task for this mail: {{number}}. No new task was made; what you filled in was not used.",
  "mail.addToTaskTitle": "Add mail to a task",
  "mail.addToTaskDesc": "Pick the task this mail should be added to — useful when the conversation got a new subject.",
  "mail.addToTaskMailboxGroup": "Tasks in {{name}}",
  "mail.addToTaskPersonalGroup": "My personal tasks",
  "mail.noActiveTasks": "No open tasks in this mailbox.",
  "tasks.colNumber": "Number",
  "tasks.colPriority": "Prio",
  "tasks.colCategory": "Category",
  "tasks.filterByPriority": "Filter by priority",
  "tasks.allPriorities": "All priorities",
  "tasks.priorityLabel": "Priority",
  "tasks.priorityP1": "P1 — Critical",
  "tasks.priorityP2": "P2 — High",
  "tasks.priorityP3": "P3 — Normal",
  "tasks.priorityP4": "P4 — Low",
  "tasks.priorityP5": "P5 — Very low",
  "tasks.filterByCategory": "Filter by category",
  "tasks.allCategories": "All categories",
  "tasks.categoryLabel": "Category",
  "tasks.categoryNone": "No category",
  "tasks.manageCategories": "Manage categories",
  "tasks.assignedToLabel": "Escalated to {{name}}",
  "tasks.escalateButton": "Escalate",
  "tasks.escalateTitle": "Escalate task",
  "tasks.escalateDesc":
    "Hand the task over to a colleague who can help. They become the assignee and can see the task, even without being a member of the mailbox.",
  "tasks.escalateToLabel": "Escalate to",
  "tasks.escalateToPlaceholder": "Choose a colleague…",
  "tasks.escalateSuggestLabel": "Previously handled this customer",
  "tasks.escalateSuggestHint": "Handled {{count}} earlier task from this customer",
  "tasks.escalateSearchPlaceholder": "Search for a colleague…",
  "tasks.escalateChange": "Change",
  "tasks.escalateNone": "Don't hand over",
  "tasks.escalateNoMatch": "No colleague found.",
  "tasks.escalateNoteLabel": "Note",
  "tasks.escalateNotePlaceholder": "Why are you escalating this task?",
  "tasks.escalateNoteHelp": "Required — the note is added to the task timeline.",
  "tasks.escalateSubmit": "Escalate",
  "tasks.activityEscalated": "Escalated to {{to}}",
  "tasks.colOrder": "Order",
  "tasks.withOrder": "On an order",
  "tasks.orderLabel": "Order",
  "tasks.orderUnlink": "Unlink",
  "tasks.orderPickPlaceholder": "Order number, reference or customer",
  "tasks.orderPickNone": "No order found",
  "tasks.scopeHelpOrder": "Personal on an order: everyone who can open the order sees the task.",
  "tasks.scopePersonalOrder": "Personal (on the order)",
  "tasks.assigneeMyself": "Myself",
  "tasks.assigneeOrderHelp": "Your colleague gets it at once. When they finish it, it comes back to you to check.",
  "tasks.activityMadeFor": "Made for {{to}}",
  "tasks.mergeButton": "Merge",
  "tasks.mergeHelp": "Merge this task with a duplicate task",
  "tasks.mergeTitle": "Merge task",
  "tasks.mergeDesc":
    "Merge this task ({{task}}) into another task. Its e-mails and internal comments move to that task; this task stays behind as a reference.",
  "tasks.mergeSearchLabel": "Target task (this one survives)",
  "tasks.mergeSearchPlaceholder": "Search by number or title…",
  "tasks.mergeSearchHint": "Type at least 2 characters to find a task.",
  "tasks.mergeNoResults": "No tasks found.",
  "tasks.mergeConfirm":
    "{{source}} will be merged into {{target}}. The e-mails and comments move to {{target}}; {{source}} stays behind as a reference.",
  "tasks.mergeSubmit": "Merge",
  "tasks.mergedBanner": "This task has been merged into {{number}}.",
  "tasks.mergedBannerLink": "Go to the merged task",
  "tasks.mergedFromLabel": "Merged from:",
  "tasks.openTaskFallback": "task",
  "tasks.catNew": "New category",
  "tasks.catNewTitle": "Add category",
  "tasks.catColName": "Name",
  "tasks.catColList": "List",
  "tasks.catListLabel": "Which list?",
  "tasks.catListPersonal": "My categories",
  "tasks.catListShared": "Shared mailbox",
  "tasks.catListHelp":
    "Your own categories are yours alone. A shared mailbox's categories belong to all its members. They cannot be moved afterwards — tasks already carrying one would be stranded.",
  "tasks.catColSortOrder": "Order",
  "tasks.catColStatus": "Status",
  "tasks.catEmpty": "No categories yet. Add the first one.",
  "tasks.catNameLabel": "Name",
  "tasks.catNamePlaceholder": "e.g. Invoicing",
  "tasks.catSortOrderLabel": "Order",
  "tasks.catSortOrderHelp": "Lower numbers appear first in the pickers.",
  "tasks.catCreateButton": "Add category",

  // Weekday abbreviations (Monday-first)
  "weekdays.0": "Mon",
  "weekdays.1": "Tue",
  "weekdays.2": "Wed",
  "weekdays.3": "Thu",
  "weekdays.4": "Fri",
  "weekdays.5": "Sat",
  "weekdays.6": "Sun",
  // Warehouse — Plekken, Artikelen, Instellingen (docs/design_handoff_wms/README.md §4)
  "nav.warehouseWork": "Work",
  "nav.warehouseCrossdock": "Crossdock",
  "nav.warehouseStock": "Stock",
  "nav.warehouseInbound": "Receipts",
  "nav.warehouseReplenishment": "Replenish",
  "nav.warehouseOutbound": "Orders",
  "nav.warehouseLocations": "Storage locations",
  "nav.warehouseArticles": "Articles",
  "nav.warehouseVas": "VAS",
  "vasCodes.count": "{{count}} of {{total}} codes",
  "vasCodes.empty": "No VAS codes match the filters",
  "vasCodes.col.code": "Code",
  "vasCodes.col.description": "Description",
  "vasCodes.col.moment": "Moment",
  "vasCodes.col.scanner": "On scanner",
  "vasCodes.col.customerList": "Customer list",
  "vasCodes.col.appliesTo": "On an order",
  "vasCodes.col.atOrderEntry": "In the portal",
  "vasCodes.appliesTo.header": "Whole order",
  "vasCodes.appliesTo.article": "Line",
  "vasCodes.appliesTo.both": "Order or line",
  "vasCodes.appliesTo.none": "Not on an order",
  "vasCodes.atOrderEntryTick": "{{code}} can be chosen in the portal",
  "vasCodes.col.handling": "Handling",
  "vasCodes.col.registration": "Record",
  "vasCodes.col.breaksPallet": "Break pallet",
  "vasCodes.col.fullPalletsOnly": "One batch per pallet",
  "vasCodes.col.state": "State",
  "vasCodes.moment.startRide": "Before the trip",
  "vasCodes.moment.startOrder": "Before loading",
  "vasCodes.moment.pickAmount": "When picking",
  "vasCodes.moment.toStack": "When stacking",
  "vasCodes.moment.newBatch": "On a new batch",
  "vasCodes.moment.finishOrder": "After loading",
  "vasCodes.moment.orderReady": "When reporting done",
  "vasCodes.handling.instruction": "Instruction only",
  "vasCodes.handling.restack": "Restack",
  "vasCodes.handling.tilt": "Tilt",
  "vasCodes.handling.step": "Own step",
  "vasCodes.handlingHelp.instruction": "Text for the picker or loader. After picking the order goes to Picked as usual.",
  "vasCodes.handlingHelp.restack": "After picking to Ready for VAS; the goods go onto new pallets, up to the load quantity on the customer's pallet type.",
  "vasCodes.handlingHelp.tilt": "After picking to Ready for VAS; the goods go onto new pallets, from block to block.",
  "vasCodes.handlingHelp.step": "After picking to Ready for VAS; started and reported done on the scanner.",
  "vasCodes.registration.none": "Nothing",
  "vasCodes.registration.seal": "Seal number",
  "vasCodes.registration.container_number": "Container number",
  "vasCodes.registration.trailer_plate": "Trailer plate",
  "vasCodes.registration.truck_plate": "Truck plate",
  "vasCodes.registration.transport_reference": "Transport reference",
  "vasCodes.registration.amount": "Quantity",
  "vasCodes.level.pallet": "per pallet",
  "vasCodes.level.order": "per order",
  "vasCodes.levelLabel": "Per pallet or per order",
  "vasCodes.levelChoose": "Choose…",
  "vasCodes.registrationHelp": "What the floor records with this code, such as a seal on every pallet or the trailer's plate.",
  "vasCodes.state.used": "In use",
  "vasCodes.state.retired": "Do not use",
  "vasCodes.state.gone": "No longer in the list",
  "vasCodes.breaksPalletLabel": "May break a pallet that otherwise stays whole",
  "vasCodes.breaksPalletHelp": "For a sample: a line with this code takes bags or boxes off a pallet that otherwise leaves whole.",
  "vasCodes.fullPalletsOnlyLabel": "One batch per pallet: no pallets with more batches",
  "vasCodes.fullPalletsOnlyHelp": "As I032: for an order or line with this code the parts on the collecting pallet come from one batch, so no rest pallet of another batch goes on it: full pallets, and a part of one batch for what is left. A pallet with more batches never goes whole. Who orders less than a full pallet simply gets less.",
  "vasCodes.retiredLabel": "Do not use",
  "vasCodes.retiredHelp": "An old or test code: not on the scanner, no Groot VAS and not in the download for customers.",
  "vasCodes.editTitle": "VAS code {{code}}",
  "nav.warehouseConfirmations": "Confirmations",
  "confirmations.direction.inbound": "Inbound",
  "confirmations.direction.outbound": "Outbound",
  "confirmations.state.waiting_document": "Waiting for freight document",
  "confirmations.state.deviation": "Deviation",
  "confirmations.state.queued": "On its way",
  "confirmations.state.sent": "Sent",
  "confirmations.state.failed": "Not sent",
  "confirmations.deviation.manco": "Short",
  "confirmations.deviation.blocked": "Blocked",
  "confirmations.deviation.both": "Short and blocked",
  "confirmations.deviation.none": "None",
  "confirmations.error.not_wanted": "The customer no longer wants a confirmation (Communication on the relation card)",
  "confirmations.error.too_large": "The scan and the photo together are too large for one mail",
  "confirmations.col.direction": "Direction",
  "confirmations.col.party": "Customer",
  "confirmations.col.documentNumber": "Document number",
  "confirmations.col.reference": "Reference",
  "confirmations.col.readyAt": "Done",
  "confirmations.col.state": "State",
  "confirmations.col.deviation": "Deviation",
  "confirmations.col.freightDocument": "Freight document",
  "confirmations.col.dossier": "Dossier",
  "confirmations.col.remark": "Remark",
  "confirmations.col.sent": "Sent",
  "confirmations.owner": "Owner {{owner}}",
  "confirmations.requested": "Document requested {{at}}",
  "confirmations.approve": "Approve deviation",
  "confirmations.withoutDocument": "Send without freight document",
  "confirmations.withoutDocumentBy": "Without freight document ({{name}})",
  "confirmations.photo": "Photo of the deviation",
  "confirmations.noDossier": "No dossier in WLX",
  "confirmations.approvedBy": "Approved: {{name}}, {{at}}",
  "confirmations.searchPlaceholder": "Search by document number, customer or dossier",
  "confirmations.viewLabel": "View",
  "confirmations.view.open": "Open",
  "confirmations.view.sent": "Sent (14 days)",
  "confirmations.view.all": "All",
  "confirmations.count": "{{count}} of {{total}}",
  "confirmations.emptyOpen": "Nothing waits: every confirmation went.",
  "confirmations.empty": "No confirmations.",
  "confirmations.approveTitle": "Approve deviation — {{number}}",
  "confirmations.approveSubmit": "Approve and send",
  "confirmations.approveIntro": "{{party}} gets the inbound confirmation with the deviation ({{deviation}}). The remark is in bold in the mail.",
  "confirmations.remarkLabel": "Remark for the customer",
  "confirmations.remarkHelp": "For example: 2 pallets fewer received, agreed with the customer.",
  "confirmations.photoLabel": "Photo (optional)",
  "confirmations.photoHelp": "A jpg, png or pdf. It goes into the dossier and with the mail.",
  "confirmations.photoNoDossier": "This order has no dossier in WLX, so a photo cannot be added.",
  "confirmations.withoutDocumentTitle": "Send without freight document — {{number}}",
  "confirmations.withoutDocumentSubmit": "Send",
  "confirmations.withoutDocumentIntro": "{{party}} gets the confirmation without the scanned freight document. If the scan comes later, it does not go with it.",
  "parties.purposeWarehouseOutRequest": "Document request, dispatch",
  "parties.waitForDocument": "Waits for the freight document",
  "parties.waitForDocumentLabel": "{{purpose}}: waits for the scanned freight document",
  "nav.warehouseSettings": "Settings",
  "nav.warehouseScannerUsers": "Scanner users",
  "perm.modWmsScanner": "Use the scanner",
  "perm.modWmsScannerLogins": "Manage scanner users",
  "perm.modPartnerUsers": "Manage portal users",
  "scannerLogins.intro": "Who signs in on the scanner without Entra: the warehouse floor. A new employee gets a temporary password and chooses their own at the first sign-in. Password forgotten? Give a new temporary password; every scanner still signed in with the old one stops.",
  "scannerLogins.new": "New scanner user",
  "scannerLogins.newTitle": "New scanner user",
  "scannerLogins.newExplain": "For an employee without Entra. WLX makes a temporary password and shows it once.",
  "scannerLogins.kindLabel": "For whom",
  "scannerLogins.kind.new": "New employee",
  "scannerLogins.kind.existing": "Existing user (with Entra)",
  "scannerLogins.existingExplain": "For somebody who is in WLX already, like a team leader or admin who scans too: the same person, with a user name and password for the scanner. WLX makes a temporary password and shows it once.",
  "scannerLogins.searchPerson": "Who",
  "scannerLogins.searchPersonHint": "Search by name or e-mail",
  "scannerLogins.noPerson": "Nobody found, or they have a scanner login already.",
  "scannerLogins.otherPerson": "Somebody else",
  "scannerLogins.rolesAdd": "Add a role",
  "scannerLogins.rolesAddHint": "Only needed when their own role does not allow the scanner.",
  "scannerLogins.create": "Create",
  "scannerLogins.colName": "Name",
  "scannerLogins.colUsername": "User name",
  "scannerLogins.colRoles": "Roles",
  "scannerLogins.colStatus": "Status",
  "scannerLogins.colLastLogin": "Last signed in",
  "scannerLogins.colActions": "Actions",
  "scannerLogins.usernameHint": "Lower case letters, digits and . _ - — short, it is typed with gloves (the personnel number, for instance).",
  "scannerLogins.noRoles": "No role may use the scanner. First give a role the right Use the scanner (Beheer → Rechten).",
  "scannerLogins.status.active": "Active",
  "scannerLogins.status.waiting": "Waiting for own password",
  "scannerLogins.status.locked": "Locked",
  "scannerLogins.status.off": "Off",
  "scannerLogins.alsoEntra": "Entra too",
  "scannerLogins.adminOnly": "An admin only",
  "scannerLogins.unlock": "Unlock",
  "scannerLogins.reset": "Temporary password",
  "scannerLogins.turnOff": "Turn off",
  "scannerLogins.turnOn": "Turn on",
  "scannerLogins.empty": "No scanner users yet.",
  "scannerLogins.temporaryPassword": "Temporary password",
  "scannerLogins.createdTitle": "{{name}} can sign in",
  "scannerLogins.resetTitle": "New temporary password for {{name}}",
  "scannerLogins.createdExplain": "Pass this on to the employee. At the first sign-in on the scanner they choose a password of their own. WLX does not show this password again.",
  "scannerLogins.resetExplain": "Pass this on to the employee. Every scanner still signed in with the old password is now signed out; at the sign-in the employee chooses a password of their own. WLX does not show this password again.",
  "scannerLogins.done": "Done",
  "portal.intro": "These people see the shipments of {{party}} and enter orders.",
  "portal.mailOff": "Portal mail is not on yet (PARTNER_MAIL_SENDER and PARTNER_PORTAL_BASE_URL). Inviting works once they are set.",
  "portal.mailOffLocal": "Portal mail is off. Locally WLX shows the link here instead of mailing it.",
  "portal.invite": "Invite",
  "portal.inviteTitle": "Invite someone for {{party}}",
  "portal.inviteExplain": "They get a mail with a link that works once, for seven days. With it they choose a password and link an authenticator app.",
  "portal.emailInvalid": "This is not a valid e-mail address",
  "portal.colName": "Name",
  "portal.colEmail": "E-mail address",
  "portal.colLanguage": "Language",
  "portal.colStatus": "Status",
  "portal.colLastLogin": "Last signed in",
  "portal.colInvited": "Invited",
  "portal.colOtherParties": "Also for",
  "portal.colActions": "Actions",
  "portal.language.nl": "Dutch",
  "portal.language.en": "English",
  "portal.language.de": "German",
  "portal.status.active": "Active",
  "portal.status.invited": "Invited",
  "portal.status.expired": "Invitation expired",
  "portal.status.locked": "Locked",
  "portal.status.disabled": "Turned off",
  "portal.invitedBy": "by {{name}}",
  "portal.reinvite": "Invite again",
  "portal.reset": "Set up access again",
  "portal.unlock": "Unlock",
  "portal.turnOff": "Turn off",
  "portal.turnOn": "Turn on",
  "portal.empty": "Nobody of this relation on the customer portal yet.",
  "portal.resetTitle": "Set up access of {{name}} again?",
  "portal.resetExplain": "The password, the link with the app and the recovery codes stop working, and {{name}} is signed out everywhere. A new invitation goes to {{email}}. Do this for a new phone, or when the password is forgotten and the phone is gone as well.",
  "portal.resetConfirm": "Set up again",
  "portal.unlinkTitle": "Unlink {{name}} from {{party}}?",
  "portal.unlinkExplain": "{{name}} no longer sees this relation on the customer portal.",
  "portal.unlinkLast": "It is the only relation of {{name}}, so the account is turned off as well.",
  "portal.unlinkConfirm": "Unlink",
  "portal.sentTitle": "Invitation sent",
  "portal.notSentTitle": "Invitation not sent",
  "portal.localTitle": "Link ready",
  "portal.localExplain": "Locally no mail goes out. With the link below {{name}} sets up the account; it works until {{until}}.",
  "portal.sentExplain": "{{name}} gets a mail at {{email}}. The link works until {{until}}.",
  "portal.notSent": "The mail was not sent. The account is there: try again later with Invite again.",
  "portal.localLink": "Locally, without mail: the link to set up the account",
  "portal.copy": "Copy",
  "portal.copied": "Copied",
  "portal.linkedTitle": "Linked",
  "portal.linkedExplain": "{{name}} was on the customer portal already and now works for this relation as well. No new invitation goes out.",
  "portal.done": "Done",
  "portal.introTitle": "Access to the customer portal",
  "portal.inviteMore": "Several at once",
  "portal.inviteSend": "Send invitation",
  "portal.languageLabel": "Language of the mail and the portal",
  "portal.emailHelp": "Is this address on another relation already, then it is the same person: we link them, and they choose after signing in which company they work for. No new invitation goes out then.",
  "portal.status.lockedUntil": "Locked until {{time}}",
  "portal.status.invitedUntil": "Invited · link until {{date}}",
  "portal.never": "never",
  "portal.menu": "Actions for {{name}}",
  "portal.resetHint": "Password, app and recovery codes stop working, every session ends. {{name}} gets a new invitation.",
  "portal.notLocked": "not locked",
  "portal.stock": "Stock in the portal",
  "portal.stockNoOwner": "This customer has no WMS identifier yet (System identifiers on the tab General): the portal then shows no stock.",
  "portal.stockOwners_one": "The portal asks the warehouse for the stock of owner {{owners}} the moment the customer looks.",
  "portal.stockOwners_other": "The portal asks the warehouse for the stock of the owners {{owners}} the moment the customer looks.",
  "portal.unlinkFrom": "Unlink from {{party}}",
  "portal.changedNote": "What a customer does themself (changing the password, linking a phone) does not count in Last changed.",
  "portal.carriers": "Own carriers",
  "portal.carriersNone": "none: the customer picks from the fixed list (Euro pallet, Block pallet, IBC, Roll container, …).",
  "portal.carriersAsShort": "{{name}} as {{carrier}}",
  "portal.carriersManage": "Manage",
  "portal.carriersTitle": "Own carriers of {{party}}",
  "portal.carriersExplain": "The customer sees these carriers first when entering an order, the fixed list below them. Each carrier counts as the fixed carrier beside it: that sets the loading metres and the pallet places. The name goes into the consignment's description, so planning and the CMR see which carrier it is. Removing or renaming a carrier changes nothing on orders already sent.",
  "portal.carriersName": "Name",
  "portal.carriersAs": "Counts as",
  "portal.carriersAdd": "Add carrier",
  "portal.carriersRemove": "Remove {{name}}",
  "portal.carriersSave": "Save",
  "portal.carriersDuplicate": "Each carrier has a name of its own.",
  "portal.carriersChanged": "Last changed {{date}}",
  "portal.carriersChangedBy": "Last changed {{date}} by {{name}}",
  "portal.carrierAs.europallet": "Euro pallet (0.4 lm)",
  "portal.carrierAs.block_pallet": "Block pallet (0.5 lm)",
  "portal.carrierAs.block_pallet_06": "Block pallet (0.6 lm)",
  "portal.carrierAs.block_pallet_09": "Block pallet (0.9 lm)",
  "portal.carrierAs.ibc_02": "IBC (0.2 lm)",
  "portal.carrierAs.ibc_04": "IBC (0.4 lm)",
  "portal.carrierAs.ibc": "IBC (0.5 lm)",
  "portal.carrierAs.ibc_06": "IBC (0.6 lm)",
  "portal.carrierAs.big_bag": "Big bag (0.5 lm)",
  "portal.carrierAs.roll_container": "Roll container (loading metres typed)",
  "portal.carrierAs.box": "Packages or boxes (loading metres typed)",
  "portal.carrierAs.other": "Other (loading metres typed)",
  "portal.batch.title": "Invite for {{party}}",
  "portal.batch.explain": "Paste the people who work for this customer in the TALIX Portal now, or add them one by one. Untick who should not come along, and check the language. WLX does not keep the list: only who you send to gets an account.",
  "portal.batch.tickAll": "Tick or untick all",
  "portal.batch.colLastTalix": "Last in TALIX",
  "portal.batch.remove": "Remove",
  "portal.batch.addPerson": "Add someone",
  "portal.batch.pasteOpen": "Or paste a list",
  "portal.batch.pasteLabel": "Paste a list: name; e-mail; language; last signed in",
  "portal.batch.pastePlaceholder": "{{code}}; Marieke de Wit; m.dewit@customer.nl; NL; 17-11-2026",
  "portal.batch.pasteHelp": "From Excel or with semicolons, in any order. A column with the customer's code may come along: lines of a customer other than {{code}} are left out.",
  "portal.batch.take": "Take over",
  "portal.batch.taken_one": "{{count}} person taken over",
  "portal.batch.taken_other": "{{count}} people taken over",
  "portal.batch.otherCustomer_one": "{{count}} line of another customer skipped",
  "portal.batch.otherCustomer_other": "{{count}} lines of other customers skipped",
  "portal.batch.unreadable_one": "{{count}} line without an e-mail address",
  "portal.batch.unreadable_other": "{{count}} lines without an e-mail address",
  "portal.batch.invitations_one": "{{count}} new invitation",
  "portal.batch.invitations_other": "{{count}} new invitations",
  "portal.batch.links_one": "{{count}} link",
  "portal.batch.links_other": "{{count}} links",
  "portal.batch.send_one": "Send {{count}}",
  "portal.batch.send_other": "Send {{count}}",
  "portal.batch.why.invalidEmail": "not a valid e-mail address",
  "portal.batch.why.invalidName": "the name is missing",
  "portal.batch.why.duplicate": "is in the list twice",
  "portal.batch.why.onRelation": "is on the portal for this customer already",
  "portal.batch.why.willems": "an address of Willems itself",
  "portal.batch.why.stale": "not signed in on the TALIX Portal for a long time",
  "portal.batch.why.linked_one": "has access to {{count}} relation already: will be linked",
  "portal.batch.why.linked_other": "has access to {{count}} relations already: will be linked",
  "portal.batch.colOutcome": "Outcome",
  "portal.batch.outcome.invited": "Invited",
  "portal.batch.outcome.linked": "Linked",
  "portal.batch.outcome.exists": "Was there already",
  "portal.batch.outcome.failed": "Did not work",
  "portal.batch.reasonError": "something went wrong",
  "portal.batch.notMailed": "The mail did not go out: try again later with Invite again.",
  "portal.batch.until": "link until {{until}}",
  "portal.batch.done.invited_one": "{{count}} invited",
  "portal.batch.done.invited_other": "{{count}} invited",
  "portal.batch.done.linked_one": "{{count}} linked",
  "portal.batch.done.linked_other": "{{count}} linked",
  "portal.batch.done.exists_one": "{{count}} was there already",
  "portal.batch.done.exists_other": "{{count}} were there already",
  "portal.batch.done.failed_one": "{{count}} did not work",
  "portal.batch.done.failed_other": "{{count}} did not work",
  "transition.stand.not_invited": "Not invited yet",
  "transition.stand.invited": "Invited",
  "transition.stand.over": "Over",
  "transition.stand.done": "Done",
  "transition.segment.all": "All",
  "transition.segment.not_invited": "Not yet",
  "transition.segment.invited": "Invited",
  "transition.segment.over": "Over",
  "transition.segment.done": "Done",
  "transition.colCustomer": "Customer",
  "transition.colWeek": "Week",
  "transition.colPilot": "Pilot",
  "transition.colStand": "Stand",
  "transition.colInvited": "Invited",
  "transition.colLoggedIn": "Signed in",
  "transition.colLastLogin": "Last signed in",
  "transition.colOrdersTalix": "Orders via TALIX",
  "transition.colOrdersPortal": "Orders in portal",
  "transition.colCutoff": "Cut-off time",
  "transition.colStock": "Stock",
  "transition.colTalixClosed": "TALIX closed",
  "transition.colNote": "Note",
  "transition.week": "wk {{week}}",
  "transition.pilot": "pilot",
  "transition.expired_one": "{{count}} link expired",
  "transition.expired_other": "{{count}} links expired",
  "transition.search": "Find a customer",
  "transition.rowsOf": "{{shown}} of {{total}}",
  "transition.add": "Add customers",
  "transition.empty": "No customers on the list yet. Add them by their code.",
  "transition.noneFound": "No customers with this filter.",
  "transition.invite": "Invite",
  "transition.invitePeople": "Invite people",
  "transition.menu": "Actions for {{name}}",
  "transition.edit": "Week, pilot and note",
  "transition.markDone": "Done: TALIX closed",
  "transition.reopen": "Open again: TALIX not closed yet",
  "transition.remove": "Take off the list",
  "transition.removeTitle": "Take {{name}} off the list?",
  "transition.removeExplain": "{{name}} is then no longer on the transition list. The people on the portal keep their accounts.",
  "transition.removeConfirm": "Take off the list",
  "transition.ordersNote": "Orders: the last {{days}} days, through the bridge from the TALIX Portal or entered in the portal. Over: somebody of the customer signed in. Done: the access to the TALIX Portal is closed.",
  "transition.addTitle": "Add customers",
  "transition.addCodes": "The customers' codes",
  "transition.addCodesHelp": "One code per line, the VR number. What follows it does not count, so a column from Excel will do.",
  "transition.addSubmit_one": "Add {{count}}",
  "transition.addSubmit_other": "Add {{count}}",
  "transition.pilotLabel": "Pilot",
  "transition.addOutcome.added_one": "{{count}} customer added",
  "transition.addOutcome.added_other": "{{count}} customers added",
  "transition.addOutcome.already_one": "{{count}} was there already",
  "transition.addOutcome.already_other": "{{count}} were there already",
  "transition.addOutcome.unknown_one": "{{count}} code unknown",
  "transition.addOutcome.unknown_other": "{{count}} codes unknown",
  "transition.addOutcome.not_customer_one": "{{count}} is not a sales relation",
  "transition.addOutcome.not_customer_other": "{{count}} are not a sales relation",
  "transition.addOutcome.inactive_one": "{{count}} is not active",
  "transition.addOutcome.inactive_other": "{{count}} are not active",
  "transition.editTitle": "Change {{name}}",
  "transition.doneTitle": "Mark {{name}} done",
  "transition.doneExplain": "First close the access of {{name}} to the TALIX Portal in TALIX. Then fill in the day: the customer is Done after that.",
  "transition.doneConfirm": "Mark done",
  "transition.closedHelp": "The day the access to the TALIX Portal was closed. Empty: still open.",
  "warehouse.kind.receiving": "Receiving",
  "warehouse.kind.bulk": "Bulk",
  "warehouse.kind.floor": "Floor",
  "warehouse.kind.pick": "Pick",
  "warehouse.kind.pallet": "Pallet location",
  "warehouse.kind.staging": "Staging",
  "warehouse.kind.dock": "Dock",
  "warehouse.kind.lost_found": "Lost & found",
  "warehouse.kind.damaged": "Damaged",
  "warehouse.kind.inspection": "Inspection",
  "warehouse.kind.replenishment": "Replenishment",
  "warehouse.property.cooled": "Cooled",
  "warehouse.property.frozen": "Frozen",
  "warehouse.property.hazardous": "Hazardous goods",
  "warehouse.property.dry": "Dry",
  "warehouse.blockReason.damaged": "Damaged",
  "warehouse.blockReason.quality": "Quality",
  "warehouse.blockReason.customer": "At the customer's request",
  "warehouse.blockReason.count_difference": "Count difference",
  "warehouse.blockReason.question": "Open question",
  "warehouse.blockReason.other": "Other",
  "warehouse.status.free": "Free",
  "warehouse.status.occupied": "Occupied",
  "warehouse.status.blocked": "Blocked",
  "warehouse.status.lostFound": "Lost & found",
  "warehouse.status.outOfUse": "Out of use",
  "warehouse.uom.PCE_one": "piece",
  "warehouse.uom.PCE_other": "pieces",
  "warehouse.uom.CT_one": "carton",
  "warehouse.uom.CT_other": "cartons",
  "warehouse.uom.BG_one": "bag",
  "warehouse.uom.BG_other": "bags",
  "warehouse.uom.PF_one": "pallet",
  "warehouse.uom.PF_other": "pallets",
  "warehouse.uom.KGM_one": "kilo",
  "warehouse.uom.KGM_other": "kilos",
  "warehouse.uom.other_one": "unit",
  "warehouse.uom.other_other": "units",
  "warehouse.level.cu": "CU · base unit",
  "warehouse.level.tu": "TU · trade unit",
  "warehouse.level.du": "DU · pallet",
  "warehouse.unitField.name": "name",
  "warehouse.unitField.unitOfMeasure": "unit of measure",
  "warehouse.unitField.quantityOfChild": "contains",
  "warehouse.unitField.gtin": "GTIN",
  "warehouse.unitField.netWeightKg": "net weight",
  "warehouse.unitField.grossWeightKg": "gross weight",
  "warehouse.unitField.lengthCm": "length",
  "warehouse.unitField.widthCm": "width",
  "warehouse.unitField.heightCm": "height",
  "warehouse.unitField.volumeM3": "volume",
  "warehouse.unitField.perLayer": "per layer",
  "warehouse.unitField.splittable": "splittable",
  "warehouse.setting.pickMode": "Picking",
  "warehouse.setting.pickModeHint": "Who chooses the pallets?",
  "warehouse.setting.batchPicking": "Batch picking",
  "warehouse.setting.batchPickingHint": "Several orders in one round",
  "warehouse.setting.stackPicking": "Stacking",
  "warehouse.setting.stackPickingHint": "Pallets onto a collecting carrier",
  "warehouse.setting.mergePartials": "Merge part pallets",
  "warehouse.setting.mergePartialsHint": "Remainders onto one pallet",
  "warehouse.setting.oneBatchPerPallet": "One batch per pallet",
  "warehouse.setting.oneBatchPerPalletHint": "No mixed batches on a pallet",
  "warehouse.setting.pickByLocationScan": "Pick from the location",
  "warehouse.setting.pickByLocationScanHint": "Scan the location instead of the pallet",
  "warehouse.setting.replenishMode": "Replenishing",
  "warehouse.setting.replenishModeHint": "How the pick location is filled again",
  "warehouse.setting.outboundDay": "Orders per week by",
  "warehouse.setting.outboundDayHint": "Which date sets the week in Orders",
  "warehouse.setting.receiveOnStaging": "Receive onto expedition place",
  "warehouse.setting.receiveOnStagingHint": "Every pallet that comes in is scanned onto an expedition place",
  "warehouse.setting.loadAfterActivation": "Load after activating",
  "warehouse.setting.loadAfterActivationHint": "An order is loaded only once it is activated",
  "warehouse.setting.shadowMode": "Shadow",
  "warehouse.setting.shadowModeHint": "Scoretrace leads and the floor scans in both systems",
  "warehouse.setting.receiptQuestions": "Questions at receipt",
  "warehouse.setting.receiptQuestionsHint": "Checks per warehouse, added to per customer",
  "warehouse.settingOn": "On",
  "warehouse.settingOff": "Off",
  "warehouse.settingValue.pickMode.reserve": "Reserve",
  "warehouse.settingValue.pickMode.free": "Free",
  "warehouse.settingValue.mergePartials.none": "No",
  "warehouse.settingValue.mergePartials.same_batch": "Same batch",
  "warehouse.settingValue.mergePartials.mixed_batches": "Mixed batches too",
  "warehouse.settingValue.replenishMode.replace": "Replace",
  "warehouse.settingValue.replenishMode.top_up": "Top up",
  "warehouse.settingValue.outboundDay.load": "Load day",
  "warehouse.settingValue.outboundDay.delivery": "Delivery day",
  "warehouse.settingEffect.pickMode.reserve": "The system chooses when the order is released; the picker scans what is asked for.",
  "warehouse.settingEffect.pickMode.free": "The picker chooses a pallet that meets the order; the system checks the scan.",
  "warehouse.settingEffect.batchPicking.true": "Orders are picked together in one round.",
  "warehouse.settingEffect.batchPicking.false": "Each order is picked on its own.",
  "warehouse.settingEffect.stackPicking.true": "The scanner asks for the collecting carrier after each pallet.",
  "warehouse.settingEffect.stackPicking.false": "Each pallet goes to staging on its own.",
  "warehouse.settingEffect.mergePartials.none": "Part pallets stay as they are.",
  "warehouse.settingEffect.mergePartials.same_batch": "Part pallets of the same batch are merged into a full pallet.",
  "warehouse.settingEffect.mergePartials.mixed_batches": "Part pallets are merged, different batches included.",
  "warehouse.settingEffect.oneBatchPerPallet.true": "A second batch on the same pallet is refused on the scanner.",
  "warehouse.settingEffect.oneBatchPerPallet.false": "Batches may share a pick pallet.",
  "warehouse.setting.deliveredCheck": "Best-before check per receiver",
  "warehouse.setting.deliveredCheckHint": "A receiver never gets a shorter best-before than it already had",
  "warehouse.setting.pickReport": "PIC report",
  "warehouse.setting.pickReportHint": "For countries with a COKZ inspection the batches are fixed beforehand and the customer hears them",
  "warehouse.setting.palletTypeAtReceipt": "Change the pallet type at receipt",
  "warehouse.setting.palletTypeAtReceiptHint": "A pallet can come in on another pallet type than its article's",
  "warehouse.settingEffect.deliveredCheck.true": "WLX never ships a shorter best-before of an article than the receiver already had; otherwise the line falls short. When the customer names a batch, it does not count.",
  "warehouse.settingEffect.deliveredCheck.false": "Only the order's minimum best-before counts.",
  "warehouse.settingEffect.pickReport.true": "An order to a country with a COKZ inspection gets fixed batches 5 working days before its load day (Brazil 15); the customer gets the PIC report.",
  "warehouse.settingEffect.pickReport.false": "No PIC report; the floor picks FEFO.",
  "warehouse.settingEffect.palletTypeAtReceipt.true": "The floor can choose another pallet type when receiving.",
  "warehouse.settingEffect.palletTypeAtReceipt.false": "The floor sees the article's pallet type and cannot change it.",
  "warehouse.settingEffect.pickByLocationScan.true": "The picker scans the location instead of the pallet.",
  "warehouse.settingEffect.pickByLocationScan.false": "The picker scans the pallet.",
  "warehouse.settingEffect.replenishMode.replace": "A new pallet goes onto the pick location once the old one is empty.",
  "warehouse.settingEffect.replenishMode.top_up": "The location is topped up with the same batch once it falls below the threshold.",
  "warehouse.settingEffect.outboundDay.load": "Orders shows per day what is picked up that day; the delivery day stands beside it.",
  "warehouse.settingEffect.outboundDay.delivery": "Orders shows per day what must be at the receiver that day; the load day stands beside it.",
  "warehouse.settingEffect.receiveOnStaging.true": "The floor scans every pallet that comes in onto an expedition place (S01 …).",
  "warehouse.settingEffect.receiveOnStaging.false": "A pallet that comes in goes onto the receiving place of the receipt.",
  "warehouse.settingEffect.loadAfterActivation.true": "Loading starts only once the office (or iTV or the portal) activated the order; the scanner confirms the plate or container number.",
  "warehouse.settingEffect.loadAfterActivation.false": "Loading needs no activation; the floor types the plate.",
  "warehouse.settingEffect.shadowMode.true": "Scoretrace leads: every scanner shows the shadow bar and WLX sends the customer nothing.",
  "warehouse.settingEffect.shadowMode.false": "WLX is the warehouse system.",
  "warehouse.addArticle": "Add article",
  "warehouse.addModeLabel": "What to add",
  "warehouse.addModeSeries": "A series",
  "warehouse.addModeSingle": "One location",
  "warehouse.addPlaces": "Add locations",
  "warehouse.addSeriesSubmit_one": "Add {{count}} location",
  "warehouse.addSeriesSubmit_other": "Add {{count}} locations",
  "warehouse.addSingleSubmit": "Add location",
  "warehouse.addTitle": "Add locations in {{warehouse}}",
  "warehouse.addedOne": "{{name}} was added.",
  "warehouse.addedResult_one": "{{count}} location added.",
  "warehouse.addedResult_other": "{{count}} locations added.",
  "warehouse.aisleLabel": "Aisle",
  "warehouse.articleActiveLabel": "In use",
  "warehouse.articleCodeHelp": "As the customer sends it, leading zeros included.",
  "warehouse.articleCodeLabel": "Article code",
  "warehouse.articleCount_one": "{{count}} article",
  "warehouse.articleCount_other": "{{count}} articles",
  "warehouse.articleDescriptionLabel": "Description",
  "warehouse.articleGroupLabel": "Customer's article group",
  "warehouse.articleListLabel": "Articles",
  "warehouse.articleSearch": "Article or code",
  "warehouse.articleShortLabel": "Short description",
  "warehouse.articlesMore": "{{shown}} of {{total}} shown: search to find the rest.",
  "warehouse.articlesNoMatch": "No article found.",
  "warehouse.articlesNone": "This customer has no articles yet.",
  "warehouse.barcodeLabel": "Barcode",
  "warehouse.batchPureAll": "Every level",
  "warehouse.batchPureBottom": "Bottom level only",
  "warehouse.blockAction": "Block…",
  "warehouse.blockExplain": "A blocked location refuses putting away on the scanner. The reason goes into the log.",
  "warehouse.blockReasonLabel": "Reason",
  "warehouse.blockRemarkLabel": "Remark",
  "warehouse.blockSubmit": "Block",
  "warehouse.blockTitle_one": "Block {{count}} location",
  "warehouse.blockTitle_other": "Block {{count}} locations",
  "warehouse.blockedBy": "Blocked on {{when}} by {{who}}",
  "warehouse.blockedResult": "Blocked: {{count}}.",
  "warehouse.blockedResultAlready": "Blocked: {{count}}. Blocked already: {{already}}.",
  "warehouse.blocksNone": "This location has never been blocked.",
  "warehouse.blocksTitle": "Blocks",
  "warehouse.cellHint": "Click to depart from the standard for this customer",
  "warehouse.check.batchAndBestBefore": "Batch and best-before required at receipt",
  "warehouse.check.batchRequired": "Batch required at receipt",
  "warehouse.check.bestBeforeRequired": "Best-before date required at receipt",
  "warehouse.check.minDespatch": "Minimum shelf life at despatch",
  "warehouse.check.minReceipt": "Minimum shelf life at receipt",
  "warehouse.check.palletNumberRequired": "Pallet number required at receipt",
  "warehouse.check.temperature": "Temperature",
  "warehouse.checkSentence.batchAndBestBefore": "From the GS1 label; otherwise the scanner asks for it.",
  "warehouse.checkSentence.minDespatch": "A pallet with a shorter best-before is refused when picking.",
  "warehouse.checkSentence.minReceipt": "A pallet with a shorter best-before is refused at receipt.",
  "warehouse.checkSentence.palletNumber": "The scanner asks for the pallet sequence number at receipt.",
  "warehouse.checkSentence.temperature": "Putting away only on a location with this property.",
  "warehouse.checksSubtitle": "Enforced by the system, on the scanner",
  "warehouse.checksTitle": "Checks",
  "warehouse.chooseOwnerFirst": "Choose a customer at the top right to see its articles.",
  "warehouse.clearSelection": "Clear selection",
  "warehouse.colActions": "Actions",
  "warehouse.colBatchPure": "Batch pure",
  "warehouse.colContains": "Contains",
  "warehouse.colDimensions": "Size (l × w × h)",
  "warehouse.colGtin": "GTIN on label",
  "warehouse.colKind": "Kind",
  "warehouse.colMaxHeight": "Max height",
  "warehouse.colMaxWeight": "Max weight",
  "warehouse.colOwner": "Customer",
  "warehouse.colPlace": "Location",
  "warehouse.colProperties": "Properties",
  "warehouse.colSinglePallet": "Single pallet",
  "warehouse.colSource": "Source",
  "warehouse.colStatus": "Status",
  "warehouse.colUnit": "Pallet",
  "warehouse.colUnitKind": "Kind",
  "warehouse.colUnitName": "Unit",
  "warehouse.colWeight": "Weight",
  "warehouse.days_one": "{{count}} day",
  "warehouse.days_other": "{{count}} days",
  "warehouse.deviating": "{{count}} different",
  "warehouse.deviatingFrom": "{{count}} different from {{name}}",
  "warehouse.duContainsLabel": "Contains (TU per DU)",
  "warehouse.editAction": "Edit",
  "warehouse.editArticleTitle": "Edit article {{code}}",
  "warehouse.filledByWlx_one": "{{count}} field filled in or changed by WLX",
  "warehouse.filledByWlx_other": "{{count}} fields filled in or changed by WLX",
  "warehouse.followsStandard": "standard",
  "warehouse.followsStandardOf": "Follows the standard of {{name}}",
  "warehouse.fromCustomerLocked": "This article comes from the customer: description and article group stay as the customer sent them. The checks and the storage are WLX's.",
  "warehouse.fromSettings": "from Settings",
  "warehouse.grossWeightLabel": "Gross weight (kg)",
  "warehouse.groupChip": "Group {{group}}",
  "warehouse.gtinLabel": "GTIN",
  "warehouse.head.aisles_one": "{{count}} aisle",
  "warehouse.head.aisles_other": "{{count}} aisles",
  "warehouse.head.batchPureAll": "batch pure",
  "warehouse.head.batchPureBottom": "batch pure at the bottom",
  "warehouse.head.batchPureSome": "{{count}} batch pure",
  "warehouse.head.blocked": "{{count}} blocked",
  "warehouse.head.levels_one": "{{count}} level",
  "warehouse.head.levels_other": "{{count}} levels",
  "warehouse.head.perLevel_one": "{{count}} location per level",
  "warehouse.head.perLevel_other": "{{count}} locations per level",
  "warehouse.head.places_one": "{{count}} location",
  "warehouse.head.places_other": "{{count}} locations",
  "warehouse.head.racks_one": "{{count}} rack",
  "warehouse.head.racks_other": "{{count}} racks",
  "warehouse.head.zones_one": "{{count}} zone",
  "warehouse.head.zones_other": "{{count}} zones",
  "warehouse.heightCmLabel": "Max height (cm)",
  "warehouse.heightLabel": "Height (cm)",
  "warehouse.inUseLabel": "In use",
  "warehouse.keep": "Leave as is",
  "warehouse.colWalkOrder": "Walking route",
  "warehouse.walkOrderAction": "Walking route…",
  "warehouse.walkOrderTitle_one": "Walking route of {{count}} location",
  "warehouse.walkOrderTitle_other": "Walking route of {{count}} locations",
  "warehouse.walkOrderMode.number": "Number",
  "warehouse.walkOrderMode.clear": "Take off the route",
  "warehouse.walkOrderExplain": "The scanner walks the picks from low to high. The locations get a number in the order of their names, with a step between them so that a location fits in between later.",
  "warehouse.walkOrderClearExplain": "Without a number these locations come last in the route, by name.",
  "warehouse.walkOrderStart": "Start at",
  "warehouse.walkOrderStep": "Step",
  "warehouse.walkOrderDirection": "Order",
  "warehouse.walkOrderAsc": "By name, ascending",
  "warehouse.walkOrderDesc": "By name, descending",
  "warehouse.walkOrderPreview": "{{first}} gets {{from}}, {{last}} gets {{to}}.",
  "warehouse.walkOrderPreviewOne": "{{first}} gets {{from}}.",
  "warehouse.kindAction": "Change kind",
  "warehouse.kindTitle_one": "Change the kind of {{count}} location",
  "warehouse.kindTitle_other": "Change the kind of {{count}} locations",
  "warehouse.lengthLabel": "Length (cm)",
  "warehouse.levelsLabel": "Levels",
  "warehouse.matrixCaption": "Grey = follows the standard of {{name}}. Click a cell to depart from it for that customer; the change goes into the log.",
  "warehouse.maxWeightKgLabel": "Max weight (kg)",
  "warehouse.minDespatchLabel": "Min. shelf life at despatch (days)",
  "warehouse.minReceiptLabel": "Min. shelf life at receipt (days)",
  "warehouse.netWeightLabel": "Net weight (kg)",
  "warehouse.newArticleExplain": "An article WLX makes itself. When the customer sends it later in an article message, its units come with it.",
  "warehouse.newArticleSubmit": "Add article",
  "warehouse.newArticleTitle": "New article for {{owner}}",
  "warehouse.noArticleChosen": "Choose an article on the left.",
  "warehouse.noCustomerUnits": "No units from the customer yet. Fill them in or wait for the article message.",
  "warehouse.noOwnersYet": "No customers in {{name}} yet: a customer appears here with its first article or a setting of its own. Find one with Choose customer.",
  "warehouse.noRequirement": "No requirement",
  "warehouse.noThresholds": "No thresholds",
  "warehouse.noWarehouses": "There are no warehouses yet.",
  "warehouse.occupancy": "Occupancy",
  "warehouse.optional": "optional",
  "warehouse.ownerChoose": "Choose customer",
  "warehouse.ownerIn": "{{owner}} in {{warehouse}}",
  "warehouse.ownerLabel": "Customer: {{name}}",
  "warehouse.ownerListLabel": "Customers",
  "warehouse.ownerNone": "No customer found.",
  "warehouse.ownerSearch": "Find customer",
  "warehouse.ownerTypeToFind": "Type a name to find a customer.",
  "warehouse.perLayerLabel": "Per layer",
  "warehouse.pickAdd": "Add pick location",
  "warehouse.pickAddTitle": "Add pick location",
  "warehouse.pickEditTitle": "Pick location in {{warehouse}}",
  "warehouse.pickMaxLabel": "Replenish up to",
  "warehouse.pickMinLabel": "Replenish below",
  "warehouse.pickNone": "No fixed pick location yet.",
  "warehouse.pickPlaceLabel": "Location",
  "warehouse.pickSubtitle": "Fixed, per warehouse",
  "warehouse.pickTitle": "Pick location",
  "warehouse.pickUnitLabel": "Thresholds in",
  "warehouse.pickerAria": "Warehouse",
  "warehouse.pickerLabel": "Warehouse: {{name}}",
  // Warehouse → Crossdock (docs/tms-crossdock.md)
  "crossdock.depotLabel": "Depot: {{name}}",
  "crossdock.depotAria": "Choose the depot",
  "crossdock.noDepots": "No branch is a depot. Tick Depot under Admin → Branches.",
  "crossdock.tabIncoming": "Incoming ({{count}})",
  "crossdock.tabOutgoing": "Outgoing ({{count}})",
  "crossdock.emptyIncoming": "No lorry comes to unload at {{depot}} on {{day}}.",
  "crossdock.emptyOutgoing": "No trip loads at {{depot}} on {{day}}.",
  "crossdock.phaseExpected": "Expected",
  "crossdock.phaseArrived": "Arrived",
  "crossdock.phaseUnloaded": "Unloaded",
  "crossdock.phaseWaiting": "Waiting for goods",
  "crossdock.phaseLate": "Arrives late",
  "crossdock.phaseWarehouse": "From the warehouse",
  "crossdock.phaseComplete": "Complete",
  "crossdock.phaseLoaded": "Loaded",
  "crossdock.kindPickup": "Pickup",
  "crossdock.kindShuttle": "Depot shuttle",
  "crossdock.kindFactoryShuttle": "Factory shuttle",
  "crossdock.kindDelivery": "Delivery",
  "crossdock.kindDirect": "Direct",
  "crossdock.kindWarehouse": "Warehouse",
  "crossdock.colTrip": "Trip",
  "crossdock.colKind": "Kind",
  "crossdock.colExpected": "Expected",
  "crossdock.colDeparture": "Departure",
  "crossdock.colVehicle": "Lorry",
  "crossdock.colTrailer": "Trailer",
  "crossdock.colDriver": "Driver / charter",
  "crossdock.colShipments": "Consignments",
  "crossdock.colInDepot": "In",
  "crossdock.colOnward": "Goes on with",
  "crossdock.colWaitingFor": "Waits for",
  "crossdock.colPallets": "Pallets",
  "crossdock.colLoadingMeters": "LDM",
  "crossdock.colWeight": "Weight",
  "crossdock.colPhase": "Stage",
  "crossdock.colTripStatus": "Trip status",
  "crossdock.colConsignment": "Consignment",
  "crossdock.colCustomer": "Customer",
  "crossdock.colFrom": "From",
  "crossdock.colTo": "To",
  "crossdock.colReference": "Reference",
  "crossdock.colTemperature": "Temperature",
  "crossdock.colOnwardOne": "Goes on with",
  "crossdock.colInboundOne": "Comes in with",
  "crossdock.colState": "In the depot",
  "crossdock.arrivedAt": "in {{time}}",
  "crossdock.departedAt": "left {{time}}",
  "crossdock.notPlannedCount": "{{count}} not planned yet",
  "crossdock.staysCount": "{{count}} stays in the warehouse",
  "crossdock.notPlanned": "Not planned yet",
  "crossdock.staysInWarehouse": "Stays in the warehouse",
  "crossdock.fromWarehouse": "From the warehouse",
  "crossdock.staysInTrailer": "stays in the trailer",
  "crossdock.stateUnloaded": "Unloaded",
  "crossdock.stateNotUnloaded": "Not unloaded yet",
  "crossdock.stateInDepot": "In",
  "crossdock.stateNotInDepot": "Not in yet",
  "crossdock.stateUnknown": "Not reported",
  "crossdock.colDock": "Dock",
  "crossdock.colUnloadingList": "Unloading list",
  "crossdock.colLoadingList": "Loading list",
  "crossdock.colAction": "Unloaded / loaded",
  "crossdock.paperNever": "Not printed",
  "crossdock.paperPrinted": "Printed",
  "crossdock.paperPrintedAt": "Printed {{at}}",
  "crossdock.paperChanged": "Changed since printed",
  "crossdock.dockAria": "Dock of trip {{trip}}",
  "crossdock.undo": "Undo",
  "crossdock.markUnloaded": "Unloaded",
  "crossdock.markLoaded": "Loaded",
  "crossdock.remarkUnloading": "Remark on the unloading list",
  "crossdock.remarkLoading": "Remark on the loading list",
  "crossdock.picked": "{{count}} selected",
  "crossdock.pickAll": "Choose all trips",
  "crossdock.pickTrip": "Choose trip {{trip}}",
  "crossdock.printUnloadingButton": "Print unloading list…",
  "crossdock.printLoadingButton": "Print loading list…",
  "crossdock.printCouplingButton": "Coupling list…",
  "crossdock.printUnloadingOne": "Unloading list of {{number}}",
  "crossdock.printUnloadingMany": "Unloading lists of {{count}} trips",
  "crossdock.printLoadingOne": "Loading list of {{number}}",
  "crossdock.printLoadingMany": "Loading lists of {{count}} trips",
  "crossdock.printCouplingTitle": "Coupling list {{depot}}",
  "crossdock.printCouplingHelp": "The lorries of this depot that leave with a trailer today, in the order they leave.",
  "crossdock.printUnloadingList": "Unloading list",
  "crossdock.printLoadingList": "Loading list",
  "crossdock.printLabels": "Pallet labels",
  "crossdock.printDone": "To {{place}}: {{what}}.",
  "crossdock.printDoneUnloading": "{{count}} unloading list(s)",
  "crossdock.printDoneLoading": "{{count}} loading list(s)",
  "crossdock.printDoneLabels": "{{count}} pallet label(s)",
  "crossdock.printDoneScoretrace": "the loading to Scoretrace",
  "crossdock.printCouplingDone": "the coupling list with {{count}} lorry/lorries",
  "warehouse.placeCodeLabel": "Location code",
  "warehouse.placeSearch": "Find location",
  "warehouse.placeUnitsNone": "Nothing stands on this location.",
  "warehouse.placesNone": "No locations match.",
  "warehouse.placesNoneYet": "This warehouse has no locations yet. Add them with Add locations.",
  "warehouse.positionsLabel": "Locations per level",
  "warehouse.previewCodes_one": "{{count}} location: {{first}}",
  "warehouse.previewCodes_other": "{{count}} locations: {{first}} … {{last}}",
  "warehouse.previewExisting": "{{count}} of these locations exist already: {{names}}.",
  "warehouse.previewIncomplete": "Fill in the aisle and the numbers to see the codes.",
  "warehouse.propertiesAction": "Properties",
  "warehouse.propertiesExplain": "Only what you fill in or choose changes; the rest stays as it is per location.",
  "warehouse.propertiesTitle_one": "Properties of {{count}} location",
  "warehouse.propertiesTitle_other": "Properties of {{count}} locations",
  "warehouse.rackFromLabel": "Rack from",
  "warehouse.rackToLabel": "Rack up to",
  "warehouse.receiptQuestionsLater": "Under Checks (to come).",
  "warehouse.releaseAction": "Release…",
  "warehouse.releaseExplain": "The location can be used again. Say why; it goes into the log.",
  "warehouse.releaseRemarkLabel": "Why release",
  "warehouse.releaseSubmit": "Release",
  "warehouse.releaseTitle_one": "Release {{count}} location",
  "warehouse.releaseTitle_other": "Release {{count}} locations",
  "warehouse.releasedBy": "Released on {{when}} by {{who}}: {{remark}}",
  "warehouse.releasedResult": "Released: {{count}}.",
  "warehouse.replenishFollowWarehouse": "As the warehouse",
  "warehouse.replenishLabel": "Replenishment",
  "warehouse.replenishThresholds": "Replenish",
  "warehouse.saveSettings": "Save",
  "warehouse.selectPage": "Select all on this page",
  "warehouse.selectPlace": "Select {{name}}",
  "warehouse.selectedCount": "{{count}} selected",
  "warehouse.setPropertiesLabel": "Replace the storage properties with:",
  "warehouse.settingsAdminOnly": "Only an admin changes settings, until it is decided which role may.",
  "warehouse.settingsSaved_one": "{{count}} change saved.",
  "warehouse.settingsSaved_other": "{{count}} changes saved.",
  "warehouse.shelfLifeLabel": "Shelf life (days)",
  "warehouse.sourceCustomer": "customer",
  "warehouse.sourceWlx": "WLX",
  "warehouse.ssccPerPallet": "SSCC per pallet",
  "warehouse.standard": "Standard",
  "warehouse.standardHint": "applies unless the customer departs from it",
  "warehouse.standardOf": "Standard {{name}}",
  "warehouse.storageLabel": "Storage",
  "warehouse.thresholds": "below {{min}}, up to {{max}}",
  "warehouse.tree.aisle": "Aisle {{aisle}}",
  "warehouse.tree.floor": "Floor · receiving and staging",
  "warehouse.tree.noAisle": "No aisle",
  "warehouse.tree.noRack": "No rack",
  "warehouse.tree.noZone": "No zone",
  "warehouse.tree.rack": "Rack {{rack}}",
  "warehouse.tree.special": "Lost & found, damaged, inspection",
  "warehouse.tree.zone": "Zone {{zone}}",
  "warehouse.treeEmpty": "No locations yet.",
  "warehouse.treeLabel": "Layout of the warehouse",
  "warehouse.tuContainsLabel": "Contains (CU per TU)",
  "warehouse.unitAdd": "Add unit",
  "warehouse.unitAddTitle": "Add unit",
  "warehouse.unitEditTitle": "Unit {{level}}",
  "warehouse.unitFill": "Fill in",
  "warehouse.unitFromCustomer": "This unit comes from the customer. What the customer sent stays; what is empty, WLX can fill in.",
  "warehouse.unitLevelLabel": "Level",
  "warehouse.unitNameLabel": "Name",
  "warehouse.unitOfMeasureLabel": "Unit of measure",
  "warehouse.unitsNone": "No units yet.",
  "warehouse.unitsOnPlace": "On this location",
  "warehouse.unitsSubtitle": "Working unit on the scanner: {{unit}}.",
  "warehouse.unitsSubtitleClosed": "Working unit on the scanner: {{unit}} — a {{unit}} is not opened.",
  "warehouse.unitsSubtitleWhole": "Working unit on the scanner: {{unit}} — it leaves whole, unless a VAS code may break it (a sample).",
  "warehouse.unitsSubtitleNone": "Without units the scanner cannot count.",
  "warehouse.unitsTitle": "Units",
  "warehouse.unsavedChanges_one": "{{count}} change not saved yet",
  "warehouse.unsavedChanges_other": "{{count}} changes not saved yet",
  "warehouse.updatedResult": "Changed: {{count}}.",
  "warehouse.warehouseLabel": "Warehouse",
  "warehouse.warehouseTitle": "Warehouse {{name}}",
  "warehouse.warehouseValue": "{{name}}: {{value}}",
  "warehouse.widthLabel": "Width (cm)",
  "warehouse.zoneLabel": "Zone",
  "warehouse.adminOverride": "You are changing the customer's data. That is allowed as an exception: the log keeps what the customer sent and what you made of it.",
  "warehouse.unitFromCustomerAdmin": "This unit comes from the customer. As an admin you may change the customer's values as an exception; they are then labelled WLX and logged.",
  "warehouse.adminOnly": "admin only",
  "warehouse.editWarehouse": "Edit warehouse",
  "warehouse.editWarehouseTitle": "Warehouse {{code}}",
  "warehouse.warehouseNameLabel": "Name",
  "warehouse.addressLabel": "Address",
  "warehouse.addressSearch": "Find the address in Locations: name, street or town",
  "warehouse.addressChange": "Other address",
  "warehouse.addressHelp": "Is the address not there, create it under Organisations → Locations first. Its card then shows it is a warehouse.",
  "warehouse.branchLabel": "Branch",
  "warehouse.branchNone": "No branch",
  "warehouse.branchHelp": "Only when vehicles or drivers are based there.",
  "warehouse.warehouseActiveLabel": "In use",
  "warehouse.noAddress": "no address yet",
  "locations.warehouseChip": "Warehouse {{name}}",
  "warehouse.colSplittable": "Splittable",
  "warehouse.colSplittableHint": "Bag or box: may it be opened when picking? Pallet: may bags or boxes come off it? If not, it leaves whole, unless a VAS code may break it (a sample).",
  "warehouse.splittableLabel": "May be opened when picking (splittable)",
  "warehouse.splittableLabelPallet": "Bags or boxes may come off (splittable)",
  "warehouse.property.allergens": "Allergens",
  "warehouse.property.hum": "HUM",
  "warehouse.property.non_hum": "NON_HUM",
  "warehouse.property.pharma": "Pharma",
  "warehouse.property.pharma_non_hum": "Pharma NON_HUM",
  "warehouse.property.drum": "Drum",
  "warehouse.property.feed": "Feed",
  "warehouse.property.ground": "Ground",
  "warehouse.uom.ST_one": "piece",
  "warehouse.uom.ST_other": "pieces",
  "warehouse.uom.BX_one": "box",
  "warehouse.uom.BX_other": "boxes",
  "warehouse.uom.BD_one": "bundle",
  "warehouse.uom.BD_other": "bundles",
  "warehouse.uom.KT_one": "kit",
  "warehouse.uom.KT_other": "kits",
  "warehouse.check.palletType": "Pallet type",
  "warehouse.checkSentence.palletType": "What it arrives and leaves on, unless the order asks otherwise.",
  "warehouse.importedFromScoretrace": "Taken over from Scoretrace",
  "warehouse.stock.colBarcode": "SSCC",
  "warehouse.stock.colArticle": "Article",
  "warehouse.stock.colOwner": "Owner",
  "warehouse.stock.colBatch": "Batch",
  "warehouse.stock.colBestBefore": "Best before",
  "warehouse.stock.colLocation": "Storage location",
  "warehouse.stock.colQuantity": "Quantity",
  "warehouse.stock.colStockCode": "Stock code",
  "warehouse.stock.colLabel": "Label",
  "warehouse.stock.colReceivedAt": "Received",
  "warehouse.stock.labelOwn": "Own label",
  "warehouse.stock.labelCustomer": "Customer label",
  "warehouse.stock.blockOnLine": "Line blocked",
  "warehouse.stock.blockOnUnit": "Pallet blocked",
  "warehouse.stock.blockOnPlace": "Storage location blocked",
  "warehouse.stock.pallet": "Pallet",
  "warehouse.stock.blockedSince": "Blocked since {{when}}.",
  "warehouse.stock.blockedBy": "By {{who}}",
  "warehouse.stock.placeBlocked": "Storage location {{place}} is blocked.",
  "warehouse.stock.placeBlockedHint": "Release it in Storage locations",
  "warehouse.stock.externalBatch": "Supplier batch",
  "warehouse.stock.externalBatchTitle": "Supplier batch: {{batch}}",
  "warehouse.stock.stockCodeNone": "Standard",
  "warehouse.stock.palletType": "Pallet type",
  "warehouse.stock.consignments": "Consignments",
  "warehouse.stock.linesTitle_one": "{{count}} line on this pallet",
  "warehouse.stock.linesTitle_other": "{{count}} lines on this pallet",
  "warehouse.stock.batchShort": "batch {{batch}}",
  "warehouse.stock.bestBeforeShort": "best before {{day}}",
  "warehouse.stock.history": "History",
  "warehouse.stock.historyNone": "Nothing has happened to this pallet yet.",
  "warehouse.stock.lastChanged": "Last changed {{when}} by {{who}}.",
  "warehouse.stock.mixed_one": "{{count}} line",
  "warehouse.stock.mixed_other": "{{count}} lines",
  "warehouse.stock.search": "SSCC, article, batch or storage location",
  "warehouse.stock.summary_one": "{{count}} pallet · {{weight}}",
  "warehouse.stock.summary_other": "{{count}} pallets · {{weight}}",
  "warehouse.stock.withoutWeight_one": "The weight of {{count}} line is not known",
  "warehouse.stock.withoutWeight_other": "The weight of {{count}} lines is not known",
  "warehouse.stock.noneYet": "There is no stock in this warehouse yet.",
  "warehouse.stock.none": "No stock matches.",
  "warehouse.stock.blockTitle_one": "Block {{count}} pallet",
  "warehouse.stock.blockTitle_other": "Block {{count}} pallets",
  "warehouse.stock.releaseTitle_one": "Release {{count}} pallet",
  "warehouse.stock.releaseTitle_other": "Release {{count}} pallets",
  "warehouse.stock.blockExplain": "A blocked pallet is not reserved or picked. The reason goes into the pallet's history.",
  "warehouse.stock.releaseExplain": "The pallet can be reserved and picked again. Say why; it goes into its history.",
  "warehouse.stock.blockedResult_one": "{{count}} pallet blocked.",
  "warehouse.stock.blockedResult_other": "{{count}} pallets blocked.",
  "warehouse.stock.blockedResultAlready": "Blocked: {{count}}; {{already}} was blocked already.",
  "warehouse.stock.releasedResult_one": "{{count}} pallet released.",
  "warehouse.stock.releasedResult_other": "{{count}} pallets released.",
  "warehouse.event.unpicked": "Booked back to stock",
  "unpick.order": "Book back to stock",
  "unpick.pallet": "Book back",
  "unpick.load": "Book back",
  "unpick.title.order": "Book order {{label}} back to stock",
  "unpick.title.unit": "Book pallet {{label}} back to stock",
  "unpick.title.load": "Book load {{label}} back to stock",
  "unpick.intro": "What was picked, staged, loaded or shipped becomes free stock again on the place where it is now. The order lines are open again. Move the pallets with the scanner.",
  "unpick.loadedHint": "A loaded or shipped pallet goes to the dock it was loaded at, or to where it stood before. No message goes to the customer.",
  "unpick.place": "Place where the pallet is now",
  "unpick.placeHint": "The place's name or barcode, for example S01.",
  "unpick.submit": "Book back",
  "unpick.done_one": "{{count}} pallet booked back to free stock:",
  "unpick.done_other": "{{count}} pallets booked back to free stock:",
  "unpick.doneUnit": "{{sscc}} on {{place}}",
  "unpick.doneShort_one": "{{count}} pallet booked back to free stock on {{place}}.",
  "unpick.doneShort_other": "{{count}} pallets booked back to free stock.",
  "unpick.reportSent": "The shipping message of {{orders}} had already gone to the customer. WLX cannot take that back: mail the customer.",
  "unpick.withdrawn": "{{orders}} is Created again and holds nothing reserved any more. Make it pickable again to reserve anew, or report it done with 0.",
  "unpick.refusal.NOTHING_TO_UNPICK": "Nothing here was picked, staged, loaded or shipped to book back.",
  "unpick.refusal.PALLET_BUSY": "Pallet {{sscc}} is still being picked onto. Close the carrier on the scanner first.",
  "unpick.refusal.SHARED_PALLET": "Pallet {{sscc}} also carries goods of {{orders}}. Book that pallet back itself; all its orders go with it.",
  "unpick.refusal.PLACE_NEEDED": "WLX does not know where pallet {{sscc}} is now. Fill in the place.",
  "unpick.refusal.PLACE_UNKNOWN": "Place {{place}} does not exist in this warehouse.",
  "warehouse.event.staged": "Staged",
  "warehouse.event.loaded": "Loaded",
  "warehouse.event.shipped": "Shipped",
  "warehouse.event.received": "Received",
  "warehouse.event.put_away": "Put away",
  "warehouse.event.moved": "Moved",
  "warehouse.event.picked": "Picked",
  "warehouse.event.adjusted": "Corrected",
  "warehouse.event.owner_changed": "Other owner",
  "warehouse.event.batch_split": "Batch split",
  "warehouse.event.stock_code_changed": "Other stock code",
  "warehouse.event.blocked": "Blocked",
  "warehouse.event.unblocked": "Released",
  "warehouse.event.counted": "Counted",
  "warehouse.event.migrated": "Taken over from Scoretrace",
  "warehouse.event.to_lost_found": "To lost & found",
  "warehouse.event.from_lost_found": "From lost & found",
  "warehouse.event.written_off": "Written off",
  "warehouse.event.increased": "Increased",
  "warehouse.event.status_changed": "Batch changed",
  "warehouse.event.onPlace": "on {{place}}",
  "warehouse.event.receipt": "receipt {{receipt}}",
  "warehouse.event.receivedOn": "received {{day}}",
  "warehouse.event.unitCorrected": "saldo was in {{from}}, taken over as {{to}}",
  "warehouse.event.viaScanner": "scanner",
  "warehouse.event.viaCustomer": "customer interface",
  "warehouse.event.changeBatch": "batch {{from}} → {{to}}",
  "warehouse.event.changeLhc": "stock type {{from}} → {{to}}",
  "warehouse.event.changeBestBefore": "best before {{from}} → {{to}}",
  "warehouse.event.changeArticle": "article {{from}} → {{to}}",
  "inbound.tabsLabel": "View",
  "inbound.tab.receipts": "Per receipt",
  "inbound.tab.ownLabels": "Own labels",
  "inbound.announce": "New receipt",
  "inbound.announceTitle": "New receipt · {{warehouse}}",
  "inbound.choosePrincipal": "Choose the principal",
  "inbound.deliveryNote": "Delivery note",
  "inbound.reference": "Reference",
  "inbound.searchPlaceholder": "Number, delivery note, reference or SSCC",
  "inbound.viewLabel": "Which receipts",
  "idt.arrival": "Arrival",
  "idt.expectedOn": "expected {{day}}",
  "idt.viaTimeslot": "announced through a time slot",
  "idt.viaOffice": "announced by the office ({{name}})",
  "idt.pallets": "Pallets",
  "idt.palletsOf": "{{count}} of {{total}}",
  "idt.short_one": "{{count}} pallet short",
  "idt.short_other": "{{count}} pallets short",
  "idt.over_one": "{{count}} pallet over or not announced",
  "idt.over_other": "{{count}} pallets over or not announced",
  "idt.damaged_one": "{{count}} damaged pallet",
  "idt.damaged_other": "{{count}} damaged pallets",
  "idt.toCome_one": "{{count}} still to come",
  "idt.toCome_other": "{{count}} still to come",
  "idt.perLineChecks_one": "and {{count}} check per line (tab)",
  "idt.perLineChecks_other": "and {{count}} checks per line (tab)",
  "idt.owners": "owners: {{owners}}",
  "idt.stepsLabel": "Steps of the receipt",
  "idt.next.created": "Waiting for an announcement or activation; activated, it is on the scanner.",
  "idt.next.announced": "Announced for {{time}}; activate it when the truck is there (or it happens by itself).",
  "idt.next.activeEmpty": "On the scanner; nothing scanned yet.",
  "idt.next.active": "The floor is receiving: {{count}} of {{total}} pallets in.",
  "idt.next.activeCount_one": "The floor is receiving: {{count}} pallet in.",
  "idt.next.activeCount_other": "The floor is receiving: {{count}} pallets in.",
  "idt.next.reported": "Reported done without a difference: close it.",
  "idt.next.reportedDifferences_one": "Reported done with {{count}} difference: check and close.",
  "idt.next.reportedDifferences_other": "Reported done with {{count}} differences: check and close.",
  "idt.next.done": "Closed {{time}}.",
  "idt.next.cancelled": "Cancelled.",
  "idt.tab.articles": "Per article",
  "idt.tab.pallets": "Pallets",
  "idt.tab.checks": "Checks per line",
  "idt.col.announced": "Announced",
  "idt.showSscc": "Show the SSCCs",
  "idt.missing": "did not come",
  "idt.notYet": "not yet",
  "idt.in": "in",
  "inbound.view.week": "Week",
  "inbound.labelsIntro": "The number range of our own labels (the roll) and the counter: the scanner refuses a sticker that was never printed.",
  "inbound.week.col.time": "Time",
  "inbound.week.col.arrival": "Arrival",
  "inbound.week.col.step": "Step",
  "inbound.week.title": "Arriving {{day}}",
  "inbound.week.titleToday": "Arriving today, {{day}}",
  "inbound.week.backlog": "Backlog · still open",
  "inbound.week.empty": "No receipts on this day.",
  "inbound.week.emptyFiltered": "No receipts on this day match the filter.",
  "inbound.week.col.expected": "Expected",
  "inbound.week.col.actions": "Actions",
  "inbound.week.expected": "expected",
  "inbound.week.announced": "Announced",
  "inbound.week.close": "Close",
  "inbound.week.receipts_one": "{{count}} receipt",
  "inbound.week.receipts_other": "{{count}} receipts",
  "inbound.week.palletsExpected_one": "{{count}} pallet announced",
  "inbound.week.palletsExpected_other": "{{count}} pallets announced",
  "inbound.week.notClosed_one": "{{count}} not closed",
  "inbound.week.notClosed_other": "{{count}} not closed",
  "inbound.week.allClosed": "All closed",
  "inbound.week.arrived": "{{count}} of {{total}} in",
  "inbound.week.announcedCount": "{{count}} of {{total}} announced",
  "inbound.week.attention.reported_one": "{{count}} reported done, waiting to be closed",
  "inbound.week.attention.reported_other": "{{count}} reported done, waiting to be closed",
  "inbound.week.attention.difference_one": "{{count}} with a difference",
  "inbound.week.attention.difference_other": "{{count}} with a difference",
  "inbound.week.attentionTitle.reported": "Reported done, waiting to be closed",
  "inbound.week.attentionTitle.difference": "With a difference",
  "inbound.view.open": "Open",
  "inbound.view.today": "Today",
  "inbound.view.recent": "30 days",
  "inbound.view.all": "All",
  "inbound.periodLabel": "Period",
  "inbound.periodFrom": "Created from",
  "inbound.periodTo": "up to and including",
  "inbound.periodFromLabel": "Created from",
  "inbound.periodToLabel": "Created up to and including",
  "inbound.periodClear": "Clear period",
  "inbound.limitReached": "You see the newest {{count}}. Narrow the period or search more precisely to find older ones.",
  "inbound.col.number": "Receipt",
  "inbound.col.principal": "Principal",
  "inbound.col.kind": "Kind",
  "inbound.col.owners": "Owners",
  "inbound.col.announced": "Created",
  "inbound.col.pallets": "Pallets",
  "inbound.col.scanned": "Scanned",
  "inbound.col.differences": "Difference",
  "inbound.col.state": "Status",
  "inbound.col.sscc": "SSCC",
  "inbound.col.bestBefore": "Best before",
  "inbound.col.lhc": "LHC",
  "inbound.detail.externalBatch": "supplier {{batch}}",
  "inbound.detail.lhcUnknown": "unknown in WLX",
  "inbound.col.article": "Article",
  "inbound.col.batch": "Batch",
  "inbound.col.palletType": "Pallet type",
  "inbound.col.locationNow": "Location now",
  "inbound.col.receivedAt": "Received",
  "inbound.col.line": "Line",
  "inbound.col.announcedPallets": "Ordered",
  "inbound.col.received": "Received",
  "inbound.col.difference": "Difference",
  "inbound.col.scannedAt": "Scanned",
  "inbound.col.amount": "Quantity",
  "inbound.col.by": "By",
  "inbound.empty": "No receipts.",
  "inbound.emptySearch": "Nothing found.",
  "inbound.footnote": "Reported = the floor is done. The office closes it; in the shadow period nothing goes to the customer.",
  "inbound.ownersCount_one": "{{count}} owner",
  "inbound.ownersCount_other": "{{count}} owners",
  "inbound.kind.receipt": "Receipt",
  "inbound.kind.transfer": "Shuttle",
  "inbound.kind.production": "From the belt",
  "inbound.kind.return": "Return",
  "inbound.state.announced": "Announced",
  "inbound.state.active": "Active",
  "inbound.state.reported": "Reported",
  "inbound.state.reportedDifference": "Reported · difference",
  "inbound.state.done": "Closed",
  "inbound.state.cancelled": "Cancelled",
  "inbound.state.created": "Created",
  "inbound.detail.activate": "Activate",
  "inbound.closeMissing.title": "Close receipt {{number}} with differences",
  "inbound.closeMissing.intro": "This receipt differs from what was announced. Check the differences before closing: once closed, they go to the customer like this.",
  "inbound.closeMissing.confirmDifferences": "I checked the differences",
  "inbound.closeMissing.submitDifferences": "Close with differences",
  "inbound.closeMissing.what": "{{count}} announced pallet(s) were not scanned. Closing sends them with their SSCC and content to lost & found of {{warehouse}}, and the receipt is done. For FC a stock movement to the storage location of lost & found follows.",
  "inbound.closeMissing.confirm": "I checked that these {{count}} pallet(s) are not here",
  "inbound.closeMissing.submit": "Close, {{count}} to lost & found",
  "inbound.detail.announce": "Announce",
  "inbound.detail.announceChange": "Change announcement",
  "inbound.detail.announceTitle": "Announce · {{number}}",
  "inbound.detail.announceHint": "What the carrier announces. Announcing does not activate the receipt: only once activated is it on the scanner.",
  "inbound.detail.announceSave": "Save announcement",
  "inbound.detail.announcedForLabel": "Announced for",
  "inbound.detail.carrier": "Carrier",
  "inbound.detail.vehicle": "Truck or container",
  "inbound.detail.dockLabel": "Dock",
  "inbound.detail.noDock": "No dock yet",
  "inbound.detail.announcedFor": "for {{time}}",
  "inbound.detail.announced": "announced: {{what}} (by {{name}})",
  "inbound.detail.activated": "activated {{time}} by {{name}}",
  "inbound.detail.activatedAuto": "activated by itself {{time}}",
  "inbound.detail.closedAuto": "closed by itself {{time}}, after the last announced pallet",
  "inbound.notFound": "Receipt not found",
  "inbound.back": "Receipts",
  "inbound.detail.title": "Receipt {{number}}",
  "inbound.differencesCount_one": "{{count}} difference",
  "inbound.differencesCount_other": "{{count}} differences",
  "inbound.detail.cancel": "Did not come",
  "inbound.detail.close": "Close receipt",
  "inbound.detail.deliveryNote": "delivery note {{number}}",
  "inbound.detail.started": "started {{time}} by {{name}}",
  "inbound.detail.reported": "reported {{time}} by {{name}}",
  "inbound.detail.closed": "closed {{time}} by {{name}}",
  "inbound.detail.shadow": "Shadow period: Scoretrace leads. Closing sends nothing to the customer.",
  "inbound.detail.temperature": "{{value}} °C",
  "inbound.detail.blocked": "pallets blocked",
  "inbound.detail.checks": "Checks at receipt",
  "inbound.detail.checksNone": "Not answered yet",
  "inbound.detail.labels": "Labels",
  "inbound.detail.labelsValue": "{{customer}} customer · {{own}} own",
  "inbound.detail.receiving": "Receiving location",
  "inbound.detail.noLines": "Nothing received yet. A line comes as soon as the floor scans a pallet.",
  "inbound.detail.notAnnounced": "not announced",
  "inbound.detail.noPallets": "No pallets scanned yet.",
  "inbound.detail.noPalletsFiltered": "No pallets match the filter.",
  "inbound.detail.differences": "Differences",
  "inbound.detail.differencesHint": "Go by mail to {{principal}} on closing, once the messages to the customer exist.",
  "inbound.detail.noDifferences": "No differences.",
  "inbound.palletsCount_one": "{{count}} pallet",
  "inbound.palletsCount_other": "{{count}} pallets",
  "inbound.ownLabel": "own label",
  "inbound.damaged": "Damage",
  "inbound.bestBefore": "BB {{date}}",
  "inbound.difference.short_one": "{{count}} pallet short",
  "inbound.difference.short_other": "{{count}} pallets short",
  "inbound.difference.over_one": "{{count}} pallet over",
  "inbound.difference.over_other": "{{count}} pallets over",
  "inbound.difference.not_announced_one": "Not announced · {{count}} pallet",
  "inbound.difference.not_announced_other": "Not announced · {{count}} pallets",
  "inbound.difference.damaged_one": "Damage · {{count}} pallet",
  "inbound.difference.damaged_other": "Damage · {{count}} pallets",
  "inbound.check.vehicle_clean_dry": "Vehicle clean and dry",
  "inbound.check.load_undamaged": "Load undamaged",
  "inbound.answer.yes": "Yes",
  "inbound.answer.no": "No",
  "inbound.range.owner": "Owner",
  "inbound.range.willems": "Willems",
  "inbound.range.prefix": "Prefix",
  "inbound.range.serials": "Serials",
  "inbound.range.counter": "Counter",
  "inbound.range.noCounter": "not kept",
  "inbound.range.free": "Still free",
  "inbound.range.used": "Used on pallets",
  "inbound.range.edit": "Set counter",
  "inbound.range.editTitle": "Counter of the own labels",
  "inbound.range.counterHint": "The highest serial printed on a roll. Empty: WLX does not check the counter.",
  "inbound.range.badCounter": "Enter a serial, or leave it empty.",
  "inbound.range.explain": "A sticker from this range with a serial above {{counter}} was never printed: the scanner refuses it.",
  "inbound.range.explainNoCounter": "WLX does not keep the counter yet: every valid sticker from this range is accepted. Printing rolls comes later.",
  "inbound.range.shared": "Scoretrace prints from the same range while other warehouses work in it. A number already on a pallet is always refused by the scanner.",
  "warehouse.maxPalletsLabel": "Pallet places",
  "outbound.tabsLabel": "Orders or shipping",
  "outbound.tab.orders": "Orders",
  "outbound.col.asks": "Requirements",
  "outbound.asks.batch": "batch {{batch}}",
  "outbound.asks.bestBefore": "BBD {{date}}",
  "outbound.asks.stockCodes": "LHC {{codes}}",
  "outbound.asks.load": "per pallet {{quantity}} {{unit}}",
  "outbound.asks.maxBatches_one": "max. {{count}} batch",
  "outbound.asks.maxBatches_other": "max. {{count}} batches",
  "outbound.line.change": "Change",
  "outbound.line.title": "Change line {{line}} · {{article}}",
  "outbound.line.quantity": "Ordered ({{unit}})",
  "outbound.line.load": "Load quantity ({{unit}})",
  "outbound.line.batch": "Batch",
  "outbound.line.vas": "VAS codes",
  "outbound.line.vasRetired": "VAS code {{codes}} is not used (Warehouse → VAS).",
  "outbound.line.vasUnknown": "VAS code {{codes}} does not exist in WLX. Check the code in Warehouse → VAS.",
  "outbound.activate.open": "Activate",
  "outbound.activate.change": "Change activation",
  "outbound.activate.title": "Activate order {{number}}",
  "outbound.activate.hint": "Activating puts the order on loading. The scanner shows the plate or container number and the floor confirms it; it can only be changed here.",
  "outbound.activate.kindLabel": "Truck or container",
  "outbound.activate.kind.truck": "Truck",
  "outbound.activate.kind.container": "Container",
  "outbound.activate.containerNumber": "Container number",
  "outbound.activate.tare": "Tare (kg)",
  "outbound.activate.trailerPlate": "Trailer plate",
  "outbound.activate.truckPlate": "Truck plate",
  "outbound.activate.submit": "Activate",
  "outbound.activate.withdraw": "Withdraw activation",
  "outbound.activate.fact": "Activation",
  "outbound.activate.not": "Not activated",
  "outbound.activate.via.wlx": "office",
  "outbound.activate.via.itv": "iTV",
  "outbound.activate.via.portal": "portal",
  "outbound.activate.trip": "trip {{trip}}",
  "outbound.activate.dock": "dock {{dock}}",
  "outbound.activate.containerInvalid": "{{number}} is not a valid container number: the check digit is wrong.",
  "outbound.activate.loading": "The order is being loaded; its activation can no longer change.",
  "outbound.registrations.title": "Recorded for VAS codes",
  "outbound.registrations.pallet": "pallet {{sscc}}",
  "outbound.registrations.order": "order",
  "outbound.asks.fixed": "Fixed {{batch}} · {{quantity}}",
  "outbound.pickReport.button": "COKZ reservation",
  "outbound.pickReport.sentNow": "PIC report sent: {{count}} batch lines fixed and the order released.",
  "outbound.pickReport.shortNow": "No PIC report: too little suitable stock. {{lines}}",
  "outbound.pickReport.shortLine": "line {{line}} {{article}}: {{available}} of {{needed}}",
  "outbound.pickReport.fact": "PIC report",
  "outbound.pickReport.sent": "Sent, batches fixed",
  "outbound.pickReport.failed": "Not sent: too little suitable stock",
  "outbound.line.vasHint": "Codes with a space between them. Taking a code off or adding one counts as a change.",
  "outbound.line.reason": "Why do you change this line?",
  "outbound.line.submit": "Save",
  "outbound.line.quantityInvalid": "Fill in a quantity above 0.",
  "outbound.line.loadInvalid": "Fill in a load quantity above 0, or leave it empty.",
  "outbound.tab.changes": "Changes",
  "outbound.changes.period": "Period",
  "outbound.changes.from": "From",
  "outbound.changes.to": "Up to and including",
  "outbound.changes.lastWeek": "Last 7 days",
  "outbound.changes.download": "Download",
  "outbound.changes.fileName": "changes",
  "outbound.changes.empty": "No changes in this period.",
  "outbound.changes.col.order": "Order",
  "outbound.changes.col.owner": "Owner",
  "outbound.changes.col.customerContact": "Customer contact",
  "outbound.changes.col.line": "Line",
  "outbound.changes.col.what": "What",
  "outbound.changes.col.old": "Was",
  "outbound.changes.col.new": "Becomes",
  "outbound.changes.col.reason": "Reason",
  "outbound.changes.col.remark": "Remark",
  "outbound.changes.col.at": "When",
  "outbound.changes.col.by": "By",
  "outbound.changes.col.orderNumber": "Order number",
  "outbound.changes.col.reference": "Customer reference",
  "outbound.changes.col.lineNumber": "Line number",
  "outbound.changes.col.article": "Article",
  "outbound.changes.col.vasCode": "VAS code",
  "outbound.changes.field.quantity": "Quantity changed",
  "outbound.changes.field.load_quantity": "Load quantity changed",
  "outbound.changes.field.batch": "Batch changed",
  "outbound.changes.field.vas_added": "VAS added",
  "outbound.changes.field.vas_removed": "VAS removed",
  "outbound.changes.field.reported_zero": "Done with 0",
  "outbound.searchPlaceholder": "Search by order, reference or address",
  "outbound.viewLabel": "Which orders",
  "outbound.view.week": "Week",
  "outbound.view.today": "Loading today",
  "outbound.week.navLabel": "Week",
  "outbound.week.number": "Week {{week}}",
  "outbound.week.previous": "Previous week",
  "outbound.week.next": "Next week",
  "outbound.week.thisWeek": "This week",
  "outbound.week.daysLabel": "Days of the week",
  "outbound.week.today": "today",
  "outbound.week.orders_one": "{{count}} order",
  "outbound.week.orders_other": "{{count}} orders",
  "outbound.week.allLoaded": "All loaded",
  "outbound.week.notLoaded_one": "{{count}} not loaded",
  "outbound.week.notLoaded_other": "{{count}} not loaded",
  "outbound.week.readyCount": "{{count}} of {{total}} ready",
  "outbound.week.lateCount_one": "{{count}} misses {{time}}",
  "outbound.week.lateCount_other": "{{count}} miss {{time}}",
  "outbound.week.created_one": "{{count}} not pickable yet",
  "outbound.week.created_other": "{{count}} not pickable yet",
  "outbound.week.allReleased": "All pickable",
  "outbound.week.lateNoTime_one": "{{count}} late",
  "outbound.week.lateNoTime_other": "{{count}} late",
  "outbound.week.attention.lateNoTime_one": "{{count}} late",
  "outbound.week.attention.lateNoTime_other": "{{count}} late",
  "outbound.week.title.loadTodayNoTime": "Pick-up today, {{day}}",
  "outbound.week.backlogCount_one": "+ {{count}} backlog",
  "outbound.week.backlogCount_other": "+ {{count}} backlog",
  "outbound.week.backlog": "Backlog · not loaded yet",
  "outbound.week.title.load": "Pick-up {{day}}",
  "outbound.week.title.loadToday": "Pick-up today, {{day}} · ready by {{time}}",
  "outbound.week.title.delivery": "Delivery {{day}}",
  "outbound.week.title.deliveryToday": "Delivery today, {{day}}",
  "outbound.week.attentionLabel": "Attention",
  "outbound.week.attention.unlinked_one": "{{count}} address not linked",
  "outbound.week.attention.unlinked_other": "{{count}} addresses not linked",
  "outbound.week.attention.unknownArticle_one": "{{count}} with an unknown article",
  "outbound.week.attention.unknownArticle_other": "{{count}} with an unknown article",
  "outbound.week.attention.late_one": "{{count}} misses {{time}}",
  "outbound.week.attention.late_other": "{{count}} miss {{time}}",
  "outbound.week.attention.pickReport_one": "{{count}} PIC report not sent",
  "outbound.week.attention.pickReport_other": "{{count}} PIC reports not sent",
  "outbound.week.attentionTitle.unlinked": "Address not linked",
  "outbound.week.attentionTitle.unknownArticle": "With an unknown article",
  "outbound.week.attentionTitle.late": "Misses {{time}}",
  "outbound.week.attentionTitle.lateNoTime": "Late",
  "outbound.week.attentionTitle.pickReport": "PIC report not sent",
  "outbound.week.markerLabel": "Marker",
  "outbound.week.col.owner": "Customer",
  "outbound.week.col.markers": "Marker",
  "outbound.week.col.weight": "Weight",
  "outbound.week.col.step": "Step",
  "outbound.week.col.transport": "Transport",
  "outbound.week.kind.truck": "Truck",
  "outbound.week.kind.container": "Container",
  "outbound.week.carrierOrdered": "The carrier as the customer instructs",
  "outbound.week.carrierCollects": "collector",
  "outbound.week.announced": "Announced",
  "outbound.week.announcedFor": "Announced {{time}}",
  "outbound.week.notAnnounced": "Not announced",
  "outbound.week.viaTimeslot": "Announced through a time slot",
  "outbound.week.viaOffice": "Announced by the office",
  "outbound.week.empty": "No orders on this day.",
  "outbound.week.emptyFiltered": "No orders on this day match the filter.",
  "outbound.week.pickCreated_one": "Choose the {{count}} despatch not pickable yet",
  "outbound.week.pickCreated_other": "Choose the {{count}} despatches not pickable yet",
  "outbound.week.deliverOn": "delivery {{day}}",
  "outbound.week.pickupOn": "pick-up {{day}}",
  "outbound.week.fca": "FCA · the customer picks up",
  "outbound.week.ownTransport": "Willems drives",
  "outbound.week.activated": "Activated",
  "outbound.marker.grootVas": "Groot VAS",
  "od.more": "More",
  "od.pickup": "Pick-up",
  "od.delivery": "Delivery",
  "od.to": "To",
  "od.transport": "Transport",
  "od.readyBy": "ready by {{time}}",
  "od.minBestBefore": "Best-before at least {{day}}",
  "od.minBestBeforeChip": "BB ≥ {{day}}",
  "od.fca": "FCA · {{carrier}}",
  "od.carrierOrdered": "carrier as the customer instructs",
  "od.booking": "booking {{booking}}",
  "od.announced": "Announced for {{time}} · {{carrier}} ({{via}})",
  "od.viaTimeslot": "time slot",
  "od.viaOffice": "office",
  "od.activated": "Activated: {{what}}",
  "od.grootVas": "Groot VAS {{code}} {{description}}",
  "od.stepsLabel": "Steps of the order",
  "od.now": "Now:",
  "od.next.link": "Link the delivery address first; then the order can be made pickable.",
  "od.next.release": "Make the order pickable; then it is on the scanner.",
  "od.next.releaseTogether_one": "Make the order pickable, together with {{count}} other order for the same address and delivery day.",
  "od.next.releaseTogether_other": "Make the order pickable, together with {{count}} other orders for the same address and delivery day.",
  "od.next.released": "On the scanner, waiting for a picker.",
  "od.next.picking": "Being picked: {{percent}}% picked.",
  "od.next.vas": "Groot VAS: {{codes}}; then to expedition.",
  "od.next.load": "Ready to load onto {{vehicle}}.",
  "od.next.waitCarrier": "Ready; waiting for the collector: not announced yet.",
  "od.next.activate": "Ready to load; activate with the plate or container number.",
  "od.next.picked": "Ready to load.",
  "od.next.shipped": "Loaded {{time}}.",
  "od.next.cancelled": "Reported done with 0.",
  "od.pickReportSent": "PIC report sent {{time}} (the batches are fixed).",
  "od.pickReportFailed": "PIC report not sent ({{time}}): {{problem}}",
  "od.tab.lines": "Lines",
  "od.tab.pallets": "Pallets",
  "od.tab.vas": "VAS and records",
  "od.forAllLines": "For every line:",
  "od.noPallets": "No pallets yet: nothing reserved or picked.",
  "od.noPalletsFiltered": "No pallets match the filter.",
  "od.noVas": "No VAS codes on this order.",
  "od.vas.code": "Code",
  "od.vas.what": "What",
  "od.vas.kind": "Kind",
  "od.vas.instruction": "Instruction",
  "od.vas.order": "whole order",
  "od.announce.open": "Announce",
  "od.announce.change": "Change announcement",
  "od.announce.title": "Announce · {{number}}",
  "od.announce.hint": "A carrier announced the pick-up. Record for when and who; announcing does not put the order on loading yet (that is Activate). Through a time slot this happens by itself.",
  "od.announce.for": "Announced for",
  "od.announce.carrier": "Carrier that announced",
  "od.announce.ordered": "As the customer instructs: {{carrier}}",
  "od.announce.submit": "Record announcement",
  "od.announce.withdraw": "Withdraw announcement",
  "outbound.marker.grootVasCode": "Groot VAS {{code}}",
  "outbound.marker.fca": "FCA",
  "outbound.marker.container": "Container",
  "outbound.marker.ownTransport": "Own transport",
  "outbound.marker.batchPick": "Batch picking",
  "outbound.marker.ownershipTransfer": "Ownership transfer",
  "outbound.view.open": "Open",
  "outbound.view.recent": "Last 30 days",
  "outbound.lateCount_one": "{{count}} order misses {{time}}",
  "outbound.lateCount_other": "{{count}} orders miss {{time}}",
  "outbound.empty": "No orders. An order from DataBridge shows here by itself.",
  "outbound.emptySearch": "No order found.",
  "outbound.footnote": "Delivery goes in whole bags or boxes; a big bag goes as a whole pallet. An order with an unknown article, or with an address to be linked to a place (where the shipping form is calculated), shows in red.",
  "outbound.notFound": "This order does not exist.",
  "outbound.back": "Orders",
  "outbound.status.created": "Created",
  "outbound.status.released": "Pickable",
  "outbound.status.picking": "Picking",
  "outbound.status.vas": "Ready for VAS",
  "outbound.status.picked": "Picked",
  "outbound.status.shipped": "Loaded",
  "outbound.status.cancelled": "Cancelled",
  "outbound.state.late": "Misses {{time}}",
  "outbound.form.parcel": "Parcel",
  "outbound.form.half_pallet": "Half pallet",
  "outbound.form.euro_pallet": "Europallet",
  "outbound.col.number": "Order",
  "outbound.col.place": "Address",
  "outbound.col.form": "Shipping form",
  "outbound.col.lines": "Lines",
  "outbound.col.ordered": "Ordered",
  "outbound.col.deliver": "Delivers",
  "outbound.col.picked": "Picked",
  "outbound.col.loadDate": "Load day",
  "outbound.col.deliveryDate": "Delivery day",
  "outbound.col.state": "Status",
  "outbound.col.line": "Line",
  "outbound.col.article": "Article",
  "outbound.col.orderedQty": "Ordered",
  "outbound.col.deliverIn": "Delivered in",
  "outbound.col.minBestBefore": "Min. best-before",
  "outbound.col.pickedQty": "Picked",
  "outbound.col.sscc": "SSCC",
  "outbound.col.unitKind": "Kind",
  "outbound.col.unitState": "Status",
  "outbound.col.locationNow": "Location now",
  "outbound.placeUnknown": "address not linked",
  "outbound.together_one": "{{count}} order together",
  "outbound.together_other": "{{count}} orders together",
  "outbound.pickup": "Collection (FCA)",
  "outbound.noCarrier": "No carrier · via planning",
  "outbound.source.wlx": "WLX",
  "outbound.source.manual": "Changed",
  "outbound.source.manualBy": "Changed · {{name}}",
  "outbound.unknownArticles_one": "{{count}} article unknown",
  "outbound.unknownArticles_other": "{{count}} articles unknown",
  "outbound.channel.databridge": "DataBridge",
  "outbound.channel.scoretrace": "Taken over from Scoretrace",
  "outbound.channel.manual": "By hand",
  "outbound.despatch.rule": "Under {{parcel}} kg a parcel ({{parcelCarrier}}), up to {{half}} kg a half pallet, above a Europallet ({{palletCarrier}})",
  "outbound.despatch.carrier": "Carrier",
  "outbound.despatch.wlxWould": "WLX: {{form}} · {{carrier}}",
  "outbound.despatch.change": "Change",
  "outbound.despatch.reset": "Back to WLX",
  "outbound.despatch.forAll_one": "Holds for {{count}} order",
  "outbound.despatch.forAll_other": "Holds for all {{count}} orders",
  "despatch.title": "Despatch · {{place}}",
  "despatch.notFound": "This despatch is gone.",
  "despatch.what_one": "{{count}} order, {{weight}} kg, leaves in one go.",
  "despatch.what_other": "{{count}} orders for this address and delivery day, {{weight}} kg together, leave together.",
  "despatch.calculated": "WLX calculated the shipping form from the weight.",
  "despatch.noParcel": "{{place}} never gets a parcel",
  "despatch.noParcelHint": "Willems drives itself: below the parcel limit it becomes a Europallet without a carrier. For the other days too; the list is in Settings.",
  "outbound.noParcel.title": "Never a parcel",
  "outbound.noParcel.hint": "Addresses where Willems drives itself (was TaskCentre task 858): under the parcel limit it becomes a Europallet without a carrier. {{warehouse}} itself and an address with the same postal code always belong to it.",
  "outbound.noParcel.none": "No addresses yet.",
  "outbound.noParcel.remove": "Remove",
  "outbound.noParcel.add": "Add an address: search by name, place or postal code",
  "outbound.place.search": "Search by name, code, place or postal code",
  "outbound.place.none": "Nothing found in the address book.",
  "outbound.detail.title": "Order {{number}} · {{reference}}",
  "outbound.detail.cancel": "Report done with 0",
  "outbound.zero.title": "Report order {{number}} done with 0",
  "outbound.zero.intro": "The order does not go: nothing is picked and the customer hears 0 was delivered. This is only possible while nothing is being picked.",
  "outbound.zero.question": "Why is this order reported with 0?",
  "outbound.zero.choose": "Choose a reason",
  "outbound.zero.remark": "Remark",
  "outbound.zero.remarkNeeded": "Say in a few words what it is.",
  "outbound.zero.submit": "Report done with 0",
  "outbound.zero.done": "Reported done with 0 on {{time}}",
  "outbound.detail.debtor": "debtor {{code}}",
  "outbound.detail.customerOrder": "customer order {{number}}",
  "outbound.detail.pickingStarted": "picking from {{time}}",
  "outbound.detail.pickingDone": "picked {{time}}",
  "outbound.detail.released": "pickable {{time}}",
  "outbound.col.released": "Made pickable",
  "outbound.release.make": "Make pickable",
  "outbound.release.makeCount_one": "Make {{count}} shipment pickable",
  "outbound.release.makeCount_other": "Make {{count}} shipments pickable",
  "outbound.release.withdraw": "Withdraw",
  "outbound.release.withdrawCount_one": "Withdraw {{count}} shipment",
  "outbound.release.withdrawCount_other": "Withdraw {{count}} shipments",
  "outbound.release.clear": "Clear",
  "outbound.release.pickedOrders_one": "{{count}} order selected",
  "outbound.release.pickedOrders_other": "{{count}} orders selected",
  "outbound.release.pickedDespatches_one": "{{count}} shipment selected",
  "outbound.release.pickedDespatches_other": "{{count}} shipments selected",
  "outbound.release.wholeDespatch": "A shipment goes as a whole: the other orders to that address on that day too.",
  "outbound.release.waiting_one": "{{count}} order not pickable yet",
  "outbound.release.waiting_other": "{{count}} orders not pickable yet",
  "outbound.release.pickCreated_one": "Select the created order",
  "outbound.release.pickCreated_other": "Select the {{count}} created orders",
  "outbound.release.pickOrder": "Select order {{number}}",
  "outbound.release.pickDespatch": "Select the shipment to {{place}}",
  "outbound.release.done_one": "{{count}} order is on the scanner now.",
  "outbound.release.done_other": "{{count}} orders are on the scanner now.",
  "outbound.release.doneShort_one": "{{count}} order is on the scanner now; {{short}} line(s) fall short.",
  "outbound.release.doneShort_other": "{{count}} orders are on the scanner now; {{short}} line(s) fall short.",
  "outbound.release.reserved_one": "{{count}} pallet reserved.",
  "outbound.release.reserved_other": "{{count}} pallets reserved.",
  "outbound.reserve.again": "Reserve again",
  "outbound.reserve.mode": "Reserved when made pickable",
  "outbound.reserve.title": "Reserved pallets",
  "outbound.reserve.col.place": "Place",
  "outbound.reserve.col.batch": "Batch",
  "outbound.reserve.col.bestBefore": "Best before",
  "outbound.reserve.col.quantity": "Quantity",
  "outbound.reserve.col.how": "Goes",
  "outbound.reserve.col.state": "Status",
  "outbound.reserve.whole": "Whole pallet",
  "outbound.reserve.part": "Part, the rest goes back",
  "outbound.reserve.state.active": "Reserved",
  "outbound.reserve.state.picked": "Picked",
  "outbound.reserve.hint": "A pallet that fits in what a line still needs goes whole; otherwise a part of the oldest. After a part, the pallet gets a return task at Put away.",
  "outbound.reserve.done_one": "{{count}} more pallet reserved.",
  "outbound.reserve.done_other": "{{count}} more pallets reserved.",
  "outbound.reserve.doneShort_one": "{{count}} more pallet reserved; {{short}} line(s) still fall short.",
  "outbound.reserve.doneShort_other": "{{count}} more pallets reserved; {{short}} line(s) still fall short.",
  "outbound.release.withdrawn_one": "{{count}} order was taken off the scanner.",
  "outbound.release.withdrawn_other": "{{count}} orders were taken off the scanner.",
  "outbound.release.withdrawnBusy_one": "{{count}} order was taken off the scanner; {{busy}} is being picked and stays.",
  "outbound.release.withdrawnBusy_other": "{{count}} orders were taken off the scanner; {{busy}} is being picked and stays.",
  "outbound.release.mancoTitle_one": "{{count}} line falls short",
  "outbound.release.mancoTitle_other": "{{count}} lines fall short",
  "outbound.release.mancoWhy": "There is not enough stock for these lines, after what the orders made pickable earlier already need. Make them pickable all the same and those earlier orders go first; these lines fall short.",
  "outbound.release.order": "Order",
  "outbound.release.article": "Article",
  "outbound.release.needed": "Needed",
  "outbound.release.available": "Available",
  "outbound.release.leave": "Leave them",
  "outbound.release.anyway": "Make pickable anyway",
  "outbound.detail.shadow": "Shadow period: Scoretrace leads. What is picked here does not go to the customer.",
  "outbound.detail.deliveryCode": "address code {{code}}",
  "outbound.detail.together": "Together with",
  "outbound.detail.ownTransport": "The message says: own transport — Willems drives",
  "outbound.detail.fixedCarrier": "The message says: always {{carrier}}",
  "outbound.detail.alone": "This order alone",
  "outbound.detail.minBestBefore": "Min. best-before",
  "outbound.detail.noMinimum": "No demand",
  "outbound.detail.linkTitle": "Link the address",
  "outbound.detail.linkHint": "WLX did not find {{name}} ({{address}}) in the address book. Choose the address; the order then joins the shipping of that place and day.",
  "outbound.detail.linkNoRight": "The office links it, with the right to change orders.",
  "outbound.detail.unknownArticle": "Unknown article",
  "outbound.detail.wholePallet": "Whole pallet",
  "outbound.detail.deliverHint": "Delivered in: what the floor takes. Kilos become whole bags; a big bag rounds to the nearest whole big bag, at least one.",
  "outbound.lineState.open": "Open",
  "outbound.lineState.picked": "Picked",
  "outbound.lineState.short": "Short",
  "outbound.lineState.cancelled": "Cancelled",
  "outbound.lineState.unknown_article": "Unknown article",
  "outbound.unitKind.pallet": "Collecting pallet",
  "outbound.unitKind.box": "Shipping box",
  "outbound.unitKind.whole_pallet": "Whole pallet",
  "outbound.unitState.picked": "Picked",
  "outbound.unitState.staged": "On expedition",
  "outbound.unitState.loaded": "Loaded",
  "outbound.unitState.shipped": "Shipped",
  "outbound.unitState.stored": "Stored",

  "counts.tabsLabel": "Pallets or count differences",
  "counts.tab.pallets": "Pallets",
  "counts.tab.counts": "Count differences",
  "counts.tab.lostfound": "Lost & found",
  "counts.increaseHint": "Lost & found does not cover it all: choose the customer's reason to increase the rest.",
  "lostFound.intro": "What is missing waits here: part of a pallet with a number of its own, or a whole pallet with its SSCC. It counts in the customer's stock and is not picked. Found: put it back or away. Not found: write it off with the reason for the customer.",
  "lostFound.empty": "Nothing on lost & found.",
  "lostFound.footnote": "More counted than WLX has comes from lost & found first. Only writing off and increasing change the customer's stock; those two go into the mutation file with their reason.",
  "lostFound.col.number": "Number",
  "lostFound.col.from": "From",
  "lostFound.col.since": "Since",
  "lostFound.col.by": "By",
  "lostFound.col.reason": "Why",
  "lostFound.col.actions": "Actions",
  "lostFound.kind.part": "Part of a pallet",
  "lostFound.kind.pallet": "Whole pallet",
  "lostFound.moreLines_one": "+{{count}} line",
  "lostFound.moreLines_other": "+{{count}} lines",
  "lostFound.days_zero": "today",
  "lostFound.days_one": "{{count}} day",
  "lostFound.days_other": "{{count}} days",
  "lostFound.state.missing": "Missing",
  "lostFound.state.found": "Found · waits for the forklift",
  "lostFound.reason.not_found": "Pallet not found",
  "lostFound.chooseBookReason": "Choose the reason for the customer",
  "lostFound.bookReasonLabel": "Reason for the customer",
  "lostFound.reasonLabel": "Why",
  "lostFound.remarkLabel": "Remark",
  "lostFound.line": "Line",
  "lostFound.adjust.action": "Adjust quantity",
  "lostFound.adjust.title": "Adjust quantity · {{pallet}}",
  "lostFound.adjust.submit": "Adjust",
  "lostFound.adjust.explain": "What is less goes to lost & found. What is more comes from lost & found first; the rest is increased.",
  "lostFound.adjust.quantity": "Quantity in {{unit}} (now {{now}})",
  "lostFound.adjust.toLostFound": "To lost & found: {{amount}}. The customer's stock stays the same.",
  "lostFound.adjust.fromLostFound": "From lost & found: {{amount}} ({{numbers}}).",
  "lostFound.adjust.increase": "Increase: {{amount}}. The customer's stock goes up; choose the reason for the customer.",
  "lostFound.adjust.increaseNotAllowed": "Increase: {{amount}}. That needs the right Write off and increase.",
  "lostFound.done.to": "{{amount}} to lost & found ({{number}}).",
  "lostFound.done.from": "{{amount}} from lost & found ({{number}}).",
  "lostFound.done.increased": "{{amount}} increased.",
  "lostFound.lost.action": "Pallet missing",
  "lostFound.lost.title": "Pallet missing · {{pallet}}",
  "lostFound.lost.submit": "To lost & found",
  "lostFound.lost.explain": "The pallet stood on {{place}}. It goes to lost & found with its SSCC and is not picked any more. When the forklift scans it later, it is found and put away. The customer's stock stays the same.",
  "lostFound.lost.done": "{{pallet}} is on lost & found.",
  "lostFound.found.action": "Found",
  "lostFound.found.done": "{{pallet}} is found and ready to be put away.",
  "lostFound.return.action": "Put back",
  "lostFound.return.title": "Put back · {{number}}",
  "lostFound.return.submit": "Put back",
  "lostFound.return.explain": "Give the SSCC of the pallet it goes onto, or the place when one pallet with this article stands there. The customer's stock stays the same.",
  "lostFound.return.code": "Pallet or place",
  "lostFound.returned": "{{number}} is on {{pallet}} again.",
  "lostFound.writeOff.action": "Write off",
  "lostFound.writeOff.title": "Write off · {{number}}",
  "lostFound.writeOff.submit": "Write off",
  "lostFound.writeOff.explain": "Writing off takes it out of the customer's stock. The customer gets the reason back in the mutation file.",
  "lostFound.writeOff.explainAll": "Everything on this pallet ({{count}} lines) goes out of the customer's stock. The customer gets the reason back in the mutation file.",
  "lostFound.writeOff.quantity": "Quantity in {{unit}} (now {{now}})",
  "lostFound.writtenOff": "{{amount}} written off from {{number}}, reason {{code}}.",
  "lostFound.drawer.part": "This is a part on lost & found: what a pallet missed. Put it back onto a pallet when it is found, or write it off.",
  "lostFound.drawer.pallet": "This pallet is missing and on lost & found; it is not picked. When the forklift scans it, or you choose Found, it is put away.",
  "lostFound.error.bookNotAllowed": "Increasing {{amount}} needs the right Write off and increase.",
  "lostFound.error.bookReasonNeeded": "Lost & found does not cover {{amount}}: choose the customer's reason to increase it.",
  "lostFound.error.noPlace": "This warehouse has no lost & found place. Make one in Storage locations.",
  "lostFound.error.unknownTarget": "No pallet or place with code {{code}}.",
  "lostFound.error.emptyPlace": "No pallet stands on {{place}} in WLX.",
  "lostFound.error.ambiguousPlace": "More pallets stand on {{place}}: give the SSCC.",
  "lostFound.error.wholePallet": "A whole pallet is not put back: choose Found, and the forklift puts it away.",
  "lostFound.error.onLostFound": "What is on lost & found is put back or written off.",
  "lostFound.error.part": "This is a part on lost & found, not a pallet: put it back onto a pallet.",
  "lostFound.error.notATarget": "Put it back onto a pallet in stock in the same warehouse.",
  "whwork.intro": "What happens on the floor now, and what was loaded today.",
  "whwork.tile.ready": "Ready before {{time}}",
  "whwork.tile.readyNoTime": "Ready today",
  "whwork.tile.readyNote": "orders with load day today, picked or shipped",
  "whwork.tile.late": "Will not make {{time}}",
  "whwork.tile.lateNoTime": "Late",
  "whwork.tile.lateNote": "orders still open from an earlier load day or past the ready-by time",
  "whwork.tile.replenish": "Replenish · empty",
  "whwork.tile.replenishNote": "pick locations with a pallet ready in bulk",
  "whwork.tile.counts": "Count differences",
  "whwork.tile.countsNote": "waiting for the team leader",
  "whwork.tile.open": "Open",
  "whwork.now": "Work now",
  "whwork.loadsToday": "Loads today",
  "whwork.nothingNow": "No open work.",
  "whwork.noLoads": "Nothing loaded yet today.",
  "whwork.kind.load": "Load",
  "whwork.kind.replenish": "Replenish",
  "whwork.kind.pick": "Pick",
  "whwork.kind.count": "Count",
  "whwork.kind.putaway": "Put away",
  "whwork.kind.fetch": "Fetch",
  "whwork.state.open": "Open",
  "whwork.state.in_progress": "In progress",
  "whwork.state.waiting": "Waiting",
  "whwork.loadState.open": "Loading",
  "whwork.loadState.done": "Done",
  "whwork.loadState.cancelled": "Cancelled",
  "whwork.loadKind.own_transport": "Own transport",
  "whwork.loadKind.pickup": "Pickup",
  "whwork.loadKind.carrier": "Carrier",
  "whwork.col.kind": "Kind",
  "whwork.col.what": "For",
  "whwork.col.fromTo": "From → to",
  "whwork.col.who": "Employee",
  "whwork.col.since": "Since",
  "whwork.col.state": "Status",
  "whwork.col.load": "Load",
  "whwork.col.forWhom": "Carrier or address",
  "whwork.col.vehicle": "Plate",
  "whwork.col.units": "Pallets",
  "whwork.col.checks": "Checks",
  "whwork.col.started": "Started",
  "whwork.col.done": "Done",
  "whwork.units_one": "{{count}} pallet",
  "whwork.units_other": "{{count}} pallets",
  "whwork.nobody": "Nobody",
  "whwork.clean": "Clean",
  "whwork.notClean": "Not clean",
  "whwork.seal": "seal {{seal}}",
  "replenishment.viewLabel": "View",
  "replenishment.view.now": "Now ({{count}})",
  "replenishment.view.done": "Done today ({{count}})",
  "replenishment.today_one": "{{count}} replenished today",
  "replenishment.today_other": "{{count}} replenished today",
  "replenishment.todayAverage_one": "{{count}} replenished today · on average {{minutes}} min from empty to filled",
  "replenishment.todayAverage_other": "{{count}} replenished today · on average {{minutes}} min from empty to filled",
  "replenishment.col.pickLocation": "Pick location",
  "replenishment.col.article": "Article",
  "replenishment.col.since": "Left",
  "replenishment.col.pallet": "Pallet to put there",
  "replenishment.col.why": "Why this one",
  "replenishment.col.task": "Task",
  "replenishment.col.doneAt": "Time",
  "replenishment.col.palletPut": "Pallet",
  "replenishment.col.from": "From",
  "replenishment.col.doneBy": "By",
  "replenishment.col.minutes": "Empty to filled",
  "replenishment.why.fefo": "Oldest batch (FEFO)",
  "replenishment.why.countedZero": "Counted at 0 · correct the count first",
  "replenishment.why.noStock": "No pallet in stock",
  "replenishment.op": "Empty",
  "replenishment.countedZero": "Counted 0",
  "replenishment.bestBefore": "BB {{date}}",
  "replenishment.taskOpen": "In progress",
  "replenishment.taskNobody": "Open · nobody",
  "replenishment.minutes_one": "{{count}} min",
  "replenishment.minutes_other": "{{count}} min",
  "replenishment.emptyNow": "No pick location is empty.",
  "replenishment.emptyDone": "Nothing replenished yet today.",
  "replenishment.how": "How WLX chooses: a pick location is empty when no pallet stands on it any more (the last bag was picked) or when it was counted blind at 0. The pallet that goes there is the oldest batch (FEFO) from bulk; a pallet with the same batch and best-before is fine too. The empty pallet was signed off with the last bag. A count at 0 while WLX still has stock waits until the difference is corrected. Putting ready when nearly empty comes later.",
  "counts.intro": "Counted blind after the last pick on a location, and not what WLX expected. Correct the stock with a reason, or have the location counted again.",
  "counts.viewLabel": "Which counts",
  "counts.view.open": "Open",
  "counts.view.all": "All",
  "counts.empty": "No count differences.",
  "counts.emptyAll": "Nothing counted yet.",
  "counts.footnote": "Correcting puts the difference of that count on the location, so what was picked since stays picked. Counting again makes a task on the scanner; the newest count replaces this one.",
  "counts.col.location": "Location",
  "counts.col.article": "Article and batch",
  "counts.col.expected": "Expected",
  "counts.col.counted": "Counted",
  "counts.col.difference": "Difference",
  "counts.col.by": "Counted by",
  "counts.col.at": "Counted at",
  "counts.col.state": "Status",
  "counts.col.action": "Resolve",
  "counts.col.reason": "Reason",
  "counts.state.open": "Difference",
  "counts.state.recount": "Count again",
  "counts.state.matched": "Matches",
  "counts.state.corrected": "Corrected",
  "counts.state.superseded": "Counted again",
  "counts.chooseReason": "Choose reason",
  "counts.reason.wrong_pick": "Wrong pick",
  "counts.reason.damaged": "Damage",
  "counts.reason.count_error": "Earlier count error",
  "counts.reason.unknown": "Unknown",
  "counts.correct": "Correct",
  "counts.recount": "Count again",
  "counts.waitingScanner": "A task on the scanner",
  // Pallets (docs/tms-emballage.md)
  "pallets.kind.euro": "Euro pallets",
  "pallets.kind.disposable": "Disposable",
  "pallets.kind.various": "Various",
  "pallets.kind.eurochep": "Eurochep",
  "pallets.kind.ibc": "IBC",
  "pallets.kind.pc_iconic": "PC Iconic",
  "pallets.kind.blokchep": "Block Chep",
  "pallets.kind.tank": "Tank",
  "pallets.kind.magnum": "Magnum",
  "pallets.kind.tosca_euro": "Tosca euro",
  "pallets.kind.h1": "H1",
  "pallets.kind.pc_ultra": "PC Ultra",
  "pallets.kind.tosca_blok": "Tosca block",
  "pallets.kind.h3": "H3",
  "pallets.kind.dusseldorfer": "Dusseldorfer",
  "pallets.kind.cbl17": "CBL 17",
  "pallets.kindColumn": "Kind",
  "pallets.planned": "Planned",
  "pallets.actual": "Actual",
  "pallets.unloaded": "Unloaded",
  "pallets.loaded": "Loaded",
  "pallets.returned": "Returned",
  "pallets.removeKind": "Remove kind",
  "pallets.addKind": "Add a kind…",
  "pallets.none": "No pallets",
  "pallets.atLoading": "Loading",
  "pallets.atUnloading": "Unloading",
  "pallets.orderIntro": "Per loading and unloading address the pallets exchanged. Planned goes into box 13 of the CMR; actual is what the signed CMR says.",
  "pallets.emballageNotAllReturned": "Not all emballage returned: {{amount}} · {{reason}}",
  "pallets.emballageAllReturned": "All emballage returned, says the driver",
  "pallets.emballageScanned_one": "1 barcode scanned back by the driver (CHEP {{chep}}, other {{other}})",
  "pallets.emballageScanned_other": "{{count}} barcodes scanned back by the driver (CHEP {{chep}}, other {{other}})",
  "pallets.emballageKindEpw": "EPW",
  "pallets.emballageKindTank": "Tank, IBC or CHEP pallet (GRAI)",
  "pallets.toCheck": "Still to check",
  "pallets.checkedBy": "Checked by {{who}}, {{when}}",
  "pallets.state.open": "To check",
  "pallets.state.checked": "Checked",
  "pallets.list.intro": "All consignments with pallets that have been unloaded, also without a CMR. Click a row to look at it or open it again.",
  "pallets.list.colUnloaded": "Unloaded",
  "pallets.list.colFrom": "Loading address",
  "pallets.list.colTo": "Unloading address",
  "pallets.list.colCustomer": "Customer",
  "pallets.list.colConsignment": "Order",
  "pallets.list.colTrip": "Trip",
  "pallets.list.colPallets": "Pallets",
  "pallets.list.colCmr": "CMR",
  "pallets.list.colChecked": "Checked",
  "pallets.list.empty.open": "Nothing to check.",
  "pallets.list.empty.checked": "Nothing checked yet.",
  "pallets.cmrThere": "Signed",
  "pallets.cmrMissing": "Not signed",
  "pallets.cmrNone": "No CMR back",
  "pallets.cmrArea": "Part of the CMR",
  "pallets.area.box13": "Box 13",
  "pallets.area.page": "Whole CMR",
  "pallets.openCmr": "Open CMR",
  "pallets.cmrPictureFailed": "The CMR could not be shown. Open it on its own.",
  "pallets.cmrAlt": "CMR of consignment {{number}}",
  "pallets.noCmr": "There is no CMR for this consignment yet.",
  "pallets.noCmrReturn": "No signed CMR comes back of this consignment.",
  "pallets.prefilled": "Actual is set to planned. Change what the CMR says otherwise.",
  "pallets.reopen": "Reopen",
  "pallets.check": "Checked",
  "purchaseInvoices.intro": "The invoices our suppliers send. Add the pdf, fill in and code the invoice, and send it to AFAS. There the reviewer approves it in the purchase invoice workflow.",
  "purchaseInvoices.add": "Add purchase invoice",
  "purchaseInvoices.uploading": "Adding…",
  "purchaseInvoices.empty": "No purchase invoices yet.",
  "purchaseInvoices.notTypedIn": "Not filled in yet",
  "purchaseInvoices.fromMail": "By mail from {{from}} on {{at}}: {{subject}}",
  "purchaseInvoices.untitled": "New purchase invoice",
  "purchaseInvoices.notFound": "This purchase invoice does not exist (any more).",
  "purchaseInvoices.colStatus": "Status",
  "purchaseInvoices.colSupplier": "Supplier",
  "purchaseInvoices.colCreditor": "Creditor",
  "purchaseInvoices.colNumber": "Invoice number",
  "purchaseInvoices.colInvoiceDate": "Invoice date",
  "purchaseInvoices.colTotal": "Total",
  "purchaseInvoices.colAfasInvoice": "Number in AFAS",
  "purchaseInvoices.colCreatedAt": "Added",
  "purchaseInvoices.status.draft": "To fill in",
  "purchaseInvoices.status.queued": "On its way to AFAS",
  "purchaseInvoices.status.booked": "In AFAS",
  "purchaseInvoices.status.dry_run": "Trial, not in AFAS",
  "purchaseInvoices.status.failed": "Failed",
  "purchaseInvoices.kind.invoice": "Invoice",
  "purchaseInvoices.kind.credit_note": "Credit note",
  "purchaseInvoices.fieldKind": "Kind",
  "purchaseInvoices.fieldAdministration": "Administration",
  "purchaseInvoices.administrationHelp": "The addressee on the invoice decides.",
  "purchaseInvoices.administrationChoose": "Choose…",
  "purchaseInvoices.administration.1": "1 · Holding Willems Logistics B.V.",
  "purchaseInvoices.administration.2": "2 · Willems Logistics B.V.",
  "purchaseInvoices.administration.3": "3 · Willems Logistics O.G. B.V.",
  "purchaseInvoices.fieldCreditor": "Creditor (IR number)",
  "purchaseInvoices.knownAs": "In WLX: {{name}}",
  "purchaseInvoices.fieldSupplier": "Supplier",
  "purchaseInvoices.fieldNumber": "Supplier's invoice number",
  "purchaseInvoices.fieldNumberHelp": "Becomes the document number in AFAS. Not read, or read wrong: Point, and click the number on the pdf.",
  "purchaseInvoices.fieldInvoiceDate": "Invoice date",
  "purchaseInvoices.fieldDueDate": "Due date",
  "purchaseInvoices.fieldDueDateHelp": "AFAS works the due date out from the creditor's payment condition, also when the invoice says otherwise.",
  "purchaseInvoices.fieldDescription": "Description of the booking",
  "purchaseInvoices.fieldDescriptionHelp": "The supplier, the invoice number and what was delivered; can be changed. No names of people.",
  "purchaseInvoices.fieldTotal": "Total incl. VAT",
  "purchaseInvoices.linesTitle": "Booking lines",
  "purchaseInvoices.colAccount": "Account",
  "purchaseInvoices.colDim1": "Cost centre",
  "purchaseInvoices.colDim2": "Location",
  "purchaseInvoices.colDim3": "Licence plate",
  "purchaseInvoices.colCommitment": "Commitment",
  "purchaseInvoices.commitmentNone": "None",
  "purchaseInvoices.dimRequired": "required",
  "purchaseInvoices.dimNone": "not used",
  "purchaseInvoices.dimNotAllowedHere": "AFAS does not allocate this code to account {{account}}. Pick a code from the list.",
  "purchaseInvoices.pickNumber": "Point",
  "purchaseInvoices.pickNumberTitle": "Point at the invoice number on the pdf",
  "purchaseInvoices.pickNumberPrompt": "Click the supplier's invoice number on the pdf. In two pieces: click the first, point again and click the last with Shift. Esc stops.",
  "purchaseInvoices.explainTitleHead": "Why do you change what WLX read?",
  "costSplit.listTitle": "Key of Klopsteen 6",
  "costSplit.listIntro": "Per creditor the share that goes to Asian Food Group, on 29700 with cost centre 2100 and location 01. With a marker WLX splits by itself when the invoice has it; without one there is a button on the card.",
  "costSplit.colMarker": "Marker",
  "costSplit.colPercentage": "Asian Food",
  "costSplit.colCoding": "Account / cost centre / location",
  "costSplit.byButton": "with the button on the card",
  "purchaseInvoices.otherCreditor": "Other creditor",
  "purchaseInvoices.otherCreditorSearch": "IR number or name",
  "purchaseInvoices.otherCreditorHelp": "Choose the creditor and save: WLX asks why, then reads the invoice again for that creditor.",
  "purchaseInvoices.pickDateTitle": "Point at the invoice date on the pdf",
  "purchaseInvoices.pickDatePrompt": "Click the invoice date on the pdf. Esc stops.",
  "purchaseInvoices.pickDateUnreadable": "WLX does not know \"{{text}}\" as a date. Point at the date.",
  "purchaseInvoices.pickTotalTitle": "Point at the total on the pdf",
  "purchaseInvoices.pickTotalPrompt": "Click the invoice's total on the pdf. Esc stops.",
  "purchaseInvoices.pickTotalUnreadable": "WLX does not know \"{{text}}\" as an amount. Point at the total.",
  "purchaseInvoices.vatMissing": "VAT missing",
  "purchaseInvoices.vatMissingHelp": "There is no VAT line. At the rate it would be {{amount}}, but that does not go to AFAS. Read the invoice again.",
  "purchaseInvoices.codingField.invoiceDate": "invoice date",
  "purchaseInvoices.codingField.total": "total",
  "purchaseInvoices.codingField.creditorNumber": "creditor",
  "purchaseInvoices.codingField.commitment": "commitment",
  "purchaseInvoices.explainChangeHead": "{{field}}: {{from}} → {{to}}",
  "purchaseInvoices.readBy.chosen": "a choice on this card",
  "purchaseInvoices.readFlag.net_not_found": "Note: WLX did not find the net and the VAT in the text of the invoice. The line is at 0.00 for that; do not fill it in yourself, but read the invoice again or report Reading is wrong.",
  "purchaseInvoices.error.PURCHASE_INVOICE_UNKNOWN_CREDITOR": "AFAS does not know that creditor, or it is blocked.",
  "purchaseInvoices.error.PURCHASE_INVOICE_UNKNOWN_COMMITMENT": "That is no open commitment of this creditor.",
  "purchaseInvoices.error.PURCHASE_INVOICE_UNKNOWN_SPLIT": "That key does not belong to this creditor.",
  "purchaseInvoices.error.PURCHASE_INVOICE_ALREADY_SPLIT": "The invoice is split already, or has no lines.",
  "purchaseInvoices.error.MOTOR_TAX_SPEC_UNREADABLE": "This is no specification of GWH, or its lines do not add up to its total.",
  "purchaseInvoices.error.MOTOR_TAX_SPEC_OTHER_NOTICE": "This specification belongs to kenmerk {{specification}}, the notice has {{invoice}}.",
  "purchaseInvoices.error.MOTOR_TAX_SPEC_TOTAL": "The specification adds up to {{specification}}, the notice is {{invoice}}.",
  "purchaseInvoices.error.MOTOR_TAX_SPEC_NO_LINE": "The notice has no line yet to code the plates as. Read it first.",
  "costSplit.title": "Passed on for Klopsteen 6",
  "costSplit.intro": "Is this invoice for Klopsteen 6 in Haps? Then a share goes to Asian Food Group on 29700. Write why and choose the split.",
  "costSplit.explanation": "Explanation (required)",
  "costSplit.apply": "Split by the key ({{percentage}} % Asian Food)",
  "costSplit.applyMarker": "Split: {{marker}} ({{percentage}} % Asian Food)",
  "costSplit.done": "Split by the key: {{percentage}} % to Asian Food on 29700, recognised by {{marker}}.",
  "motorTax.title": "Motor vehicle tax",
  "motorTax.intro": "Kenmerk {{kenmerk}}. The amounts per plate are in GWH's specification (the text file). When it comes into the mailbox WLX adds it by itself; else add it here.",
  "motorTax.summary": "Specification {{file}}: {{vehicles}} plates, per plate a line per month.",
  "motorTax.upload": "Add specification",
  "motorTax.uploadOther": "Other specification",
  "purchaseInvoices.pickNoText": "WLX found no words on this pdf to point at. Report it with Reading is wrong.",
  "purchaseInvoices.pickFallback": "Nothing can be pointed at in the browser's viewer: type the number in.",
  "purchaseInvoices.accountUnknown": "Not known in AFAS",
  "purchaseInvoices.commitmentsTitle": "Open commitments in AFAS",
  "purchaseInvoices.commitmentsHelp": "Of this creditor. A line with a commitment settles it in AFAS.",
  "purchaseInvoices.colCommitmentNumber": "Number",
  "purchaseInvoices.colReference": "Reference",
  "purchaseInvoices.colCoding": "Account · axis",
  "purchaseInvoices.colAmount": "Amount",
  "purchaseInvoices.colBalance": "Balance",
  "purchaseInvoices.colOnInvoice": "On this invoice",
  "purchaseInvoices.colRemaining": "Difference",
  "purchaseInvoices.commitmentNamed": "on the invoice",
  "purchaseInvoices.colVatCode": "VAT code",
  "purchaseInvoices.colLineDescription": "Description",
  "purchaseInvoices.colNet": "Net",
  "purchaseInvoices.colActions": "Actions",
  "purchaseInvoices.addLine": "Add line",
  "purchaseInvoices.removeLine": "Remove",
  "purchaseInvoices.vatLine": "VAT on {{net}}",
  "purchaseInvoices.sum": "Lines plus VAT:",
  "purchaseInvoices.difference": "Difference with the total: {{amount}}",
  "purchaseInvoices.vat.4": "4 · 21 %",
  "purchaseInvoices.vat.5": "5 · 9 %",
  "purchaseInvoices.vat.6": "6 · 0 %",
  "purchaseInvoices.vat.32": "32 · reverse charge",
  "purchaseInvoices.vat.36": "36 · import outside the EU",
  "purchaseInvoices.vat.37": "37 · intra-EU acquisition 21 %",
  "purchaseInvoices.vat.38": "38 · intra-EU acquisition 9 %",
  "purchaseInvoices.vat.39": "39 · intra-EU acquisition 0 %",
  "purchaseInvoices.vat.99": "99 · no VAT",
  "purchaseInvoices.problemsTitle": "Not ready for AFAS yet:",
  "purchaseInvoices.problem.no_creditor": "The creditor (IR number) is missing.",
  "purchaseInvoices.problem.no_invoice_number": "The supplier's invoice number is missing.",
  "purchaseInvoices.problem.no_invoice_date": "The invoice date is missing.",
  "purchaseInvoices.problem.no_total": "The total is missing.",
  "purchaseInvoices.problem.no_lines": "There is no booking line yet.",
  "purchaseInvoices.problem.line_incomplete": "A booking line has no account or no VAT code.",
  "purchaseInvoices.problem.unknown_vat_code": "A VAT code is not a purchase code of AFAS.",
  "purchaseInvoices.problem.vat_not_on_invoice": "There is VAT on a code without VAT on the invoice.",
  "purchaseInvoices.problem.sum_mismatch": "The lines plus the VAT do not equal the total.",
  "purchaseInvoices.problem.duplicate": "This creditor already has a purchase invoice with this number in WLX.",
  "purchaseInvoices.problem.no_administration": "The administration is missing.",
  "purchaseInvoices.problem.dim_unknown": "AFAS does not know a cost centre, location or licence plate.",
  "purchaseInvoices.problem.dim_required": "The account asks for a cost centre, location or licence plate that is still empty.",
  "purchaseInvoices.problem.dim_not_used": "A line has a code on an axis the account does not use.",
  "purchaseInvoices.problem.dim_not_allowed": "A code on cost centre, location or licence plate is not allocated in AFAS to the ledger account of its line (outlined red). Pick a code from the list at the field.",
  "purchaseInvoices.problem.commitment_unknown": "A commitment on a line is not open in AFAS for this creditor and administration.",
  "purchaseInvoices.delete": "Delete",
  "purchaseInvoices.deleteConfirm": "Delete this purchase invoice and its pdf?",
  "purchaseInvoices.book": "To AFAS",
  "purchaseInvoices.bookAgain": "To AFAS again",
  "purchaseInvoices.saveFirst": "Save your changes first.",
  "purchaseInvoices.bookingOff": "Sending to AFAS is not switched on yet.",
  "purchaseInvoices.afasTitle": "AFAS",
  "purchaseInvoices.queuedText": "On its way to AFAS. The answer comes by itself.",
  "purchaseInvoices.noAnswer": "No answer",
  "purchaseInvoices.noAnswerTitle": "No answer from AFAS",
  "purchaseInvoices.noAnswerText": "On its way since {{at}}, and no answer yet. The message may not have reached the DataBridge. First check in AFAS whether the invoice is there after all. If it is not, reset it and send it to AFAS again.",
  "purchaseInvoices.noAnswerReset": "Reset",
  "purchaseInvoices.dryRunText": "The DataBridge treated it as a trial: not booked. The booking is in the DataBridge log.",
  "purchaseInvoices.bookedText": "Booked in AFAS with the pdf. The purchase invoice workflow now runs in AFAS.",
  "purchaseInvoices.stage.entry": "AFAS refused the booking.",
  "purchaseInvoices.stage.attachment": "Booked, but without the pdf and without the workflow. Block it for payment in AFAS and add the pdf.",
  "purchaseInvoices.stage.send": "The message could not reach the DataBridge.",
  "purchaseInvoices.stage.no_answer": "No answer from AFAS; reset. If it is not in AFAS, send it again.",
  "purchaseInvoices.afasInvoice": "Internal invoice number",
  "purchaseInvoices.afasEntry": "Journal entry",
  "purchaseInvoices.afasSubject": "Dossier item",
  "purchaseInvoices.queuedAt": "Sent to AFAS",
  "purchaseInvoices.answeredAt": "Answer",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_A_PDF": "This file is not a pdf.",
  "purchaseInvoices.error.PURCHASE_INVOICE_PDF_TOO_LARGE": "The pdf is larger than 10 MB.",
  "purchaseInvoices.error.PURCHASE_INVOICE_LOCKED": "This purchase invoice is on its way to AFAS or in it already.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_WAITING": "This invoice is not (or no longer) waiting for an answer from AFAS.",
  "purchaseInvoices.error.PURCHASE_INVOICE_BOOKING_OFF": "Sending to AFAS is not switched on yet.",
  "purchaseInvoices.error.PURCHASE_INVOICE_INCOMPLETE": "This purchase invoice is not ready for AFAS yet.",
  "purchaseInvoices.error.amount": "An amount is not right. Write it as 1234.56.",
  "purchaseInvoices.reading": "WLX is reading the invoice…",
  "purchaseInvoices.readAgain": "Read again",
  "purchaseInvoices.readFailed": "Reading failed. Fill the invoice in yourself, or try again.",
  "purchaseInvoices.readNoText": "This pdf has no text WLX can read. Fill the invoice in yourself.",
  "purchaseInvoices.readCreditor": "Recognised as {{name}} ({{number}}), by {{by}}.",
  "purchaseInvoices.readCandidates": "More creditors fit ({{numbers}}). Pick one yourself.",
  "purchaseInvoices.readNoCreditor": "No creditor recognised. Choose it with Other creditor, with why.",
  "purchaseInvoices.readFilled": "Filled in: {{fields}}. Check it beside the pdf.",
  "purchaseInvoices.readUncertain": "Not taken over, as not found like that in the text: {{fields}}.",
  "purchaseInvoices.readTotalFromParts": "The total ({{total}}) is not legible in the text, the net and VAT are: together they make up the total to the cent. Check it beside the pdf.",
  "purchaseInvoices.readWithAi": "Read with AI.",
  "purchaseInvoices.readWithoutAi": "Read without AI: only VAT number, IBAN and CoC number.",
  "purchaseInvoices.readAiFailed": "The AI model gave no answer: only VAT number, IBAN and CoC number read.",
  "purchaseInvoices.readOcr": "The pdf was a scan: the text comes from OCR.",
  "purchaseInvoices.readBy.vat": "the VAT number",
  "purchaseInvoices.readBy.iban": "the IBAN",
  "purchaseInvoices.readBy.coc": "the CoC number",
  "purchaseInvoices.readBy.name": "the name",
  "purchaseInvoices.readBy.learned": "an earlier choice in WLX (VAT or CoC number)",
  "purchaseInvoices.readBy.domain": "the web or mail address",
  "purchaseInvoices.readBy.charter_vat": "the VAT or CoC number of a charter in WLX",
  "purchaseInvoices.readFlag.iban_mismatch": "Mind: AFAS does not know the IBAN on this invoice for this creditor. Check with the supplier that the account number is right before you send it to AFAS.",
  "purchaseInvoices.readFlag.creditor_blocked": "Mind: this creditor is blocked in AFAS.",
  "purchaseInvoices.readFlag.payment_terms_mismatch": "Mind: the invoice states a payment term of {{invoice}} days, the creditor in AFAS has payment condition {{afas}}. Correct the creditor's payment condition in AFAS, so that AFAS works out the due date right.",
  "purchaseInvoices.readFlag.administration_unclear": "Mind: WLX could not tell the administration from the addressee. Choose it yourself.",
  "purchaseInvoices.readFlag.dim_unknown": "Mind: the coding had a cost centre, location or licence plate AFAS does not know. That field was left empty.",
  "purchaseInvoices.readFlag.commitments_several": "Mind: the invoice names more commitments and their balances do not add up to the net amount. Choose the commitment per line.",
  "purchaseInvoices.readField.creditorNumber": "creditor",
  "purchaseInvoices.readField.supplierName": "supplier",
  "purchaseInvoices.readField.supplierInvoiceNumber": "invoice number",
  "purchaseInvoices.readField.invoiceNumber": "invoice number",
  "purchaseInvoices.readField.invoiceDate": "invoice date",
  "purchaseInvoices.readField.dueDate": "due date",
  "purchaseInvoices.readField.total": "total",
  "purchaseInvoices.readField.kind": "kind",
  "purchaseInvoices.readField.lines": "booking lines",
  "purchaseInvoices.readField.vatLines": "VAT lines",
  "purchaseInvoices.readField.currency": "currency (not EUR)",
  "purchaseInvoices.readField.administration": "administration",
  "purchaseInvoices.readCodingDefault": "Coded with the creditor's preferred account and axes in AFAS.",
  "purchaseInvoices.readCodingHistory_one": "Coded like this creditor's previous invoice in AFAS.",
  "purchaseInvoices.readCodingHistory_other": "Coded like this creditor's last {{count}} invoices in AFAS.",
  "purchaseInvoices.readNever": "WLX has not read this invoice yet.",
  "purchaseInvoices.documentType.invoice": "Invoice",
  "purchaseInvoices.documentType.credit_note": "Credit note",
  "purchaseInvoices.documentType.reminder": "Payment reminder",
  "purchaseInvoices.documentType.statement": "Statement",
  "purchaseInvoices.documentType.order_confirmation": "Order confirmation",
  "purchaseInvoices.documentType.other": "Not an invoice",
  "purchaseInvoices.colDocument": "Document",
  "purchaseInvoices.notAnInvoice": "WLX thinks this is a {{type}}, not an invoice: it does not go to AFAS. If it is an invoice after all, set it back. If not, delete it.",
  "purchaseInvoices.notAnInvoiceOther": "WLX thinks this is not an invoice: it does not go to AFAS. If it is an invoice after all, set it back. If it is the CMR of an invoice, link it below. If not, delete it.",
  "purchaseInvoices.notAnInvoiceButton": "An invoice after all",
  "purchaseInvoices.problem.not_an_invoice": "This is not an invoice or a credit note.",
  "purchaseInvoices.readUbl": "Read from the e-invoice (UBL) the supplier sent with it.",
  "purchaseInvoices.readField.documentType": "kind of document",
  "purchaseInvoices.feedback.button": "Reading is wrong",
  "purchaseInvoices.feedback.title": "What was wrong?",
  "purchaseInvoices.feedback.note": "Explain: what did it say, and what should it have been?",
  "purchaseInvoices.feedback.send": "Report",
  "purchaseInvoices.feedback.cancel": "Cancel",
  "purchaseInvoices.feedback.needField": "Choose what was wrong.",
  "purchaseInvoices.feedback.open": "Reported on {{date}}, not looked at yet.",
  "purchaseInvoices.feedback.handled": "Reported on {{date}}, looked at.",
  "purchaseInvoices.feedbackField.creditor": "Creditor",
  "purchaseInvoices.feedbackField.number": "Invoice number",
  "purchaseInvoices.feedbackField.dates": "Dates",
  "purchaseInvoices.feedbackField.amounts": "Amounts or VAT",
  "purchaseInvoices.feedbackField.coding": "Account or axes",
  "purchaseInvoices.feedbackField.administration": "Administration",
  "purchaseInvoices.feedbackField.commitment": "Commitment",
  "purchaseInvoices.feedbackField.document_type": "Kind of document",
  "purchaseInvoices.feedbackField.other": "Other",
  "nav.readFeedback": "Reading reports",
  "readFeedback.title": "Reading reports",
  "readFeedback.intro": "What colleagues reported with \"Reading is wrong\". Look at it, improve the reading where needed, and mark the report as looked at.",
  "readFeedback.showHandled": "Also reports looked at",
  "readFeedback.colInvoice": "Invoice",
  "readFeedback.colFields": "What",
  "readFeedback.colNote": "Explanation",
  "readFeedback.colRead": "Read",
  "readFeedback.colBy": "Reported by",
  "readFeedback.colAt": "Reported on",
  "readFeedback.handle": "Looked at",
  "readFeedback.handledBy": "Looked at by {{name}}",
  "readFeedback.empty": "No open reports.",
  "readFeedback.read.text": "text",
  "readFeedback.read.ocr": "OCR",
  "readFeedback.read.ubl": "UBL",
  "readFeedback.read.none": "no text",
  "readFeedback.withAi": "with AI",
  "readFeedback.withoutAi": "without AI",
  "nav.fuelCardProducts": "Fuel card products",
  "fuelCard.title": "BP fuel card invoice",
  "fuelCard.intro": "The booking lines come from this invoice's specification: download it in BP's portal (Show invoiced transactions, Download to excel) and put it here.",
  "fuelCard.upload": "Add specification",
  "fuelCard.uploadOther": "Other specification",
  "fuelCard.rebuild": "Make the lines again",
  "fuelCard.summary": "Specification {{file}}: {{rows}} transactions, {{plates}} licence plates. Net {{net}}, VAT {{vat}}.",
  "fuelCard.country": "{{name}} {{net}} + VAT {{vat}}",
  "fuelCard.countryUnknown": "country unknown",
  "fuelCard.unknown": "No account yet for: {{products}}. Give them an account and make the lines again.",
  "fuelCard.toProducts": "To fuel card products",
  "fuelCard.productsTitle": "Fuel card products",
  "fuelCard.productsIntro": "Which ledger account a product on a BP invoice is booked on. A product not listed here stops the invoice until it has an account.",
  "fuelCard.unmappedTitle": "On a specification, without an account yet",
  "fuelCard.link": "Link",
  "fuelCard.colProduct": "Product (as in the specification)",
  "fuelCard.colAccount": "Account",
  "fuelCard.colAccountName": "Name in AFAS",
  "fuelCard.colActions": "Actions",
  "fuelCard.newProduct": "New product",
  "fuelCard.add": "Add",
  "fuelCard.save": "Save",
  "fuelCard.delete": "Delete",
  "fuelCard.deleteConfirm": "Take {{product}} out of the table? An invoice with this product cannot go to AFAS until it has an account again.",
  "purchaseInvoices.problem.fuel_card_unknown_product": "A product of the fuel card invoice has no account yet (Finance → Fuel card products).",
  "purchaseInvoices.error.FUEL_CARD_SPEC_FORMAT": "This is not BP's specification (an Excel with, among others, B2M factuurnummer, Product omschrijving, Nettobedrag VV and BTW bedrag VV).",
  "purchaseInvoices.error.FUEL_CARD_SPEC_EMPTY": "This specification holds no transactions.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_CURRENCY": "This specification is not in euros.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_MORE_INVOICES": "This specification holds more invoices ({{numbers}}). Download it per invoice.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_OTHER_INVOICE": "This specification is of invoice {{specification}}, not {{invoice}}.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_TOTAL": "The specification adds up to {{specification}}, the invoice is {{invoice}}.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_TOO_LARGE": "The specification is larger than 10 MB.",
  "purchaseInvoices.error.FUEL_CARD_SPEC_NONE": "This invoice has no specification yet.",
  "purchaseInvoices.readCodingCommitment": "Coded with the account and axes of the commitment in AFAS.",
  "purchaseInvoices.readAdministrationAddressee": "Administration {{name}}, from the addressee.",
  "purchaseInvoices.readAdministrationCommitment": "Administration {{name}}, from the commitment.",
  "purchaseInvoices.readCommitments_one": "The invoice names commitment {{numbers}}.",
  "purchaseInvoices.readCommitments_other": "The invoice names commitments {{numbers}}.",
  "purchaseInvoices.readPlate": "Licence plate {{plate}} found.",
  "purchaseInvoices.colCmr": "CMR",
  "purchaseInvoices.documentType.cmr": "CMR",
  "purchaseInvoices.cmr.missingShort": "CMR missing",
  "purchaseInvoices.cmr.requestedShort": "CMR requested",
  "purchaseInvoices.cmr.title": "CMR",
  "purchaseInvoices.cmr.missingTitle": "CMR missing",
  "purchaseInvoices.cmr.missingText": "Transport invoice on commitment {{commitments}} (account 41500): it does not go to AFAS without the CMR.",
  "purchaseInvoices.cmr.requiredText": "Transport invoice on commitment {{commitments}} (account 41500): the CMR goes to AFAS with the invoice, in the same pdf.",
  "purchaseInvoices.cmr.inPdf_one": "The CMR is in the pdf: page {{pages}}.",
  "purchaseInvoices.cmr.inPdf_other": "The CMR is in the pdf: pages {{pages}}.",
  "purchaseInvoices.cmr.source.mail": "from the same mail",
  "purchaseInvoices.cmr.source.reply": "from a later mail",
  "purchaseInvoices.cmr.source.manual": "added by hand",
  "purchaseInvoices.cmr.remove": "Remove",
  "purchaseInvoices.cmr.requested": "Requested from {{to}} on {{at}} by {{by}}.",
  "purchaseInvoices.cmr.ask": "Request CMR",
  "purchaseInvoices.cmr.askAgain": "Request again",
  "purchaseInvoices.cmr.askTo": "To",
  "purchaseInvoices.cmr.askPreview": "WLX replies from the mailbox to the mail of the invoice, in Dutch and English: “We have received your invoice {{number}}. A transport invoice must come with the CMR of the trip, and it is missing. We cannot process the invoice without it. Please send the CMR in reply to this e-mail.” As soon as the answer is in the purchase invoices folder, WLX puts the CMR with this invoice.",
  "purchaseInvoices.cmr.askSend": "Send",
  "purchaseInvoices.cmr.add": "Add CMR or photo",
  "purchaseInvoices.cmr.isCmr": "This is a CMR, not an invoice. WLX could not find which invoice it belongs to. Pick the invoice: the CMR then leaves the list and goes to AFAS with that invoice.",
  "purchaseInvoices.cmr.linkTo": "Pick the invoice…",
  "purchaseInvoices.cmr.noneWaiting": "No invoice is waiting for a CMR",
  "purchaseInvoices.cmr.link": "Link",
  "purchaseInvoices.cmr.maybeCmr": "Is this the CMR of an invoice? Pick the invoice: the document leaves the list and goes with that invoice to AFAS as its CMR.",
  "purchaseInvoices.cmr.linkAsCmr": "Link as CMR",
  "purchaseInvoices.cmr.sameMail": "In the same mail: {{file}}",
  "purchaseInvoices.cmr.optionSameMail": "From the same mail: {{name}}",
  "purchaseInvoices.problem.cmr_missing": "The CMR is missing: a transport invoice on a commitment on 41500 goes to AFAS only with its CMR.",
  "purchaseInvoices.problem.pdf_too_large": "The invoice and the CMR together are larger than 10 MB.",
  "purchaseInvoices.error.PURCHASE_INVOICE_IS_CMR": "This is a CMR, not an invoice.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_A_CMR": "Only a CMR, or a document that is no invoice, can be linked to an invoice.",
  "purchaseInvoices.error.PURCHASE_INVOICE_MAIL_OFF": "The purchase invoices mailbox is not set up.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NO_MAIL": "This invoice did not come by mail: there is nothing to reply to.",
  "purchaseInvoices.error.PURCHASE_INVOICE_CMR_NOT_MISSING": "This invoice needs no CMR, or has it already.",
  "purchaseInvoices.error.PURCHASE_INVOICE_MAIL_GONE": "The mail of this invoice is no longer in the mailbox.",
  "nav.codingRules": "Learned coding",
  "purchaseInvoices.pdfPages_one": "1 page",
  "purchaseInvoices.pdfPages_other": "{{count}} pages",
  "purchaseInvoices.pdfMarked": "yellow: what WLX read",
  "purchaseInvoices.pdfNotFound": "not found on the pdf",
  "purchaseInvoices.pdfZoomIn": "Larger",
  "purchaseInvoices.pdfZoomOut": "Smaller",
  "purchaseInvoices.pdfOpen": "Open",
  "purchaseInvoices.pdfFallback": "WLX could not draw the pdf itself; this is the browser's viewer, without marks and loupe.",
  "purchaseInvoices.fieldAutoPay": "Automatic payment",
  "purchaseInvoices.fromAfas": "As the creditor has it in AFAS.",
  "purchaseInvoices.fieldGAccount": "G-account",
  "purchaseInvoices.gAccountHelp": "Percentage from AFAS × total incl. VAT: that share goes to the G-account.",
  "purchaseInvoices.gAccountNoPercentage": "no percentage in AFAS",
  "purchaseInvoices.colPeriod": "Period",
  "purchaseInvoices.periodHead": "Head ({{period}})",
  "purchaseInvoices.periodHeadNone": "Head",
  "purchaseInvoices.periodVia": "{{period}} via {{account}}",
  "purchaseInvoices.periodTransit": "Booked through transit account {{account}}",
  "purchaseInvoices.correctionsTitle": "Changed by hand",
  "purchaseInvoices.correction": "Line {{line}}: {{field}} {{from}} → {{to}}. {{explanation}}",
  "purchaseInvoices.correctionNumber": "Invoice number {{from}} → {{to}}. {{explanation}}",
  "purchaseInvoices.correctionLearned": "learned",
  "purchaseInvoices.codingField.account": "account",
  "purchaseInvoices.codingField.dim1": "cost centre",
  "purchaseInvoices.codingField.dim2": "location",
  "purchaseInvoices.codingField.dim3": "licence plate",
  "purchaseInvoices.codingField.vatCode": "VAT code",
  "purchaseInvoices.codingField.period": "period",
  "purchaseInvoices.codingField.supplierInvoiceNumber": "invoice number",
  "purchaseInvoices.explainTitle": "Why do you change the coding?",
  "purchaseInvoices.explainChange": "Line {{line}}: {{field}} {{from}} → {{to}}",
  "purchaseInvoices.explainChangeNumber": "Invoice number: {{from}} → {{to}}",
  "purchaseInvoices.explainTitleNumber": "Why do you change the invoice number?",
  "purchaseInvoices.explainEmpty": "empty",
  "purchaseInvoices.explainWhy": "Explanation (required)",
  "purchaseInvoices.explainPlaceholder": "For example: reference Borculo is location 09 Borculo",
  "purchaseInvoices.explainLearn": "What does this apply to?",
  "purchaseInvoices.explainLearnAll": "for every invoice of {{creditor}}",
  "purchaseInvoices.explainLearnReference": "only with reference {{reference}}",
  "purchaseInvoices.explainNoCreditor": "Without a creditor WLX learns nothing; the explanation is kept.",
  "purchaseInvoices.explainPeriodOnly": "The period is kept with the explanation. WLX does not learn it: it belongs to this invoice.",
  "purchaseInvoices.explainNotLearned": "WLX keeps it with the explanation, but does not learn it: it belongs to this invoice.",
  "purchaseInvoices.readLocation": "Location {{code}} from reference {{reference}}.",
  "purchaseInvoices.readCostPeriods": "Costs per period: {{periods}}.",
  "purchaseInvoices.readLearned": "Learned: {{field}} {{value}}. {{explanation}} ({{by}})",
  "purchaseInvoices.readLearnedReference": "Learned for reference {{reference}}: {{field}} {{value}}. {{explanation}} ({{by}})",
  "purchaseInvoices.readFlag.g_account_no_percentage": "Note: the invoice has a G-account, but the creditor has no G-account percentage in AFAS. Put the percentage in AFAS and read the invoice again.",
  "purchaseInvoices.readFlag.g_account_unknown_iban": "Note: the G-account on the invoice is not a G-account of this creditor in AFAS. AFAS pays to the G-account it knows; check with the supplier.",
  "purchaseInvoices.readFlag.cost_periods_unsure": "Note: WLX could not make the weeks or dates on the invoice add up to the net amount. Everything is in the invoice date's period; change the period per line if that is wrong.",
  "purchaseInvoices.documentType.specification": "Specification",
  "purchaseInvoices.readBy.rule": "a fixed rule of finance",
  "purchaseInvoices.readFlag.plate_unknown": "Note: licence plate {{plate}} on the invoice is not in AFAS. The plate is left empty.",
  "purchaseInvoices.readFlag.department_unknown": "Note: WLX found no location for a department on the invoice. Fill in the location on that line yourself.",
  "purchaseInvoices.readFlag.vehicles_unsure": "Note: the amounts per licence plate do not add up to the total. Everything is on one line.",
  "purchaseInvoices.readFlag.fuel_card_unsure": "Note: WLX could not read the cards of this fuel card invoice so that they add up. Everything is on one line.",
  "purchaseInvoices.readField.gAccountPercentage": "G-account percentage",
  "purchaseInvoices.readField.description": "description",
  "purchaseInvoices.notice.transport_without_commitment": "Transport invoice without a commitment: a line is on 41500 or the creditor is a charter, but the invoice names no commitment in AFAS.",
  "purchaseInvoices.mail": "Mail",
  "purchaseInvoices.mailed": "Mailed to {{to}} on {{at}} by {{by}}",
  "purchaseInvoices.mailTitle": "Mail the invoice",
  "purchaseInvoices.mailHelp_one": "The mail goes from the mailbox of the purchase invoices, with the invoice attached.",
  "purchaseInvoices.mailHelp_other": "The mail goes from the mailbox of the purchase invoices, with {{count}} attachments: the invoice and what goes with it.",
  "purchaseInvoices.mailTo": "To",
  "purchaseInvoices.mailSubjectLabel": "Subject",
  "purchaseInvoices.mailSubject": "Your invoice {{number}}",
  "purchaseInvoices.mailBody": "Text",
  "purchaseInvoices.mailSend": "Send",
  "purchaseInvoices.explainLearnOnce": "this invoice only",
  "purchaseInvoices.spread": "Spread over months",
  "purchaseInvoices.spreadTitle": "Spread line {{line}} over months",
  "purchaseInvoices.spreadIntro": "The same amount each month. A month other than the invoice date's goes through 29100.",
  "purchaseInvoices.spreadFrom": "From",
  "purchaseInvoices.spreadTo": "Up to and including",
  "purchaseInvoices.perArticle": "Per article: a line per article",
  "purchaseInvoices.perArticleHelp": "A line for each article on the invoice, when the amounts make up the net. From the next read on.",
  "purchaseInvoices.colMailed": "Mailed",
  "purchaseInvoices.countsLabel": "Number per status",
  "purchaseInvoices.cmr.deadFreight": "No CMR needed: dead freight.",
  "purchaseInvoices.cmr.optionInAfas": "in AFAS",
  "purchaseInvoices.cmr.afas.queued": "On its way to AFAS",
  "purchaseInvoices.cmr.afas.done": "In AFAS",
  "purchaseInvoices.cmr.afas.failed": "AFAS refused",
  "purchaseInvoices.cmr.afas.dry_run": "Dry run, not in AFAS",
  "purchaseInvoices.cmr.afasAgain": "To AFAS again",
  "purchaseInvoices.readFlag.article_lines_unsure": "Note: WLX could not read the articles so that they add up. The invoice stands per VAT rate.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NO_OWN_CODING": "All earlier bookings of this creditor are on this account. Put the line on Willems' own account first.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NO_AFAS_DOSSIER": "WLX does not know this invoice's dossier item in AFAS. Add the document there by hand.",
  "purchaseInvoices.error.PURCHASE_INVOICE_BAD_SPREAD": "Choose at least two months and at most 36.",
  "motorTax.part": "A first specification is on it ({{file}}), but it is not the whole amount. WLX waits for the second.",
  "purchaseInvoices.tempAgency": "Employment agency: per department",
  "purchaseInvoices.tempAgencyHelp": "A line per department on cost centre 1100 with the department's location. From the next read on.",
  "purchaseInvoices.afasTerm": "By AFAS ({{days}} days): {{date}}",
  "purchaseInvoices.pickReadingScan": "Reading the words on the scan…",
  "purchaseInvoices.cmrPageSet": "This page is the CMR",
  "purchaseInvoices.cmrPageUnset": "No CMR",
  "purchaseInvoices.cmrPageChip": "CMR",
  "purchaseInvoices.colCommitmentPeriod": "Period",
  "purchaseInvoices.cmr.specification": "Specification",
  "purchaseInvoices.cmr.maybeSpecification": "This pdf has no invoice number of its own. Is it the specification of an invoice of the same mail? Link it: it then goes to AFAS with that invoice, behind it.",
  "purchaseInvoices.cmr.linkAsSpecification": "Link as specification",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_AN_IMAGE": "This file is no pdf and no photo (jpg, png or heic).",
  "fuelCard.supplier.BP": "BP",
  "fuelCard.supplier.VAN_KESSEL": "Van Kessel",
  "fuelCard.productsIntroVanKessel": "Charging (kWh) goes to 41030 by itself, fuel to 41020 and the card fee to 44100. Here you put a product WLX does not know, or another account. A product without an account stops the invoice.",
  "codingRules.word": "Word on the invoice",
  "codingRules.wordPlaceholder": "e.g. Garantieprovisie",
  "codingRules.add": "Add rule",
  "purchaseInvoices.problem.g_account_percentage_missing": "The invoice has a G-account, but the creditor has no percentage in AFAS.",
  "purchaseInvoices.problem.cost_period_invalid": "A line has a period that is not right.",
  "purchaseInvoices.error.PURCHASE_INVOICE_EXPLANATION_REQUIRED": "Say why you change the coding.",
  "purchaseInvoices.error.PURCHASE_INVOICE_LINES_FIXED": "Lines are not added or removed: only the coding changes.",
  "purchaseInvoices.error.PURCHASE_INVOICE_UNKNOWN_REFERENCE": "That reference is not on this invoice.",
  "purchaseInvoices.error.PURCHASE_INVOICE_NOT_ON_PDF": "That number is not in the text of the pdf. Point at the number on the pdf.",
  "codingRules.title": "Learned coding",
  "codingRules.intro": "What WLX learned from changes by hand on purchase invoices, with the explanation given, and rules by hand on a word in the invoice. WLX applies them when it reads the creditor's next invoice. Remove a rule that is wrong.",
  "codingRules.colCreditor": "Creditor",
  "codingRules.colWhen": "When",
  "codingRules.colField": "Field",
  "codingRules.colValue": "Becomes",
  "codingRules.colExplanation": "Explanation",
  "codingRules.colBy": "By",
  "codingRules.colActions": "Actions",
  "codingRules.whenAll": "every invoice",
  "codingRules.whenReference": "reference {{reference}}",
  "codingRules.openInvoice": "invoice",
  "codingRules.delete": "Remove",
  "codingRules.deleteConfirm": "Remove this learned coding? The creditor's next invoice is then coded as AFAS says again.",
  "codingRules.empty": "WLX has learned nothing yet.",
  "batchPick.button": "Batch picking",
  "batchPick.buttonBusy_one": "Batch picking · {{count}} round under way",
  "batchPick.buttonBusy_other": "Batch picking · {{count}} rounds under way",
  "batchPick.title": "Batch picking · {{warehouse}}",
  "batchPick.newRound": "New round",
  "batchPick.intro": "WLX takes the orders of the unloading day that are not pickable yet (P&O's on their load day), reserves exactly what they ask and sets it out on a pick place with batch-pick tasks. Once every task of the round is done, the orders are on the scanner. A second round for the same day takes only the orders that came later.",
  "batchPick.day": "Unloading day",
  "batchPick.look": "Look",
  "batchPick.noOrders": "No orders for {{day}} that can go into a round.",
  "batchPick.atLoading_one": "{{count}} line is taken from the rack at loading (a palletbox, or not to be split).",
  "batchPick.atLoading_other": "{{count}} lines are taken from the rack at loading (a palletbox, or not to be split).",
  "batchPick.short_one": "{{count}} line falls short:",
  "batchPick.short_other": "{{count}} lines fall short:",
  "batchPick.notInRound": "Not in the round: No batch picking on the address",
  "batchPick.start": "Start round",
  "batchPick.startAnyway": "Start all the same",
  "batchPick.nothing": "There are no orders left for this day.",
  "batchPick.changed": "Something now falls short that the preview did not show. Look at the round again.",
  "batchPick.rounds": "Rounds",
  "batchPick.noRounds": "No rounds in the last two weeks.",
  "batchPick.colDay": "Unloading day",
  "batchPick.colSetOut": "Set out",
  "batchPick.setOut": "{{done}} of {{total}}",
  "batchPick.orders_one": "{{count}} order",
  "batchPick.orders_other": "{{count}} orders",
  "batchPick.linesToSetOut_one": "{{count}} line to set out",
  "batchPick.linesToSetOut_other": "{{count}} lines to set out",
  "batchPick.fromPallets_one": "from {{count}} pallet",
  "batchPick.fromPallets_other": "from {{count}} pallets",
  "batchPick.palletsToSetOut_one": "{{count}} pallet to set out",
  "batchPick.palletsToSetOut_other": "{{count}} pallets to set out",
  "batchPick.summary": "{{orders}} for {{day}}: {{lines}} {{pallets}}.",
  "batchPick.started": "Round for {{day}} started: {{orders}}, {{pallets}}.",
  "batchPick.startedBy": "started {{when}} · {{who}}",
  "batchPick.startedAt": "started {{when}}",
  "batchPick.ready": "On the scanner",
  "batchPick.busy_one": "{{count}} pallet under way",
  "batchPick.busy_other": "{{count}} pallets under way",
  "batchPick.open": "To set out",
  "batchPick.fact": "Batch picking",
  "batchPick.factValue": "Round {{day}}",
  "batchPick.atLoadingChip": "At loading",
  "batchPick.atLoadingHint": "Taken from the rack at loading: not reserved and not picked.",

  // Transport → Magazijnorders (portal step 8).
  "warehouseOrders.search": "Search by number, customer or reference",
  "warehouseOrders.count_one": "{{count}} warehouse order",
  "warehouseOrders.count_other": "{{count}} warehouse orders",
  "warehouseOrders.new": "New warehouse order",
  "warehouseOrders.empty": "No warehouse orders yet.",
  "warehouseOrders.col.number": "Number",
  "warehouseOrders.col.customer": "Customer",
  "warehouseOrders.col.kind": "Kind",
  "warehouseOrders.col.warehouse": "Warehouse",
  "warehouseOrders.col.reference": "Customer reference",
  "warehouseOrders.col.day": "Day",
  "warehouseOrders.col.transport": "Transport",
  "warehouseOrders.col.status": "In Scoretrace",
  "warehouseOrders.col.document": "Number in Scoretrace",
  "warehouseOrders.col.transportOrder": "Transport order",
  "warehouseOrders.col.channel": "Entered in",
  "warehouseOrders.col.createdAt": "Entered on",
  "warehouseOrders.kind.outbound": "Outbound",
  "warehouseOrders.kind.inbound": "Inbound",
  "warehouseOrders.channel.portal": "Portal",
  "warehouseOrders.channel.manual": "Back-office",
  "warehouseOrders.transport.willems": "Willems drives",
  "warehouseOrders.transport.collected": "Collected",
  "warehouseOrders.transport.brought": "Brought in",
  "warehouseOrders.status.sending": "Being sent",
  "warehouseOrders.status.created": "In Scoretrace",
  "warehouseOrders.status.dry": "Dry (acceptance)",
  "warehouseOrders.status.refused": "Refused",
  "warehouseOrders.status.outside_wms": "Outside the stock",
  "warehouseOrders.outsideStock.new": "Collect outside the stock",
  "warehouseOrders.outsideStock.newTitle": "Collect outside the stock",
  "warehouseOrders.outsideStock.explain": "For what is collected at the warehouse but is not in the stock, mostly emballage. The order does not go to the WMS; you print the CMR from the order.",
  "warehouseOrders.outsideStock.submit": "Create pick-up order",
  "warehouseOrders.outsideStock.day": "Pick-up day",
  "warehouseOrders.outsideStock.kind": "Kind",
  "warehouseOrders.outsideStock.other": "Other",
  "warehouseOrders.outsideStock.otherHint": "What it is, e.g. roll containers",
  "warehouseOrders.outsideStock.cardExplain": "Collected outside the stock: this order does not go to the WMS. Print its CMR here.",
  "warehouseOrders.outsideStock.cmrPrinted": "CMR printed",
  "warehouseOrders.outsideStock.print": "Print CMR",
  "warehouseOrders.outsideStock.printTitle": "Print the CMR of {{number}}",
  "warehouseOrders.outsideStock.printHelp": "Box 16 and 23, the carrier, are filled in by hand at loading.",
  "warehouseOrders.outsideStock.printed": "The CMR goes to {{place}}.",
  "warehouseOrders.cardTitle": "Warehouse order {{number}}",
  "warehouseOrders.refusedBecause": "Scoretrace refused the order: {{reason}}",
  "warehouseOrders.dryExplain": "On acceptance nothing goes to Scoretrace: the order is in the DataBridge log as it would be sent.",
  "warehouseOrders.dayOut": "Day it leaves the warehouse",
  "warehouseOrders.dayIn": "Day of arrival",
  "warehouseOrders.deliveryDay": "Delivery day",
  "warehouseOrders.owner": "Owner in Scoretrace",
  "warehouseOrders.deliverTo": "Deliver to",
  "warehouseOrders.collectFrom": "Collect from",
  "warehouseOrders.dossier": "Dossier",
  "warehouseOrders.sent": "Sent",
  "warehouseOrders.answered": "Answer from Scoretrace",
  "warehouseOrders.resend": "Send again",
  "warehouseOrders.addressMissing": "This collected order has no delivery address. Scoretrace refuses it without one, and the CMR needs it: fill in where it goes and send it again.",
  "warehouseOrders.line.article": "Article",
  "warehouseOrders.line.description": "Description",
  "warehouseOrders.line.quantity": "Quantity",
  "warehouseOrders.line.unit": "Unit",
  "warehouseOrders.line.free": "Available",
  "warehouseOrders.line.batch": "Batch",
  "warehouseOrders.line.pallets": "Pallets",
  "warehouseOrders.line.pallet": "Pallet",
  "warehouseOrders.line.vas": "VAS",
  "warehouseOrders.vas.label": "VAS codes",
  "warehouseOrders.vas.placeholder": "Find a code",
  "warehouseOrders.vas.none": "No VAS codes for an order",
  "warehouseOrders.vas.order": "VAS for the whole order",
  "warehouseOrders.form.choosePallets": "Choose pallets",
  "warehouseOrders.form.palletsChosen_one": "{{count}} pallet",
  "warehouseOrders.form.palletsChosen_other": "{{count}} pallets",
  "warehouseOrders.form.perPallet": "Per pallet",
  "warehouseOrders.form.palletNumber": "Pallet no. {{n}}",
  "warehouseOrders.form.bestBefore": "BBD {{date}}",
  "warehouseOrders.form.batchFree": "{{n}} free",
  "warehouseOrders.form.submit": "Send to Scoretrace",
  "warehouseOrders.form.noOwner": "This customer has no WMS identifier (System identifiers on the relation card): a warehouse order is not possible.",
  "warehouseOrders.form.chooseOwner": "Choose an owner",
  "warehouseOrders.form.collectDay": "Collection day",
  "warehouseOrders.form.deliveryDay": "Delivery day",
  "warehouseOrders.form.name": "Name",
  "warehouseOrders.form.street": "Street",
  "warehouseOrders.form.houseNumber": "No.",
  "warehouseOrders.form.postalCode": "Postal code",
  "warehouseOrders.form.city": "City",
  "warehouseOrders.form.country": "Country",
  "warehouseOrders.form.from": "From",
  "warehouseOrders.form.to": "To",
  "warehouseOrders.form.pallets": "Pallets",
  "warehouseOrders.form.carrier": "Carrier",
  "warehouseOrders.form.weight": "Weight (kg)",
  "warehouseOrders.form.lines": "Articles",
  "warehouseOrders.form.stockAsOf": "Stock as of {{time}}",
  "warehouseOrders.form.stockFailed": "The stock cannot be fetched now: type the article codes yourself.",
  "warehouseOrders.form.stockLoading": "Fetching the stock…",
  "warehouseOrders.form.refresh": "Refresh",
  "warehouseOrders.form.notInStock": "Not in stock",
  "warehouseOrders.form.notAnArticle": "Not an article of this customer",
  "warehouseOrders.form.pickFromList_one": "1 line without an article from the list: choose the article",
  "warehouseOrders.form.pickFromList_other": "{{count}} lines without an article from the list: choose the article",
  "warehouseOrders.form.removeLine": "Remove line",
  "warehouseOrders.form.addLine": "Add a line",
  "warehouseOrders.form.remark": "Remark for the warehouse",
  "warehouseOrders.form.forWarehouse": "For the warehouse",
  "warehouseOrders.form.remarkLabel": "Remark",
  "warehouseOrders.carrier.europallet": "Euro pallet",
  "warehouseOrders.carrier.block_pallet": "Block pallet 0.5 lm",
  "warehouseOrders.carrier.block_pallet_06": "Block pallet 0.6 lm",
  "warehouseOrders.carrier.block_pallet_09": "Block pallet 0.9 lm",
  "warehouseOrders.carrier.ibc_02": "IBC 0.2 lm",
  "warehouseOrders.carrier.ibc_04": "IBC 0.4 lm",
  "warehouseOrders.carrier.ibc": "IBC 0.5 lm",
  "warehouseOrders.carrier.ibc_06": "IBC 0.6 lm",
  "warehouseOrders.carrier.big_bag": "Big bag 0.5 lm",
  "warehouseOrders.card.order": "Customer and order",
  "warehouseOrders.form.ownArticles_one": "{{count}} article of the customer",
  "warehouseOrders.form.ownArticles_other": "{{count}} articles of the customer",
  "warehouseOrders.form.batchChoose": "Choose or type",
  "warehouseOrders.form.palletsHint": "Tick the pallets that go out; the quantity becomes what is on them",
  "warehouseOrders.form.palletsHintBatch": "Tick the pallets of batch {{batch}} that go out; the quantity becomes what is on them",
  "warehouseOrders.form.noPalletsOfBatch": "No free pallets of this batch",
  "warehouseOrders.transport.delivers": "Willems delivers",
  "warehouseOrders.transport.collects": "Willems collects",
  "warehouseOrders.form.place": "Location or address",
  "warehouseOrders.form.collectedAddressHint": "Where it goes: needed for the CMR and for Scoretrace.",
  "warehouseOrders.form.stopReference": "Reference there",
  "warehouseOrders.form.goods": "Load",
  "warehouseOrders.form.count": "Number",
  "warehouseOrders.form.addGoods": "Another line of load",
  "warehouseOrders.form.goodsTotal": "Together {{pallets}} pieces, {{meters}} m loading metres",
  "warehouseOrders.carrier.roll_container": "Roll container",
  "warehouseOrders.carrier.box": "Colli or boxes",
  "warehouseOrders.carrier.other": "Other",
  "standingOrders.intro": "Orders that come back every week on the same days. WLX makes them every night for the next 14 days.",
  "standingOrders.new": "New standing order",
  "standingOrders.none": "No standing orders yet.",
  "standingOrders.back": "← Standing orders",
  "standingOrders.col.name": "Name",
  "standingOrders.col.customer": "Customer",
  "standingOrders.col.days": "Days",
  "standingOrders.col.route": "From → to",
  "standingOrders.col.upcoming": "Made",
  "standingOrders.col.valid": "Valid",
  "standingOrders.moreLines_one": "and {{count}} more line",
  "standingOrders.moreLines_other": "and {{count}} more lines",
  "standingOrders.upcomingUntil_one": "{{count}} order up to {{until}}",
  "standingOrders.upcomingUntil_other": "{{count}} orders up to {{until}}",
  "standingOrders.validFrom": "From {{from}}",
  "standingOrders.validFromUntil": "{{from}} up to {{until}}",
  "standingOrders.day.1": "Mon",
  "standingOrders.day.2": "Tue",
  "standingOrders.day.3": "Wed",
  "standingOrders.day.4": "Thu",
  "standingOrders.day.5": "Fri",
  "standingOrders.day.6": "Sat",
  "standingOrders.day.7": "Sun",
  "standingOrders.everyDay": "Every day",
  "standingOrders.card.head": "Standing order",
  "standingOrders.reference": "Reference",
  "standingOrders.referenceHelp": "Each order gets this text with its date as its invoice reference, for example Pendels Roquette 02-11-2026.",
  "standingOrders.validFromLabel": "Valid from",
  "standingOrders.validUntilLabel": "Valid up to and including",
  "standingOrders.validUntilHelp": "Empty: no end date.",
  "standingOrders.priority": "Priority",
  "standingOrders.pendelText": "Every order of this standing order is a factory shuttle",
  "pendelRoutes.from": "Loads at",
  "pendelRoutes.to": "Unloads at",
  "pendelRoutes.fromHelp": "Where the factory shuttles load, for instance FrieslandCampina NCB-laan 80 in Veghel. More than one may.",
  "pendelRoutes.toHelp": "Where they unload, for instance Doornhoek and Kempkens. A full load coming back drives the other way and belongs to the same route.",
  "pendelRoutes.departure": "Departure",
  "pendelRoutes.departureNone": "No fixed departure",
  "pendelRoutes.vehicles": "Own lorries",
  "pendelRoutes.vehiclesPlaceholder": "Find a lorry by fleet number or plate",
  "pendelRoutes.vehiclesHelp": "With its own lorries WLX puts every order on this route on the trip of one of them by itself, in turn: one trip per lorry per day, the first lorry gets the first order. Step 1 then leaves the route alone. When the planner takes an order off the trip, WLX does not put it back. Without own lorries the planner plans the route.",
  "pendelRoutes.departureHelp": "Where a trip on this route starts and ends while it has no lorry yet, for instance Haps for Nutrifeed. After that the lorry's standplaats counts, and a depot the planner chooses on the trip always goes first. Without a departure the trip starts at our own branch where it loads or unloads, or else at the nearest branch.",
  "pendelRoutes.rounds": "Rounds per trip",
  "pendelRoutes.minutes": "Loading and unloading",
  "pendelRoutes.unlimited": "everything on one trip",
  "pendelRoutes.roundsSame": "{{count}}× back and forth",
  "pendelRoutes.roundsBoth": "{{with}}× with a return, {{without}}× without",
  "pendelRoutes.placeRemove": "Remove",
  "pendelRoutes.deleteConfirm": "Delete route {{name}}? Setting it inactive keeps it to look back at.",
  "pendelRoutes.newTitle": "New route",
  "pendelRoutes.newRoute": "New route",
  "pendelRoutes.namePlaceholder": "RFC Veghel → Doornhoek/Kempkens",
  "pendelRoutes.unlimitedLabel": "Everything on one trip, no limit",
  "pendelRoutes.withReturn": "Rounds with a return",
  "pendelRoutes.withReturnHelp": "So many rounds back and forth when a full load comes back on the trip.",
  "pendelRoutes.withoutReturn": "Rounds without a return",
  "pendelRoutes.withoutReturnHelp": "So many when the lorry always drives back empty; at least as many as with a return.",
  "pendelRoutes.acrossDaysLabel": "Loading and unloading may fall on different days",
  "pendelRoutes.acrossDaysHelp": "For a long route, such as to Nörten-Hardenberg: step 1 then also divides a consignment that loads the day before or unloads only the day after. Without this tick such a consignment becomes a trip of its own.",
  "pendelRoutes.acrossDaysShort": "over more days",
  "pendelRoutes.loadMinutes": "Loading (minutes)",
  "pendelRoutes.unloadMinutes": "Unloading (minutes)",
  "pendelRoutes.minutesHelp": "The driver loads and unloads himself: 45 and 30 minutes by default; coupling and loading in Nuenen 60.",
  "pendelRoutes.minutesCell": "{{load}} / {{unload}} min",
  "pendelRoutes.hours": "Opening hours",
  "pendelRoutes.hoursBoth": "loading and unloading address",
  "pendelRoutes.hoursFrom": "loading address",
  "pendelRoutes.hoursTo": "unloading address",
  "pendelRoutes.fromOpeningHoursLabel": "Keep to the opening hours of the loading address",
  "pendelRoutes.toOpeningHoursLabel": "Keep to the opening hours of the unloading address",
  "pendelRoutes.openingHoursHelp": "Off by default: a shuttle does not wait for the address to open and is never late there. The time on the order then only says when the trip is there, and order entry gives no note on the opening hours of that address. On: the address counts like any stop. A return loads at the unloading address and unloads at the loading address: the tick belongs to the address, not to loading or unloading.",
  "pendelRoutes.remark": "Remark",
  "pendelRoutes.sortOrder": "Order",
  "pendelRoutes.delete": "Delete",
  "pendelRoutes.count_one": "1 route",
  "pendelRoutes.count_other": "{{count}} routes",
  "pendelRoutes.none": "No routes yet. Without a shuttle schedule, step 1 drives factory shuttles back and forth as long as it fits in time.",
  "standingOrders.skipDates": "Skip on",
  "standingOrders.skipDatesHelp": "Days WLX makes no order, for example a public holiday.",
  "standingOrders.skipAdd": "Add",
  "standingOrders.skipRemove": "Remove",
  "standingOrders.remark": "Remark",
  "standingOrders.active": "Active",
  "standingOrders.activeHelp": "Off: WLX makes no new orders. What is there stays.",
  "standingOrders.line": "Consignment {{n}}",
  "standingOrders.lineAdd": "Add consignment",
  "standingOrders.lineRemove": "Remove consignment",
  "standingOrders.load": "Load",
  "standingOrders.unload": "Unload",
  "standingOrders.unloadDay": "Unloading day",
  "standingOrders.sameDay": "The same day",
  "standingOrders.daysLater_one": "{{count}} day later",
  "standingOrders.daysLater_other": "{{count}} days later",
  "standingOrders.from": "From",
  "standingOrders.to": "To",
  "standingOrders.stopReference": "Reference",
  "standingOrders.description": "Description",
  "standingOrders.pallets": "Pallets",
  "standingOrders.loadingMeters": "Loading metres",
  "standingOrders.weightKg": "Weight (kg)",
  "standingOrders.noInvoice": "Do not invoice",
  "standingOrders.noInvoiceHelp": "The consignment goes on no invoice, with the reason.",
  "standingOrders.noInvoiceReason": "Reason",
  "standingOrders.noInvoiceDefault": "Standing order",
  "standingOrders.noCmrReturn": "No CMR back",
  "standingOrders.noCmrReturnHelp": "No signed CMR comes back: WLX does not wait for one. The CMR is printed all the same.",
  "standingOrders.delete": "Delete",
  "standingOrders.deleteConfirm": "Yes, delete",
  "standingOrders.orders": "Orders made (the next {{days}} days)",
  "standingOrders.noOrders": "No orders yet: WLX makes them when it is saved and every hour after.",
  "standingOrders.orderDay": "Day",
  "standingOrders.orderNumber": "Order",
  "standingOrders.saved_one": "Saved. {{count}} order made.",
  "standingOrders.saved_other": "Saved. {{count}} orders made.",
  "standingOrders.failed": "Not made: {{days}}",
  "standingOrders.missing.name": "Give the standing order a name.",
  "standingOrders.missing.customer": "Choose the customer.",
  "standingOrders.missing.reference": "Fill in the reference.",
  "standingOrders.missing.validFrom": "Fill in from when it is valid.",
  "standingOrders.missing.days": "Choose at least one day for consignment {{n}}.",
  "standingOrders.missing.place": "Choose the loading and unloading place of consignment {{n}} from the address book.",
  "standingOrders.missing.time": "A time of consignment {{n}} is not right: write it as 16:30.",
  "standingOrders.missing.loadingMeters": "Fill in the loading metres of consignment {{n}}: without them WLX does not plan its orders.",
  // The scantafel (docs/scantafel.md §4)
  "documentCheck.palletOverview": "Overview",
  "documentCheck.view.work": "Work",
  "documentCheck.view.queue": "Queue",
  "documentCheck.stat.open": "To do",
  "documentCheck.stat.late": "Older than 2 days",
  "documentCheck.stat.today": "Done today · {{count}} by you",
  "documentCheck.readOnly": "You are looking on. Linking and checking take the rights Edit dossiers and Edit orders.",
  "documentCheck.kind.link": "Link",
  "documentCheck.kind.pallets": "Check pallets",
  "documentCheck.scan": "Scan",
  "documentCheck.work": "The work on this scan",
  "documentCheck.area.page": "Page",
  "documentCheck.area.box13": "Box 13",
  "documentCheck.page": "{{page}} / {{count}}",
  "documentCheck.pagePrev": "Previous page",
  "documentCheck.pageNext": "Next page",
  "documentCheck.pages": "page {{pages}}",
  "documentCheck.turn": "Turn",
  "documentCheck.openFile": "Open the scan in a new tab",
  "documentCheck.scanAlt": "Scan {{file}}",
  "documentCheck.pictureFailed": "The scan could not be shown. Open it on its own.",
  "documentCheck.consignment": "Consignment",
  "documentCheck.trip.title": "Trip",
  "documentCheck.trip.open": "Open trip",
  "documentCheck.trip.none": "This consignment is not on a trip yet.",
  "documentCheck.trip.unloads": "unloads at the customer",
  "documentCheck.trip.before": "before",
  "documentCheck.trip.number": "Trip number",
  "documentCheck.trip.date": "Trip date",
  "documentCheck.trip.lines_one": "{{count}} activity on this trip",
  "documentCheck.trip.lines_other": "{{count}} activities on this trip",
  "documentCheck.trip.customer": "Customer",
  "documentCheck.trip.location": "Address",
  "documentCheck.trip.choose": "Choose consignment {{number}}",
  "documentCheck.trip.depotLoad": "Load at depot",
  "documentCheck.trip.depotUnload": "Unload at depot",
  "missingCmrs.intro": "Consignments that were unloaded and whose signed CMR is not in yet. After {{count}} days it is missing: ask the driver or the charter for it.",
  "missingCmrs.tile.missing": "CMR missing",
  "missingCmrs.tile.missingNote": "more than {{count}} days after unloading",
  "missingCmrs.tile.overdue": "More than {{count}} days",
  "missingCmrs.tile.overdueNote": "of the missing ones",
  "missingCmrs.tile.charter": "With a charter",
  "missingCmrs.tile.charterNote": "of the missing ones, unloaded by a charter",
  "missingCmrs.state.missing": "Missing",
  "missingCmrs.state.recent": "Just unloaded",
  "missingCmrs.state.no_return": "No CMR return",
  "missingCmrs.search": "Search consignment, customer, reference, place, lorry or charter…",
  "missingCmrs.period": "Period",
  "missingCmrs.periodDays": "Last {{count}} days",
  "missingCmrs.customer": "Customer",
  "missingCmrs.allCustomers": "All customers",
  "missingCmrs.charter": "charter",
  "missingCmrs.noReturn": "No CMR return",
  "missingCmrs.noReturnHint": "No signed CMR ever comes back for this consignment: it leaves the list",
  "missingCmrs.undoNoReturn": "A CMR after all",
  "missingCmrs.undoNoReturnHint": "A signed CMR comes after all: the consignment waits for it again",
  "missingCmrs.col.days": "Days",
  "missingCmrs.col.consignment": "Consignment",
  "missingCmrs.col.customer": "Customer",
  "missingCmrs.col.loadDay": "Loading date",
  "missingCmrs.col.loadPlace": "Loading place",
  "missingCmrs.col.unloadDay": "Unloading date",
  "missingCmrs.col.unloadPlace": "Unloading place",
  "missingCmrs.col.unloadedBy": "Unloaded by",
  "missingCmrs.col.driver": "Driver",
  "missingCmrs.col.trip": "Trip",
  "missingCmrs.col.reference": "Reference",
  "missingCmrs.col.invoiceReference": "Invoice reference",
  "missingCmrs.col.loadReference": "Loading reference",
  "missingCmrs.col.unloadReference": "Unloading reference",
  "missingCmrs.empty.missing": "No missing CMRs.",
  "missingCmrs.empty.recent": "Nothing just unloaded without a CMR.",
  "missingCmrs.empty.no_return": "No consignments with No CMR return in this period.",
  "documentCheck.pallets": "Pallets",
  "documentCheck.candidates": "Possible consignments",
  "documentCheck.noCandidates": "WLX found no consignment. Search on consignment number, reference or licence plate.",
  "documentCheck.searchPlaceholder": "Search on consignment, reference, licence plate, place, address or name",
  "documentCheck.foundAtUnloading": "Found on the unloading place:",
  "documentCheck.foundAtLoading": "Found on the loading place:",
  "documentCheck.foundAtCustomer": "Found on the customer:",
  "documentCheck.searchNone": "Nothing found for {{q}}.",
  "documentCheck.readNumber": "read: {{number}}",
  "documentCheck.behindTrip": "behind trip sheet {{trip}}",
  "documentCheck.found.barcode": "Found on the barcode {{barcode}}",
  "documentCheck.found.barcodeNone": "Found on the barcode",
  "documentCheck.found.combined": "On the CMR of another consignment (more consignments on one CMR)",
  "documentCheck.found.text": "Found on the text: {{reference}}",
  "documentCheck.found.textPostcode": "Found on the text: {{reference}} and postcode {{postcode}}",
  "documentCheck.found.hand": "Linked by hand by {{who}}",
  "documentCheck.found.databridge": "Linked on the number that came with the scan",
  "documentCheck.orderCancelled": "Cancelled",
  "documentCheck.orderRejected": "Rejected",
  "documentCheck.col.planned": "Planned",
  "documentCheck.col.driver": "Driver",
  "documentCheck.col.box13": "Box 13",
  "documentCheck.col.verdict": "Right",
  "documentCheck.box.unloaded": "unloaded",
  "documentCheck.box.loaded": "loaded",
  "documentCheck.box.returned": "returned",
  "documentCheck.noPallets": "No pallets planned or reported. If box 13 says something, add the kind.",
  "documentCheck.addKind": "Add a kind…",
  "documentCheck.noExchange": "No exchange",
  "documentCheck.alreadyChecked": "These pallets were checked by {{who}}, {{when}}. Approving only links the scan.",
  "documentCheck.chooseFirst": "Choose the consignment first.",
  "documentCheck.link": "Link",
  "documentCheck.toType_one": "1 box left to type: planned and driver differ",
  "documentCheck.toType_other": "{{count}} boxes left to type: planned and driver differ",
  "documentCheck.ready": "Ready to approve",
  "documentCheck.approve": "Approve",
  "documentCheck.skip": "Skip",
  "documentCheck.discard": "Put aside",
  "documentCheck.discardConfirm": "Put this scan aside? It is kept, but leaves the queue.",
  "documentCheck.skipTitle": "Skip, with a reason",
  "documentCheck.skipReason.order_missing": "Order not in yet",
  "documentCheck.skipReason.unreadable": "Scan unreadable",
  "documentCheck.skipReason.ask_colleague": "A question for a colleague",
  "documentCheck.skipReason.other": "Other",
  "documentCheck.skipNote": "Note (may stay empty)",
  "documentCheck.skippedBy": "Skipped by {{who}}: {{reason}}",
  "documentCheck.lost": "{{who}} has this scan open now. Go on to the next.",
  "documentCheck.claimedBy": "{{who}} has this scan open.",
  "documentCheck.prevClaimed": "{{who}} has the previous scan open now.",
  "documentCheck.prevGone": "The previous scan was handled already.",
  "documentCheck.noOther": "No other scan is free.",
  "documentCheck.done": "Approved: {{number}}",
  "documentCheck.doneLinked": "Linked: {{number}}",
  "documentCheck.skipped": "Skipped",
  "documentCheck.discarded": "Put aside",
  "documentCheck.empty.title": "Nothing left to do",
  "documentCheck.empty.text.link": "Every scan is linked. A new scan opens here by itself.",
  "documentCheck.empty.text.pallets": "The pallets of every linked CMR are checked. A new CMR opens here by itself.",
  "documentCheck.empty.refresh": "Look again",
  "documentCheck.lateFlag": "late",
  "documentCheck.queue.at": "In",
  "documentCheck.queue.what": "Scan or consignment",
  "documentCheck.queue.customer": "Customer",
  "documentCheck.queue.why": "Why",
  "documentCheck.queue.who": "Open with",
  "documentCheck.queue.mine": "You",
  "documentCheck.queue.noMatch": "Nothing found with these filters.",
  "documentCheck.hint.move": "next, previous",
  "documentCheck.hint.box13": "box 13",
  "documentCheck.hint.choose": "choose",
  "documentCheck.hint.all": "all keys",
  "documentCheck.kb.approve": "Approve and on to the next",
  "documentCheck.kb.link": "Link and on to the next",
  "documentCheck.kb.next": "Next scan",
  "documentCheck.kb.previous": "Previous scan",
  "documentCheck.kb.nextAlways": "Next scan, also while typing (Ctrl + ↑ the previous)",
  "documentCheck.kb.box13": "Box 13 or the whole page",
  "documentCheck.kb.turn": "Turn the scan half round",
  "documentCheck.kb.page": "Next page (PgUp the previous)",
  "documentCheck.kb.search": "Search for the consignment",
  "documentCheck.kb.choose": "Choose a consignment from the list",
  "documentCheck.kb.noExchange": "No exchange: no empties left or taken back",
  "documentCheck.kb.skip": "Skip with a reason",
  "documentCheck.kb.open": "Open the scan in a new tab",
  "documentCheck.kb.escape": "Out of the box, so the letters work again",
  "nav.secrets": "Secrets",
  "secrets.intro": "Every secret WLX leans on in this environment: where it lives, who renews it and when it expires. The API's own come in by themselves and WLX reads an Entra app's date from Entra; the rest you fill in. WLX mails 60, 30 and 7 days ahead and on the day itself.",
  "secrets.mailTo": "The warnings go to {{to}}.",
  "secrets.mailOff": "The warnings go nowhere now: set SECRET_EXPIRY_MAIL_TO or CHANNEL_SILENCE_MAIL_TO, a sender and the mail app.",
  "secrets.entraOff": "The Graph app is not set up in this environment.",
  "secrets.checkNow": "Read Entra now",
  "secrets.checkedNow_one": "Read 1 app from Entra.",
  "secrets.checkedNow_other": "Read {{count}} apps from Entra.",
  "secrets.new": "New secret",
  "secrets.save": "Save",
  "secrets.edit": "Edit",
  "secrets.delete": "Remove",
  "secrets.deleteConfirm": "Remove {{name}} from the register?",
  "secrets.empty": "Nothing in the register yet.",
  "secrets.colName": "Secret",
  "secrets.colStatus": "Standing",
  "secrets.colExpiresAt": "Expires on",
  "secrets.colKind": "Kind",
  "secrets.colLocation": "Where it lives",
  "secrets.colOwner": "Who renews it",
  "secrets.colRenewal": "How to renew",
  "secrets.colChecked": "Read from Entra",
  "secrets.colActions": "Actions",
  "secrets.kind.entra_app": "Entra app",
  "secrets.kind.manual": "Date by hand",
  "secrets.appId": "Application (client) ID",
  "secrets.noExpiry": "Does not expire",
  "secrets.envLocation": "The API's environment (Portainer)",
  "secrets.locationPlaceholder": "For example Drone → Secrets",
  "secrets.neverValue": "Never put the secret itself here, only where it lives.",
  "secrets.notCheckedYet": "Not read yet",
  "secrets.checkedWith_one": "{{at}} · {{name}} (1 secret on the app)",
  "secrets.checkedWith_other": "{{at}} · {{name}} ({{count}} secrets on the app)",
  "secrets.status.refused": "Refused by Microsoft",
  "secrets.status.notConfigured": "No longer set",
  "secrets.status.noExpiry": "Does not expire",
  "secrets.status.unknown": "Date unknown",
  "secrets.status.expired": "Expired",
  "secrets.status.today": "Expires today",
  "secrets.status.days_one": "Expires tomorrow",
  "secrets.status.days_other": "{{count}} days left",
  "secrets.status.ok": "Fine",
  "secrets.checkError.no_permission": "No right to read Entra: the Graph app lacks Application.Read.All",
  "secrets.checkError.app_not_found": "This app does not exist in Entra",
  "secrets.checkError.secret_not_on_app": "The secret in the environment is not (or no longer) on the app",
  "secrets.checkError.no_secret": "The app has no secret or certificate",
  "secrets.checkError.failed": "Reading Entra failed; WLX tries again",
  "secrets.checkError.not_configured": "Reading Entra is off: the Graph app is not set up",
  "secrets.system.ENTRA_CLIENT_SECRET.name": "Signing in to WLX (Entra app)",
  "secrets.system.ENTRA_CLIENT_SECRET.renewal": "Entra → App registrations → the sign-in app → Certificates & secrets: new client secret. Put it in the stack as ENTRA_CLIENT_SECRET (production: both nodes), deploy, try signing in, and only then remove the old secret.",
  "secrets.system.GRAPH_CLIENT_SECRET.name": "SharePoint and calendars (Graph app)",
  "secrets.system.GRAPH_CLIENT_SECRET.renewal": "Entra → App registrations → the Graph app → Certificates & secrets: new client secret. Put it in the stack as GRAPH_CLIENT_SECRET (production: both nodes), deploy, open a dossier, and only then remove the old secret.",
  "secrets.system.GRAPH_MAIL_CLIENT_SECRET.name": "Shared mailboxes and system mail (mail app)",
  "secrets.system.GRAPH_MAIL_CLIENT_SECRET.renewal": "Entra → App registrations → the mail app → Certificates & secrets: new client secret. Put it in the stack as GRAPH_MAIL_CLIENT_SECRET (production: both nodes), deploy, open a shared mailbox, and only then remove the old secret.",
  "secrets.system.HERE_API_KEY.name": "Address checks, map and routes (HERE)",
  "secrets.system.HERE_API_KEY.renewal": "HERE platform → the app → API keys: create the second key, put it in the stack as HERE_API_KEY, deploy, then disable the old one. If the key has no end date, tick Does not expire.",
  "secrets.system.AZURE_OPENAI_API_KEY.name": "AI help (Azure OpenAI)",
  "secrets.system.AZURE_OPENAI_API_KEY.renewal": "Azure portal → the OpenAI resource → Keys and endpoint: put key 2 in the stack as AZURE_OPENAI_API_KEY, deploy, then regenerate key 1.",
  "secrets.system.RDW_APP_TOKEN.name": "Vehicle data (RDW)",
  "secrets.system.RDW_APP_TOKEN.renewal": "opendata.rdw.nl → the profile → app tokens: new token, as RDW_APP_TOKEN in the stack, deploy.",
  "secrets.system.DATADOCS_API_KEY.name": "DataDocs",
  "secrets.system.DATADOCS_API_KEY.renewal": "Agree a new key with Datow, as DATADOCS_API_KEY in the stack, deploy.",
  "secrets.system.SESSION_SECRET.name": "WLX sessions",
  "secrets.system.SESSION_SECRET.renewal": "Does not expire. A new value (at least 32 characters) signs everybody out; the same on both production nodes.",
  "secrets.system.REFRESH_TOKEN_ENC_KEY.name": "Key of the Outlook connections",
  "secrets.system.REFRESH_TOKEN_ENC_KEY.renewal": "Does not expire and cannot be recovered: lost means everybody connects Outlook again. Keep a copy outside DigitalOcean (docs/backup.md §8.3); the same on both production nodes.",
  // A document on the wrong consignment, moved (docs/scantafel.md §6.2)
  "documents.inbox.reason.unlinked": "Unlinked: pick the right consignment",
  "documents.relink.open": "Move",
  "documents.relink.title": "Move document",
  "documents.relink.explain": "{{file}} is with {{from}}. Where does it belong?",
  "documents.relink.toConsignment": "To another consignment",
  "documents.relink.numberPlaceholder": "Consignment, order or dossier number",
  "documents.relink.toQueue": "Back to Document check",
  "documents.relink.reopen": "Open the pallet check of {{from}} again",
  "documents.relink.submit": "Move",
  "documents.relink.numberRequired": "Fill in the consignment it belongs to.",
  "documents.relink.doneTo": "Moved from {{from}} to {{to}}.",
  "documents.relink.doneQueue": "Unlinked from {{from}}: the scan is in the work queue.",
  "documents.relink.reopened": "The pallet check is open again.",
  "documentCheck.relink": "Other consignment",
  "documentCheck.relinkCancel": "Keep this consignment",
  "documentCheck.relinkFrom": "Linked to {{number}} now: pick the right consignment",
  "documentCheck.relinkSearch": "Search the consignment this CMR belongs to",
  "documentCheck.unlink": "Unlink",
  "documentCheck.unlinkConfirm": "Unlink this CMR from {{number}}? It goes back to Document check to be linked again.",
  "documentCheck.unlinked": "Unlinked from {{number}}: the scan is back at Document check",
  "documentCheck.kb.relink": "Choose another consignment",
  // Pages put together or apart at the scantafel (docs/scantafel.md §6.2)
  "documents.inbox.reason.split": "Cut off another scan",
  "documents.inbox.reason.merged": "Put behind the scan before",
  "documentCheck.mergeButton": "Behind the one before: {{what}}",
  "documentCheck.lookBack": "See the one before",
  "documentCheck.lookBackDone": "Back to this scan",
  "documentCheck.lookingBack": "The scan before: {{what}}",
  "documentCheck.mergeConfirm": "Put this scan behind the one before ({{what}})? Its pages go at the end of that pdf, and this scan leaves the queue.",
  "documentCheck.merged": "Put behind {{what}}",
  "documentCheck.splitButton": "Cut",
  "documentCheck.splitHere": "From page {{page}} a scan of its own",
  "documentCheck.splitFirstPage": "Go to the page where the second scan starts",
  "documentCheck.splitToLink": "Cut: from page {{page}} on, a scan of its own waits at Document check.",
  "documentCheck.splitConfirm": "Cut before page {{page}} of {{count}}? From there it becomes a scan of its own in the queue, right behind this one.",
  "documentCheck.split": "Cut: from page {{page}} there is a scan of its own in the queue, right behind this one.",
  "documentCheck.kb.merge": "Put behind the scan before",
  "documentCheck.kb.lookBack": "See the scan before, and back again",
  "documentCheck.kb.split": "Cut before the page on the screen",
  // The pallet account (docs/scantafel.md §5)
  "nav.palletAccounts": "Pallet administration",
  "palletAccounts.view.accounts": "Balances",
  "palletAccounts.view.purchases": "Euros bought",
  "palletAccounts.intro": "Per relation the balance of Euro, H1 and H3 from the approved pallet checks and what was booked by hand. A row opens the mutations.",
  "palletAccounts.purchases.intro": "For customers whose euro pallets of inbound goods Willems buys: came in minus not returned at delivery, per month. What came in through Scoretrace is not in WLX: type the number before booking.",
  "palletAccounts.role.principal": "Principal",
  "palletAccounts.role.charter": "Charter",
  "palletAccounts.col.party": "Relation",
  "palletAccounts.col.code": "Code",
  "palletAccounts.col.role": "Role",
  "palletAccounts.col.agreement": "Agreement",
  "palletAccounts.col.lastAt": "Last mutation",
  "palletAccounts.col.mutations": "Mutations",
  "palletAccounts.col.date": "Date",
  "palletAccounts.col.kind": "Kind",
  "palletAccounts.col.quantity": "Quantity",
  "palletAccounts.col.balance": "Balance",
  "palletAccounts.col.reason": "Reason",
  "palletAccounts.col.stop": "Stop",
  "palletAccounts.col.consignment": "Consignment",
  "palletAccounts.col.trip": "Trip",
  "palletAccounts.col.evidence": "Evidence",
  "palletAccounts.col.note": "Note",
  "palletAccounts.col.settlement": "Shortage",
  "palletAccounts.col.by": "By",
  "palletAccounts.agreement.title": "Agreement",
  "palletAccounts.agreement.edit": "Change",
  "palletAccounts.agreement.none": "No exchange",
  "palletAccounts.agreement.all": "Exchanges Euro, H1 and H3",
  "palletAccounts.agreement.some": "Exchanges only {{kinds}}",
  "palletAccounts.agreement.default": "no agreement of its own",
  "palletAccounts.agreement.buys": "buys euros",
  "palletAccounts.agreement.buysLong": "Willems buys the euro pallets this customer's goods come in on",
  "palletAccounts.agreement.explain": "What the relation agreed counts for the pallet checks approved from now on; what was booked stays.",
  "palletAccounts.agreement.exchanges": "Exchanges pallets",
  "palletAccounts.onlyOpen": "Only with a balance",
  "palletAccounts.sign": "+ is what the relation owes Willems, − what Willems owes the relation.",
  "palletAccounts.empty": "No pallet account yet: it starts with the first approved pallet check or a mutation by hand.",
  "palletAccounts.emptyOpen": "No relation with a balance. Clear the tick to see all.",
  "palletAccounts.noMutations": "No mutations yet.",
  "palletAccounts.notFound": "This relation was not found.",
  "palletAccounts.bySystem": "WLX",
  "palletAccounts.toAccount": "To the pallet administration",
  "palletAccounts.onPartyCard": "Pallet administration",
  "palletAccounts.balanceAsPrincipal": "Balance as principal",
  "palletAccounts.balanceAsCharter": "Balance as charter (to hand in)",
  "palletAccounts.purchases.month": "Month",
  "palletAccounts.purchases.inbound": "Came in",
  "palletAccounts.purchases.notReturned": "Not returned",
  "palletAccounts.purchases.proposed": "Bought",
  "palletAccounts.purchases.booked": "Booked",
  "palletAccounts.purchases.book": "Book",
  "palletAccounts.purchases.bookedOn": "on {{date}}",
  "palletAccounts.purchases.empty": "No customer whose euro pallets Willems buys. Set it in the agreement on the customer's pallet account.",
  "palletAccounts.purchases.confirm": "Book {{quantity}} euros of {{party}} as bought in {{month}}?",
  "palletAccounts.reason.check": "Pallet check",
  "palletAccounts.reason.check_correction": "Pallet check, approved again",
  "palletAccounts.reason.pallet_slip": "Pallet slip",
  "palletAccounts.reason.correction": "Correction",
  "palletAccounts.reason.purchased": "Bought",
  "palletAccounts.reason.charged": "Charged",
  "palletAccounts.reason.opening_balance": "Opening balance",
  "palletAccounts.settlement.charge": "Charge",
  "palletAccounts.settlement.keep": "Keep",
  "palletAccounts.settlement.open": "To choose",
  "palletAccounts.settlement.undo": "Undo",
  "palletAccounts.evidence.cmr": "Signed CMR",
  "palletAccounts.add.open": "Add mutation",
  "palletAccounts.add.title": "Mutation by hand",
  "palletAccounts.add.submit": "Book",
  "palletAccounts.add.amount": "Quantity",
  "palletAccounts.add.amountRequired": "Fill in a quantity above 0.",
  "palletAccounts.add.noteRequired": "A correction says why: fill in the note.",
  "palletAccounts.add.direction.less": "{{party}} handed in, or Willems owes more (−)",
  "palletAccounts.add.direction.owes": "{{party}} took pallets, or owes Willems more (+)",
  "palletAccounts.add.notePlaceholder": "Slip number, what happened",
  "palletAccounts.add.attach": "Add pallet slip",
  "palletAccounts.add.attachHint": "A pdf or a photo, up to 10 MB",
  "perm.row.palletAccounts": "Book in the pallet administration",
  "perm.hint.palletAccounts": "Mutations by hand, charging shortages, agreements per relation, and letting a charter's invoice go with pallets open. Viewing is for whoever reads orders.",
  "perm.row.orderIntake": "Order intake",
  "perm.row.carryOver": "Carry Hager over",
  "perm.hint.carryOver": "Transport → Carry over: what of Hager's was not scanned in on the day before its unloading, carried over to the next delivery day. Admins have it by default.",
  "perm.hint.orderIntake": "The order intake: mails into it, the order intake on a second screen, and orders from a table or with a proposal of AI. Only an admin makes and changes a customer's order mail, on the relation card. Needs entering orders as well.",
  "purchaseInvoices.problem.pallets_not_returned": "Pallets not handed in: the charter still has pallets to hand in, and then the invoice does not go to AFAS.",
  "purchaseInvoices.pallets.held": "Pallets not handed in: {{balance}}. The invoice does not go to AFAS until the charter handed them in.",
  "purchaseInvoices.pallets.released": "Let go by {{who}} on {{when}}, with {{balance}} still to hand in.",
  "purchaseInvoices.pallets.toAccount": "Pallet administration",
  "purchaseInvoices.pallets.release": "Let go anyway",
  "purchaseInvoices.pallets.hold": "Hold again",
} as const;
